import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any; }
  Date: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /**
   * Long integer that can be larger than 32-bits but still smaller than the
   * arbitrary BigInt.  Unlike BigInt, this is a number in JSON and not a string.
   */
  Long: { input: number; output: number; }
};

/** Autogenerated input type of AbandonPreapproval */
export type AbandonPreapprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preapprovalId: Scalars['ID']['input'];
};

/** Autogenerated return type of AbandonPreapproval. */
export type AbandonPreapprovalPayload = {
  __typename?: 'AbandonPreapprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  preapproval?: Maybe<Preapproval>;
};

/** Autogenerated input type of AcceptFlywheelParticipation */
export type AcceptFlywheelParticipationInput = {
  accountSecureId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AcceptFlywheelParticipation. */
export type AcceptFlywheelParticipationPayload = {
  __typename?: 'AcceptFlywheelParticipationPayload';
  accountConfig?: Maybe<AutoInvestorAccountConfig>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  termsAndConditionsAcceptance?: Maybe<TermsAndConditionsAcceptance>;
};

/** A user can own or be a member of many Accounts, each type of account determines what the Account can be used for. */
export type Account = Timestamp & {
  __typename?: 'Account';
  /** The account's auto-investor configuration */
  autoInvestorAccountConfig?: Maybe<AutoInvestorAccountConfig>;
  /** Returns the setting if the user has enabled automatic repayment transfers out of this account */
  automaticRepaymentTransferSetting?: Maybe<AutomaticRepaymentTransferSetting>;
  /** Break down of the Account's balances */
  balance: Balance;
  /** Does the Account have an active ACH connected? */
  connectedToActiveAch: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fundsTransfers?: Maybe<Array<FundsTransfer>>;
  id: Scalars['ID']['output'];
  /** @deprecated Use invested_securities instead. */
  investedGroundfloorNotes: SecuritiesConnection;
  investedInLoansThatArePendingSettlement: Scalars['Boolean']['output'];
  /** @deprecated Use invested_securities instead. */
  investedLoans: SecuritiesConnection;
  investedSecurities: SecuritiesConnection;
  /** Investments purchased by this Account */
  investments?: Maybe<Array<Investment>>;
  /**
   * Balances specific to investible funds, withdrawable funds, and limits for
   * unverified users to transfer funds into the system
   */
  investorBalanceInformation: BalanceInformation;
  /** Id of the Ira Services Client associated to the account */
  iraServicesClientId?: Maybe<Scalars['String']['output']>;
  /** Status of Ira Services Client associated to the account */
  iraServicesClientStatus?: Maybe<Scalars['String']['output']>;
  /** Whether the account's DwollaCustomer was registered as a Business. Returns false if account has no DwollaCustomer. */
  isDwollaBusinessCustomer: Scalars['Boolean']['output'];
  /**
   * Does the user have no posted funds transfers?
   * @deprecated Use UserActivityStatistics has_posted_funds_transfer
   */
  isFirstFundsTransfer: Scalars['Boolean']['output'];
  julyTransferInvestPromotion: JulyTransferInvestPromotion;
  /** First transfer into account must meet or exceed this amount (in dollars). */
  minimumFirstTransferAmountDollars?: Maybe<Scalars['Int']['output']>;
  /** User defined display name */
  nickname?: Maybe<Scalars['String']['output']>;
  numberOfInvestments: Scalars['Int']['output'];
  /**
   * A summary of all open LRO investments for this account.
   * @deprecated Use summary instead
   */
  openInvestmentsSummary: OpenInvestmentsSummary;
  /** User that owns the Account */
  owner: User;
  /** Preapprovals associated to this acount */
  preapprovals?: Maybe<Array<Preapproval>>;
  /** Principals associated to this account */
  principals?: Maybe<Array<Principal>>;
  recurringTransferSchedules?: Maybe<Array<RecurringTransferSchedule>>;
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  stairsAccountCaps?: Maybe<AccountCaps>;
  /** A summary of stats for this account's start page. */
  startPageAccountSummary: StartPageAccountSummary;
  /** A summary of investments and stats for this account. */
  summary: InvestorActivitySummary;
  /**
   * All active or posted account transactions for this account.  Does not include failed transactions.
   * @deprecated Use transaction_history instead
   */
  transactions: AccountTransactionCollection;
  transferInvestPromotion?: Maybe<TransferInvestPromotionTracker>;
  /** Primary form of funds movement */
  trustlines?: Maybe<Array<Trustline>>;
  /** The type of Account determines what the Account can be used for */
  type: AccountTypeName;
  unsecureId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};


/** A user can own or be a member of many Accounts, each type of account determines what the Account can be used for. */
export type AccountFundsTransfersArgs = {
  state?: InputMaybe<Array<FundsTransferState>>;
};


/** A user can own or be a member of many Accounts, each type of account determines what the Account can be used for. */
export type AccountInvestedGroundfloorNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<FundingStateScope>;
  sort?: InputMaybe<SecuritySortAttributes>;
};


/** A user can own or be a member of many Accounts, each type of account determines what the Account can be used for. */
export type AccountInvestedLoansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<FundingStateScope>;
  sort?: InputMaybe<SecuritySortAttributes>;
};


/** A user can own or be a member of many Accounts, each type of account determines what the Account can be used for. */
export type AccountInvestedSecuritiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maturesOnOrBefore?: InputMaybe<Scalars['ISO8601Date']['input']>;
  performanceStates?: InputMaybe<Array<PerformanceState>>;
  ratings?: InputMaybe<Array<LoanGrades>>;
  repaymentOutcomeTypes?: InputMaybe<Array<RepaymentOutcome>>;
  scope?: InputMaybe<FundingStateScope>;
  sort?: InputMaybe<SecuritySortAttributes>;
  type?: Array<SecurityTypeName>;
};


/** A user can own or be a member of many Accounts, each type of account determines what the Account can be used for. */
export type AccountInvestmentsArgs = {
  securityType?: InputMaybe<SecurityTypeName>;
};


/** A user can own or be a member of many Accounts, each type of account determines what the Account can be used for. */
export type AccountTransactionsArgs = {
  pagination?: InputMaybe<PaginationAttributes>;
  sort?: InputMaybe<Array<AccountTransactionSortAttributes>>;
};


/** A user can own or be a member of many Accounts, each type of account determines what the Account can be used for. */
export type AccountTrustlinesArgs = {
  providers?: InputMaybe<Array<TrustlineProvider>>;
};

/** Information regarding an account's caps */
export type AccountCaps = {
  __typename?: 'AccountCaps';
  /** Feature flag for account balance cap */
  accountBalanceCapFeatureFlagEnabled: Scalars['Boolean']['output'];
  /** The cap on funds transfer schedule amount, in cents; null = uncapped */
  fundsTransferScheduleCap?: Maybe<Scalars['Int']['output']>;
  /** Feature flag for funds transfer schedule amount cap */
  fundsTransferScheduleCapFeatureFlagEnabled: Scalars['Boolean']['output'];
  /** The balance cap which informs manual transfer limits, in cents; null = uncapped */
  manualFundsTransferInCap?: Maybe<Scalars['Int']['output']>;
  /** The remaining amount of money the user can still transfer in this week; null = uncapped */
  manualTransferInRemainingAmountCents?: Maybe<Scalars['Int']['output']>;
};

export type AccountDisplayName = {
  __typename?: 'AccountDisplayName';
  /** The human-friendly name for the account */
  nickname: Scalars['String']['output'];
  /** The ID of the account */
  secureId: Scalars['String']['output'];
};

export enum AccountFlags {
  /** bypass_bank_probationary_period */
  BypassBankProbationaryPeriod = 'BYPASS_BANK_PROBATIONARY_PERIOD'
}

export type AccountTransaction = {
  account?: Maybe<Account>;
  bankAccount: Array<BankAccount>;
  /** The category of the transaction */
  category?: Maybe<TransactionCategory>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A generated description of the transaction */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True if the transaction is a debit, false if it is a credit */
  isDebit?: Maybe<Scalars['Boolean']['output']>;
  /** True if the transaction has been posted, false if it is still pending. */
  isPosted: Scalars['Boolean']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** The UTC timestamp the transaction posted.  Will be null if the transaction is not posted yet. */
  postedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  realizedReturnCents?: Maybe<Scalars['Int']['output']>;
  returnOfCapitalCents?: Maybe<Scalars['Int']['output']>;
  /** A very short description of the transaction */
  shortDescription: Scalars['String']['output'];
  /** @deprecated Use isPosted instead */
  state: Scalars['String']['output'];
  statementText?: Maybe<Scalars['String']['output']>;
  transactionAmountCents: Scalars['Int']['output'];
  transactionNumber: Scalars['String']['output'];
  transactionableType?: Maybe<Scalars['String']['output']>;
  /** The type of the transaction */
  typeName?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Paginated collection of account transactions with pagination metadata. */
export type AccountTransactionCollection = {
  __typename?: 'AccountTransactionCollection';
  /** The account transactions for this page */
  accountTransactions?: Maybe<Array<AccountTransaction>>;
  /** Metadata on the paginated collection.  Will be null if and only if there is an error. */
  paginationMetadata?: Maybe<PaginationMetadata>;
};

/** The connection type for AccountTransaction. */
export type AccountTransactionConnection = {
  __typename?: 'AccountTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AccountTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AccountTransactionEdge = {
  __typename?: 'AccountTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountTransaction>;
};

/** How to sort account transactions */
export type AccountTransactionSortAttributes = {
  field: AccountTransactionSortField;
  order: Order;
};

export enum AccountTransactionSortField {
  CreatedAt = 'createdAt',
  /** Sort by the default method of either posted_at or created_at timestamps. */
  Default = 'default',
  Id = 'id',
  TransactionAmountCents = 'transactionAmountCents',
  UpdatedAt = 'updatedAt'
}

/** Tracks the movement of funds from one internal account to another */
export type AccountTransfer = {
  __typename?: 'AccountTransfer';
  /** Amount of the transfer */
  amountCents: Scalars['Int']['output'];
  /** Currency of the transfer */
  amountCurrency: Scalars['String']['output'];
  /** The creation timestamp of the account transfer */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** account money is moving from */
  fromBankAccount: BankAccount;
  id: Scalars['ID']['output'];
  /** funds transfer out of the origin account */
  originFundsTransfer: FundsTransfer;
  /** Current state of the account transfer */
  state: AccountTransferState;
  /** account money is moving to */
  toBankAccount: BankAccount;
  /** Unique ID for the account transfer */
  transactionNumber: Scalars['String']['output'];
};

export type AccountTransferAttributes = {
  amountCents: Scalars['Int']['input'];
  destinationAccountSecureId: Scalars['ID']['input'];
  originAccountSecureId: Scalars['ID']['input'];
};

/** Object to hold error information for authorization or validations */
export type AccountTransferError = {
  __typename?: 'AccountTransferError';
  /** Error code describing the nature of the failure. */
  code?: Maybe<AccountTransferErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum AccountTransferErrorCode {
  MissingEnvVars = 'MISSING_ENV_VARS',
  PendingFundsTransfers = 'PENDING_FUNDS_TRANSFERS',
  RecaptchaAuthenticationFailed = 'RECAPTCHA_AUTHENTICATION_FAILED',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  UnauthorizedClient = 'UNAUTHORIZED_CLIENT',
  ValidationsFailed = 'VALIDATIONS_FAILED'
}

export enum AccountTransferState {
  /** transfer has been created and is awaiting initiation */
  Created = 'CREATED',
  /** transfer failed to complete */
  Failed = 'FAILED',
  /** transfer is pending funds being credited to the destination account */
  PendingCredit = 'PENDING_CREDIT',
  /** transfer is pending funds being debited from the origin account */
  PendingDebit = 'PENDING_DEBIT',
  /** transfer has posted */
  Posted = 'POSTED'
}

export enum AccountTypeName {
  /** Able to submit LoanApplications and manage Loans */
  Borrower = 'BORROWER',
  /** Brokers Loans to Borrowers */
  Broker = 'BROKER',
  /** Business Development Managers */
  BusinessDevelopmentManager = 'BUSINESS_DEVELOPMENT_MANAGER',
  /** Investor funded by bank account/ach */
  Investor = 'INVESTOR',
  /** An automatic/bundle investor. */
  InvestorAuto = 'INVESTOR_AUTO',
  /** CryptoCurrency Payment Rail Investors */
  InvestorCrypto = 'INVESTOR_CRYPTO',
  /** Institutional Investors */
  InvestorInstitutional = 'INVESTOR_INSTITUTIONAL',
  /** Investor funded by IRA */
  InvestorIra = 'INVESTOR_IRA',
  /** Yield Investor funded by bank account/ach */
  InvestorYield = 'INVESTOR_YIELD',
  /** Able to have refferal tag to refer other users to GROUNDFLOOR */
  Referrer = 'REFERRER',
  /** Security-Owned Investor Accounts */
  SecurityOwnedInvestor = 'SECURITY_OWNED_INVESTOR'
}

/** Autogenerated input type of ActivateAutomaticInvestingSchedules */
export type ActivateAutomaticInvestingSchedulesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The secure_id associated with an Account. */
  secureId: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateAutomaticInvestingSchedules. */
export type ActivateAutomaticInvestingSchedulesPayload = {
  __typename?: 'ActivateAutomaticInvestingSchedulesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentSchedules: Array<InvestmentSchedule>;
};

/** Autogenerated input type of ActivateLoanApplicationFeeWaiverPromotion */
export type ActivateLoanApplicationFeeWaiverPromotionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ActivateLoanApplicationFeeWaiverPromotion. */
export type ActivateLoanApplicationFeeWaiverPromotionPayload = {
  __typename?: 'ActivateLoanApplicationFeeWaiverPromotionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A collection of errors, if any have occurred. */
  errors?: Maybe<Array<Error>>;
  /** The current loan application fee waiver promotion. */
  loanApplicationFeeWaiverPromotion?: Maybe<LoanApplicationFeeWaiverPromotion>;
};

/** a single data point in a graph where the X axis is a date and the Y axis is some dollar amount. */
export type ActiveInvestmentDataPoint = InvestmentDataPoint & {
  __typename?: 'ActiveInvestmentDataPoint';
  /** The dollar amount at the end of the date. */
  amountCents: Scalars['BigInt']['output'];
  /** The date! */
  date: Scalars['ISO8601Date']['output'];
  /** The number of active investments at the end of the date. */
  investmentCount: Scalars['Int']['output'];
  /** The subgrouping of the data point, if any.  Only used if specified in the query. */
  subgrouping?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AddConditionForLoanAgreements */
export type AddConditionForLoanAgreementsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of AddConditionForLoanAgreements. */
export type AddConditionForLoanAgreementsPayload = {
  __typename?: 'AddConditionForLoanAgreementsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Condition>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of AddConditionToLendingLoanApplication */
export type AddConditionToLendingLoanApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conditionId: Scalars['ID']['input'];
  lendingLoanApplicationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddConditionToLendingLoanApplication. */
export type AddConditionToLendingLoanApplicationPayload = {
  __typename?: 'AddConditionToLendingLoanApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  loanApplicationCondition?: Maybe<LoanApplicationCondition>;
};

/** Autogenerated input type of AddDocumentToPreapproval */
export type AddDocumentToPreapprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hostedDocumentId: Scalars['ID']['input'];
  preapprovalId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddDocumentToPreapproval. */
export type AddDocumentToPreapprovalPayload = {
  __typename?: 'AddDocumentToPreapprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  preapproval?: Maybe<Preapproval>;
};

/** Autogenerated input type of AddDomainToBlockList */
export type AddDomainToBlockListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  domains: Scalars['String']['input'];
};

/** Autogenerated return type of AddDomainToBlockList. */
export type AddDomainToBlockListPayload = {
  __typename?: 'AddDomainToBlockListPayload';
  addedDomains?: Maybe<Array<Scalars['String']['output']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  failedToAddDomains?: Maybe<Array<Scalars['String']['output']>>;
  successMessage: Scalars['String']['output'];
};

/** Autogenerated input type of AddSecurityToExternalPartner */
export type AddSecurityToExternalPartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  securityId: Scalars['Int']['input'];
};

/** Autogenerated return type of AddSecurityToExternalPartner. */
export type AddSecurityToExternalPartnerPayload = {
  __typename?: 'AddSecurityToExternalPartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  externalPartner?: Maybe<ExternalPartner>;
};

/** Self-contained address info for a property or user */
export type Address = {
  __typename?: 'Address';
  /** First line of the street address */
  address1?: Maybe<Scalars['String']['output']>;
  /** Second line of a street address */
  address2?: Maybe<Scalars['String']['output']>;
  /** City of a street address */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of a street address */
  country?: Maybe<Scalars['String']['output']>;
  /** ISO code of country */
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  /** ID of the address */
  id?: Maybe<Scalars['ID']['output']>;
  /** The latitude of the address */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude of the address */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** State of a street address */
  state?: Maybe<Scalars['String']['output']>;
  /** Zip code of a street address */
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type AddressAttributes = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export enum AdminPauseReason {
  /** The account was paused because the default strategy is no longer available. */
  DefaultStrategyUnavailable = 'DEFAULT_STRATEGY_UNAVAILABLE',
  /** The account is not paused for an admin reason. */
  None = 'NONE'
}

/** The info for a BDM Admin User */
export type AdminUser = {
  __typename?: 'AdminUser';
  /** Admin email address */
  email: Scalars['String']['output'];
  /** Admin first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Admin last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Admin last name */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AllocateReitSecurities */
export type AllocateReitSecuritiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reitId: Scalars['Int']['input'];
  securityIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated return type of AllocateReitSecurities. */
export type AllocateReitSecuritiesPayload = {
  __typename?: 'AllocateReitSecuritiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reit?: Maybe<Reit>;
};

/** Autogenerated input type of AmendDrawRequest */
export type AmendDrawRequestInput = {
  approvedAmountCents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  transferFeeAmountCents: Scalars['Int']['input'];
};

/** Autogenerated return type of AmendDrawRequest. */
export type AmendDrawRequestPayload = {
  __typename?: 'AmendDrawRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  drawRequest?: Maybe<DrawRequest>;
  errors?: Maybe<Array<Error>>;
};

export type ApplicationContent = {
  __typename?: 'ApplicationContent';
  /** The application content as displayable HTML. */
  html: Scalars['String']['output'];
  /** The location where the application content is meant to be displayed. */
  location: ApplicationContentLocation;
};

export enum ApplicationContentLocation {
  InvestPageLroDescription = 'INVEST_PAGE_LRO_DESCRIPTION',
  InvestPageNoteDescription = 'INVEST_PAGE_NOTE_DESCRIPTION',
  InvestPagePromoText = 'INVEST_PAGE_PROMO_TEXT'
}

export enum ApplicationSku {
  /** For property puchase loans */
  PurchaseSku_1 = 'PURCHASE_SKU_1'
}

/** Autogenerated input type of ApplyPromotionalCredit */
export type ApplyPromotionalCreditInput = {
  accountId: Scalars['ID']['input'];
  amountCents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ApplyPromotionalCredit. */
export type ApplyPromotionalCreditPayload = {
  __typename?: 'ApplyPromotionalCreditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  promotionalCredit?: Maybe<PromotionalCredit>;
};

/** Autogenerated input type of ApproveBalanceAdjustment */
export type ApproveBalanceAdjustmentInput = {
  balanceAdjustmentId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ApproveBalanceAdjustment. */
export type ApproveBalanceAdjustmentPayload = {
  __typename?: 'ApproveBalanceAdjustmentPayload';
  balanceAdjustment?: Maybe<BalanceAdjustment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ApproveBankAccount */
export type ApproveBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the bank account */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveBankAccount. */
export type ApproveBankAccountPayload = {
  __typename?: 'ApproveBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ApproveFundsTransfers */
export type ApproveFundsTransfersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the funds transfers to approve. */
  fundsTransferIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ApproveFundsTransfers. */
export type ApproveFundsTransfersPayload = {
  __typename?: 'ApproveFundsTransfersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of ApprovePreapproval */
export type ApprovePreapprovalInput = {
  amountApprovedCents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preapprovalId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApprovePreapproval. */
export type ApprovePreapprovalPayload = {
  __typename?: 'ApprovePreapprovalPayload';
  amountApprovedCents?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  preapprovalId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of ApproveRequestedTransaction */
export type ApproveRequestedTransactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveRequestedTransaction. */
export type ApproveRequestedTransactionPayload = {
  __typename?: 'ApproveRequestedTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  id?: Maybe<Scalars['ID']['output']>;
  transactionRequest?: Maybe<TransactionRequest>;
};

/** Autogenerated input type of ArchiveInvestorUpdate */
export type ArchiveInvestorUpdateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of ArchiveInvestorUpdate. */
export type ArchiveInvestorUpdatePayload = {
  __typename?: 'ArchiveInvestorUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investorUpdate?: Maybe<InvestorUpdate>;
};

/** Autogenerated input type of ArchiveNotification */
export type ArchiveNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveNotification. */
export type ArchiveNotificationPayload = {
  __typename?: 'ArchiveNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  notification?: Maybe<Notification>;
};

/** Autogenerated input type of ArchiveProgressUpdate */
export type ArchiveProgressUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  progressUpdateId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveProgressUpdate. */
export type ArchiveProgressUpdatePayload = {
  __typename?: 'ArchiveProgressUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  progressUpdate?: Maybe<ProgressUpdate>;
};

/** Autogenerated input type of ArchiveUser */
export type ArchiveUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveUser. */
export type ArchiveUserPayload = {
  __typename?: 'ArchiveUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Describes documents associated to multiple models */
export type Asset = {
  __typename?: 'Asset';
  /** category of the document */
  category?: Maybe<Scalars['String']['output']>;
  /** ID of the Asset */
  id: Scalars['ID']['output'];
  /** name of the document */
  name?: Maybe<Scalars['String']['output']>;
  /** state of the document */
  state?: Maybe<Scalars['String']['output']>;
  /** type of document */
  type?: Maybe<Scalars['String']['output']>;
  /** last time the doc was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** URL of the document */
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AssignGuarantorToLoanApplication */
export type AssignGuarantorToLoanApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lendingLoanApplicationId: Scalars['Int']['input'];
  lendingPrincipalId: Scalars['Int']['input'];
};

/** Autogenerated return type of AssignGuarantorToLoanApplication. */
export type AssignGuarantorToLoanApplicationPayload = {
  __typename?: 'AssignGuarantorToLoanApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  lendingLoanApplication?: Maybe<LendingLoanApplication>;
};

export type Attachment = {
  /** The attachment's file-type. */
  fileType?: Maybe<Scalars['String']['output']>;
  /** The primary key of the attachment. */
  id: Scalars['ID']['output'];
  /** The URL of the attachment. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Object to hold error information for authorization or validations */
export type AuthenticationError = {
  __typename?: 'AuthenticationError';
  /** Error code describing the nature of the failure. */
  code?: Maybe<AuthenticationErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum AuthenticationErrorCode {
  BadMfaAttempt = 'BAD_MFA_ATTEMPT',
  InvalidPassword = 'INVALID_PASSWORD',
  MfaRequired = 'MFA_REQUIRED',
  RecaptchaAuthenticationFailed = 'RECAPTCHA_AUTHENTICATION_FAILED',
  ResourceArchived = 'RESOURCE_ARCHIVED',
  ResourceLocked = 'RESOURCE_LOCKED',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  ServerError = 'SERVER_ERROR',
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY'
}

/** Autogenerated input type of AuthorGeneralizedSecurityCategory */
export type AuthorGeneralizedSecurityCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalizedSecurityCategory: GeneralizedSecurityCategoryAuthorAttributes;
};

/** Autogenerated return type of AuthorGeneralizedSecurityCategory. */
export type AuthorGeneralizedSecurityCategoryPayload = {
  __typename?: 'AuthorGeneralizedSecurityCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  generalizedSecurityCategory?: Maybe<GeneralizedSecurityCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of AuthorGeneralizedSecurity */
export type AuthorGeneralizedSecurityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalizedSecurity: GeneralizedSecurityInput;
};

/** Autogenerated return type of AuthorGeneralizedSecurity. */
export type AuthorGeneralizedSecurityPayload = {
  __typename?: 'AuthorGeneralizedSecurityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  generalizedSecurity?: Maybe<GeneralizedSecurity>;
};

/** Account-level configuration for auto-investor service */
export type AutoInvestorAccountConfig = {
  __typename?: 'AutoInvestorAccountConfig';
  /** Reason for the admin pause, if any. */
  adminPauseReason?: Maybe<AdminPauseReason>;
  cashTarget: Scalars['Int']['output'];
  /** ID of the config record */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether or not the auto-invest service is currently paused for the given account. */
  paused: Scalars['Boolean']['output'];
  /** Secure ID of the account */
  secureId: Scalars['String']['output'];
  strategy: AutoInvestorStrategy;
};

export type AutoInvestorAccountConfigAttributes = {
  adminPauseReason?: InputMaybe<AdminPauseReason>;
  cashTarget?: InputMaybe<Scalars['Int']['input']>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  strategy?: InputMaybe<AutoInvestorStrategy>;
};

export type AutoInvestorAccountInvestment = {
  __typename?: 'AutoInvestorAccountInvestment';
  /** Purchase amount for individual investment */
  purchaseAmountCents: Scalars['Int']['output'];
  security: SecurityV2;
  /** slug of the security.  for actual id, use security.id */
  securityId: Scalars['ID']['output'];
  securityName: Scalars['String']['output'];
  /** Sanity check for the type of security associated with the investment */
  securityType: Scalars['String']['output'];
};

export type AutoInvestorAccountPurchaseOrder = {
  __typename?: 'AutoInvestorAccountPurchaseOrder';
  /** Purchase amount for the entire run */
  amountCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  investments: Array<AutoInvestorAccountInvestment>;
};

export type AutoInvestorAccountRun = {
  __typename?: 'AutoInvestorAccountRun';
  cancellable: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** the diversification quotient at the time the account run completed.  Null if the run is not complete. */
  diversificationQuotient?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  purchaseOrder?: Maybe<AutoInvestorAccountPurchaseOrder>;
};

export type AutoInvestorAccountRunCollection = {
  __typename?: 'AutoInvestorAccountRunCollection';
  /** The collection of auto-investor account runs. */
  autoInvestorAccountRuns: Array<AutoInvestorAccountRun>;
  /** Information regarding the paginated results. */
  paginationMetadata: PaginationMetadata;
};

export enum AutoInvestorStrategy {
  Default = 'DEFAULT',
  Index = 'INDEX',
  Reit = 'REIT'
}

/** When enabled allows automatic account-to-account transfer of repaid funds */
export type AutomaticRepaymentTransferSetting = {
  __typename?: 'AutomaticRepaymentTransferSetting';
  /** The creation timestamp of the account transfer */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** account to which repaid funds will be automatically transferred */
  destinationAccount: Account;
  /** The timestamp when automatic repayment transfers were disabled */
  disabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** account from which repaid funds will be automatically transferred */
  originAccount: Account;
  /** user whose repaid funds will be transferred automatically */
  user: User;
};

/** Maps an Account's various balances from GFIA and IRF and indicates what that balance can be used for */
export type Balance = {
  __typename?: 'Balance';
  /** Transferrable account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Investable amount */
  balanceCents?: Maybe<Scalars['Int']['output']>;
  /** Transferrable amount */
  clearedBalanceCents?: Maybe<Scalars['Int']['output']>;
  /** Cleared amount for internal transfers */
  clearedInternalBalanceCents?: Maybe<Scalars['Int']['output']>;
  /** Restricted (only ever Investable until repaid) amount */
  restrictedBalanceCents?: Maybe<Scalars['Int']['output']>;
  /** Untransferrable amount */
  unclearedBalanceCents?: Maybe<Scalars['Int']['output']>;
};

export type BalanceAdjustment = {
  __typename?: 'BalanceAdjustment';
  /** Foreign Key relating to user's account record */
  account: Account;
  /** The type of transfer that initiated this balance adjustment */
  adjustmentType: BalanceAdjustmentAdjustment;
  /** Amount of the balance adjustment */
  amountCents: Scalars['Int']['output'];
  /** The time this adjustment was approved */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The employee that approved this adjustment */
  approvedBy?: Maybe<Employee>;
  /** The time this adjustment finished processing successfully */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The time this adjustment was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The employee that created this adjustment */
  createdBy: Employee;
  /** Whether the transfer in "in" or "out" */
  direction: Scalars['String']['output'];
  /** The time this adjustment failed during processing */
  failedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Primary key for BalanceAdjustment records */
  id: Scalars['Int']['output'];
  /** The explanation for this balance adjustment */
  reason: Scalars['String']['output'];
  /** The time this adjustment was rejected */
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The employee that rejected this adjustment */
  rejectedBy?: Maybe<Employee>;
  /** The time this adjustment was reversed */
  reversedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The employee that reversed this adjustment */
  reversedBy?: Maybe<Employee>;
  /** The current state for the BalanceAdjustment */
  state: BalanceAdjustmentState;
  /** The time this adjustment was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Foreign Key relating to user record */
  user: User;
};

export enum BalanceAdjustmentAdjustment {
  Check = 'CHECK',
  CryptoTransfer = 'CRYPTO_TRANSFER',
  Reit = 'REIT',
  WireTransfer = 'WIRE_TRANSFER'
}

export enum BalanceAdjustmentState {
  /** This balance adjustment will begin processing shortly. */
  Approved = 'APPROVED',
  /** This balance adjustment has finished processing. */
  Completed = 'COMPLETED',
  /** This account lacks sufficient funds for debiting. */
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  /** This account lacks sufficent funds for reversal. */
  InsufficientReversalBalance = 'INSUFFICIENT_REVERSAL_BALANCE',
  /** This balance adjustment requires approval before processing. */
  PendingApproval = 'PENDING_APPROVAL',
  /** An employee rejected this balance adjustment and it will not process. */
  Rejected = 'REJECTED',
  /** This balance adjustment has finished reversing. */
  Reversed = 'REVERSED',
  /** This balance adjustment was rejected and will reverse its transactions shortly. */
  Reversing = 'REVERSING'
}

/**
 * Offers front-end friendly representations of an account's balance with regard to
 * limitations on transfer amounts, like cleared/restricted balances and unverified
 * user limits enforced by our payment provider.
 */
export type BalanceInformation = {
  __typename?: 'BalanceInformation';
  /** For unverified users, the remaining amount of money they can still transfer in this week */
  allowedTransferInRemainingAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The amount of money a user may currently transfer out. This amount doesn't include uncleared or restricted funds. */
  allowedTransferOutRemainingAmountCents: Scalars['Int']['output'];
  /** Funds available for investing right now */
  investibleBalanceCents: Scalars['Int']['output'];
  /** Total investible funds once all pending transactions post */
  investibleBalanceCentsWithPendingTransfersIn: Scalars['Int']['output'];
  /**
   * The amount of money currently pending in
   * PendingScheduledPredefinedInvestmentStrategies. This money is usally waiting
   * on FundsTransfer(s) in to post.
   */
  pendingScheduledPredefinedInvestmentStrategyCents: Scalars['Int']['output'];
};

export type BankAccount = {
  accountType?: Maybe<Scalars['String']['output']>;
  bankAccountFeatures: Array<BankAccountFeature>;
  bankName?: Maybe<Scalars['String']['output']>;
  connectedTrustlines: Array<Trustline>;
  descriptiveName: Scalars['String']['output'];
  errors: Array<BankAccountError>;
  id: Scalars['ID']['output'];
  last4Digits?: Maybe<Scalars['String']['output']>;
  /** Have associated micro deposits posted to users bank account. */
  microDepositsPosted: Scalars['Boolean']['output'];
  state: BankAccountState;
  uuid: Scalars['ID']['output'];
  verificationAttempts: Scalars['Int']['output'];
  verificationLevel: BankAccountVerificationLevel;
};

export enum BankAccountAction {
  Create = 'CREATE',
  CreateMicroDeposits = 'CREATE_MICRO_DEPOSITS',
  PlaidPullTransactions = 'PLAID_PULL_TRANSACTIONS',
  PlaidRemove = 'PLAID_REMOVE',
  PlaidVerify = 'PLAID_VERIFY',
  Remove = 'REMOVE',
  VerifyMicroDeposits = 'VERIFY_MICRO_DEPOSITS'
}

/** Object to hold error information for authorization or validations */
export type BankAccountConnectionError = {
  __typename?: 'BankAccountConnectionError';
  /** Error code describing the nature of the failure. */
  code?: Maybe<BankAccountConnectionErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum BankAccountConnectionErrorCode {
  AccountInBankProbationaryPeriod = 'ACCOUNT_IN_BANK_PROBATIONARY_PERIOD',
  AssociationsImmutable = 'ASSOCIATIONS_IMMUTABLE',
  DuplicateResource = 'DUPLICATE_RESOURCE',
  MicroDepositsPending = 'MICRO_DEPOSITS_PENDING',
  RequiredConditionsMissing = 'REQUIRED_CONDITIONS_MISSING',
  ResourceArchived = 'RESOURCE_ARCHIVED',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  ServerError = 'SERVER_ERROR',
  TrustlineHasBankAccount = 'TRUSTLINE_HAS_BANK_ACCOUNT',
  UnauthorizedClient = 'UNAUTHORIZED_CLIENT',
  ValidationsFailed = 'VALIDATIONS_FAILED'
}

export type BankAccountError = {
  __typename?: 'BankAccountError';
  createdAt: Scalars['ISO8601DateTime']['output'];
  errorCode?: Maybe<ErrorCode>;
  originAction?: Maybe<BankAccountAction>;
};

export type BankAccountFeature = {
  __typename?: 'BankAccountFeature';
  bankAccountFeatureType: BankAccountFeatureTypeName;
  state?: Maybe<BankAccountFeatureState>;
};

export enum BankAccountFeatureState {
  /** The feature has broken and no longer works. The user must take steps to fix the bank account feature */
  Broken = 'BROKEN',
  /** The feature is not enabled and can't be used by the bank account */
  Disabled = 'DISABLED',
  /** The feature is enabled and is able to be used by the bank account */
  Enabled = 'ENABLED'
}

export enum BankAccountFeatureTypeName {
  /** The bank account has access to the plaid API, generally */
  PlaidIntegration = 'PLAID_INTEGRATION',
  /** The bank account can have account information pulled via plaid */
  PlaidPullAccountInfo = 'PLAID_PULL_ACCOUNT_INFO',
  /** The bank account can have transactions pulled via plaid */
  PlaidPullTransactions = 'PLAID_PULL_TRANSACTIONS',
  /** The bank account can transfer funds in via it's provider */
  TransferIn = 'TRANSFER_IN',
  /** The bank account can transfer funds out via it's provider */
  TransferOut = 'TRANSFER_OUT'
}

export enum BankAccountState {
  /** The account is verified and ready to transact */
  Active = 'ACTIVE',
  /** The bank account was approved by a member of customer succcess and was cleared of being fradulent */
  Approved = 'APPROVED',
  /** The account has been archived and can no longer transact */
  Archived = 'ARCHIVED',
  /** Typically used with IRA accounts to assist in multiple steps needed to provision account */
  Authoring = 'AUTHORING',
  /** Something has gone wrong and the account can no longer transact or verify */
  Broken = 'BROKEN',
  /** Bank account details have been confirmed by the user but not sent to provider */
  Committed = 'COMMITTED',
  /** The customer associated with the bank account has been verified */
  Created = 'CREATED',
  /** The account is marked for archival and can no longer transact */
  PendingArchival = 'PENDING_ARCHIVAL',
  /** Bank account is waiting for the customer before attempting sync with external provider */
  PendingCustomerCreation = 'PENDING_CUSTOMER_CREATION',
  /** The account has been provisioned and microdeposit verification is initializing */
  PendingMicrodepositCreation = 'PENDING_MICRODEPOSIT_CREATION',
  /** The bank account hasn't been setup yet */
  PendingProcessing = 'PENDING_PROCESSING',
  /** The bank account was flagged for review by a member of customer succcess due to potential fraudlent activity */
  PendingReview = 'PENDING_REVIEW',
  /** The steps required for verification have been completed and the account is awaiting confirmation */
  PendingVerification = 'PENDING_VERIFICATION',
  /** The account is being setup with the third party */
  Provisioning = 'PROVISIONING',
  /** The bank account has been suspended and activity halted */
  Suspended = 'SUSPENDED',
  /** An error occurred when trying to verify this bank account. Action is required. */
  VerificationRequired = 'VERIFICATION_REQUIRED',
  /** The account ownership has been verified but isn't ready to transact */
  Verified = 'VERIFIED'
}

export enum BankAccountVerificationLevel {
  /** Verifying via 2 small deposits */
  Microdeposits = 'MICRODEPOSITS',
  /** No verification */
  None = 'NONE',
  /** IDK wtf this is */
  Ping = 'PING',
  /** Using plaid to instantly verify */
  Plaid = 'PLAID'
}

export enum BaseSortField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type BatchInvestmentReservation = {
  __typename?: 'BatchInvestmentReservation';
  account: Account;
  expiresAt: Scalars['ISO8601DateTime']['output'];
  fundsTransfer?: Maybe<FundsTransfer>;
  groundfloorPurchaseOrder?: Maybe<PurchaseOrder>;
  id: Scalars['ID']['output'];
  investorPurchaseOrder?: Maybe<PurchaseOrder>;
  state: BatchInvestmentReservationState;
};

export enum BatchInvestmentReservationState {
  /** The investments have been transferred to the account. */
  Completed = 'COMPLETED',
  /** The reservation has been placed by an investor. */
  Placed = 'PLACED',
  /** The investments have been reserved. */
  Reserved = 'RESERVED',
  /** We are in the process of reserving the investments. */
  Reserving = 'RESERVING',
  /** The investments are being transferred to the account. */
  Transferring = 'TRANSFERRING'
}

export type BatchInvestmentSchedules = {
  accountId: Scalars['Int']['input'];
  grade?: InputMaybe<Scalars['String']['input']>;
  maxPurchaseAmountCents: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** The info for a BDM Admin User */
export type BdmProfile = {
  __typename?: 'BdmProfile';
  /** Account ID */
  accountId: Scalars['ID']['output'];
  adminUser: AdminUser;
  /** Admin User ID */
  employeeId: Scalars['ID']['output'];
  /** SalesForce User ID */
  salesforceId: Scalars['ID']['output'];
};

/** Autogenerated input type of BeginDocumentation */
export type BeginDocumentationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  originationEvent?: InputMaybe<Scalars['String']['input']>;
  underwritingEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BeginDocumentation. */
export type BeginDocumentationPayload = {
  __typename?: 'BeginDocumentationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<Array<LendingLoanApplication>>;
};

/** Autogenerated input type of BeginMfaEnrollment */
export type BeginMfaEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of BeginMfaEnrollment. */
export type BeginMfaEnrollmentPayload = {
  __typename?: 'BeginMfaEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  mfaAttempt?: Maybe<MfaAttempt>;
};

/** Autogenerated input type of BeginUnderwriting */
export type BeginUnderwritingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  originationEvent?: InputMaybe<Scalars['String']['input']>;
  underwritingEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BeginUnderwriting. */
export type BeginUnderwritingPayload = {
  __typename?: 'BeginUnderwritingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<Array<LendingLoanApplication>>;
};

/** The personal details and system details of a Beneficiary */
export type Beneficiary = Timestamp & {
  __typename?: 'Beneficiary';
  /** The beneficiary's associated address */
  address?: Maybe<Address>;
  /** The beneficiary's type, e.g. "INDIVIDUAL" */
  beneficiaryType: BeneficiaryVariety;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The beneficiary's designation, e.g. "PRIMARY" */
  designation: BeneficiaryDesignation;
  /** The beneficiary's DOB */
  dob: Scalars['Date']['output'];
  /** The beneficiary's first name */
  firstName: Scalars['String']['output'];
  /** The ID of the beneficiary */
  id: Scalars['Int']['output'];
  /** The beneficiary's last name */
  lastName: Scalars['String']['output'];
  /** The beneficiary's middle name */
  middleName?: Maybe<Scalars['String']['output']>;
  /** The last 4 digits of the beneficiary's SSN */
  obfuscatedSsn: Scalars['String']['output'];
  /** The percentage of GF shares that would fall to the beneficiary */
  percentageOfShares?: Maybe<Scalars['Int']['output']>;
  /** The beneficiary's phone number */
  phoneNumber: Scalars['String']['output'];
  /** The DateTime of completion of provisioning of the beneficiary */
  provisionedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The relationship of the beneficiary to the account owner, e.g. "MOTHER" */
  relationship: BeneficiaryRelationship;
  /** The DateTime when a beneficiary was soft deleted */
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The state of the beneficiary in GF, e.g. "submitted" or "authoring" */
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum BeneficiaryDesignation {
  /** Contingent */
  Contingent = 'CONTINGENT',
  /** Primary */
  Primary = 'PRIMARY'
}

export type BeneficiaryInput = {
  beneficiaryType?: InputMaybe<BeneficiaryVariety>;
  designation?: InputMaybe<BeneficiaryDesignation>;
  /** MUST BE OF FORMAT MM/DD/YYYY */
  dob?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  percentageOfShares?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<BeneficiaryRelationship>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export enum BeneficiaryRelationship {
  /** Aunt */
  Aunt = 'AUNT',
  /** Brother */
  Brother = 'BROTHER',
  /** Brother In Law */
  BrotherInLaw = 'BROTHER_IN_LAW',
  /** Child */
  Child = 'CHILD',
  /** Cousin */
  Cousin = 'COUSIN',
  /** Daughter */
  Daughter = 'DAUGHTER',
  /** Daughter In Law */
  DaughterInLaw = 'DAUGHTER_IN_LAW',
  /** Ex Husband */
  ExHusband = 'EX_HUSBAND',
  /** Ex Wife */
  ExWife = 'EX_WIFE',
  /** Father */
  Father = 'FATHER',
  /** Father In Law */
  FatherInLaw = 'FATHER_IN_LAW',
  /** Fiance */
  Fiance = 'FIANCE',
  /** Fiancee */
  Fiancee = 'FIANCEE',
  /** Friend */
  Friend = 'FRIEND',
  /** Granddaughter */
  Granddaughter = 'GRANDDAUGHTER',
  /** Grandfather */
  Grandfather = 'GRANDFATHER',
  /** Grandmother */
  Grandmother = 'GRANDMOTHER',
  /** Grandson */
  Grandson = 'GRANDSON',
  /** Husband */
  Husband = 'HUSBAND',
  /** Mother */
  Mother = 'MOTHER',
  /** Mother In Law */
  MotherInLaw = 'MOTHER_IN_LAW',
  /** Nephew */
  Nephew = 'NEPHEW',
  /** Niece */
  Niece = 'NIECE',
  /** Other */
  Other = 'OTHER',
  /** Significant Other */
  SignificantOther = 'SIGNIFICANT_OTHER',
  /** Sister */
  Sister = 'SISTER',
  /** Sister In Law */
  SisterInLaw = 'SISTER_IN_LAW',
  /** Son */
  Son = 'SON',
  /** Son In Law */
  SonInLaw = 'SON_IN_LAW',
  /** Spouse */
  Spouse = 'SPOUSE',
  /** Stepbrother */
  Stepbrother = 'STEPBROTHER',
  /** Stepdaughter */
  Stepdaughter = 'STEPDAUGHTER',
  /** Stepfather */
  Stepfather = 'STEPFATHER',
  /** Stepmother */
  Stepmother = 'STEPMOTHER',
  /** Stepsister */
  Stepsister = 'STEPSISTER',
  /** Stepson */
  Stepson = 'STEPSON',
  /** Uncle */
  Uncle = 'UNCLE',
  /** Wife */
  Wife = 'WIFE'
}

export enum BeneficiaryVariety {
  /** Entity */
  Entity = 'ENTITY',
  /** Individual */
  Individual = 'INDIVIDUAL'
}

/** Autogenerated input type of BorrowerApproves */
export type BorrowerApprovesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  originationEvent?: InputMaybe<Scalars['String']['input']>;
  underwritingEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BorrowerApproves. */
export type BorrowerApprovesPayload = {
  __typename?: 'BorrowerApprovesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<Array<LendingLoanApplication>>;
};

/** Information on the borrower used for closing */
export type BorrowerEntity = {
  __typename?: 'BorrowerEntity';
  account?: Maybe<Account>;
  dateOfFormation?: Maybe<Scalars['Date']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name of the borrower entity */
  fullName?: Maybe<Scalars['String']['output']>;
  hasMoreOnePrincipal?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the borrower_entity */
  id: Scalars['ID']['output'];
  stateOfFormation?: Maybe<Scalars['String']['output']>;
};

export type BorrowerEntityAttributes = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  agedUnsoldUnit?: InputMaybe<Scalars['Int']['input']>;
  dateOfFormation?: InputMaybe<Scalars['Date']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  grossMargin?: InputMaybe<Scalars['Float']['input']>;
  hasMoreOnePrincipal?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  projectsCompleted?: InputMaybe<Scalars['Int']['input']>;
  revenueCents?: InputMaybe<Scalars['BigInt']['input']>;
  stateOfFormation?: InputMaybe<Scalars['String']['input']>;
  totalDebtCents?: InputMaybe<Scalars['BigInt']['input']>;
  totalInventoryValueCents?: InputMaybe<Scalars['BigInt']['input']>;
  unsoldUnits?: InputMaybe<Scalars['Int']['input']>;
};

export enum BorrowerEntityTypeName {
  /** Corporation Entity */
  Corporation = 'CORPORATION',
  /** Limited Liability Company (long version) */
  LimitedLiabilityCompany = 'LIMITED_LIABILITY_COMPANY',
  /** Limited Liability Company */
  Llc = 'LLC',
  /** Partnership Entity */
  Partnership = 'PARTNERSHIP',
  /** Sole Proprietorship Entity */
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
  /** Trust Entity */
  Trust = 'TRUST'
}

export type BorrowerEntityV2 = {
  __typename?: 'BorrowerEntityV2';
  /** Their number of aged unsold units. */
  agedUnsoldUnitsCount: Scalars['Int']['output'];
  /** The number of projects that the borrower has completed in the past. */
  completedProjectsCount: Scalars['Int']['output'];
  /** The date that the borrowing-entity was formed on. */
  dateOfFormation?: Maybe<Scalars['Date']['output']>;
  /** Their gross margin as a percentage. */
  grossMarginPercentage?: Maybe<Scalars['Float']['output']>;
  /** ID of the borrower. */
  id: Scalars['ID']['output'];
  /** Name of the borrower. */
  name?: Maybe<Scalars['String']['output']>;
  /** Their revenue in cents. */
  revenueCents: Scalars['BigInt']['output'];
  /** The state in which the borrowing-entity was formed. */
  stateOfFormation?: Maybe<Scalars['String']['output']>;
  /** The total debt that the borrower has in cents. */
  totalDebtCents: Scalars['Int']['output'];
  /** The combined value of all of the borrower's properties in cents. */
  totalInventoryValueCents: Scalars['BigInt']['output'];
  /** The type of the borrower (Corp, LLC etc). */
  type?: Maybe<BorrowerEntityTypeName>;
  /** Their number of unsold units. */
  unsoldUnitsCount: Scalars['Int']['output'];
};

export type BrokerApplicationFeeConfiguration = {
  __typename?: 'BrokerApplicationFeeConfiguration';
  /** The current fee amount for submitting brokered loan applications, in cents. */
  feeAmountCents: Scalars['Int']['output'];
  /** Whether or not the broker application fee is currently in effect. */
  feeEnabled: Scalars['Boolean']['output'];
  /** The ID of the configuration. */
  id: Scalars['Int']['output'];
};

/** Autogenerated input type of BulkAddExistingUsersToPromo */
export type BulkAddExistingUsersToPromoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  transferInvestPromoId: Scalars['Int']['input'];
};

/** Autogenerated return type of BulkAddExistingUsersToPromo. */
export type BulkAddExistingUsersToPromoPayload = {
  __typename?: 'BulkAddExistingUsersToPromoPayload';
  addedUserCount?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  updatedPromo?: Maybe<TransferInvestPromo>;
};

/** Autogenerated input type of BulkInitiatePartialRepayment */
export type BulkInitiatePartialRepaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  repayments: Array<PartialRepaymentInput>;
};

/** Autogenerated return type of BulkInitiatePartialRepayment. */
export type BulkInitiatePartialRepaymentPayload = {
  __typename?: 'BulkInitiatePartialRepaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  partialRepayments?: Maybe<Array<PartialRepayment>>;
};

/** Autogenerated input type of CancelAutoInvestorAccountRun */
export type CancelAutoInvestorAccountRunInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the auto-investor account run being cancelled. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelAutoInvestorAccountRun. */
export type CancelAutoInvestorAccountRunPayload = {
  __typename?: 'CancelAutoInvestorAccountRunPayload';
  autoInvestorAccountRun?: Maybe<AutoInvestorAccountRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CancelInvestment */
export type CancelInvestmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelInvestment. */
export type CancelInvestmentPayload = {
  __typename?: 'CancelInvestmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investment?: Maybe<Investment>;
};

/** Autogenerated input type of CancelPendingFundsTransfer */
export type CancelPendingFundsTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundsTransferId: Scalars['Int']['input'];
};

/** Autogenerated return type of CancelPendingFundsTransfer. */
export type CancelPendingFundsTransferPayload = {
  __typename?: 'CancelPendingFundsTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  fundsTransfer?: Maybe<FundsTransfer>;
};

/** Autogenerated input type of CancelRepayment */
export type CancelRepaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of CancelRepayment. */
export type CancelRepaymentPayload = {
  __typename?: 'CancelRepaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type CashFlowChartData = {
  __typename?: 'CashFlowChartData';
  /** The amount of money invested in the account. */
  investments: Array<CashFlowDataPoint>;
  /** The amount of money repaid to the account, principal and interest. */
  repayments: Array<CashFlowDataPoint>;
  /** The amount of money transferred into the account. */
  transfersIn: Array<CashFlowDataPoint>;
  /** The amount of money transferred out of the account. */
  transfersOut: Array<CashFlowDataPoint>;
};

export type CashFlowDataPoint = InvestmentDataPoint & {
  __typename?: 'CashFlowDataPoint';
  /** The dollar amount at the end of the date. */
  amountCents: Scalars['BigInt']['output'];
  /** The date! */
  date: Scalars['ISO8601Date']['output'];
  /** The number of active investments at the end of the date. */
  investmentCount: Scalars['Int']['output'];
  /** The subgrouping of the data point, if any.  Only used if specified in the query. */
  subgrouping?: Maybe<Scalars['String']['output']>;
  /** The number of transactions that occurred on the date. */
  transactionCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ChangeAccount */
export type ChangeAccountInput = {
  accountSecureId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newAccountType: AccountTypeName;
};

/** Autogenerated return type of ChangeAccount. */
export type ChangeAccountPayload = {
  __typename?: 'ChangeAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ChangeUserPassword */
export type ChangeUserPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  previousPassword: Scalars['String']['input'];
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of ChangeUserPassword. */
export type ChangeUserPasswordPayload = {
  __typename?: 'ChangeUserPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PasswordModificationError>>;
  /** If MFA is required, a new MFA Attempt will be triggered and returned */
  mfaAttempt?: Maybe<MfaAttempt>;
};

/** An account's CJ cookie, created upon account registration. */
export type CjCookie = Timestamp & {
  __typename?: 'CjCookie';
  /** The associated affiliate link's "CJEVENT", to be used for conversion tracking. */
  cjEvent: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The time at which this cookie will be considered expired or invalid. */
  expiredAt: Scalars['ISO8601DateTime']['output'];
  /** The primary key of the object. */
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type CjCookieInput = {
  /** The primary key of the cookie's account. */
  accountId: Scalars['Int']['input'];
  /** The "CJEVENT" associated with the cookie, provided by the affiliate link. */
  cjEvent: Scalars['String']['input'];
  /** The time at which this cookie will be considered expired or invalid. */
  expiredAt: Scalars['ISO8601DateTime']['input'];
};

/** A user's clients which represents an authenticated session */
export type Client = {
  __typename?: 'Client';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the cilent */
  id: Scalars['ID']['output'];
  /** The IP of the device */
  ipAddress: Scalars['String']['output'];
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The device which generated the client */
  userAgent: Scalars['String']['output'];
};

/** Autogenerated input type of CloneLoanApplication */
export type CloneLoanApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CloneLoanApplication. */
export type CloneLoanApplicationPayload = {
  __typename?: 'CloneLoanApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  loanApplication?: Maybe<LoanApplication>;
};

/** Autogenerated input type of CloseSecurity */
export type CloseSecurityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CloseSecurity. */
export type CloseSecurityPayload = {
  __typename?: 'CloseSecurityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  security?: Maybe<Security>;
};

/** provides details related to closing a loan */
export type ClosingDetail = {
  __typename?: 'ClosingDetail';
  appointmentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  appointmentLocation?: Maybe<Scalars['String']['output']>;
  assignment?: Maybe<Scalars['String']['output']>;
  brokerPoints?: Maybe<Scalars['String']['output']>;
  buyersAttorneyCents?: Maybe<Scalars['Int']['output']>;
  cashToCloseCents?: Maybe<Scalars['Int']['output']>;
  closingDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  downPaymentCents?: Maybe<Scalars['Int']['output']>;
  earnestAmountCents?: Maybe<Scalars['Int']['output']>;
  entityAddressState?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  estimatedTitleFeesCents?: Maybe<Scalars['Int']['output']>;
  firstDrawHoldbackCents?: Maybe<Scalars['Int']['output']>;
  homeOwnersInsuranceCents?: Maybe<Scalars['Int']['output']>;
  /** ID of the conversion */
  id: Scalars['ID']['output'];
  lenderChargesCents?: Maybe<Scalars['Int']['output']>;
  loanApplication?: Maybe<LoanApplication>;
  name?: Maybe<Scalars['String']['output']>;
  originationPoints?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  principal?: Maybe<Scalars['String']['output']>;
  purchasePriceCents?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  referralBroker?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  taxesCents?: Maybe<Scalars['Int']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  titleAddress?: Maybe<Scalars['String']['output']>;
  titleContact?: Maybe<Scalars['String']['output']>;
  titleContactName?: Maybe<Scalars['String']['output']>;
  titleContactPhone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ClosingDetailAttributes = {
  appointmentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  appointmentLocation?: InputMaybe<Scalars['String']['input']>;
  assignment?: InputMaybe<Scalars['String']['input']>;
  buyersAttorneyCents?: InputMaybe<Scalars['Int']['input']>;
  cashToCloseCents?: InputMaybe<Scalars['Int']['input']>;
  closingDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  downPaymentCents?: InputMaybe<Scalars['Int']['input']>;
  earnestAmountCents?: InputMaybe<Scalars['Int']['input']>;
  estimatedTitleFeesCents?: InputMaybe<Scalars['Int']['input']>;
  firstDrawHoldbackCents?: InputMaybe<Scalars['Int']['input']>;
  homeOwnersInsuranceCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lenderChargesCents?: InputMaybe<Scalars['Int']['input']>;
  referralBroker?: InputMaybe<Scalars['String']['input']>;
  taxesCents?: InputMaybe<Scalars['Int']['input']>;
  titleAddress?: InputMaybe<Scalars['String']['input']>;
  titleContactName?: InputMaybe<Scalars['String']['input']>;
  titleContactPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ClosingOrigination */
export type ClosingOriginationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  originationEvent?: InputMaybe<Scalars['String']['input']>;
  underwritingEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ClosingOrigination. */
export type ClosingOriginationPayload = {
  __typename?: 'ClosingOriginationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<Array<LendingLoanApplication>>;
};

/** Clubs act as gates to functionality in the application */
export type Club = Timestamp & {
  __typename?: 'Club';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the club */
  id: Scalars['ID']['output'];
  /** name of the club */
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of CommitGeneralizedSecurityFunding */
export type CommitGeneralizedSecurityFundingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalizedSecurityId: Scalars['ID']['input'];
};

/** Autogenerated return type of CommitGeneralizedSecurityFunding. */
export type CommitGeneralizedSecurityFundingPayload = {
  __typename?: 'CommitGeneralizedSecurityFundingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  generalizedSecurity?: Maybe<GeneralizedSecurity>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** Info about a communication protocol */
export type CommunicationProtocol = {
  __typename?: 'CommunicationProtocol';
  communicationProtocolAttributes?: Maybe<Array<CommunicationProtocolAttribute>>;
  /** ID */
  id: Scalars['ID']['output'];
  protocolType?: Maybe<CommunicationProtocolProtocol>;
  /** email/phone number of protocol */
  protocolValue?: Maybe<Scalars['String']['output']>;
  protocolVerified: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

/** Info about a communication protocol attribute */
export type CommunicationProtocolAttribute = {
  __typename?: 'CommunicationProtocolAttribute';
  /** ID */
  id: Scalars['ID']['output'];
  protocolAttributeKey?: Maybe<CommunicationProtocolAttributeKey>;
  protocolAttributeValue?: Maybe<Scalars['String']['output']>;
};

export type CommunicationProtocolAttributeAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>;
  protocolAttributeKey?: InputMaybe<CommunicationProtocolAttributeKey>;
  protocolAttributeValue?: InputMaybe<Scalars['String']['input']>;
};

export enum CommunicationProtocolAttributeKey {
  EmailRaw = 'EMAIL_RAW',
  PhoneNumberCountryCode = 'PHONE_NUMBER_COUNTRY_CODE',
  PhoneNumberCountryIso = 'PHONE_NUMBER_COUNTRY_ISO',
  PhoneNumberLine = 'PHONE_NUMBER_LINE',
  PhoneNumberRaw = 'PHONE_NUMBER_RAW'
}

export type CommunicationProtocolAttributes = {
  communicationProtocolAttributes?: InputMaybe<Array<CommunicationProtocolAttributeAttributes>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  protocolType?: InputMaybe<CommunicationProtocolProtocol>;
  protocolValue?: InputMaybe<Scalars['String']['input']>;
};

export enum CommunicationProtocolProtocol {
  Authenticator = 'AUTHENTICATOR',
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER'
}

/** An individual record of a Company Update */
export type CompanyUpdate = Timestamp & {
  __typename?: 'CompanyUpdate';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Company Update identifier */
  id: Scalars['ID']['output'];
  /** ID of image uploaded for Company Update */
  imageId: Scalars['Int']['output'];
  /** URL from the associated image for Company Update */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Text to display for Company Update link */
  linkText: Scalars['String']['output'];
  /** Link to pdf for Company Update */
  pdfLink: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of CompleteClaCondition */
export type CompleteClaConditionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CompleteClaCondition. */
export type CompleteClaConditionPayload = {
  __typename?: 'CompleteClaConditionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplicationCondition?: Maybe<LoanApplicationCondition>;
};

/** Autogenerated input type of CompleteMfaEnrollment */
export type CompleteMfaEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one-time code sent from beginMfaEnrollment or triggerMfa */
  otp: Scalars['String']['input'];
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of CompleteMfaEnrollment. */
export type CompleteMfaEnrollmentPayload = {
  __typename?: 'CompleteMfaEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of CompleteUserRegistration */
export type CompleteUserRegistrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  secureId: Scalars['String']['input'];
  secureToken: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteUserRegistration. */
export type CompleteUserRegistrationPayload = {
  __typename?: 'CompleteUserRegistrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RegistrationError>>;
  jwt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Requirements that the borrower mustfilfil to close */
export type Condition = {
  __typename?: 'Condition';
  /** The default description of the condition */
  description: Scalars['String']['output'];
  /** ID of the condition */
  id: Scalars['ID']['output'];
  /** Human readable handle */
  name: Scalars['String']['output'];
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of ConfirmFundsTransfer */
export type ConfirmFundsTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundsTransferId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmFundsTransfer. */
export type ConfirmFundsTransferPayload = {
  __typename?: 'ConfirmFundsTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  fundsTransfer?: Maybe<FundsTransfer>;
};

/** Autogenerated input type of ConnectAchWithPlaid */
export type ConnectAchWithPlaidInput = {
  /** Required if trustline_id provided */
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  plaidAccountId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  /** Required if no account_secure_id provided */
  trustlineId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ConnectAchWithPlaid. */
export type ConnectAchWithPlaidPayload = {
  __typename?: 'ConnectAchWithPlaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<BankAccountConnectionError>;
  fundingSource?: Maybe<FundingSource>;
};

/** Autogenerated input type of ConnectBankAccountToUserAccount */
export type ConnectBankAccountToUserAccountInput = {
  accountId: Scalars['ID']['input'];
  bankAccountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ConnectBankAccountToUserAccount. */
export type ConnectBankAccountToUserAccountPayload = {
  __typename?: 'ConnectBankAccountToUserAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<BankAccountConnectionError>;
  trustline?: Maybe<Trustline>;
};

/** Object to represent a contributions from IRA Services */
export type Contribution = {
  __typename?: 'Contribution';
  /** Amount of the contribution */
  amountCents: Scalars['Int']['output'];
  /** Currency of the contribution */
  amountCurrency: Scalars['String']['output'];
  /** When the transfer was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Id of the directive in Ira Services */
  directiveId: Scalars['String']['output'];
  /** Method of contribution */
  directiveMethod: Scalars['String']['output'];
  /** Status of the directive in Ira Services */
  directiveStatus: Scalars['String']['output'];
  /** Update date of the directive status in Ira Services */
  directiveUpdatedAt: Scalars['String']['output'];
  /** Current state of downloaded forms for contribution */
  formDownloadsState: Scalars['String']['output'];
  /** Type of account the contribution is from */
  fromAccountType: Scalars['String']['output'];
  /** funds_transfer associated to contribution */
  fundsTransfer: FundsTransfer;
  /** Current state of the associated funds transfer */
  fundsTransferState: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** ira_custodian associated to contribution */
  iraCustodian: IraCustodian;
  /** Unique id for contribution in our system */
  secureId: Scalars['String']['output'];
  /** Current state of contribution */
  state: ContributionState;
  /** Account number to which money is wired in Ira Services */
  toAccountNumber: Scalars['String']['output'];
  /** trustline of contribution */
  trustline: Trustline;
  /** When the transfer was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum ContributionState {
  /** Initial state of contribution */
  Authoring = 'AUTHORING',
  /** Contribution is being processed */
  BeingProcessed = 'BEING_PROCESSED',
  /** Contribution is cancelled */
  Cancelled = 'CANCELLED',
  /** Contribution is failed */
  Failed = 'FAILED',
  /** Contribution is pending processing */
  PendingProcessing = 'PENDING_PROCESSING',
  /** Contribution application is being processed */
  ProviderApplicationProcessing = 'PROVIDER_APPLICATION_PROCESSING',
  /** Contribution assets being processed */
  ProviderAssetProcessing = 'PROVIDER_ASSET_PROCESSING',
  /** Contribution has been cancelled by provider */
  ProviderCancelled = 'PROVIDER_CANCELLED',
  /** Contribution has completed */
  ProviderCompleted = 'PROVIDER_COMPLETED',
  /** Contribution has failed */
  ProviderFailed = 'PROVIDER_FAILED',
  /** Contribution requires documentation */
  ProviderPendingDocumentation = 'PROVIDER_PENDING_DOCUMENTATION',
  /** Contribution is being provisioned by provider */
  ProviderProvisioned = 'PROVIDER_PROVISIONED',
  /** Contribution has been rejected by provider */
  ProviderRejected = 'PROVIDER_REJECTED'
}

/** Convertibal Debt Note */
export type ConvertibleDebtNote = Security & {
  __typename?: 'ConvertibleDebtNote';
  /** Amount that security is for */
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  /** Interest rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** Length of time to projected maturity in months from loan effectivedate */
  term: Scalars['Int']['output'];
};

/** A convertible devt note debt security offering. */
export type ConvertibleDebtNoteV2 = SecurityV2 & {
  __typename?: 'ConvertibleDebtNoteV2';
  /** The percentage of an account's portfolio which is made up of investments in this security. */
  accountCommitmentsPortfolioPercentage?: Maybe<Scalars['Float']['output']>;
  activeOfferingSummaryUrl?: Maybe<Scalars['String']['output']>;
  /** The maximum amount investable in the note */
  amountCents: Scalars['Int']['output'];
  /** The amount that has been invested in the security in cents. */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** The amount remaining until the security has been fully funded. */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** Page/application content for the security. */
  contents: Array<SecurityContent>;
  /** The creation timestamp of the security. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The title of the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  disbursementType?: Maybe<DisbursementTypeName>;
  /** The date the security will no longer be available on the platform */
  externalCloseOn?: Maybe<Scalars['Date']['output']>;
  /** External partners for this security */
  externalPartners: Array<ExternalPartner>;
  /** The date the loan was funded */
  fundsPostedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the security will be available on the platform */
  goLiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The primary key of the security. */
  id: Scalars['ID']['output'];
  /** Purchase constraints and other information for an investment in a particular account. */
  investmentPurchaseMetadata?: Maybe<InvestmentPurchaseMetadata>;
  /** Investments that have been made in the security. */
  investments: Array<Investment>;
  /** Updates for the investors on the progress of the project. */
  investorUpdates: Array<InvestorUpdate>;
  /** The number of people that have made an investment in the security. */
  investorsCount: Scalars['Int']['output'];
  /** The time at which the lenders were repaid. */
  lendersRepaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The marketing category that the security has been assigned to. */
  marketingCategory?: Maybe<MarketingCategory>;
  /** The date on which the security is expected to be repaid. */
  maturityDate?: Maybe<Scalars['Date']['output']>;
  /** Minimum number of units needed to purchase a GFN. */
  minUnitsPerAccount?: Maybe<Scalars['Int']['output']>;
  /** The date the security was most recently purchased */
  mostRecentPurchasedAtForAccount?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name or title of the security. */
  name: Scalars['String']['output'];
  /** Regulation for the Offering */
  offeringRegulation?: Maybe<Scalars['String']['output']>;
  /** The interest rate of the note. */
  rate: Scalars['Float']['output'];
  /** Remaining days for funding. */
  remainingDays: Scalars['Int']['output'];
  /** Name of SecBatch of the GFN */
  secBatchName?: Maybe<Scalars['String']['output']>;
  /** The date the sec_batch was qualified by sec */
  secBatchQualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the sec_batch was submitted to sec */
  secBatchSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether security is Tier 1 or not */
  secBatchTier1: Scalars['Boolean']['output'];
  securityAgreementUrl?: Maybe<Scalars['String']['output']>;
  /** The date the security began acrring interest */
  securityEffectiveOn?: Maybe<Scalars['Date']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** The state of the security. */
  state?: Maybe<Scalars['String']['output']>;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** The term of the debt security in months. */
  termMonths: Scalars['Int']['output'];
  /** The maximum amount investable in the note */
  totalAmountCents: Scalars['Int']['output'];
  /** Increment price to purchase GFN. */
  unitPriceCents?: Maybe<Scalars['Int']['output']>;
  /** The update timestamp of the security. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A convertible devt note debt security offering. */
export type ConvertibleDebtNoteV2AccountCommitmentsPortfolioPercentageArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** A convertible devt note debt security offering. */
export type ConvertibleDebtNoteV2InvestmentPurchaseMetadataArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** A convertible devt note debt security offering. */
export type ConvertibleDebtNoteV2InvestmentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<InvestmentState>;
};


/** A convertible devt note debt security offering. */
export type ConvertibleDebtNoteV2MostRecentPurchasedAtForAccountArgs = {
  accountSecureId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateAccountTransfer */
export type CreateAccountTransferInput = {
  accountTransfer: AccountTransferAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of CreateAccountTransfer. */
export type CreateAccountTransferPayload = {
  __typename?: 'CreateAccountTransferPayload';
  accountTransfer?: Maybe<AccountTransfer>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<AccountTransferError>>;
};

/** Autogenerated input type of CreateBalanceAdjustment */
export type CreateBalanceAdjustmentInput = {
  accountSecureId: Scalars['String']['input'];
  adjustmentType: BalanceAdjustmentAdjustment;
  amountCents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  direction: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateBalanceAdjustment. */
export type CreateBalanceAdjustmentPayload = {
  __typename?: 'CreateBalanceAdjustmentPayload';
  balanceAdjustment?: Maybe<BalanceAdjustment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateBeneficiary */
export type CreateBeneficiaryInput = {
  /** The secure ID of the account that the beneficiary will belong to. */
  accountSecureId: Scalars['ID']['input'];
  addressAttributes?: InputMaybe<AddressAttributes>;
  beneficiaryInput: BeneficiaryInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBeneficiary. */
export type CreateBeneficiaryPayload = {
  __typename?: 'CreateBeneficiaryPayload';
  beneficiary?: Maybe<Beneficiary>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateBorrowerEntity */
export type CreateBorrowerEntityInput = {
  borrowerEntity: BorrowerEntityAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBorrowerEntity. */
export type CreateBorrowerEntityPayload = {
  __typename?: 'CreateBorrowerEntityPayload';
  borrowerEntity?: Maybe<BorrowerEntity>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateCompanyUpdate */
export type CreateCompanyUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['Int']['input'];
  linkText: Scalars['String']['input'];
  pdfLink: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCompanyUpdate. */
export type CreateCompanyUpdatePayload = {
  __typename?: 'CreateCompanyUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyUpdate?: Maybe<CompanyUpdate>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateEquityOffering */
export type CreateEquityOfferingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equityOffering: EquityOfferingInput;
};

/** Autogenerated return type of CreateEquityOffering. */
export type CreateEquityOfferingPayload = {
  __typename?: 'CreateEquityOfferingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityOffering?: Maybe<EquityOffering>;
  errors: Array<Error>;
};

export type CreateExternalPartnerAttributes = {
  partnerDescription: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
};

/** Autogenerated input type of CreateExternalPartner */
export type CreateExternalPartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalPartner: CreateExternalPartnerAttributes;
};

/** Autogenerated return type of CreateExternalPartner. */
export type CreateExternalPartnerPayload = {
  __typename?: 'CreateExternalPartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  externalPartner?: Maybe<ExternalPartner>;
};

/** Autogenerated input type of CreateGroundfloorNoteIcon */
export type CreateGroundfloorNoteIconInput = {
  /** The s3 bucket for the uploaded image asset. */
  bucket: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The secureId of the GroundfloorNote. */
  groundfloorNoteId: Scalars['ID']['input'];
  /** The s3 key for the uploaded image asset. */
  key: Scalars['String']['input'];
};

/** Autogenerated return type of CreateGroundfloorNoteIcon. */
export type CreateGroundfloorNoteIconPayload = {
  __typename?: 'CreateGroundfloorNoteIconPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  groundfloorNote?: Maybe<GroundfloorNoteV2>;
};

/** Autogenerated input type of CreateGroundfloorNote */
export type CreateGroundfloorNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalPartnerId?: InputMaybe<Scalars['ID']['input']>;
  groundfloorNote: GroundfloorNoteCreateAttributes;
  groundfloorNoteId?: InputMaybe<Scalars['ID']['input']>;
  minUnitsPerAccount?: InputMaybe<Scalars['Int']['input']>;
  offeringType?: InputMaybe<OfferingRegulation>;
  securityContents?: InputMaybe<Array<SecurityContentInput>>;
  unitPriceCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateGroundfloorNote. */
export type CreateGroundfloorNotePayload = {
  __typename?: 'CreateGroundfloorNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  groundfloorNote: GroundfloorNoteV2;
};

/** Autogenerated input type of CreateHostedDocument */
export type CreateHostedDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hostedDocument?: InputMaybe<HostedDocumentAttributes>;
};

/** Autogenerated return type of CreateHostedDocument. */
export type CreateHostedDocumentPayload = {
  __typename?: 'CreateHostedDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  hostedDocument?: Maybe<HostedDocument>;
};

/** Autogenerated input type of CreateInvestmentOpportunityFromLendingData */
export type CreateInvestmentOpportunityFromLendingDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lendingData: LendingDataConversionInput;
};

/** Autogenerated return type of CreateInvestmentOpportunityFromLendingData. */
export type CreateInvestmentOpportunityFromLendingDataPayload = {
  __typename?: 'CreateInvestmentOpportunityFromLendingDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  loanApplication?: Maybe<LoanApplication>;
};

/** Autogenerated input type of CreateInvestmentOwnershipTransfer */
export type CreateInvestmentOwnershipTransferInput = {
  afterAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hostedDocumentId: Scalars['ID']['input'];
  investmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateInvestmentOwnershipTransfer. */
export type CreateInvestmentOwnershipTransferPayload = {
  __typename?: 'CreateInvestmentOwnershipTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  ownershipTransfer?: Maybe<OwnershipTransfer>;
};

/** Autogenerated input type of CreateInvestmentSchedules */
export type CreateInvestmentSchedulesInput = {
  accountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentSchedules: Array<BatchInvestmentSchedules>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateInvestmentSchedules. */
export type CreateInvestmentSchedulesPayload = {
  __typename?: 'CreateInvestmentSchedulesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentSchedules?: Maybe<Array<InvestmentSchedule>>;
};

/** Autogenerated input type of CreateInvestmentWizardStrategy */
export type CreateInvestmentWizardStrategyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investmentWizardStrategy: InvestmentWizardStrategyInput;
  purchaseOrderId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateInvestmentWizardStrategy. */
export type CreateInvestmentWizardStrategyPayload = {
  __typename?: 'CreateInvestmentWizardStrategyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentWizardStrategy?: Maybe<InvestmentWizardStrategy>;
};

/** Autogenerated input type of CreateInvestorUpdate */
export type CreateInvestorUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  html: Scalars['String']['input'];
  imageS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  loanId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateInvestorUpdate. */
export type CreateInvestorUpdatePayload = {
  __typename?: 'CreateInvestorUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investorUpdate?: Maybe<InvestorUpdate>;
};

/** Autogenerated input type of CreateLendingBorrowerEntityAddress */
export type CreateLendingBorrowerEntityAddressInput = {
  addressAttributes: AddressAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateLendingBorrowerEntityAddress. */
export type CreateLendingBorrowerEntityAddressPayload = {
  __typename?: 'CreateLendingBorrowerEntityAddressPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateLendingBorrowerEntity */
export type CreateLendingBorrowerEntityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lendingBorrowerEntity: LendingBorrowerEntityAttributes;
};

/** Autogenerated return type of CreateLendingBorrowerEntity. */
export type CreateLendingBorrowerEntityPayload = {
  __typename?: 'CreateLendingBorrowerEntityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingBorrowerEntity?: Maybe<LendingBorrowerEntity>;
};

/** Autogenerated input type of CreateLendingPrincipalAddress */
export type CreateLendingPrincipalAddressInput = {
  addressAttributes: AddressAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateLendingPrincipalAddress. */
export type CreateLendingPrincipalAddressPayload = {
  __typename?: 'CreateLendingPrincipalAddressPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateLendingPrincipal */
export type CreateLendingPrincipalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lendingPrincipal: LendingPrincipalAttributes;
};

/** Autogenerated return type of CreateLendingPrincipal. */
export type CreateLendingPrincipalPayload = {
  __typename?: 'CreateLendingPrincipalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingPrincipal?: Maybe<LendingPrincipal>;
};

/** Autogenerated input type of CreatePreapproval */
export type CreatePreapprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preapproval?: InputMaybe<PreapprovalAttributes>;
};

/** Autogenerated return type of CreatePreapproval. */
export type CreatePreapprovalPayload = {
  __typename?: 'CreatePreapprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  preapproval?: Maybe<Preapproval>;
};

/** Autogenerated input type of CreatePrincipal */
export type CreatePrincipalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  principal: PrincipalAttributes;
};

/** Autogenerated return type of CreatePrincipal. */
export type CreatePrincipalPayload = {
  __typename?: 'CreatePrincipalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  principal?: Maybe<Principal>;
};

/** Autogenerated input type of CreateProgressUpdate */
export type CreateProgressUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  html: Scalars['String']['input'];
  lendingLoanId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProgressUpdate. */
export type CreateProgressUpdatePayload = {
  __typename?: 'CreateProgressUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  progressUpdate?: Maybe<ProgressUpdate>;
};

/** Autogenerated input type of CreatePushNotificationSubscriptionConfiguration */
export type CreatePushNotificationSubscriptionConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pushNotificationSubscriptionConfiguration: PushNotificationSubscriptionConfigurationInput;
};

/** Autogenerated return type of CreatePushNotificationSubscriptionConfiguration. */
export type CreatePushNotificationSubscriptionConfigurationPayload = {
  __typename?: 'CreatePushNotificationSubscriptionConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PushNotificationSubscriptionConfigurationError>>;
  pushNotificationSubscriptionConfiguration?: Maybe<PushNotificationSubscriptionConfiguration>;
};

export type CreateRecurringTransferScheduleAttributes = {
  amountCents: Scalars['Int']['input'];
  destinationType: Scalars['String']['input'];
  interval: RecurringTransferScheduleInterval;
  scheduleStartOn: Scalars['ISO8601Date']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated input type of CreateRecurringTransferSchedule */
export type CreateRecurringTransferScheduleInput = {
  accountSecureId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recurringTransferSchedule: CreateRecurringTransferScheduleAttributes;
};

/** Autogenerated return type of CreateRecurringTransferSchedule. */
export type CreateRecurringTransferSchedulePayload = {
  __typename?: 'CreateRecurringTransferSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  recurringTransferSchedule?: Maybe<RecurringTransferSchedule>;
};

/** Autogenerated input type of CreateReferralCampaign */
export type CreateReferralCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referralCampaign: NewReferralCampaignInput;
};

/** Autogenerated return type of CreateReferralCampaign. */
export type CreateReferralCampaignPayload = {
  __typename?: 'CreateReferralCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  referralCampaign?: Maybe<ReferralCampaign>;
};

/** Autogenerated input type of CreateReit */
export type CreateReitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  initialFundingDetails: ReitInitialFundingDetailsInput;
  reit: ReitInput;
};

/** Autogenerated return type of CreateReit. */
export type CreateReitPayload = {
  __typename?: 'CreateReitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reit?: Maybe<Reit>;
};

/** Autogenerated input type of CreateSavingsGoal */
export type CreateSavingsGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  savingsGoal: SavingsGoalAttributes;
};

/** Autogenerated return type of CreateSavingsGoal. */
export type CreateSavingsGoalPayload = {
  __typename?: 'CreateSavingsGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  savingsGoal?: Maybe<SavingsGoal>;
};

/** Autogenerated input type of CreateTaxPayerForAccount */
export type CreateTaxPayerForAccountInput = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taxPayer: NewTaxPayerInput;
};

/** Autogenerated return type of CreateTaxPayerForAccount. */
export type CreateTaxPayerForAccountPayload = {
  __typename?: 'CreateTaxPayerForAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  taxPayer?: Maybe<TaxPayer>;
};

/** Autogenerated input type of CreateTaxPayer */
export type CreateTaxPayerInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taxPayerAttributes: NewTaxPayerInput;
};

/** Autogenerated return type of CreateTaxPayer. */
export type CreateTaxPayerPayload = {
  __typename?: 'CreateTaxPayerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  taxPayer?: Maybe<TaxPayer>;
};

/** Autogenerated input type of CreateTermSheet */
export type CreateTermSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lendingLoanApplicationId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateTermSheet. */
export type CreateTermSheetPayload = {
  __typename?: 'CreateTermSheetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  termSheet?: Maybe<TermSheet>;
};

/** Autogenerated input type of CreateVerifiedFundsTransfer */
export type CreateVerifiedFundsTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundsTransfer: FundsTransferAttributes;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of CreateVerifiedFundsTransfer. */
export type CreateVerifiedFundsTransferPayload = {
  __typename?: 'CreateVerifiedFundsTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  fundsTransfer?: Maybe<FundsTransfer>;
};

/** Autogenerated input type of CreateWireTransferRequest */
export type CreateWireTransferRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  wireTransferRequest?: InputMaybe<WireTransferRequestAttributes>;
};

/** Autogenerated return type of CreateWireTransferRequest. */
export type CreateWireTransferRequestPayload = {
  __typename?: 'CreateWireTransferRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  wireTransferRequest?: Maybe<WireTransferRequest>;
};

export type CredentialAttributes = {
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A key ID and signature to use as an alternative to a password */
  signature?: InputMaybe<SignatureCredentials>;
};

/** Represents a credit to a given bank account */
export type Credit = AccountTransaction & {
  __typename?: 'Credit';
  account?: Maybe<Account>;
  bankAccount: Array<BankAccount>;
  /** The category of the transaction */
  category?: Maybe<TransactionCategory>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A generated description of the transaction */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True if the transaction is a debit, false if it is a credit */
  isDebit?: Maybe<Scalars['Boolean']['output']>;
  /** True if the transaction has been posted, false if it is still pending. */
  isPosted: Scalars['Boolean']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** The UTC timestamp the transaction posted.  Will be null if the transaction is not posted yet. */
  postedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  realizedReturnCents?: Maybe<Scalars['Int']['output']>;
  returnOfCapitalCents?: Maybe<Scalars['Int']['output']>;
  /** A very short description of the transaction */
  shortDescription: Scalars['String']['output'];
  /** @deprecated Use isPosted instead */
  state: Scalars['String']['output'];
  statementText?: Maybe<Scalars['String']['output']>;
  transactionAmountCents: Scalars['Int']['output'];
  transactionNumber: Scalars['String']['output'];
  transactionableType?: Maybe<Scalars['String']['output']>;
  /** The type of the transaction */
  typeName?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of CreditUser */
export type CreditUserInput = {
  amountCents: Scalars['Int']['input'];
  bankAccountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreditUser. */
export type CreditUserPayload = {
  __typename?: 'CreditUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Credit>;
  errors: Array<Error>;
};

/** Input for a custom summary of investments */
export type CustomSummaryInput = {
  /** The end date for the lookback period.  Defaults to the end of today. */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The grouping to use for the summary.  If none is specified, a single group is returned. */
  grouping?: InputMaybe<InvestmentGrouping>;
  /** The number of days to look back for investments.  Null means no limit. */
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  /** The scope of investments to summarize */
  scope?: InputMaybe<InvestmentScope>;
  /** The types of securities to consider investments for */
  securityTypes?: InputMaybe<Array<SecurityTypeName>>;
};

export type Customer = {
  address?: Maybe<Address>;
  id: Scalars['ID']['output'];
  state: CustomerState;
  trustline: Trustline;
  verified: Scalars['Boolean']['output'];
};

/** Forms for completing contributions to IRA Services */
export type CustomerAuthorizationForm = {
  __typename?: 'CustomerAuthorizationForm';
  /** Contribution for form */
  contribution: Contribution;
  /** When form was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Name of the form */
  formName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** State for form */
  state: Scalars['String']['output'];
  /** When form was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum CustomerCategory {
  /** An account owned by a business entity */
  Business = 'BUSINESS',
  /** An account owned by an individual */
  Individual = 'INDIVIDUAL',
  /** An account owned by an unspecified entity */
  Unspecified = 'UNSPECIFIED'
}

export enum CustomerState {
  /** The customer information is valid and active */
  Active = 'ACTIVE',
  /** The customer information is no longer valid */
  Archived = 'ARCHIVED',
  /** Typically used with IRA accounts to assist in multiple steps needed to provision account */
  Authoring = 'AUTHORING',
  /** Something has gone wrong and customer account needs to be fixed */
  Broken = 'BROKEN',
  /** User must provide verifying documentation */
  DocumentationRequired = 'DOCUMENTATION_REQUIRED',
  /** User must provide additional verifying information */
  InformationRequired = 'INFORMATION_REQUIRED',
  /** The customer hasn't been setup yet */
  PendingProcessing = 'PENDING_PROCESSING',
  /** The customer state is being synced */
  PendingProviderStateSync = 'PENDING_PROVIDER_STATE_SYNC',
  /** Customer updates are being synced */
  PendingProviderUpdatesSync = 'PENDING_PROVIDER_UPDATES_SYNC',
  /** The information needs to be reviewed by GROUNDFLOOR */
  PendingReview = 'PENDING_REVIEW',
  /** IRA flow - Customer information must be updatedwith the provider */
  ProviderVerificationInformationRequired = 'PROVIDER_VERIFICATION_INFORMATION_REQUIRED',
  /** IRA flow - Customer details sent to IRAST */
  ProviderVerificationRequired = 'PROVIDER_VERIFICATION_REQUIRED',
  /** Customer information has been sent to provider */
  Submitted = 'SUBMITTED',
  /** User must verify their status as an authorized representitive of the business */
  VerifyAuthorizedRepresentativeAndBusinessWithDocumentRequired = 'VERIFY_AUTHORIZED_REPRESENTATIVE_AND_BUSINESS_WITH_DOCUMENT_REQUIRED',
  /** User must verify ownership of their business */
  VerifyBusinessWithDocumentRequired = 'VERIFY_BUSINESS_WITH_DOCUMENT_REQUIRED',
  /** User must provide a form of identification */
  VerifyWithDocumentRequired = 'VERIFY_WITH_DOCUMENT_REQUIRED'
}

export type DailyInvestmentGroup = {
  __typename?: 'DailyInvestmentGroup';
  id: Scalars['ID']['output'];
  investmentDate: Scalars['ISO8601Date']['output'];
  investments: Array<Investment>;
  /** total amount cents of investments on the day */
  totalPurchaseAmountCents: Scalars['Int']['output'];
};

export type DailyInvestmentGroupCollection = {
  __typename?: 'DailyInvestmentGroupCollection';
  /** An array of investments grouped by date */
  dailyInvestmentGroups: Array<DailyInvestmentGroup>;
  paginationMetadata: PaginationMetadata;
};

/** the various granularities possible when graphing data by date */
export enum DateGraphGranularity {
  /** One data point per day */
  Day = 'DAY',
  /** One data point per month */
  Month = 'MONTH',
  /** One data point per week, with weeks ending Sunday and starting Monday */
  Week = 'WEEK',
  /** One data point per year */
  Year = 'YEAR'
}

/** Autogenerated input type of DeactivateLoanApplicationFeeWaiverPromotion */
export type DeactivateLoanApplicationFeeWaiverPromotionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeactivateLoanApplicationFeeWaiverPromotion. */
export type DeactivateLoanApplicationFeeWaiverPromotionPayload = {
  __typename?: 'DeactivateLoanApplicationFeeWaiverPromotionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A collection of errors, if any have occurred. */
  errors?: Maybe<Array<Error>>;
  /** The current loan application fee waiver promotion. */
  loanApplicationFeeWaiverPromotion?: Maybe<LoanApplicationFeeWaiverPromotion>;
};

/** Represents a debit from a given bank account */
export type Debit = AccountTransaction & {
  __typename?: 'Debit';
  account?: Maybe<Account>;
  bankAccount: Array<BankAccount>;
  /** The category of the transaction */
  category?: Maybe<TransactionCategory>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A generated description of the transaction */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True if the transaction is a debit, false if it is a credit */
  isDebit?: Maybe<Scalars['Boolean']['output']>;
  /** True if the transaction has been posted, false if it is still pending. */
  isPosted: Scalars['Boolean']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** The UTC timestamp the transaction posted.  Will be null if the transaction is not posted yet. */
  postedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  realizedReturnCents?: Maybe<Scalars['Int']['output']>;
  returnOfCapitalCents?: Maybe<Scalars['Int']['output']>;
  /** A very short description of the transaction */
  shortDescription: Scalars['String']['output'];
  /** @deprecated Use isPosted instead */
  state: Scalars['String']['output'];
  statementText?: Maybe<Scalars['String']['output']>;
  transactionAmountCents: Scalars['Int']['output'];
  transactionNumber: Scalars['String']['output'];
  transactionableType?: Maybe<Scalars['String']['output']>;
  /** The type of the transaction */
  typeName?: Maybe<TransactionType>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Describes a converted debt investment transitioned into equity */
export type DebtConversion = {
  __typename?: 'DebtConversion';
  /** The current state of the conversion as documented in carta */
  cartaState?: Maybe<Scalars['String']['output']>;
  convertedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the converted investment */
  convertedInvestment?: Maybe<Investment>;
  convertedValueCents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  documentsReceivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  documentsSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the conversion */
  id: Scalars['ID']['output'];
  interestEarnedCents?: Maybe<Scalars['Int']['output']>;
  /** ID of the investment to be converted */
  investment?: Maybe<Investment>;
  /** ID of the convertible debt note */
  security?: Maybe<Security>;
  /** The current internal state of the conversion */
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DefaultSortAttributes = {
  field: BaseSortField;
  order: Order;
};

/** Autogenerated input type of DisableAutomaticRepaymentTransfers */
export type DisableAutomaticRepaymentTransfersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DisableAutomaticRepaymentTransfers. */
export type DisableAutomaticRepaymentTransfersPayload = {
  __typename?: 'DisableAutomaticRepaymentTransfersPayload';
  automaticRepaymentTransferSetting?: Maybe<AutomaticRepaymentTransferSetting>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DisableCondition */
export type DisableConditionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DisableCondition. */
export type DisableConditionPayload = {
  __typename?: 'DisableConditionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Condition>;
  errors?: Maybe<Array<Error>>;
};

export enum DisbursementTypeName {
  Annual = 'ANNUAL',
  Deferred = 'DEFERRED',
  Immediate = 'IMMEDIATE',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

/**
 * A rollup of disbursement data. Differs from repaid investment summariessince it
 * includes all disbursements, not just for investments that have fully repaid.
 */
export type DisbursementsSummary = {
  __typename?: 'DisbursementsSummary';
  /** The total repaid interest in all the investments */
  repaidInterestCents?: Maybe<Scalars['Long']['output']>;
  /** The total repaid principal in all the investments */
  repaidPrincipalCents?: Maybe<Scalars['Long']['output']>;
  totalPaymentsAmountCents?: Maybe<Scalars['Long']['output']>;
};

/** Request to withdraw funds from an escrow account for a borrower */
export type DrawRequest = {
  __typename?: 'DrawRequest';
  /** ID of the draw request */
  id: Scalars['ID']['output'];
};

/** BankAccount that is provisioned on Dwolla ACH as a funding source */
export type DwollaBankAccount = BankAccount & {
  __typename?: 'DwollaBankAccount';
  accountType?: Maybe<Scalars['String']['output']>;
  bankAccountFeatures: Array<BankAccountFeature>;
  bankName?: Maybe<Scalars['String']['output']>;
  connectedTrustlines: Array<Trustline>;
  descriptiveName: Scalars['String']['output'];
  errors: Array<BankAccountError>;
  id: Scalars['ID']['output'];
  last4Digits?: Maybe<Scalars['String']['output']>;
  /** Have associated micro deposits posted to users bank account. */
  microDepositsPosted: Scalars['Boolean']['output'];
  state: BankAccountState;
  uuid: Scalars['ID']['output'];
  verificationAttempts: Scalars['Int']['output'];
  verificationLevel: BankAccountVerificationLevel;
  /** Amount that can currently be transferred in for the current week */
  weeklyTransferInLeftCents?: Maybe<Scalars['Int']['output']>;
};

/** Identifying customer information used by the trustline */
export type DwollaCustomer = Customer & {
  __typename?: 'DwollaCustomer';
  address?: Maybe<Address>;
  businessClassification?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CustomerCategory>;
  dob?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identityProviderId?: Maybe<Scalars['Int']['output']>;
  identityState?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['Int']['output']>;
  providerState?: Maybe<Scalars['String']['output']>;
  state: CustomerState;
  trustline: Trustline;
  type?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  /** Amount that can currently be transferred in for the current week */
  weeklyTransferInLeftCents?: Maybe<Scalars['Int']['output']>;
  weeklyTransferInLimitCents?: Maybe<Scalars['Int']['output']>;
};

export type DwollaCustomerInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  businessClassification?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CustomerCategory>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of EditInvestorUpdate */
export type EditInvestorUpdateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of EditInvestorUpdate. */
export type EditInvestorUpdatePayload = {
  __typename?: 'EditInvestorUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investorUpdate?: Maybe<InvestorUpdate>;
};

/** Autogenerated input type of EditProgressUpdate */
export type EditProgressUpdateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Optional list of image secure ids to remove from the progress update. */
  removeImageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of EditProgressUpdate. */
export type EditProgressUpdatePayload = {
  __typename?: 'EditProgressUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  progressUpdate?: Maybe<ProgressUpdate>;
};

export type EditReferralCampaignInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  effectiveAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  investmentMaturationThreshold?: InputMaybe<Scalars['Int']['input']>;
  investmentThresholdAmountCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referredRewardAmountCents?: InputMaybe<Scalars['Int']['input']>;
  referrerRewardAmountCents?: InputMaybe<Scalars['Int']['input']>;
  removedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  rewardThresholdAmountCents?: InputMaybe<Scalars['Int']['input']>;
  systemName?: InputMaybe<ReferralCampaignSystemName>;
  type?: InputMaybe<ReferralCampaignTypes>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Object to signify requests for whether an email is registered with GROUNDFLOOR. */
export type EmailStatus = {
  __typename?: 'EmailStatus';
  /** Whether or not the email address can be registered with our system. */
  canRegister: Scalars['Boolean']['output'];
  /** Whether or not a Stairs account exists for the given email. */
  hasStairsAccount: Scalars['Boolean']['output'];
  /** Whether the email is valid per our validation rules */
  valid: Scalars['Boolean']['output'];
};

/** The identity and credentials of an employee on the platform */
export type Employee = Timestamp & {
  __typename?: 'Employee';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Email of the employee */
  email: Scalars['String']['output'];
  employeeRoles: Array<EmployeeRole>;
  /** First name of the employee */
  firstName: Scalars['String']['output'];
  /** identifier for the employee */
  id: Scalars['ID']['output'];
  /** Last name of the employee */
  lastName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type EmployeeRole = {
  __typename?: 'EmployeeRole';
  id: Scalars['Int']['output'];
  name: EmployeeRoleName;
  state: EmployeeRoleState;
};

export enum EmployeeRoleName {
  /** BDM */
  Bdm = 'BDM',
  /** Credit Issuer */
  CreditIssuer = 'CREDIT_ISSUER',
  /** Customer Support */
  CustomerSupport = 'CUSTOMER_SUPPORT',
  /** Data Admin */
  DataAdmin = 'DATA_ADMIN',
  /** Finance Officer */
  FinanceOfficer = 'FINANCE_OFFICER',
  /** Fraud Officer */
  FraudOfficer = 'FRAUD_OFFICER',
  /** IRA Admin */
  IraAdmin = 'IRA_ADMIN',
  /** Loan Manager */
  LoanManager = 'LOAN_MANAGER',
  /** Loan Officer */
  LoanOfficer = 'LOAN_OFFICER',
  /** Marketing Manager */
  MarketingManager = 'MARKETING_MANAGER',
  /** Press Manager */
  PressManager = 'PRESS_MANAGER',
  /** Processor */
  Processor = 'PROCESSOR',
  /** Promotional Credit Approver */
  PromotionalCreditApprover = 'PROMOTIONAL_CREDIT_APPROVER',
  /** Super Admin */
  SuperAdmin = 'SUPER_ADMIN',
  /** Underwriter */
  Underwriter = 'UNDERWRITER'
}

export enum EmployeeRoleState {
  /** Active */
  Active = 'ACTIVE'
}

/** Autogenerated input type of EnableAutomaticRepaymentTransfers */
export type EnableAutomaticRepaymentTransfersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationAccountSecureId: Scalars['String']['input'];
  originAccountSecureId: Scalars['String']['input'];
};

/** Autogenerated return type of EnableAutomaticRepaymentTransfers. */
export type EnableAutomaticRepaymentTransfersPayload = {
  __typename?: 'EnableAutomaticRepaymentTransfersPayload';
  automaticRepaymentTransferSetting?: Maybe<AutomaticRepaymentTransferSetting>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of EnablePlaidFeatures */
export type EnablePlaidFeaturesInput = {
  bankAccountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EnablePlaidFeatures. */
export type EnablePlaidFeaturesPayload = {
  __typename?: 'EnablePlaidFeaturesPayload';
  bankAccountFeatures?: Maybe<Array<BankAccountFeature>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export enum Entity {
  /** Business */
  Business = 'BUSINESS',
  /** Individual */
  Individual = 'INDIVIDUAL'
}

/** A Groundfloor equity security available to the investment platform */
export type EquityOffering = SecurityV2 & {
  __typename?: 'EquityOffering';
  /** The percentage of an account's portfolio which is made up of investments in this security. */
  accountCommitmentsPortfolioPercentage?: Maybe<Scalars['Float']['output']>;
  activeOfferingSummaryUrl?: Maybe<Scalars['String']['output']>;
  /** The amount that has been invested in the security in cents. */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** The amount remaining until the security has been fully funded. */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** Page/application content for the security. */
  contents: Array<SecurityContent>;
  /** The creation timestamp of the security. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The title of the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** The date the security will no longer be available on the platform */
  externalCloseOn?: Maybe<Scalars['Date']['output']>;
  /** External partners for this security */
  externalPartners: Array<ExternalPartner>;
  /** The date the loan was funded */
  fundsPostedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the security will be available on the platform */
  goLiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The primary key of the security. */
  id: Scalars['ID']['output'];
  /** Purchase constraints and other information for an investment in a particular account. */
  investmentPurchaseMetadata?: Maybe<InvestmentPurchaseMetadata>;
  /** Investments that have been made in the security. */
  investments: Array<Investment>;
  /** Updates for the investors on the progress of the project. */
  investorUpdates: Array<InvestorUpdate>;
  /** The number of people that have made an investment in the security. */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that the security has been assigned to. */
  marketingCategory?: Maybe<MarketingCategory>;
  /** The date the security was most recently purchased */
  mostRecentPurchasedAtForAccount?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name or title of the security. */
  name: Scalars['String']['output'];
  /** Regulation for the Offering */
  offeringRegulation?: Maybe<Scalars['String']['output']>;
  /** The date the sec_batch was qualified by sec */
  secBatchQualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the sec_batch was submitted to sec */
  secBatchSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether security is Tier 1 or not */
  secBatchTier1: Scalars['Boolean']['output'];
  securityAgreementUrl?: Maybe<Scalars['String']['output']>;
  /** The date the security began acrring interest */
  securityEffectiveOn?: Maybe<Scalars['Date']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** The state of the security. */
  state?: Maybe<Scalars['String']['output']>;
  /** The update timestamp of the security. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A Groundfloor equity security available to the investment platform */
export type EquityOfferingAccountCommitmentsPortfolioPercentageArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** A Groundfloor equity security available to the investment platform */
export type EquityOfferingInvestmentPurchaseMetadataArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** A Groundfloor equity security available to the investment platform */
export type EquityOfferingInvestmentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<InvestmentState>;
};


/** A Groundfloor equity security available to the investment platform */
export type EquityOfferingMostRecentPurchasedAtForAccountArgs = {
  accountSecureId: Scalars['ID']['input'];
};

export type EquityOfferingInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  descriptiveTitle?: InputMaybe<Scalars['String']['input']>;
  goLiveAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  secBatchId?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
};

/** Object to hold error information for authorization or validations */
export type Error = {
  __typename?: 'Error';
  /** Error code describing the nature of the failure. */
  code?: Maybe<ErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum ErrorCode {
  AccountInBankProbationaryPeriod = 'ACCOUNT_IN_BANK_PROBATIONARY_PERIOD',
  AssociationsImmutable = 'ASSOCIATIONS_IMMUTABLE',
  AssociationMissing = 'ASSOCIATION_MISSING',
  BadMfaAttempt = 'BAD_MFA_ATTEMPT',
  BadRequest = 'BAD_REQUEST',
  BrokenBankAccount = 'BROKEN_BANK_ACCOUNT',
  DuplicateAccount = 'DUPLICATE_ACCOUNT',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  DuplicateLendingLoan = 'DUPLICATE_LENDING_LOAN',
  DuplicateResource = 'DUPLICATE_RESOURCE',
  EmailIssue = 'EMAIL_ISSUE',
  ImmutableState = 'IMMUTABLE_STATE',
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  InvalidClient = 'INVALID_CLIENT',
  InvalidPassword = 'INVALID_PASSWORD',
  InvalidZipcode = 'INVALID_ZIPCODE',
  LoanManagerRoleRequired = 'LOAN_MANAGER_ROLE_REQUIRED',
  MaxNumberOfResources = 'MAX_NUMBER_OF_RESOURCES',
  MfaAlreadyEnrolled = 'MFA_ALREADY_ENROLLED',
  MfaCodeIncorrect = 'MFA_CODE_INCORRECT',
  MfaNotEnrolled = 'MFA_NOT_ENROLLED',
  MfaRequired = 'MFA_REQUIRED',
  MfaSessionExpired = 'MFA_SESSION_EXPIRED',
  MicroDepositsMaxAttempts = 'MICRO_DEPOSITS_MAX_ATTEMPTS',
  MicroDepositsPending = 'MICRO_DEPOSITS_PENDING',
  MissingEnvVars = 'MISSING_ENV_VARS',
  PaymentFailed = 'PAYMENT_FAILED',
  PendingFundsTransfers = 'PENDING_FUNDS_TRANSFERS',
  RateLimitExceeded = 'RATE_LIMIT_EXCEEDED',
  RecaptchaAuthenticationFailed = 'RECAPTCHA_AUTHENTICATION_FAILED',
  ReferringUserNotFound = 'REFERRING_USER_NOT_FOUND',
  RequiredConditionsMissing = 'REQUIRED_CONDITIONS_MISSING',
  ResourceAlreadyVerified = 'RESOURCE_ALREADY_VERIFIED',
  ResourceArchived = 'RESOURCE_ARCHIVED',
  ResourceLocked = 'RESOURCE_LOCKED',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  ResourceNotUnique = 'RESOURCE_NOT_UNIQUE',
  ScheduledMaintenance = 'SCHEDULED_MAINTENANCE',
  ServerError = 'SERVER_ERROR',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  StairsBankAccountLinkIncompatibility = 'STAIRS_BANK_ACCOUNT_LINK_INCOMPATIBILITY',
  TrustlineHasBankAccount = 'TRUSTLINE_HAS_BANK_ACCOUNT',
  UnauthorizedArguments = 'UNAUTHORIZED_ARGUMENTS',
  UnauthorizedClient = 'UNAUTHORIZED_CLIENT',
  UnauthorizedStateEvent = 'UNAUTHORIZED_STATE_EVENT',
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY',
  UpgradeRequired = 'UPGRADE_REQUIRED',
  UsedOwnReferralCode = 'USED_OWN_REFERRAL_CODE',
  UserAlreadyHasPushNotificationSubscriptionConfiguration = 'USER_ALREADY_HAS_PUSH_NOTIFICATION_SUBSCRIPTION_CONFIGURATION',
  UserAlreadyReferred = 'USER_ALREADY_REFERRED',
  UserRegistrationDatePastReferralWindow = 'USER_REGISTRATION_DATE_PAST_REFERRAL_WINDOW',
  ValidationsFailed = 'VALIDATIONS_FAILED'
}

/** Autogenerated input type of EstablishReferralSessionForNewUsers */
export type EstablishReferralSessionForNewUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer used. */
  referralCampaignType?: InputMaybe<ReferralCampaignSystemName>;
  /** @deprecated Use `code` instead. */
  referralTagSecureId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of EstablishReferralSessionForNewUsers. */
export type EstablishReferralSessionForNewUsersPayload = {
  __typename?: 'EstablishReferralSessionForNewUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ReferralError>>;
  /** Corresponds to the secure_id field of the created ReferralSession */
  referralSessionId?: Maybe<Scalars['ID']['output']>;
  /** The name of the referring user */
  referrerName?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the reward amount from the active ReferralCampaign */
  rewardAmountCents?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of EstablishReferralSession */
export type EstablishReferralSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer used. */
  referralCampaignType?: InputMaybe<ReferralCampaignSystemName>;
  /** @deprecated Use `code` instead. */
  referralTagSecureId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of EstablishReferralSession. */
export type EstablishReferralSessionPayload = {
  __typename?: 'EstablishReferralSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<ReferralError>>;
  referralSession?: Maybe<ReferralSession>;
  /** Corresponds to the secure_id field of the created ReferralSession */
  referralSessionId?: Maybe<Scalars['ID']['output']>;
  /** The name of the referring user */
  referrerName?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the reward amount from the active ReferralCampaign */
  rewardAmountCents?: Maybe<Scalars['Int']['output']>;
};

/** Object to signify requests for exportation of data. */
export type ExportRequest = Timestamp & {
  __typename?: 'ExportRequest';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  sentToEmail: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ExportRequestAttributes = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  exportType: ExportRequestExport;
  id?: InputMaybe<Scalars['ID']['input']>;
  sentToEmail: Scalars['String']['input'];
};

export enum ExportRequestExport {
  /** Account Transactions */
  AccountTransactions = 'ACCOUNT_TRANSACTIONS'
}

/** Represents an external partner associated with an object */
export type ExternalPartner = {
  __typename?: 'ExternalPartner';
  /** ID of the external partner */
  id: Scalars['Int']['output'];
  /** Detail about who the partner is */
  partnerDescription: Scalars['String']['output'];
  /** Generally the way the partner represents it's name */
  partnerName: Scalars['String']['output'];
};

/** Autogenerated input type of FinishFundingLoansWithFinanceAccount */
export type FinishFundingLoansWithFinanceAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FinishFundingLoansWithFinanceAccount. */
export type FinishFundingLoansWithFinanceAccountPayload = {
  __typename?: 'FinishFundingLoansWithFinanceAccountPayload';
  children?: Maybe<Array<PurchaseOrder>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** The Flagship Index (REIT), which is comprised of individual cohorts (generalized securities). */
export type FlagshipIndex = {
  __typename?: 'FlagshipIndex';
  description: Scalars['String']['output'];
  disbursementType: DisbursementTypeName;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl: Scalars['String']['output'];
  investmentCollection?: Maybe<InvestmentCollection>;
  investmentPurchaseMetadata?: Maybe<InvestmentPurchaseMetadata>;
  investments: Array<Investment>;
  isLive: Scalars['Boolean']['output'];
  loanToCostRange: FloatRange;
  minimumReinvestmentAmountCents: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nextDisbursementDate?: Maybe<Scalars['Date']['output']>;
  nextLoansReleaseDate?: Maybe<Scalars['Date']['output']>;
  rateRange: FloatRange;
  securityPurchaseConfiguration?: Maybe<SecurityPurchaseConfiguration>;
  targetReturn?: Maybe<Scalars['Float']['output']>;
  totalAmountInvestedCents: Scalars['Long']['output'];
  totalInvestorCount: Scalars['Int']['output'];
  totalLoanCount: Scalars['Int']['output'];
  weightedLoanAverages?: Maybe<WeightedLoanAverages>;
};


/** The Flagship Index (REIT), which is comprised of individual cohorts (generalized securities). */
export type FlagshipIndexInvestmentCollectionArgs = {
  accountSecureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<PaginationAttributes>;
};


/** The Flagship Index (REIT), which is comprised of individual cohorts (generalized securities). */
export type FlagshipIndexInvestmentPurchaseMetadataArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** The Flagship Index (REIT), which is comprised of individual cohorts (generalized securities). */
export type FlagshipIndexInvestmentsArgs = {
  accountSecureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Aggregated grade data for the Flagship Index. */
export type FlagshipIndexGradeAggregation = {
  __typename?: 'FlagshipIndexGradeAggregation';
  /** Sum of amount invested in loans in this grade */
  alreadyFundedCents: Scalars['Long']['output'];
  /** Weighted expected rate of return for loans in this grade */
  expectedRate: Scalars['Float']['output'];
  /** The grade of loans in this aggregation */
  grade: Scalars['String']['output'];
  /** Number of loans in this grade */
  loanCount: Scalars['Int']['output'];
  /** Percentage of total portfolio in this grade */
  percentOfPortfolio: Scalars['Float']['output'];
  /** Sum of the maximum funding amounts of loans in this grade */
  totalAmountCents: Scalars['Long']['output'];
};

/** The securities that make up the Flagship Index. */
export type FlagshipIndexHoldings = {
  __typename?: 'FlagshipIndexHoldings';
  /** The loans in the Flagship Index. */
  loans: LoansByState;
};

export type FloatRange = {
  __typename?: 'FloatRange';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Funds source where money maybe FundsTransfered to and/or from */
export type FundingSource = Timestamp & {
  __typename?: 'FundingSource';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Current state of the connection to the funding source */
  state: FundingSourceState;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  verificationLevel: BankAccountVerificationLevel;
};

export enum FundingSourceState {
  /** Ready for transfers */
  Active = 'ACTIVE',
  /** Archived/Inactive */
  Archived = 'ARCHIVED',
  /** Currently being editted, no processing will occur */
  Authoring = 'AUTHORING',
  /** Not funcitioning correctly, requires support */
  Broken = 'BROKEN',
  /** Created in the provider but waiting on verification (webhook) */
  Created = 'CREATED',
  /** Waiting for Customer to be provisioned */
  PendingCustomerCreation = 'PENDING_CUSTOMER_CREATION',
  /** Waiting on verification step to beprovisioned, may not actually bemicrodeposits */
  PendingMicrodepositCreation = 'PENDING_MICRODEPOSIT_CREATION',
  /** Created and queued to be provisioned with provider */
  PendingProcessing = 'PENDING_PROCESSING',
  /** Waiting on verification */
  PendingVerification = 'PENDING_VERIFICATION',
  /** Actively provisioning with provider */
  Provisioning = 'PROVISIONING',
  /** Provider suspended funding source, no activity allowed */
  Suspended = 'SUSPENDED',
  /** Provider verified funding source */
  Verified = 'VERIFIED'
}

export enum FundingStateScope {
  /** Purchased investments in securities that have not fully funded on the platform. */
  Committed = 'COMMITTED',
  /** Purchased investments in securities that have not been repaid. */
  CommittedAndOpen = 'COMMITTED_AND_OPEN',
  /** Purchased investments in securities that have been funded. */
  Open = 'OPEN',
  /** Repaid investments in securities that have been refunded. */
  Refunded = 'REFUNDED',
  /** Repaid investments in securities that have been funded or repaid. */
  Repaid = 'REPAID',
  /** Repaid investments in securities that have been refunded/repaid */
  RepaidAndRefunded = 'REPAID_AND_REFUNDED'
}

/** Tracks the movement of funds from one bank account to another */
export type FundsTransfer = {
  __typename?: 'FundsTransfer';
  /** owner of the transfer */
  account: Account;
  /** Amount of the transfer */
  amountCents: Scalars['Int']['output'];
  /** Currency of the transfer */
  amountCurrency: Scalars['String']['output'];
  /** The creation timestamp of the funds transfer */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** In or out of the platform */
  direction: Scalars['String']['output'];
  /** A user-friendly description of the transfer */
  friendlyDescription: Scalars['String']['output'];
  /** account money is moving from */
  fromBankAccount: BankAccount;
  id: Scalars['ID']['output'];
  /** When the transfer was started */
  initiatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the transfer was started */
  postedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** For daily rollup */
  rollup: Scalars['Boolean']['output'];
  /** One off or Scheduled */
  scheduled: Scalars['Boolean']['output'];
  /** Current state of the transfer */
  state: FundsTransferState;
  /** account money is moving to */
  toBankAccount: BankAccount;
  /** Unique ID for the xfer */
  transactionNumber: Scalars['String']['output'];
  /** The last update timestamp of the funds transfer */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** user who initiated the transfer */
  user: User;
  uuid: Scalars['ID']['output'];
};

export type FundsTransferAttributes = {
  accountId: Scalars['ID']['input'];
  amountCents: Scalars['Int']['input'];
  fromBankAccountId: Scalars['ID']['input'];
  toBankAccountId: Scalars['ID']['input'];
};

/** Paginated collection of Funds Transfers with pagination metadata. */
export type FundsTransferCollection = {
  __typename?: 'FundsTransferCollection';
  /** Funds Transfers for an account */
  fundsTransfers?: Maybe<Array<FundsTransfer>>;
  /** Metadata on the paginated collection of Funds Transfers */
  paginationMetadata: PaginationMetadata;
};

/** Limited fields on FundsTransfer model. */
export type FundsTransferListItem = {
  __typename?: 'FundsTransferListItem';
  /** Amount of the transfer */
  amountCents: Scalars['Int']['output'];
  /** The creation timestamp of the funds transfer */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** In or out of the platform */
  direction: Scalars['String']['output'];
  /** Descriptive name of bank account money is moving from */
  fromBankAccountDescriptiveName?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of bank account money is moving from */
  fromBankAccountLast4Digits?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Current state of the transfer */
  state: FundsTransferState;
  /** Descriptive name of bank account money is moving to */
  toBankAccountDescriptiveName?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of bank account money is moving to */
  toBankAccountLast4Digits?: Maybe<Scalars['String']['output']>;
  /** Unique ID for the funds transfer */
  transactionNumber: Scalars['String']['output'];
  /** Type of transfer (Transfer, Deposit, Withdrawal) */
  transferType: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

/** Paginated collection of limited fields on FundsTransfer model with pagination metadata. */
export type FundsTransferListItemCollection = {
  __typename?: 'FundsTransferListItemCollection';
  /** Funds Transfers for an account */
  fundsTransfers: Array<FundsTransferListItem>;
  /** Metadata on the paginated collection of Funds Transfers */
  paginationMetadata: PaginationMetadata;
};

export type FundsTransferSchedule = {
  __typename?: 'FundsTransferSchedule';
  account: Account;
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fromBankAccount: BankAccount;
  groupTag: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  runOn: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  toBankAccount: BankAccount;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  version: Scalars['Int']['output'];
  versionedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum FundsTransferScheduleState {
  /** Schedule is actie and running */
  Active = 'ACTIVE',
  /** Schedule is paused and not running */
  Paused = 'PAUSED'
}

export enum FundsTransferState {
  /** transfer was approved by the business */
  Approved = 'APPROVED',
  /** transfer was cancelled before funds posted */
  Cancelled = 'CANCELLED',
  /** transfer failed to initiate */
  Failed = 'FAILED',
  /** Transfer will process when account is activated */
  PendingBankAccountActivation = 'PENDING_BANK_ACCOUNT_ACTIVATION',
  /** transfer is waiting for funds to be credited to account */
  PendingCredit = 'PENDING_CREDIT',
  /** transfer is waiting for customer to be credited */
  PendingCustomerCredit = 'PENDING_CUSTOMER_CREDIT',
  /** transfer is waiting for funds to be debited from account */
  PendingDebit = 'PENDING_DEBIT',
  /** transfer is waiting for funds to be credited to fbo */
  PendingFboCredit = 'PENDING_FBO_CREDIT',
  /** transfer is waiting for funds to be debited from fbo */
  PendingFboDebit = 'PENDING_FBO_DEBIT',
  /** transfer is waiting for funds to be credited to gfia */
  PendingGfiaCredit = 'PENDING_GFIA_CREDIT',
  /** transfer is being reviewed by the bunsiness */
  PendingReview = 'PENDING_REVIEW',
  /** transfer is waiting for user to confirm transfer */
  PendingVerification = 'PENDING_VERIFICATION',
  /** funds have arrived in user's account */
  Posted = 'POSTED',
  /** transfer was rejected by the business */
  Rejected = 'REJECTED',
  /** transfer has been verified for initiation */
  Verified = 'VERIFIED'
}

export type FutureYieldBalance = {
  __typename?: 'FutureYieldBalance';
  amountCents: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  interestEarnedCents: Scalars['Float']['output'];
  timestamp: Scalars['ISO8601DateTime']['output'];
  transferredAmountCents: Scalars['Float']['output'];
};

/**
 * Categorized, generalized securities; currently this model is only leveraged for
 * Groundfloor Labs offerings, I.E. third-party originated financial securities.
 */
export type GeneralizedSecurity = SecurityV2 & {
  __typename?: 'GeneralizedSecurity';
  /** The percentage of an account's portfolio which is made up of investments in this security. */
  accountCommitmentsPortfolioPercentage?: Maybe<Scalars['Float']['output']>;
  activeOfferingSummaryUrl?: Maybe<Scalars['String']['output']>;
  amountCents: Scalars['Int']['output'];
  /** The amount that has been invested in the security in cents. */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** The minimum amount that must be purchased in order to invest. */
  amountMinInvestmentCents: Scalars['Int']['output'];
  /** The amount remaining until the security has been fully funded. */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  category?: Maybe<GeneralizedSecurityCategory>;
  /** Page/application content for the security. */
  contents: Array<SecurityContent>;
  /** The creation timestamp of the security. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The title of the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  disbursementType?: Maybe<DisbursementTypeName>;
  /** The date the security will no longer be available on the platform */
  externalCloseOn?: Maybe<Scalars['Date']['output']>;
  /** External partners for this security */
  externalPartners: Array<ExternalPartner>;
  fundedAmountCents: Scalars['Int']['output'];
  /** The date the loan was funded */
  fundsPostedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the security will be available on the platform */
  goLiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The primary key of the security. */
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  investmentMultiple?: Maybe<Scalars['Float']['output']>;
  /** Purchase constraints and other information for an investment in a particular account. */
  investmentPurchaseMetadata?: Maybe<InvestmentPurchaseMetadata>;
  /** Investments that have been made in the security. */
  investments: Array<Investment>;
  /** Updates for the investors on the progress of the project. */
  investorUpdates: Array<InvestorUpdate>;
  /** The number of people that have made an investment in the security. */
  investorsCount: Scalars['Int']['output'];
  listingFee?: Maybe<Scalars['Float']['output']>;
  /** The marketing category that the security has been assigned to. */
  marketingCategory?: Maybe<MarketingCategory>;
  /** The date the security was most recently purchased */
  mostRecentPurchasedAtForAccount?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name or title of the security. */
  name: Scalars['String']['output'];
  /** Regulation for the Offering */
  offeringRegulation?: Maybe<Scalars['String']['output']>;
  pdfUrl: Scalars['String']['output'];
  /** The date the sec_batch was qualified by sec */
  secBatchQualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the sec_batch was submitted to sec */
  secBatchSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether security is Tier 1 or not */
  secBatchTier1: Scalars['Boolean']['output'];
  securityAgreementUrl?: Maybe<Scalars['String']['output']>;
  /** The date the security began acrring interest */
  securityEffectiveOn?: Maybe<Scalars['Date']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** The state of the security. */
  state?: Maybe<Scalars['String']['output']>;
  targetReturn?: Maybe<Scalars['Float']['output']>;
  termMonths?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/**
 * Categorized, generalized securities; currently this model is only leveraged for
 * Groundfloor Labs offerings, I.E. third-party originated financial securities.
 */
export type GeneralizedSecurityAccountCommitmentsPortfolioPercentageArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/**
 * Categorized, generalized securities; currently this model is only leveraged for
 * Groundfloor Labs offerings, I.E. third-party originated financial securities.
 */
export type GeneralizedSecurityInvestmentPurchaseMetadataArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/**
 * Categorized, generalized securities; currently this model is only leveraged for
 * Groundfloor Labs offerings, I.E. third-party originated financial securities.
 */
export type GeneralizedSecurityInvestmentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<InvestmentState>;
};


/**
 * Categorized, generalized securities; currently this model is only leveraged for
 * Groundfloor Labs offerings, I.E. third-party originated financial securities.
 */
export type GeneralizedSecurityMostRecentPurchasedAtForAccountArgs = {
  accountSecureId: Scalars['ID']['input'];
};

/** Category for GeneralizedSecurity */
export type GeneralizedSecurityCategory = {
  __typename?: 'GeneralizedSecurityCategory';
  defaultMinUnitsPerAccount: Scalars['Int']['output'];
  defaultUnitPriceCents: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  generalizedSecurityType?: Maybe<GeneralizedSecurityTypeName>;
  graduated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GeneralizedSecurityCategoryAuthorAttributes = {
  defaultMinUnitsPerAccount: Scalars['Int']['input'];
  defaultUnitPriceCents: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  generalizedSecurityType?: InputMaybe<GeneralizedSecurityTypeName>;
  name: Scalars['String']['input'];
};

export type GeneralizedSecurityCategoryModifyAttributes = {
  defaultMinUnitPerAccount?: InputMaybe<Scalars['Int']['input']>;
  defaultUnitPriceCents?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  generalizedSecurityType?: InputMaybe<GeneralizedSecurityTypeName>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralizedSecurityInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disbursementType?: InputMaybe<DisbursementTypeName>;
  externalCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  generalizedSecurityCategoryId?: InputMaybe<Scalars['ID']['input']>;
  goLiveAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  investmentMultiple?: InputMaybe<Scalars['Float']['input']>;
  listingFee?: InputMaybe<Scalars['Float']['input']>;
  minimumUnitsPerAccount?: InputMaybe<Scalars['Int']['input']>;
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  targetReturn?: InputMaybe<Scalars['Float']['input']>;
  termMonths?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitPriceCents?: InputMaybe<Scalars['Int']['input']>;
};

export enum GeneralizedSecurityTypeName {
  CashFlowAdvance = 'CASH_FLOW_ADVANCE',
  ConstructionEquity = 'CONSTRUCTION_EQUITY',
  FlagshipIndexCohort = 'FLAGSHIP_INDEX_COHORT',
  GrowthIndex = 'GROWTH_INDEX',
  GrowthIndexSidecar = 'GROWTH_INDEX_SIDECAR',
  HomeEquityInvestment = 'HOME_EQUITY_INVESTMENT',
  LandAdvance = 'LAND_ADVANCE',
  LongTermRentalEquity = 'LONG_TERM_RENTAL_EQUITY',
  MonthlyIncomeIndex = 'MONTHLY_INCOME_INDEX',
  PortfolioResale = 'PORTFOLIO_RESALE',
  RenovationEquity = 'RENOVATION_EQUITY',
  RentalPortfolio = 'RENTAL_PORTFOLIO',
  SecondLienFinancing = 'SECOND_LIEN_FINANCING',
  ShortTermRentalEquity = 'SHORT_TERM_RENTAL_EQUITY'
}

/** Categorized general equity */
export type GeneralizedSecurityV1 = Security & {
  __typename?: 'GeneralizedSecurityV1';
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** The minimum that must be purchased */
  amountMinInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  category?: Maybe<GeneralizedSecurityCategory>;
  description?: Maybe<Scalars['String']['output']>;
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
  /** Interest rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  targetReturn?: Maybe<Scalars['Float']['output']>;
  /** Length of time to projected maturity in months from loan effectivedate */
  term: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Includes investment results, generally in a month-by-month format, for UI graphs */
export type Gf3PerformanceDashboard = {
  __typename?: 'Gf3PerformanceDashboard';
  /** @deprecated Why are you using this?  Stop it. */
  accountSecureId?: Maybe<Scalars['ID']['output']>;
  /** the current diversification quotient for the account. */
  currentDiversificationQuotient: Scalars['Float']['output'];
  errors?: Maybe<Array<Error>>;
  monthlyRepayments?: Maybe<Array<Gf3RepaymentMonth>>;
  /** the previous diversification quotient as of the for the account, used to show a change in dq over time. */
  previousDiversificationQuotient: Scalars['Float']['output'];
};

/** A single month's repayment data */
export type Gf3RepaymentMonth = {
  __typename?: 'Gf3RepaymentMonth';
  annualizedReturnRate: Scalars['Float']['output'];
  /** Amount of cumulative interest (cents) earned at this point in the year. */
  cumulativeInterestCents: Scalars['Int']['output'];
  /** Amount of interest (cents) that was earned this month */
  interestCents: Scalars['Int']['output'];
  /** 1 - 12, for sorting purposes */
  month: Scalars['Int']['output'];
  /** January, February, etc. */
  monthName: Scalars['String']['output'];
  /** Amount of principal (cents) that was repaid this month */
  principalCents: Scalars['Int']['output'];
  /** Four-digit integer year for sorting purposes */
  year: Scalars['Int']['output'];
};

/** Groundfloor equity securities offered at a certain share price to investors. */
export type GroundfloorEquityOffering = Security & {
  __typename?: 'GroundfloorEquityOffering';
  /** Amount that security is for */
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  /** Interest rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** Length of time to projected maturity in months from loan effectivedate */
  term: Scalars['Int']['output'];
};

/** A transfer restrited, funding source that can be used to purchase investments */
export type GroundfloorInternalRestrictedFund = BankAccount & {
  __typename?: 'GroundfloorInternalRestrictedFund';
  accountType?: Maybe<Scalars['String']['output']>;
  bankAccountFeatures: Array<BankAccountFeature>;
  bankName?: Maybe<Scalars['String']['output']>;
  connectedTrustlines: Array<Trustline>;
  descriptiveName: Scalars['String']['output'];
  errors: Array<BankAccountError>;
  id: Scalars['ID']['output'];
  last4Digits?: Maybe<Scalars['String']['output']>;
  /** Have associated micro deposits posted to users bank account. */
  microDepositsPosted: Scalars['Boolean']['output'];
  state: BankAccountState;
  uuid: Scalars['ID']['output'];
  verificationAttempts: Scalars['Int']['output'];
  verificationLevel: BankAccountVerificationLevel;
};

/** A funding source that can be used to purchase investments */
export type GroundfloorInvestorAccount = BankAccount & {
  __typename?: 'GroundfloorInvestorAccount';
  accountType?: Maybe<Scalars['String']['output']>;
  bankAccountFeatures: Array<BankAccountFeature>;
  bankName?: Maybe<Scalars['String']['output']>;
  connectedTrustlines: Array<Trustline>;
  descriptiveName: Scalars['String']['output'];
  errors: Array<BankAccountError>;
  id: Scalars['ID']['output'];
  last4Digits?: Maybe<Scalars['String']['output']>;
  /** Have associated micro deposits posted to users bank account. */
  microDepositsPosted: Scalars['Boolean']['output'];
  state: BankAccountState;
  uuid: Scalars['ID']['output'];
  verificationAttempts: Scalars['Int']['output'];
  verificationLevel: BankAccountVerificationLevel;
};

/** A GROUNDFLOOR note debt security offering (old version). */
export type GroundfloorNote = Security & {
  __typename?: 'GroundfloorNote';
  /** Amount that security is for */
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  disbursementType?: Maybe<DisbursementTypeName>;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  /** Interest rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** Length of time to projected maturity in months from loan effectivedate */
  term: Scalars['Int']['output'];
};

export type GroundfloorNoteCreateAttributes = {
  activeOfferingSummaryUrl?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Int']['input'];
  descriptiveTitle: Scalars['String']['input'];
  disbursementType?: InputMaybe<DisbursementTypeName>;
  externalCloseDate: Scalars['Date']['input'];
  goLiveAt: Scalars['ISO8601DateTime']['input'];
  loanEffectiveOn: Scalars['Date']['input'];
  loanMaturesOn: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  securityAgreementUrl?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['Int']['input'];
};

export type GroundfloorNoteUpdateAttributes = {
  activeOfferingSummaryUrl?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  descriptiveTitle?: InputMaybe<Scalars['String']['input']>;
  externalCloseDate?: InputMaybe<Scalars['Date']['input']>;
  goLiveAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  loanEffectiveOn?: InputMaybe<Scalars['Date']['input']>;
  loanMaturesOn?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  securityAgreementUrl?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
};

/** A GROUNDFLOOR note debt security offering. */
export type GroundfloorNoteV2 = SecurityV2 & {
  __typename?: 'GroundfloorNoteV2';
  /** The percentage of an account's portfolio which is made up of investments in this security. */
  accountCommitmentsPortfolioPercentage?: Maybe<Scalars['Float']['output']>;
  activeOfferingSummaryUrl?: Maybe<Scalars['String']['output']>;
  /** The maximum amount investable in the note */
  amountCents: Scalars['Int']['output'];
  /** The amount that has been invested in the security in cents. */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** The amount remaining until the security has been fully funded. */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** Page/application content for the security. */
  contents: Array<SecurityContent>;
  /** The creation timestamp of the security. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The title of the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  disbursementType?: Maybe<DisbursementTypeName>;
  /** The date the security will no longer be available on the platform */
  externalCloseOn?: Maybe<Scalars['Date']['output']>;
  /** External partners for this security */
  externalPartners: Array<ExternalPartner>;
  /** The date the loan was funded */
  fundsPostedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the security will be available on the platform */
  goLiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the schedule which produced this note */
  groundfloorNoteScheduleId?: Maybe<Scalars['Int']['output']>;
  /** The URL of the note's icon image. */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** The primary key of the security. */
  id: Scalars['ID']['output'];
  /** Purchase constraints and other information for an investment in a particular account. */
  investmentPurchaseMetadata?: Maybe<InvestmentPurchaseMetadata>;
  /** Investments that have been made in the security. */
  investments: Array<Investment>;
  /** Updates for the investors on the progress of the project. */
  investorUpdates: Array<InvestorUpdate>;
  /** The number of people that have made an investment in the security. */
  investorsCount: Scalars['Int']['output'];
  /** The time at which the lenders were repaid. */
  lendersRepaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The marketing category that the security has been assigned to. */
  marketingCategory?: Maybe<MarketingCategory>;
  /** The date on which the security is expected to be repaid. */
  maturityDate?: Maybe<Scalars['Date']['output']>;
  /** Minimum number of units needed to purchase a GFN. */
  minUnitsPerAccount?: Maybe<Scalars['Int']['output']>;
  /** The date the security was most recently purchased */
  mostRecentPurchasedAtForAccount?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name or title of the security. */
  name: Scalars['String']['output'];
  /** Regulation for the Offering */
  offeringRegulation?: Maybe<Scalars['String']['output']>;
  /** The interest rate of the note. */
  rate: Scalars['Float']['output'];
  /** Remaining days for funding. */
  remainingDays: Scalars['Int']['output'];
  /** Name of SecBatch of the GFN */
  secBatchName?: Maybe<Scalars['String']['output']>;
  /** The date the sec_batch was qualified by sec */
  secBatchQualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the sec_batch was submitted to sec */
  secBatchSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether security is Tier 1 or not */
  secBatchTier1: Scalars['Boolean']['output'];
  securityAgreementUrl?: Maybe<Scalars['String']['output']>;
  /** The date the security began acrring interest */
  securityEffectiveOn?: Maybe<Scalars['Date']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** The state of the security. */
  state?: Maybe<Scalars['String']['output']>;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** The term of the debt security in months. */
  termMonths: Scalars['Int']['output'];
  /** The maximum amount investable in the note */
  totalAmountCents: Scalars['Int']['output'];
  /** Increment price to purchase GFN. */
  unitPriceCents?: Maybe<Scalars['Int']['output']>;
  /** The update timestamp of the security. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A GROUNDFLOOR note debt security offering. */
export type GroundfloorNoteV2AccountCommitmentsPortfolioPercentageArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** A GROUNDFLOOR note debt security offering. */
export type GroundfloorNoteV2InvestmentPurchaseMetadataArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** A GROUNDFLOOR note debt security offering. */
export type GroundfloorNoteV2InvestmentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<InvestmentState>;
};


/** A GROUNDFLOOR note debt security offering. */
export type GroundfloorNoteV2MostRecentPurchasedAtForAccountArgs = {
  accountSecureId: Scalars['ID']['input'];
};

/** Autogenerated input type of HaltFundsTransfers */
export type HaltFundsTransfersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The secure ID of the affected user. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of HaltFundsTransfers. */
export type HaltFundsTransfersPayload = {
  __typename?: 'HaltFundsTransfersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** documents hosted outside our system */
export type HostedDocument = Timestamp & {
  __typename?: 'HostedDocument';
  account: Account;
  bucket?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  documentType: Scalars['String']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type HostedDocumentAttributes = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<HostedDocumentDocument>;
  etag?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export enum HostedDocumentDocument {
  /** Articles of incorporation */
  ArticlesOfIncorporation = 'ARTICLES_OF_INCORPORATION',
  /** By laws */
  Bylaws = 'BYLAWS',
  /** Experience workshoort */
  ExperienceWorksheet = 'EXPERIENCE_WORKSHEET',
  /** Identity Card */
  IdentityCard = 'IDENTITY_CARD',
  /** Investment transfer */
  InvestmentTransfer = 'INVESTMENT_TRANSFER',
  /** Driver's License */
  License = 'LICENSE',
  /** Other */
  Other = 'OTHER',
  /** Passport */
  Passport = 'PASSPORT'
}

/** An image attachment. */
export type Image = Attachment & {
  __typename?: 'Image';
  /** The attachment's file-type. */
  fileType?: Maybe<Scalars['String']['output']>;
  /** The primary key of the attachment. */
  id: Scalars['ID']['output'];
  /** The URL of the attachment. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of InitiateMicroDepositVerification */
export type InitiateMicroDepositVerificationInput = {
  /** The account number of the bank account to be verified. */
  accountNumber: Scalars['String']['input'];
  /** Secure Id of the Account the bank account will be connected to. Required if no trustline_id provided. */
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of bank account (checking or savings). */
  accountType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  /** The routing number of the financial institution the account belongs to. */
  routingNumber: Scalars['String']['input'];
  /** The ID of the trustline that the bank account will be connected to. */
  trustlineId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of InitiateMicroDepositVerification. */
export type InitiateMicroDepositVerificationPayload = {
  __typename?: 'InitiateMicroDepositVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<MicroDepositVerificationError>>;
  trustline?: Maybe<Trustline>;
};

/** Autogenerated input type of InitiatePartialRepayment */
export type InitiatePartialRepaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  finalPayment: Scalars['Boolean']['input'];
  returnOfCapitalCents: Scalars['Int']['input'];
  securityId: Scalars['Int']['input'];
  totalPaymentAmountCents: Scalars['Int']['input'];
  transactionDescriptor?: InputMaybe<RepaymentTransactionDescriptor>;
};

/** Autogenerated return type of InitiatePartialRepayment. */
export type InitiatePartialRepaymentPayload = {
  __typename?: 'InitiatePartialRepaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  partialRepayment?: Maybe<PartialRepayment>;
};

/** Typically a fractional purchase in a Security */
export type Investment = Timestamp & {
  __typename?: 'Investment';
  /** Account that purchased the investment */
  account: Account;
  /** The ID of the Account that purchased the investment */
  accountId: Scalars['Int']['output'];
  /** The amount of interest that has accrued based on the days held */
  accuredInterestCents: Scalars['Int']['output'];
  /** The actual annualized rate of return on the investment as a whole percentage, so 10.5 = 10.5% */
  actualRate?: Maybe<Scalars['Float']['output']>;
  /** The actual term of the investment in months. */
  actualTermMonths?: Maybe<Scalars['Float']['output']>;
  /**
   * The purchase amount weighted on an annualized basis.  This is only useful if
   * you want to calculate annualized return.  Will be null if not repaid.
   */
  actualWeightedPurchaseAmountCents?: Maybe<Scalars['Float']['output']>;
  /** Indicates if the investment is an automatic reinvestment */
  automaticReinvestment: Scalars['Boolean']['output'];
  /** Indicates if the investment is currently allowed to be cancelled by the Account that performed the purchase */
  cancellable: Scalars['Boolean']['output'];
  /** Date the investment was closed */
  closedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Credits from the investment for cancellations, rejections, refunds, repayments or interest payments */
  credits?: Maybe<Array<Maybe<Credit>>>;
  /** Debits made to fund the investment */
  debits?: Maybe<Array<Maybe<Debit>>>;
  /** metadata for convertable debt investments */
  debtConversion?: Maybe<DebtConversion>;
  /** The amount of interest the investmment should pay if fully matured */
  expectedInterestCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if the investment was issued as a promotion */
  isPromotional: Scalars['Boolean']['output'];
  /**
   * The amount of money currently invested in the security. I.E. The total amount
   * invested minus the repaid principal (return-of-capital) to-date.
   */
  moneyAtWorkCents: Scalars['Int']['output'];
  /** The actual, total, net earnings on the investment.  Will be null if the investment is not repaid. */
  netEarningsCents?: Maybe<Scalars['Float']['output']>;
  /** Amount of promotions granted for meeting certain criteria */
  promotionsAmountCents: Scalars['Int']['output'];
  /**
   * Number of units (shares) for the promotions amount, determined by the
   * SecurityPurchaseConfiguration unit_price or defaults to $10.00
   */
  promotionsUnitCount: Scalars['Float']['output'];
  /** Amount Invested in the security offering */
  purchaseAmountCents: Scalars['Int']['output'];
  /** Date the investment was purchased */
  purchasedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Interest rate of the investment */
  rate: Scalars['Float']['output'];
  /** The total amount that has been repaid. */
  repaidAmountCents: Scalars['Int']['output'];
  /** Date the investment was repaid. */
  repaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The amount of interest that has been repaid */
  repaidInterestCents: Scalars['Int']['output'];
  /** The interest paid on promotional funds invested */
  repaidPromotionsInterestCents: Scalars['Int']['output'];
  /** The principal paid on the loan's repayment */
  repaidPurchaseAmountCents: Scalars['Int']['output'];
  /** The interest paid on for their principal investment */
  repaidPurchaseInterestCents: Scalars['Int']['output'];
  /** The outcome type of the repayment, such as repaid in full or repaid without interest */
  repaymentOutcomeType?: Maybe<RepaymentOutcome>;
  /** A collection of repayments that have been made for the investment. */
  repayments: Array<InvestmentRepayment>;
  /** Security offering the investment was made in */
  security: Security;
  /** The ID of the Security offering the investment was made in */
  securityId?: Maybe<Scalars['Int']['output']>;
  /** Configuration at the time of  purchase, unit_price, mins, etc */
  securityPurchaseConfiguration?: Maybe<SecurityPurchaseConfiguration>;
  /** Security offering the investment was made in */
  securityV2: SecurityV2;
  /** Current state of the investment's purchase */
  state: InvestmentState;
  /** Payments on the investment */
  totalPaymentsAmountCents: Scalars['Int']['output'];
  /** The publically viewable transaction detail */
  transactionNumber: Scalars['ID']['output'];
  /**
   * Number of units (shares) the investment represents, determined by the
   * SecurityPurchaseConfiguration unit_price or defaults to $10.00
   */
  unitCount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The UUID of the investment */
  uuid: Scalars['ID']['output'];
};

export type InvestmentCollection = {
  __typename?: 'InvestmentCollection';
  /** An array of investments */
  investments?: Maybe<Array<Investment>>;
  paginationMetadata: PaginationMetadata;
};

/** The connection type for Investment. */
export type InvestmentConnection = {
  __typename?: 'InvestmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvestmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Investment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type InvestmentDataPoint = {
  /** The dollar amount at the end of the date. */
  amountCents: Scalars['BigInt']['output'];
  /** The date! */
  date: Scalars['ISO8601Date']['output'];
  /** The number of active investments at the end of the date. */
  investmentCount: Scalars['Int']['output'];
  /** The subgrouping of the data point, if any.  Only used if specified in the query. */
  subgrouping?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type InvestmentEdge = {
  __typename?: 'InvestmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Investment>;
};

export enum InvestmentGrouping {
  BorrowerExperienceScore = 'BORROWER_EXPERIENCE_SCORE',
  GeographicRegion = 'GEOGRAPHIC_REGION',
  LoanPerformance = 'LOAN_PERFORMANCE',
  LoanRating = 'LOAN_RATING',
  LoanToValueScoreRangeOfTwo = 'LOAN_TO_VALUE_SCORE_RANGE_OF_TWO',
  RepaymentMonth = 'REPAYMENT_MONTH',
  RepaymentOutcome = 'REPAYMENT_OUTCOME',
  SecuritySubtype = 'SECURITY_SUBTYPE'
}

export type InvestmentPortfolioBreakdown = {
  __typename?: 'InvestmentPortfolioBreakdown';
  advancePercentage: Scalars['Float']['output'];
  flagshipIndexPercentage: Scalars['Float']['output'];
  labsPercentage: Scalars['Float']['output'];
  lroPercentage: Scalars['Float']['output'];
  notePercentage: Scalars['Float']['output'];
  stockPercentage: Scalars['Float']['output'];
};

/** Provides purchase contraints and other information for an investment in a particular account. */
export type InvestmentPurchaseMetadata = {
  __typename?: 'InvestmentPurchaseMetadata';
  maximumInvestmentAmountCents: Scalars['Int']['output'];
  minimumInvestmentAmountCents: Scalars['Int']['output'];
  moneyAtWorkCents: Scalars['Int']['output'];
};

export type InvestmentRepayment = {
  __typename?: 'InvestmentRepayment';
  gainCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reinvestments: Array<Investment>;
  returnOfCapitalCents: Scalars['Int']['output'];
  state: InvestmentRepaymentState;
  totalAmountPaidCents: Scalars['Int']['output'];
};

export enum InvestmentRepaymentState {
  Applied = 'APPLIED',
  Applying = 'APPLYING',
  Cancelled = 'CANCELLED',
  Deferred = 'DEFERRED',
  Disbursed = 'DISBURSED',
  Disbursing = 'DISBURSING',
  Scheduled = 'SCHEDULED',
  Staged = 'STAGED'
}

/** An automatic investing range, up to an amount in a grade */
export type InvestmentSchedule = {
  __typename?: 'InvestmentSchedule';
  /** The Investor account */
  account: Account;
  /** grade of loans to invest in */
  grade: LoanGrades;
  /** grouping for investment schedules */
  groupTag?: Maybe<Scalars['String']['output']>;
  /** ID of the investment schedule */
  id: Scalars['ID']['output'];
  /** max investment in any loan */
  maxPurchaseAmountCents: Scalars['Int']['output'];
  /** max investment in any loan in currenty format */
  maxPurchaseAmountCurrency: Scalars['String']['output'];
  /** whether schedule is active or not */
  state: InvestmentScheduleState;
  /** the associated User */
  user: User;
};

export enum InvestmentScheduleState {
  /** The Schedule is actively investing in loans */
  Active = 'ACTIVE',
  /** The Schedule is paused from investing in loans */
  Paused = 'PAUSED'
}

export enum InvestmentScope {
  Open = 'OPEN',
  Repaid = 'REPAID',
  RepaidInDefault = 'REPAID_IN_DEFAULT'
}

export type InvestmentSortAttributes = {
  field: InvestmentSortField;
  order: Order;
};

export enum InvestmentSortField {
  CreatedAt = 'createdAt',
  Id = 'id',
  PurchaseAmountCents = 'purchaseAmountCents',
  RepaidAt = 'repaidAt',
  UpdatedAt = 'updatedAt'
}

export enum InvestmentState {
  /** Investment has been cancelled and funds creditted back */
  Cancelled = 'CANCELLED',
  /** Investor has started cancellation of investment */
  PendingCancel = 'PENDING_CANCEL',
  /** Credit is being provisioned to cancel or reject investment */
  PendingCredit = 'PENDING_CREDIT',
  /** In the process of debiting purchase amount */
  PendingDebit = 'PENDING_DEBIT',
  /** Purchase process is pending to be started */
  PendingPurchase = 'PENDING_PURCHASE',
  /** Investment is actively purchased. */
  Purchased = 'PURCHASED',
  /** Queued in investment purchase clearing */
  QueuedToPurchase = 'QUEUED_TO_PURCHASE',
  /** Debit(s) for purchase amount has posted */
  ReadyToPurchase = 'READY_TO_PURCHASE',
  /** rejected by user or clearing and purchase amount has been creditted back */
  Rejected = 'REJECTED',
  /** Rejecting Investment due to not clearing or Investor does not want it in the case of automatic investing */
  Rejecting = 'REJECTING',
  /** Investment has been repaid to investor */
  Repaid = 'REPAID'
}

/** Records details of the investment wizard choices */
export type InvestmentWizardFilterOption = Timestamp & {
  __typename?: 'InvestmentWizardFilterOption';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The purchase order resulting from the opts */
  purchaeOrder: PurchaseOrder;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** An object for users' investment wizard strategy presets. */
export type InvestmentWizardStrategy = {
  __typename?: 'InvestmentWizardStrategy';
  atMaxInvestment: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  excludeJudicialForeclosures: Scalars['Boolean']['output'];
  /** The minimum and maximum values for each loan's experience score */
  experience: MinMaxRange;
  id: Scalars['ID']['output'];
  /** The letter grades of the loans to be shown by the investment wizard. */
  loanFilterGrades: Array<LoanGrades>;
  /** The minimum and maximum values for each loan's loan-to-arv score */
  loanToArv: MinMaxRange;
  name: Scalars['String']['output'];
  /** Whether or not loans that the user has already invested in should be excluded. */
  onlyNeverInvested: Scalars['Boolean']['output'];
  /** The minimum and maximum values for each loan's skin-in-the-game score */
  skinInTheGame: MinMaxRange;
  /** The type of strategy that was initially chosen by the user. */
  strategyType: InvestmentWizardStrategyTypeName;
};

/** An input object for users' investment wizard strategy presets. */
export type InvestmentWizardStrategyInput = {
  atMaxInvestment: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  excludeJudicialForeclosures: Scalars['Boolean']['input'];
  /** The minimum and maximum values for each loan's experience score */
  experience: MinMaxRangeInput;
  /** The letter grades for the loans that will be selected by the given strategy. */
  loanFilterGrades: Array<LoanGrades>;
  /** The minimum and maximum values for each loan's loan-to-arv score */
  loanToArv: MinMaxRangeInput;
  name: Scalars['String']['input'];
  /** Whether or not the strategy should filter out loans that the user has already invested in. */
  onlyNeverInvested: Scalars['Boolean']['input'];
  /** The minimum and maximum values for each loan's skin-in-the-game score */
  skinInTheGame: MinMaxRangeInput;
  /** The initially selected type for an investment wizard strategy. */
  strategyType: InvestmentWizardStrategyTypeName;
};

export enum InvestmentWizardStrategyTypeName {
  Conservative = 'CONSERVATIVE',
  Custom = 'CUSTOM',
  Dynamic = 'DYNAMIC',
  Moderate = 'MODERATE'
}

export enum InvestorAccount {
  /** GF2 Investor Account */
  Investor = 'investor',
  /** GF3 Investor Account */
  InvestorAuto = 'investor_auto'
}

/** A summary of investor activities and totals. */
export type InvestorActivitySummary = {
  __typename?: 'InvestorActivitySummary';
  /**
   * A summary of all open investments regardless of type
   * @deprecated Use customSummary instead
   */
  allOpenInvestmentsSummary: InvestorSummaryRollup;
  /**
   * Returns the aggregate of categorized transactions for this account over the
   * given time frame and granularity.  Each data point represents a category of
   * transactions on a given date.
   */
  cashFlowOverTime: CashFlowChartData;
  /** A custom summary of investments */
  customSummary: Array<InvestorSummaryRollupGroup>;
  equityHoldings: Array<InvestorSummaryEquityHolding>;
  /** Data points that can be graphed to show the total money invested over an arbitrary timeframe */
  moneyAtWorkOverTime: Array<ActiveInvestmentDataPoint>;
  /**
   * Data points that can be graphed to show the total money invested over an
   * arbitrary timeframe using the subtype of the security
   */
  moneyAtWorkOverTimeBySubtype: Array<ActiveInvestmentDataPoint>;
  /** @deprecated Use customSummary instead */
  openAdvancesInvestmentsSummary: InvestorSummaryRollup;
  /** @deprecated Use customSummary instead */
  openCdnAndNoteInvestmentsSummary: InvestorSummaryRollup;
  /** @deprecated Use customSummary instead */
  openCdnInvestmentsSummary: InvestorSummaryRollup;
  /** @deprecated Use customSummary instead */
  openGeneralizedSecurityInvestmentsSummary: InvestorSummaryRollup;
  /** @deprecated Use customSummary instead */
  openIndexInvestmentsSummary: InvestorSummaryRollup;
  /**
   * A summary of open Generalized Security investments that are not in Advances or Indexes
   * @deprecated Use customSummary instead
   */
  openLabsInvestmentsSummary: InvestorSummaryRollup;
  /**
   * More granular details on open LRO investments
   * @deprecated just... don't
   */
  openLoanInvestmentsDetails: OpenInvestmentsSummary;
  /** @deprecated Use customSummary instead */
  openLoanInvestmentsSummary: InvestorSummaryRollup;
  /**
   * A summary of open LRO investments broken down by state or provice or territory or something
   * @deprecated Use customSummary instead
   */
  openLoansInvestmentsSummaryByGeographicRegion: Array<InvestorSummaryPerformanceByGeographicalRegion>;
  /** @deprecated Use customSummary instead */
  openNoteInvestmentsSummary: InvestorSummaryRollup;
  /**
   * A summary of LRO investments broken down by grade
   * @deprecated Use customSummary instead
   */
  performanceByGrade: Array<InvestorSummaryPerformanceByGrade>;
  /** @deprecated Use customSummary instead */
  repaidCdnInvestmentsSummary: InvestorSummaryRollup;
  /** @deprecated Use customSummary instead */
  repaidGeneralizedSecurityInvestmentsSummary: InvestorSummaryRollup;
  /** More granular details on repaid or refunded LRO investments */
  repaidLoanInvestmentsDetails: RepaidInvestmentsSummary;
  /** @deprecated Use customSummary instead */
  repaidLoanInvestmentsSummary: InvestorSummaryRollup;
  /** @deprecated Use customSummary instead */
  repaidNoteInvestmentsSummary: InvestorSummaryRollup;
};


/** A summary of investor activities and totals. */
export type InvestorActivitySummaryCashFlowOverTimeArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  granularity: DateGraphGranularity;
  lookbackDays: Scalars['Int']['input'];
};


/** A summary of investor activities and totals. */
export type InvestorActivitySummaryCustomSummaryArgs = {
  input: CustomSummaryInput;
};


/** A summary of investor activities and totals. */
export type InvestorActivitySummaryMoneyAtWorkOverTimeArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  filterIndex?: InputMaybe<Scalars['Boolean']['input']>;
  granularity: DateGraphGranularity;
  lookbackDays: Scalars['Int']['input'];
  securityTypes?: InputMaybe<Array<SecurityTypeName>>;
};


/** A summary of investor activities and totals. */
export type InvestorActivitySummaryMoneyAtWorkOverTimeBySubtypeArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  granularity: DateGraphGranularity;
  groupedBySubtype?: InputMaybe<Scalars['Boolean']['input']>;
  investmentSources?: InputMaybe<Array<Source>>;
  lookbackDays: Scalars['Int']['input'];
  securitySubtypes?: InputMaybe<Array<SecuritySubtypeName>>;
};

/** An Investor Dashboard with a list of LROs, with meta-data concerning the page number, total number of pages etc. */
export type InvestorDashboardDataset = {
  __typename?: 'InvestorDashboardDataset';
  /** The paginated collection of LROs */
  lros: Array<Loan>;
  /** Information regarding the paginated results */
  paginationMetadata: PaginationMetadata;
};

export type InvestorDashboardFilters = {
  /** Restricts dataset to LROs of the specified rating */
  grade?: InputMaybe<LoanGrades>;
  /** Restricts dataset to LROs with rate <= provided value */
  rateMax?: InputMaybe<Scalars['Float']['input']>;
  /** Restricts dataset to LROs with rate >= provided value */
  rateMin?: InputMaybe<Scalars['Float']['input']>;
};

export type InvestorDashboardInput = {
  /** Filters for filtering Loans */
  filters?: InputMaybe<InvestorDashboardFilters>;
  paginationAttributes?: InputMaybe<PaginationAttributes>;
  /** The top level tab when filtering Loans */
  tab?: InputMaybe<InvestorDashboardTab>;
};

export enum InvestorDashboardTab {
  /** All LROs the user can currently invest in. */
  All = 'ALL',
  /** All LROs the user can invest in but exluding already invested LROs. */
  Available = 'AVAILABLE',
  /** Includes all LROs the user has invested in. This does not include repaid LROs. */
  Invested = 'INVESTED'
}

/** A collection of information related to an investor. */
export type InvestorProfile = Timestamp & {
  __typename?: 'InvestorProfile';
  apartmentComplex?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  duplex?: Maybe<Scalars['Boolean']['output']>;
  experience?: Maybe<Scalars['String']['output']>;
  howDidYouHear?: Maybe<Scalars['String']['output']>;
  howResponse?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interestedInIra?: Maybe<Scalars['Boolean']['output']>;
  investmentLevel?: Maybe<Scalars['String']['output']>;
  investorType?: Maybe<Scalars['String']['output']>;
  land?: Maybe<Scalars['Boolean']['output']>;
  liquidNetWorth?: Maybe<Scalars['String']['output']>;
  lodgingResort?: Maybe<Scalars['Boolean']['output']>;
  multifamily?: Maybe<Scalars['Boolean']['output']>;
  objectives?: Maybe<Scalars['String']['output']>;
  office?: Maybe<Scalars['Boolean']['output']>;
  regionsOfInterest?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<Scalars['Boolean']['output']>;
  retail?: Maybe<Scalars['Boolean']['output']>;
  singleFamilyForLease?: Maybe<Scalars['Boolean']['output']>;
  singleFamilyForSale?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type InvestorProfileInput = {
  apartmentComplex?: InputMaybe<Scalars['Boolean']['input']>;
  duplex?: InputMaybe<Scalars['Boolean']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  howResponse?: InputMaybe<Scalars['String']['input']>;
  investmentLevel?: InputMaybe<Scalars['String']['input']>;
  investorType?: InputMaybe<Scalars['String']['input']>;
  land?: InputMaybe<Scalars['Boolean']['input']>;
  liquidNetWorth?: InputMaybe<Scalars['String']['input']>;
  lodgingResort?: InputMaybe<Scalars['Boolean']['input']>;
  multifamily?: InputMaybe<Scalars['Boolean']['input']>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  office?: InputMaybe<Scalars['Boolean']['input']>;
  regionsOfInterest?: InputMaybe<Scalars['String']['input']>;
  restaurant?: InputMaybe<Scalars['Boolean']['input']>;
  retail?: InputMaybe<Scalars['Boolean']['input']>;
  singleFamilyForLease?: InputMaybe<Scalars['Boolean']['input']>;
  singleFamilyForSale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvestorRepayment = {
  __typename?: 'InvestorRepayment';
  realizedReturnAmount: Scalars['Float']['output'];
  repaidAt: Scalars['ISO8601DateTime']['output'];
  returnOfCapitalAmount: Scalars['Float']['output'];
  securitySubtype: SecuritySubtypeName;
  totalAmount: Scalars['Float']['output'];
  transactionId: Scalars['String']['output'];
};

export type InvestorRepaymentCollection = {
  __typename?: 'InvestorRepaymentCollection';
  investorRepayments: Array<InvestorRepayment>;
  paginationMetadata: PaginationMetadata;
};

/** Status of a yield investor's rewards */
export type InvestorRewardStatus = {
  __typename?: 'InvestorRewardStatus';
  /** The yield note interest rate the investor is currently eligble for based on their current rewards */
  currentRewardInterestRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Funds Transfer Schedule has been removed */
  daysTilFundsTransferScheduleReward?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of days until the user's rewards go into effect. If user is
   * accruing time towards multiple rewards, the number of days until all such
   * rewards go into effect is returned
   */
  daysTilInterestRateIncrease?: Maybe<Scalars['Int']['output']>;
  daysTilRoundupReward?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Funds Transfer Schedule has been removed */
  fundsTransferScheduleReward: Scalars['Boolean']['output'];
  /**
   * The yield note interest rate the investor will be eligible for when the
   * rewards that the investor is currenly accruing time for are earned
   */
  interestRateAfterIncrease?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Funds Transfer Schedule has been removed */
  manualFundsTransferScheduleRewardExpiresOn?: Maybe<Scalars['String']['output']>;
  manualRoundupRewardExpiresOn?: Maybe<Scalars['String']['output']>;
  roundupReward: Scalars['Boolean']['output'];
};

/** A summary of an investor's equity holdings. */
export type InvestorSummaryEquityHolding = {
  __typename?: 'InvestorSummaryEquityHolding';
  costBasisCents: Scalars['Int']['output'];
  currentSharePriceCents: Scalars['Int']['output'];
  sharesCount: Scalars['Float']['output'];
  thirdPartyEquityName?: Maybe<Scalars['String']['output']>;
};

/** A summary of an investor's investments per U.S. State, territory, district, colony, duchy, province, etc. */
export type InvestorSummaryPerformanceByGeographicalRegion = {
  __typename?: 'InvestorSummaryPerformanceByGeographicalRegion';
  actualRateOfReturn?: Maybe<Scalars['Float']['output']>;
  amountCents: Scalars['Long']['output'];
  /**
   * An alias of expectedRateOfReturn used for backwards compatibility
   * @deprecated use expectedRateOfReturn instead
   */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /**
   * An alias of securityCount used for backwards compatibility
   * @deprecated Ambiguous field name.  Use securityCount instead.
   */
  count: Scalars['Int']['output'];
  /** Total cents of interest accrued but not paid out */
  expectedAccruedInterestCents: Scalars['Float']['output'];
  expectedEarningsCents?: Maybe<Scalars['Long']['output']>;
  /** Total cents of interest being earned per second */
  expectedInterestCentsPerSecond: Scalars['Float']['output'];
  expectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  groupKey?: Maybe<Scalars['String']['output']>;
  /** The number of investments */
  investmentCount: Scalars['Int']['output'];
  /**
   * An alias of securityCount used for backwards compatibility
   * @deprecated use securityCount instead
   */
  loansCount: Scalars['Int']['output'];
  netEarningsCents?: Maybe<Scalars['Long']['output']>;
  portfolioPercentage?: Maybe<Scalars['Float']['output']>;
  region: Scalars['String']['output'];
  /** The total repaid interest in all the investments */
  repaidInterestCents?: Maybe<Scalars['Long']['output']>;
  /** The total repaid principal in all the investments */
  repaidPrincipalCents?: Maybe<Scalars['Long']['output']>;
  /** The number of securities invested in */
  securityCount: Scalars['Int']['output'];
  totalPaymentsAmountCents: Scalars['Long']['output'];
};

/** A summary of an investor's investments per letter-grade */
export type InvestorSummaryPerformanceByGrade = {
  __typename?: 'InvestorSummaryPerformanceByGrade';
  actualRateOfReturn?: Maybe<Scalars['Float']['output']>;
  amountCents: Scalars['Long']['output'];
  /**
   * An alias of expectedRateOfReturn used for backwards compatibility
   * @deprecated use expectedRateOfReturn instead
   */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /**
   * An alias of securityCount used for backwards compatibility
   * @deprecated Ambiguous field name.  Use securityCount instead.
   */
  count: Scalars['Int']['output'];
  /** Total cents of interest accrued but not paid out */
  expectedAccruedInterestCents: Scalars['Float']['output'];
  expectedEarningsCents?: Maybe<Scalars['Long']['output']>;
  /** Total cents of interest being earned per second */
  expectedInterestCentsPerSecond: Scalars['Float']['output'];
  expectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  groupKey?: Maybe<Scalars['String']['output']>;
  /** The number of investments */
  investmentCount: Scalars['Int']['output'];
  letterGrade: Scalars['String']['output'];
  /**
   * An alias of securityCount used for backwards compatibility
   * @deprecated use securityCount instead
   */
  loansCount: Scalars['Int']['output'];
  netEarningsCents?: Maybe<Scalars['Long']['output']>;
  portfolioPercentage?: Maybe<Scalars['Float']['output']>;
  /** The total repaid interest in all the investments */
  repaidInterestCents?: Maybe<Scalars['Long']['output']>;
  /** The total repaid principal in all the investments */
  repaidPrincipalCents?: Maybe<Scalars['Long']['output']>;
  /** The number of securities invested in */
  securityCount: Scalars['Int']['output'];
  totalPaymentsAmountCents: Scalars['Long']['output'];
};

/** A rollup of investment data. */
export type InvestorSummaryRollup = {
  __typename?: 'InvestorSummaryRollup';
  actualRateOfReturn?: Maybe<Scalars['Float']['output']>;
  amountCents: Scalars['Long']['output'];
  /**
   * An alias of expectedRateOfReturn used for backwards compatibility
   * @deprecated use expectedRateOfReturn instead
   */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /**
   * An alias of securityCount used for backwards compatibility
   * @deprecated Ambiguous field name.  Use securityCount instead.
   */
  count: Scalars['Int']['output'];
  /** Total cents of interest accrued but not paid out */
  expectedAccruedInterestCents: Scalars['Float']['output'];
  expectedEarningsCents?: Maybe<Scalars['Long']['output']>;
  /** Total cents of interest being earned per second */
  expectedInterestCentsPerSecond: Scalars['Float']['output'];
  expectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  /** The number of investments */
  investmentCount: Scalars['Int']['output'];
  /**
   * An alias of securityCount used for backwards compatibility
   * @deprecated use securityCount instead
   */
  loansCount: Scalars['Int']['output'];
  netEarningsCents?: Maybe<Scalars['Long']['output']>;
  portfolioPercentage?: Maybe<Scalars['Float']['output']>;
  /** The total repaid interest in all the investments */
  repaidInterestCents?: Maybe<Scalars['Long']['output']>;
  /** The total repaid principal in all the investments */
  repaidPrincipalCents?: Maybe<Scalars['Long']['output']>;
  /** The number of securities invested in */
  securityCount: Scalars['Int']['output'];
  totalPaymentsAmountCents: Scalars['Long']['output'];
};

/** A summary of an investor's investments broken down by an arbitrary field */
export type InvestorSummaryRollupGroup = {
  __typename?: 'InvestorSummaryRollupGroup';
  actualRateOfReturn?: Maybe<Scalars['Float']['output']>;
  amountCents: Scalars['Long']['output'];
  /**
   * An alias of expectedRateOfReturn used for backwards compatibility
   * @deprecated use expectedRateOfReturn instead
   */
  blendedRate?: Maybe<Scalars['Float']['output']>;
  /**
   * An alias of securityCount used for backwards compatibility
   * @deprecated Ambiguous field name.  Use securityCount instead.
   */
  count: Scalars['Int']['output'];
  /** Total cents of interest accrued but not paid out */
  expectedAccruedInterestCents: Scalars['Float']['output'];
  expectedEarningsCents?: Maybe<Scalars['Long']['output']>;
  /** Total cents of interest being earned per second */
  expectedInterestCentsPerSecond: Scalars['Float']['output'];
  expectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  groupKey?: Maybe<Scalars['String']['output']>;
  /** The number of investments */
  investmentCount: Scalars['Int']['output'];
  /**
   * An alias of securityCount used for backwards compatibility
   * @deprecated use securityCount instead
   */
  loansCount: Scalars['Int']['output'];
  netEarningsCents?: Maybe<Scalars['Long']['output']>;
  portfolioPercentage?: Maybe<Scalars['Float']['output']>;
  /** The total repaid interest in all the investments */
  repaidInterestCents?: Maybe<Scalars['Long']['output']>;
  /** The total repaid principal in all the investments */
  repaidPrincipalCents?: Maybe<Scalars['Long']['output']>;
  /** The number of securities invested in */
  securityCount: Scalars['Int']['output'];
  totalPaymentsAmountCents: Scalars['Long']['output'];
};

/** An automatic investing range, up to an amount in a grade */
export type InvestorUpdate = {
  __typename?: 'InvestorUpdate';
  /** The effective date of the update */
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** string of html */
  html: Scalars['String']['output'];
  /** ID of the investor update */
  id: Scalars['ID']['output'];
  /** Images associated with the update */
  images: Array<Image>;
  /** The time that the record was published or updated last. */
  lastUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the associated Loan */
  loan: Loan;
  /** The progress update this update is associated with */
  progressUpdate: ProgressUpdate;
  /** the associated Security */
  security: Security;
  /** whether update is unpublished, published, or archived */
  state: InvestorUpdateState;
};

export enum InvestorUpdateState {
  /** The update is archived */
  Archived = 'ARCHIVED',
  /** The update is published */
  Published = 'PUBLISHED',
  /** The update is unpublished */
  Unpublished = 'UNPUBLISHED'
}

export type IraBankAccount = BankAccount & {
  __typename?: 'IraBankAccount';
  accountType?: Maybe<Scalars['String']['output']>;
  bankAccountFeatures: Array<BankAccountFeature>;
  bankName?: Maybe<Scalars['String']['output']>;
  connectedTrustlines: Array<Trustline>;
  descriptiveName: Scalars['String']['output'];
  errors: Array<BankAccountError>;
  id: Scalars['ID']['output'];
  last4Digits?: Maybe<Scalars['String']['output']>;
  /** Have associated micro deposits posted to users bank account. */
  microDepositsPosted: Scalars['Boolean']['output'];
  state: BankAccountState;
  uuid: Scalars['ID']['output'];
  verificationAttempts: Scalars['Int']['output'];
  verificationLevel: BankAccountVerificationLevel;
};

/** IRA Custodians for IRA accounts from IRA Services */
export type IraCustodian = {
  __typename?: 'IraCustodian';
  /** Address for IRA Custodian */
  address: Address;
  id: Scalars['ID']['output'];
  /** Name of the IRA Custodian */
  name: Scalars['String']['output'];
  /** Phone number for IRA Custodian */
  phoneNumber: Scalars['String']['output'];
  /** Provider ID for IRA Custodian */
  providerId?: Maybe<Scalars['String']['output']>;
};

export type IraCustomer = Customer & {
  __typename?: 'IraCustomer';
  address?: Maybe<Address>;
  id: Scalars['ID']['output'];
  state: CustomerState;
  trustline: Trustline;
  verified: Scalars['Boolean']['output'];
};

/** Autogenerated input type of IssueApiConsumerJwt */
export type IssueApiConsumerJwtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of IssueApiConsumerJwt. */
export type IssueApiConsumerJwtPayload = {
  __typename?: 'IssueApiConsumerJwtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  jwt?: Maybe<Jwt>;
};

/** Autogenerated input type of IssueEmployeeJwt */
export type IssueEmployeeJwtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  credentials: CredentialAttributes;
};

/** Autogenerated return type of IssueEmployeeJwt. */
export type IssueEmployeeJwtPayload = {
  __typename?: 'IssueEmployeeJwtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  jwt?: Maybe<Jwt>;
};

/** Autogenerated input type of IssueUserGhostJwt */
export type IssueUserGhostJwtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of IssueUserGhostJwt. */
export type IssueUserGhostJwtPayload = {
  __typename?: 'IssueUserGhostJwtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  jwt?: Maybe<Jwt>;
};

/** Autogenerated input type of IssueUserJwt */
export type IssueUserJwtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  credentials: CredentialAttributes;
  /**
   * Used to determine where the redirect for the instant link should lead the user
   * @deprecated We don't care where this login came from
   */
  mfaSourceApplication?: InputMaybe<MfaSourceApplication>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of IssueUserJwt. */
export type IssueUserJwtPayload = {
  __typename?: 'IssueUserJwtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<AuthenticationError>>;
  jwt?: Maybe<Jwt>;
  /** If MFA is required for login, a new MFA Attempt will be triggered and returned */
  mfaAttempt?: Maybe<MfaAttempt>;
};

/** Static, stubbed values for the transfer and Invest promotion */
export type JulyTransferInvestPromotion = {
  __typename?: 'JulyTransferInvestPromotion';
  earnedAmountCents: Scalars['Int']['output'];
  investedAmountCents: Scalars['Int']['output'];
  promoVisible: Scalars['Boolean']['output'];
  transferredAmountCents: Scalars['Int']['output'];
};

export type Jwt = {
  __typename?: 'Jwt';
  jwt: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export enum KycState {
  /** The user can transact and has completed KYC */
  ActiveHasCompletedKyc = 'ACTIVE_HAS_COMPLETED_KYC',
  /** The user can transact but has not completed full KYC */
  ActiveHasNotCompletedKyc = 'ACTIVE_HAS_NOT_COMPLETED_KYC',
  /** Something has gone wrong */
  Broken = 'BROKEN',
  /** User must provide documentation to complete KYC */
  DocumentationRequired = 'DOCUMENTATION_REQUIRED',
  /** User must provide additional information to complete KYC */
  InformationRequired = 'INFORMATION_REQUIRED',
  /** Pending a response from our KYC provider. Both registration and verification flows can result in a pending state. */
  Pending = 'PENDING'
}

export type LeafPurchaseOrderAttributes = {
  amountCents: Scalars['Int']['input'];
  securityId: Scalars['Int']['input'];
};

/** Information on the borrower used for closing */
export type LendingBorrowerEntity = {
  __typename?: 'LendingBorrowerEntity';
  account?: Maybe<Account>;
  /** Their number of aged unsold units. */
  agedUnsoldUnitsCount: Scalars['Int']['output'];
  /** The number of projects that the borrower has completed in the past. */
  completedProjectsCount: Scalars['Int']['output'];
  dateOfFormation?: Maybe<Scalars['Date']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name of the borrower entity */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Their gross margin as a percentage. */
  grossMarginPercentage?: Maybe<Scalars['Float']['output']>;
  hasMoreOnePrincipal?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the lending_borrower_entity */
  id: Scalars['ID']['output'];
  /** Their revenue in cents. */
  revenueCents: Scalars['BigInt']['output'];
  stateOfFormation?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
  /** The total debt that the borrower has in cents. */
  totalDebtCents: Scalars['BigInt']['output'];
  /** The combined value of all of the borrower's properties in cents. */
  totalInventoryValueCents: Scalars['BigInt']['output'];
  /** Their number of unsold units. */
  unsoldUnitsCount: Scalars['Int']['output'];
};

export type LendingBorrowerEntityAttributes = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  dateOfFormation?: InputMaybe<Scalars['Date']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hasMoreOnePrincipal?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stateOfFormation?: InputMaybe<Scalars['String']['input']>;
};

export type LendingDataConversionInput = {
  address: AddressAttributes;
  borrowerEntity: BorrowerEntityAttributes;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  lendingLoanApplicationId: Scalars['Int']['input'];
  loan: LoanInput;
  loanApplication: LoanApplicationAttributes;
  minimumUnitsPerAccount?: InputMaybe<Scalars['Int']['input']>;
  originationFee?: InputMaybe<OriginationFeeInput>;
  principal: PrincipalAttributes;
  unitPriceCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Limited Recourse Obligation (LRO), debt security offered to investors */
export type LendingLoan = LendingSecurity & {
  __typename?: 'LendingLoan';
  /** the address of the loan */
  address: Address;
  /** Amount that security is for */
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** borrower commitment grade factor */
  borrowerCommitmentScore?: Maybe<Scalars['Int']['output']>;
  /** borrower experience score grade factor */
  borrowerExperienceScore: Scalars['Int']['output'];
  calculatedPortfolioAmountCents?: Maybe<Scalars['Int']['output']>;
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  constructionSecondaryDrawAmountCents?: Maybe<Scalars['Int']['output']>;
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The loan application belonging to the loan. */
  lendingLoanApplication: LendingLoanApplication;
  /** loan to value grade factor */
  loanToValueScore: Scalars['Int']['output'];
  /** The Loan compared to the valuation basis (value/arv) */
  loanValuationPercent?: Maybe<Scalars['Float']['output']>;
  /** location score grade factor */
  locationScore: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  /** indicates when interest is paid */
  paymentType: LoanPayment;
  /** The expected date for the loan to mature. */
  projectedMaturityDate?: Maybe<Scalars['Date']['output']>;
  /** Expected repayment date. */
  projectedRepaymentOn?: Maybe<Scalars['Date']['output']>;
  /** Photos of the property associated with the loan. */
  propertyPhotos: Array<Image>;
  /** Loans that have been published from this LendingLoan */
  publishedLoans: Array<Loan>;
  /** The reason the borrower is requesting money */
  purpose?: Maybe<LoanPurpose>;
  /** quality of valuation report grade factor */
  qualityOfValuationReportScore: Scalars['Int']['output'];
  /** Interest rate */
  rate: Scalars['Float']['output'];
  /** Letter rating to indicate the risk of the Loan */
  rating: Scalars['String']['output'];
  /** ratings grade factor */
  ratingsScore?: Maybe<Scalars['Int']['output']>;
  /** The repayment position of the loan. */
  repaymentPosition?: Maybe<Scalars['Int']['output']>;
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** skin in the game score grade factor */
  skinInTheGameScore: Scalars['Int']['output'];
  /** The slug which represents the loan's link on the platform */
  slug: Scalars['String']['output'];
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** the term of the lending loan */
  term: Scalars['Int']['output'];
  /** Abbreviation of the valuation method used */
  valuationAbbrev: LoanValuationAbbreviation;
  /** Label for  the valuation method used */
  valuationLabel: LoanValuationLabel;
  /** Value derived from valuation method */
  valuationValue: Scalars['Float']['output'];
};

/** Describes a potential loan between GROUNDFLOOR and a borrower. */
export type LendingLoanApplication = {
  __typename?: 'LendingLoanApplication';
  address?: Maybe<Address>;
  adverseLegalJudgment?: Maybe<Scalars['Boolean']['output']>;
  afterRepairValue?: Maybe<Scalars['Float']['output']>;
  afterRepairValueBasedOn?: Maybe<Scalars['String']['output']>;
  afterRepairValueCents?: Maybe<Scalars['Int']['output']>;
  agreementAccepted?: Maybe<Scalars['String']['output']>;
  /** The product SKU of the loan application */
  applicationSku?: Maybe<ApplicationSku>;
  attorneyFeeCents: Scalars['Int']['output'];
  bankruptcy?: Maybe<Scalars['Boolean']['output']>;
  /** assigned BDM */
  bdm?: Maybe<AdminUser>;
  borrowerEquityCents?: Maybe<Scalars['Int']['output']>;
  /** Keeps track of whether the loan app is brokered */
  brokered?: Maybe<Scalars['Boolean']['output']>;
  /** down payment amount */
  cashDownPayment?: Maybe<Scalars['Float']['output']>;
  /** down payment in cents */
  cashDownPaymentCents?: Maybe<Scalars['Int']['output']>;
  cashToClose?: Maybe<Scalars['Float']['output']>;
  /** time the CLA was approved */
  claApprovedAt?: Maybe<Scalars['Date']['output']>;
  /** time the CLA was sent */
  claSentAt?: Maybe<Scalars['Date']['output']>;
  closingDetail?: Maybe<ClosingDetail>;
  contractEndDate?: Maybe<Scalars['Date']['output']>;
  /** value of property at purchase */
  contractPurchasePrice?: Maybe<Scalars['Float']['output']>;
  contractPurchasePriceCents?: Maybe<Scalars['Int']['output']>;
  convincedOfAFelony?: Maybe<Scalars['Boolean']['output']>;
  /** The primary image that is shown for the loan application */
  coverImage?: Maybe<Image>;
  /** summary of the loan-transaction */
  dealSummary?: Maybe<Scalars['String']['output']>;
  /** amount for closing */
  downPaymentAmount?: Maybe<Scalars['Float']['output']>;
  existingLoanPayoffCents?: Maybe<Scalars['Int']['output']>;
  exitStrategy?: Maybe<Scalars['String']['output']>;
  feesRolledIn: Scalars['Boolean']['output'];
  foreclosure?: Maybe<Scalars['Boolean']['output']>;
  /** initial disbursement at closing */
  groundfloorDay1?: Maybe<Scalars['Float']['output']>;
  guarantors?: Maybe<Array<LendingPrincipal>>;
  /** ID of the application */
  id: Scalars['ID']['output'];
  initialAmountRequestedCents?: Maybe<Scalars['Int']['output']>;
  /** first draw */
  initialDisbursement?: Maybe<Scalars['String']['output']>;
  interestType?: Maybe<LendingLoanApplicationInterest>;
  /** key_loan_feature field from Salesforce */
  keyLoanFeature?: Maybe<Scalars['String']['output']>;
  lendingBorrowerEntity?: Maybe<LendingBorrowerEntity>;
  /** lending_origination_fee associated to object */
  lendingOriginationFee?: Maybe<LendingOriginationFee>;
  lendingPrincipal?: Maybe<LendingPrincipal>;
  loanApplicationConditions?: Maybe<Array<LoanApplicationCondition>>;
  /** The current state of the application, as represented in the loan tracker */
  loanTrackerState?: Maybe<LoanTrackerState>;
  /** loan amount over ARV */
  ltarv?: Maybe<Scalars['Float']['output']>;
  /** loan amount over project cost */
  ltc?: Maybe<Scalars['Float']['output']>;
  /** loan amount over value */
  ltv?: Maybe<Scalars['Float']['output']>;
  monthlyInterestPayment?: Maybe<Scalars['Float']['output']>;
  /** current stage in salesforce */
  opportunityState?: Maybe<LoanApplicationOpportunityState>;
  originalPurchaseDate?: Maybe<Scalars['Date']['output']>;
  /** The status of the origination flow */
  originationState?: Maybe<LoanApplicationOriginationState>;
  ownershipStatus?: Maybe<Scalars['String']['output']>;
  /** how often payments will be made */
  paymentType?: Maybe<Scalars['String']['output']>;
  preapprovals?: Maybe<Array<Preapproval>>;
  processingFeeCents: Scalars['Int']['output'];
  propertyType?: Maybe<Scalars['String']['output']>;
  /** value of the property as-is */
  propertyValue?: Maybe<Scalars['Float']['output']>;
  propertyValueCents?: Maybe<Scalars['Int']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  /** Interest rate for the loan */
  rate?: Maybe<Scalars['Float']['output']>;
  rateModifier?: Maybe<Scalars['Float']['output']>;
  /** grade of the loan */
  rating?: Maybe<Scalars['String']['output']>;
  /** The version of the engine this was rated under */
  ratingEngineVersion?: Maybe<Scalars['String']['output']>;
  /** AKA LIP Escrow Holdback */
  rehabFundsNeeded?: Maybe<Scalars['Float']['output']>;
  /** our lien on the property */
  securityPosition?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  state: LendingLoanApplicationState;
  stateEvents: Array<LendingLoanApplicationStateEvents>;
  /** loan application as submitted */
  submittedVersion?: Maybe<SubmittedLoanApplication>;
  supportingDocuments?: Maybe<Array<Asset>>;
  targetClosingDate?: Maybe<Scalars['Date']['output']>;
  tasks: Array<Task>;
  /** length of time the loan will last */
  term?: Maybe<Scalars['String']['output']>;
  /** The current term sheet for the application */
  termSheet?: Maybe<TermSheet>;
  /** loan amount with fees */
  totalAmountWithFees?: Maybe<Scalars['Float']['output']>;
  /** total amount of the loan */
  totalLoanAmount?: Maybe<Scalars['Float']['output']>;
  totalProjectCost?: Maybe<Scalars['Float']['output']>;
  totalRehabBudget?: Maybe<Scalars['Float']['output']>;
  totalRehabBudgetCents?: Maybe<Scalars['Int']['output']>;
  underwritingFeeCents: Scalars['Int']['output'];
  /** keep track of CLA status */
  underwritingState?: Maybe<LoanApplicationUnderwritingState>;
};

export type LendingLoanApplicationAttributes = {
  afterRepairValueCents?: InputMaybe<Scalars['Int']['input']>;
  agreementAccepted?: InputMaybe<Scalars['String']['input']>;
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  contractPurchasePriceCents?: InputMaybe<Scalars['Int']['input']>;
  dealSummary?: InputMaybe<Scalars['String']['input']>;
  downPaymentAmountCents?: InputMaybe<Scalars['Int']['input']>;
  existingLoanPayoffCents?: InputMaybe<Scalars['Int']['input']>;
  exitStrategy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initialAmountRequestedCents?: InputMaybe<Scalars['Int']['input']>;
  interestType?: InputMaybe<LendingLoanApplicationInterest>;
  originalPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  ownershipStatus?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  propertyValueCents?: InputMaybe<Scalars['Int']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  rateModifier?: InputMaybe<Scalars['Float']['input']>;
  targetClosingDate?: InputMaybe<Scalars['Date']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  totalRehabBudgetCents?: InputMaybe<Scalars['Int']['input']>;
};

export enum LendingLoanApplicationInterest {
  InterestOnDisbursement = 'INTEREST_ON_DISBURSEMENT',
  Other = 'OTHER',
  Standard = 'STANDARD',
  TransactionalFunding = 'TRANSACTIONAL_FUNDING'
}

export enum LendingLoanApplicationState {
  /** No activity for N days */
  ApplicationAbandoned = 'APPLICATION_ABANDONED',
  /** Closing issues addressed and ready to close */
  ApplicationClearedToClose = 'APPLICATION_CLEARED_TO_CLOSE',
  /** Closed and no longer in servicing */
  ApplicationCompleted = 'APPLICATION_COMPLETED',
  /** Processed and ready for underwriting */
  ApplicationProcessed = 'APPLICATION_PROCESSED',
  /** Qualified by sales, awaiting submission */
  ApplicationQualified = 'APPLICATION_QUALIFIED',
  /** Major issue arose which prevented moving forward */
  ApplicationRejected = 'APPLICATION_REJECTED',
  /** Live application, being serviced by Asset Management */
  ApplicationServicingStarted = 'APPLICATION_SERVICING_STARTED',
  /** Submitted into processing flow */
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  /** Underwritten and ready for closing prep */
  ApplicationUnderwritten = 'APPLICATION_UNDERWRITTEN',
  /** Unqualified application, awaiting sales */
  ApplicationUnqualified = 'APPLICATION_UNQUALIFIED'
}

export enum LendingLoanApplicationStateEvents {
  /** Marks the application as abandoned */
  AbandonApplication = 'ABANDON_APPLICATION',
  /** Marks the application as cleared to close */
  ClearToCloseApplication = 'CLEAR_TO_CLOSE_APPLICATION',
  /** Marks the application as complete */
  CompleteApplication = 'COMPLETE_APPLICATION',
  /** Submits the application for underwriting */
  ProcessApplication = 'PROCESS_APPLICATION',
  /** Marks the application as qualified, before submission */
  QualifyApplication = 'QUALIFY_APPLICATION',
  /** Marks the application as rejected */
  RejectApplication = 'REJECT_APPLICATION',
  /** Marks the application as ready to begin servicing */
  StartServicingApplication = 'START_SERVICING_APPLICATION',
  /** Submits the application for processing */
  SubmitApplication = 'SUBMIT_APPLICATION',
  /** Submits the application for closing prep */
  UnderwriteApplication = 'UNDERWRITE_APPLICATION'
}

/** Describes a lending_origination_fee object */
export type LendingOriginationFee = {
  __typename?: 'LendingOriginationFee';
  /** total bips including groundfoor and broker */
  bips: Scalars['Int']['output'];
  /** fees amount for broker */
  brokerAmountCents: Scalars['Int']['output'];
  /** broker points on lending_loan_application */
  brokerBips: Scalars['Int']['output'];
  /** total fees including groundfloor and broker */
  fees: Scalars['Int']['output'];
  /** fees amount for groundfloor */
  groundfloorAmountCents: Scalars['Int']['output'];
  /** groundfloor points on lending_loan_application */
  groundfloorBips: Scalars['Int']['output'];
  /** minimum fee */
  minimumCents: Scalars['Int']['output'];
  /** have the fee and bips been customized? */
  overridden: Scalars['Boolean']['output'];
  /** Total fees including groundfloor and broker and rolled in fees, in cents. */
  totalFeesRolledIn: Scalars['Int']['output'];
};

/** Information of the pricipal for a loan */
export type LendingPrincipal = {
  __typename?: 'LendingPrincipal';
  /** ID of the associated account */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** The address that is associated with the principal */
  address?: Maybe<Address>;
  /** The number of projects that they complete per year on average. */
  annuallyCompletedProjectsAverageCount?: Maybe<Scalars['Int']['output']>;
  /** How much their projects typically cost in cents. */
  averageProjectCostCents?: Maybe<Scalars['Int']['output']>;
  /** The amount that their projects have sold for on average. */
  averageProjectSalesPriceCents?: Maybe<Scalars['Int']['output']>;
  /** How long their projects have taken to complete on average. */
  averageProjectsDurationMonths?: Maybe<Scalars['Int']['output']>;
  /** The date of birth for the principal */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** Email of the principal */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the principal */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The number of the their loans that have been funded or repaid. */
  fundedOrRepaidLoansCount: Scalars['Int']['output'];
  /** ID of the principal */
  id: Scalars['ID']['output'];
  /** First name of the principal */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The credit score of the principal */
  personalCreditScore?: Maybe<Scalars['String']['output']>;
  /** Phone number of the principal */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Strategic focus of the principal */
  principalStrategicFocus?: Maybe<Scalars['String']['output']>;
  /** The number of their loans that have been repaid. */
  repaidLoansCount: Scalars['Int']['output'];
  /** How often their projects are repaid on time as a percentage. */
  repaymentPercentage?: Maybe<Scalars['Float']['output']>;
  /** Social Security Number of the principal */
  ssn?: Maybe<Scalars['String']['output']>;
  /** State of the principal */
  state?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
  /** Principals experience */
  totalProjectsCompleted?: Maybe<Scalars['Int']['output']>;
};

export type LendingPrincipalAttributes = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  personalCreditScore?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  principalStrategicFocus?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  totalProjectsCompleted?: InputMaybe<Scalars['Int']['input']>;
};

export type LendingSecurity = {
  /** Amount that security is for */
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  /** Interest rate */
  rate: Scalars['Float']['output'];
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** Length of time to projected maturity in months from loan effectivedate */
  term: Scalars['Int']['output'];
};

/** Limited Recourse Obligation (LRO), debt security offered to investors */
export type Loan = Security & {
  __typename?: 'Loan';
  /** the address of the loan */
  address: Address;
  /** Amount that security is for */
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** borrower experience score grade factor */
  borrowerExperienceScore: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The maturity date of the loan. */
  loanMaturesOn?: Maybe<Scalars['Date']['output']>;
  /** The Loan amount compared to the skin in the game. */
  loanToCostPercent?: Maybe<Scalars['Float']['output']>;
  /** loan to value grade factor */
  loanToValueScore: Scalars['Int']['output'];
  /** The Loan compared to the valuation basis (value/arv) */
  loanValuationPercent?: Maybe<Scalars['Float']['output']>;
  /** location score grade factor */
  locationScore: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  /** indicates when interest is paid */
  paymentType: LoanPayment;
  /** The state of the loan's performance. */
  performanceState: Scalars['String']['output'];
  portfolioAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The reason the borrower is requesting money */
  purpose?: Maybe<LoanPurpose>;
  /** quality of valuation report grade factor */
  qualityOfValuationReportScore: Scalars['Int']['output'];
  /** Interest rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Letter rating to indicate the risk of the Loan */
  rating: Scalars['String']['output'];
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** skin in the game score grade factor */
  skinInTheGameScore: Scalars['Int']['output'];
  /** The slug which represents the loan's link on the platform */
  slug: Scalars['String']['output'];
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** Length of time to projected maturity in months from loan effectivedate */
  term: Scalars['Int']['output'];
  /** Abbreviation of the valuation method used */
  valuationAbbrev: LoanValuationAbbreviation;
  /** Label for  the valuation method used */
  valuationLabel: LoanValuationLabel;
  /** Value derived from valuation method */
  valuationValue: Scalars['Float']['output'];
};

/** Describes a potential loan between GROUNDFLOOR and a borrower. */
export type LoanApplication = {
  __typename?: 'LoanApplication';
  address?: Maybe<Address>;
  adverseLegalJudgment?: Maybe<Scalars['Boolean']['output']>;
  afterRepairValue?: Maybe<Scalars['Float']['output']>;
  afterRepairValueCents?: Maybe<Scalars['Int']['output']>;
  agreementAccepted?: Maybe<Scalars['String']['output']>;
  bankruptcy?: Maybe<Scalars['Boolean']['output']>;
  /** assigned BDM */
  bdm?: Maybe<AdminUser>;
  borrowerEntity?: Maybe<BorrowerEntity>;
  /** Keeps track of whether the loan app is brokered */
  brokered?: Maybe<Scalars['Boolean']['output']>;
  /** down payment amount */
  cashDownPayment?: Maybe<Scalars['Float']['output']>;
  /** down payment in cents */
  cashDownPaymentCents?: Maybe<Scalars['Int']['output']>;
  cashToClose?: Maybe<Scalars['Float']['output']>;
  /** time the CLA was approved */
  claApprovedAt?: Maybe<Scalars['Date']['output']>;
  /** time the CLA was sent */
  claSentAt?: Maybe<Scalars['Date']['output']>;
  contractEndDate?: Maybe<Scalars['Date']['output']>;
  /** value of property at purchase */
  contractPurchasePrice?: Maybe<Scalars['Float']['output']>;
  contractPurchasePriceCents?: Maybe<Scalars['Int']['output']>;
  convincedOfAFelony?: Maybe<Scalars['Boolean']['output']>;
  /** The primary image that is shown for the loan application */
  coverImage?: Maybe<Image>;
  /** summary of the loan-transaction */
  dealSummary?: Maybe<Scalars['String']['output']>;
  /** amount for closing */
  downPaymentAmount?: Maybe<Scalars['Float']['output']>;
  existingLoanPayoffCents?: Maybe<Scalars['Int']['output']>;
  exitStrategy?: Maybe<Scalars['String']['output']>;
  foreclosure?: Maybe<Scalars['Boolean']['output']>;
  /** initial disbursement at closing */
  groundfloorDay1?: Maybe<Scalars['Float']['output']>;
  /** ID of the application */
  id: Scalars['ID']['output'];
  initialAmountRequestedCents?: Maybe<Scalars['Int']['output']>;
  /** first draw */
  initialDisbursement?: Maybe<Scalars['String']['output']>;
  /** key_loan_feature field from Salesforce */
  keyLoanFeature?: Maybe<Scalars['String']['output']>;
  loanApplicationConditions?: Maybe<Array<LoanApplicationCondition>>;
  /** loan amount over project cost */
  ltc?: Maybe<Scalars['Float']['output']>;
  /** loan amount over ARV */
  ltv?: Maybe<Scalars['Float']['output']>;
  monthlyInterestPayment?: Maybe<Scalars['Float']['output']>;
  /** current stage in salesforce */
  opportunityState?: Maybe<LoanApplicationOpportunityState>;
  originalPurchaseDate?: Maybe<Scalars['Date']['output']>;
  /** percentage of fees applied to the loan */
  originationFee?: Maybe<Scalars['Float']['output']>;
  /** percentage points of the fee */
  originationPoints?: Maybe<Scalars['String']['output']>;
  /** The status of the origination flow */
  originationState?: Maybe<LoanApplicationOriginationState>;
  ownershipStatus?: Maybe<Scalars['String']['output']>;
  /** how often payments will be made */
  paymentType?: Maybe<Scalars['String']['output']>;
  preapprovals?: Maybe<Array<Preapproval>>;
  principal?: Maybe<Principal>;
  propertyType?: Maybe<Scalars['String']['output']>;
  /** value of the property as-is */
  propertyValue?: Maybe<Scalars['Float']['output']>;
  propertyValueCents?: Maybe<Scalars['Int']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  /** Interest rate for the loan */
  rate?: Maybe<Scalars['Float']['output']>;
  /** grade of the loan */
  rating?: Maybe<Scalars['String']['output']>;
  /** AKA LIP Escrow Holdback */
  rehabFundsNeeded?: Maybe<Scalars['Float']['output']>;
  /** our lien on the property */
  securityPosition?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  state: LoanApplicationState;
  /** loan application as submitted */
  submittedVersion?: Maybe<SubmittedLoanApplication>;
  supportingDocuments?: Maybe<Array<Asset>>;
  targetClosingDate?: Maybe<Scalars['Date']['output']>;
  /** length of time the loan will last */
  term?: Maybe<Scalars['String']['output']>;
  /** loan amount with fees */
  totalAmountWithFees?: Maybe<Scalars['Float']['output']>;
  /** total amount of the loan */
  totalLoanAmount?: Maybe<Scalars['Float']['output']>;
  totalProjectCost?: Maybe<Scalars['Float']['output']>;
  totalRehabBudget?: Maybe<Scalars['Float']['output']>;
  totalRehabBudgetCents?: Maybe<Scalars['Int']['output']>;
  /** keep track of CLA status */
  underwritingState?: Maybe<LoanApplicationUnderwritingState>;
};

export type LoanApplicationAttributes = {
  afterRepairValueBasedOn?: InputMaybe<Scalars['String']['input']>;
  afterRepairValueCents?: InputMaybe<Scalars['Int']['input']>;
  agreementAccepted?: InputMaybe<Scalars['String']['input']>;
  completedSincePurchaseCents?: InputMaybe<Scalars['Int']['input']>;
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  contractPurchasePriceCents?: InputMaybe<Scalars['Int']['input']>;
  dealSummary?: InputMaybe<Scalars['String']['input']>;
  existingLoanPayoffCents?: InputMaybe<Scalars['Int']['input']>;
  exitStrategy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initialAmountRequestedCents?: InputMaybe<Scalars['Int']['input']>;
  keyLoanFeature?: InputMaybe<Scalars['String']['input']>;
  originalPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  ownershipStatus?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  propertyValueCents?: InputMaybe<Scalars['Int']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  rehabFundsNeededCents?: InputMaybe<Scalars['Int']['input']>;
  securityPosition?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  targetClosingDate?: InputMaybe<Scalars['Date']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  totalRehabBudgetCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Requirements that the borrower mustfilfil to close */
export type LoanApplicationCondition = {
  __typename?: 'LoanApplicationCondition';
  /** A timestamp indicating if/when the condition has been completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  condition?: Maybe<Condition>;
  /** The default description of the condition */
  description: Scalars['String']['output'];
  /** ID of the condition */
  id: Scalars['ID']['output'];
  lendingLoanApplication?: Maybe<LendingLoanApplication>;
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A promotion which allows borrowers to submit loan applications without paying the usual fee. */
export type LoanApplicationFeeWaiverPromotion = {
  __typename?: 'LoanApplicationFeeWaiverPromotion';
  /** Whether or not the promotion is currently active. */
  active: Scalars['Boolean']['output'];
  /** The ID of the promotion. */
  id: Scalars['Int']['output'];
};

export enum LoanApplicationOpportunityState {
  /** Loan is ready to close */
  ClearToClose = 'CLEAR_TO_CLOSE',
  /** Loan App has closed */
  Closed = 'CLOSED',
  /** CLA ready to send to borrower */
  ConditionalApproval = 'CONDITIONAL_APPROVAL',
  /** This deal has been abandoned */
  Dead = 'DEAD',
  /** Gathering info for closing */
  PendingClose = 'PENDING_CLOSE',
  /** Initial State */
  Qualification = 'QUALIFICATION',
  /** Loan App is getting ready for submission to processing */
  ReSubmission = 'RE_SUBMISSION',
  /** Loan App is ready for Processing */
  Submitted = 'SUBMITTED',
  /** Loan App is being reviewed by Underwriting */
  Underwriting = 'UNDERWRITING'
}

export enum LoanApplicationOriginationState {
  /** Not in use */
  Abandoned = 'ABANDONED',
  /** Loan App is preparing to close */
  Closing = 'CLOSING',
  /** Not in use */
  Completed = 'COMPLETED',
  /** Loan App is showing CLA & Conditions */
  ConditionalApproval = 'CONDITIONAL_APPROVAL',
  /** Borrower is uploading docs */
  Documentation = 'DOCUMENTATION',
  /** Not in use */
  KickedBack = 'KICKED_BACK',
  /** Not in use */
  OnHold = 'ON_HOLD',
  /** Not in use */
  PendingLoanPackage = 'PENDING_LOAN_PACKAGE',
  /** Initial state before use */
  PendingOrigination = 'PENDING_ORIGINATION',
  /** Not in use */
  Rejected = 'REJECTED',
  /** Loan App is underwriting */
  Underwriting = 'UNDERWRITING'
}

export enum LoanApplicationState {
  /** Not in use */
  Abandoned = 'ABANDONED',
  /** Not in use */
  Cancelled = 'CANCELLED',
  /** Not in use */
  Completed = 'COMPLETED',
  /** Not in use */
  MarketReady = 'MARKET_READY',
  /** Not in use */
  PendingMarketReady = 'PENDING_MARKET_READY',
  /** The submission fee has not been payed yet */
  PendingSubmission = 'PENDING_SUBMISSION',
  /** Not in use */
  Rejected = 'REJECTED',
  /** Not in use */
  Servicing = 'SERVICING',
  /** The submission fee has been payed */
  Submitted = 'SUBMITTED'
}

export enum LoanApplicationUnderwritingState {
  /** Not in use */
  Abandoned = 'ABANDONED',
  /** Underwriting has approved the Loan App */
  Approved = 'APPROVED',
  /** Borrower has agreed to CLA */
  BorrowerApproved = 'BORROWER_APPROVED',
  /** Borrower is reviewing CLA */
  BorrowerReview = 'BORROWER_REVIEW',
  /** Underwriting has finished */
  Completed = 'COMPLETED',
  /** Loan App is being held in place */
  OnHold = 'ON_HOLD',
  /** Initial state before use */
  PendingOrigination = 'PENDING_ORIGINATION',
  /** Waiting for Sales to talk to Borrower */
  PendingSales = 'PENDING_SALES',
  /** Underwriting has begun */
  PendingUnderwriting = 'PENDING_UNDERWRITING',
  /** Not in use */
  Rejected = 'REJECTED',
  /** Show underwritten terms to the Borrower */
  RevealTerms = 'REVEAL_TERMS'
}

/** The connection type for Loan. */
export type LoanConnection = {
  __typename?: 'LoanConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LoanEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Loan>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LoanEdge = {
  __typename?: 'LoanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Loan>;
};

export type LoanFeeSchedules = {
  __typename?: 'LoanFeeSchedules';
  schedules: Scalars['String']['output'];
};

export enum LoanGrades {
  /** A */
  A = 'A',
  /** B */
  B = 'B',
  /** C */
  C = 'C',
  /** D */
  D = 'D',
  /** E */
  E = 'E',
  /** F */
  F = 'F',
  /** G */
  G = 'G'
}

export type LoanInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  borrowerCommitmentScore?: InputMaybe<Scalars['Int']['input']>;
  borrowerExperienceScore?: InputMaybe<Scalars['Int']['input']>;
  capitalType?: InputMaybe<Scalars['String']['input']>;
  constructionSecondaryDrawAmountCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  loanEffectiveOn?: InputMaybe<Scalars['Date']['input']>;
  loanMaturesOn?: InputMaybe<Scalars['Date']['input']>;
  loanToValueScore?: InputMaybe<Scalars['Int']['input']>;
  locationScore?: InputMaybe<Scalars['Int']['input']>;
  mortgageInstrument?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portfolioAmountCents?: InputMaybe<Scalars['Int']['input']>;
  projectedRepaymentOn?: InputMaybe<Scalars['Date']['input']>;
  propertyPurchasedOn?: InputMaybe<Scalars['Date']['input']>;
  qualityOfValuationReportScore?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  ratingsScore?: InputMaybe<Scalars['Int']['input']>;
  repaymentPosition?: InputMaybe<Scalars['Int']['input']>;
  riskFactors?: InputMaybe<Scalars['String']['input']>;
  secBatchId?: InputMaybe<Scalars['Int']['input']>;
  skinInTheGameScore?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
};

export enum LoanPayment {
  /** The security's accrued interest is due at maturity */
  DeferredTillDue = 'DEFERRED_TILL_DUE',
  /** The security's accrued interest is due monthly */
  PayMonthly = 'PAY_MONTHLY'
}

export enum LoanPurpose {
  /** Funds used to purchase the land and build */
  AcquisitionAndNewConstruction = 'ACQUISITION_AND_NEW_CONSTRUCTION',
  /** Funds used to construct a new building */
  NewConstruction = 'NEW_CONSTRUCTION',
  /** Funds used to purchase the property */
  Purchase = 'PURCHASE',
  /** Funds used to purchase and renovate the propery */
  PurchaseAndRenovation = 'PURCHASE_AND_RENOVATION',
  /** Funds taken from property value to renovate it */
  RefinanceAndRenovation = 'REFINANCE_AND_RENOVATION',
  /** Funds taken from property value */
  RefinanceCashOut = 'REFINANCE_CASH_OUT'
}

export enum LoanTrackerState {
  /** Application has been processed and is ready for underwriting */
  TrackerApplicationProcessed = 'TRACKER_APPLICATION_PROCESSED',
  /** The loan is cleared to close */
  TrackerClearedToClose = 'TRACKER_CLEARED_TO_CLOSE',
  /** Initial closing details have been prepared */
  TrackerClosingProcessed = 'TRACKER_CLOSING_PROCESSED',
  /** Application submitted but not all docs provided */
  TrackerDocumentationRequired = 'TRACKER_DOCUMENTATION_REQUIRED',
  /** Application submitted and all documentation has been provided */
  TrackerInformationSubmitted = 'TRACKER_INFORMATION_SUBMITTED',
  /** Terms have been agreed to by the borrower and application is awaiting closing */
  TrackerTermsAgreed = 'TRACKER_TERMS_AGREED',
  /** Terms are ready to be viewed by the borrower */
  TrackerTermsReady = 'TRACKER_TERMS_READY',
  /** Terms are ready to be viewed by the borrower */
  TrackerTermsViewed = 'TRACKER_TERMS_VIEWED'
}

export enum LoanValuationAbbreviation {
  /** Loan To After Repair Value */
  Arv = 'ARV',
  /** Loan To Value */
  Ltv = 'LTV'
}

export enum LoanValuationLabel {
  /** ratio of loan to the after repair value */
  LoanToArv = 'LOAN_TO_ARV',
  /** ratio of a loan to the value of an asset purchased */
  LoanToValue = 'LOAN_TO_VALUE'
}

/** The loans in the Flagship Index, grouped by state. */
export type LoansByState = {
  __typename?: 'LoansByState';
  /** Live loans. */
  live: Array<Loan>;
  /** Repaid loans. */
  repaid: Array<Loan>;
};

/** Autogenerated input type of LockUser */
export type LockUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The secure ID of the user being locked down. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of LockUser. */
export type LockUserPayload = {
  __typename?: 'LockUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<User>;
};

/** Determines which business entity is issusing the LROs */
export type LroIssuer = {
  __typename?: 'LroIssuer';
  /** Whether or not the issuer is for an institution */
  forInstitution: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The name of the offering */
  name: Scalars['String']['output'];
};

/** Autogenerated input type of MarkLendingLoanRemoved */
export type MarkLendingLoanRemovedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of MarkLendingLoanRemoved. */
export type MarkLendingLoanRemovedPayload = {
  __typename?: 'MarkLendingLoanRemovedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoan?: Maybe<LendingLoan>;
};

/** Autogenerated input type of MarkLendingLoanRepaid */
export type MarkLendingLoanRepaidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of MarkLendingLoanRepaid. */
export type MarkLendingLoanRepaidPayload = {
  __typename?: 'MarkLendingLoanRepaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoan?: Maybe<LendingLoan>;
};

/** Describes a marketing category for GROUNDFLOOR investments. */
export type MarketingCategory = {
  __typename?: 'MarketingCategory';
  categoryActive: Scalars['Boolean']['output'];
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryDetail?: Maybe<Scalars['String']['output']>;
  categoryDisplayTitle?: Maybe<Scalars['String']['output']>;
  categoryTitle?: Maybe<Scalars['String']['output']>;
  categoryWeight?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  securities: LoanConnection;
};


/** Describes a marketing category for GROUNDFLOOR investments. */
export type MarketingCategorySecuritiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for MarketingCategory. */
export type MarketingCategoryConnection = {
  __typename?: 'MarketingCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MarketingCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MarketingCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MarketingCategoryEdge = {
  __typename?: 'MarketingCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MarketingCategory>;
};

/** an attempted (and maybe successful) multi-factor authentication session. */
export type MfaAttempt = {
  __typename?: 'MfaAttempt';
  /** The channel the mfa message was sent to */
  channel: MfaChannel;
  /** The UTC timestamp that the MFA attempt completed, regardless of success or failure. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** a unique secure ID for this MFA attempt */
  id: Scalars['ID']['output'];
  /** Whether or not the MFA attempt completed sucessfully. */
  isComplete: Scalars['Boolean']['output'];
  /** alias of is_complete. */
  isSuccessful?: Maybe<Scalars['Boolean']['output']>;
  /** The email or phone number the message was sent to, obfuscatd for security. */
  obfuscatedChannelAddress: Scalars['String']['output'];
  /** The UTC timestamp the MFA message was sent to the user */
  requestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The communication channel the user is performing MFA with */
export enum MfaChannel {
  /** The user is sent an email */
  Email = 'EMAIL',
  /** The user is sent a text message */
  Sms = 'SMS'
}

export enum MfaSourceApplication {
  /** The Investor Mobile App */
  InvestorMobile = 'INVESTOR_MOBILE',
  /** The Investor Web App */
  Iwa = 'IWA'
}

/** Object to hold error information for authorization or validations */
export type MicroDepositVerificationError = {
  __typename?: 'MicroDepositVerificationError';
  /** Error code describing the nature of the failure. */
  code?: Maybe<MicroDepositVerificationErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum MicroDepositVerificationErrorCode {
  AccountInBankProbationaryPeriod = 'ACCOUNT_IN_BANK_PROBATIONARY_PERIOD',
  AssociationsImmutable = 'ASSOCIATIONS_IMMUTABLE',
  DuplicateResource = 'DUPLICATE_RESOURCE',
  MicroDepositsMaxAttempts = 'MICRO_DEPOSITS_MAX_ATTEMPTS',
  MicroDepositsPending = 'MICRO_DEPOSITS_PENDING',
  RecaptchaAuthenticationFailed = 'RECAPTCHA_AUTHENTICATION_FAILED',
  RequiredConditionsMissing = 'REQUIRED_CONDITIONS_MISSING',
  ResourceAlreadyVerified = 'RESOURCE_ALREADY_VERIFIED',
  ResourceArchived = 'RESOURCE_ARCHIVED',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  ServerError = 'SERVER_ERROR',
  TrustlineHasBankAccount = 'TRUSTLINE_HAS_BANK_ACCOUNT',
  UnauthorizedClient = 'UNAUTHORIZED_CLIENT',
  ValidationsFailed = 'VALIDATIONS_FAILED'
}

export type MinMaxRange = {
  __typename?: 'MinMaxRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type MinMaxRangeInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type MiscellaneousPdfDocument = PdfDocument & {
  __typename?: 'MiscellaneousPdfDocument';
  account: Account;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: PdfDocumentTypeName;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ModifyAccreditation */
export type ModifyAccreditationInput = {
  accredited: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ModifyAccreditation. */
export type ModifyAccreditationPayload = {
  __typename?: 'ModifyAccreditationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ModifyAddress */
export type ModifyAddressInput = {
  address?: InputMaybe<AddressAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ModifyAddress. */
export type ModifyAddressPayload = {
  __typename?: 'ModifyAddressPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ModifyBorrowerEntity */
export type ModifyBorrowerEntityInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfFormation?: InputMaybe<Scalars['Date']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hasMoreOnePrincipal?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stateOfFormation?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ModifyBorrowerEntity. */
export type ModifyBorrowerEntityPayload = {
  __typename?: 'ModifyBorrowerEntityPayload';
  accountId?: Maybe<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dateOfFormation?: Maybe<Scalars['Date']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasMoreOnePrincipal?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  stateOfFormation?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ModifyClaConditionDescription */
export type ModifyClaConditionDescriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ModifyClaConditionDescription. */
export type ModifyClaConditionDescriptionPayload = {
  __typename?: 'ModifyClaConditionDescriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplicationCondition?: Maybe<LoanApplicationCondition>;
};

/** Autogenerated input type of ModifyClosingDetail */
export type ModifyClosingDetailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  closingDetail: ClosingDetailAttributes;
};

/** Autogenerated return type of ModifyClosingDetail. */
export type ModifyClosingDetailPayload = {
  __typename?: 'ModifyClosingDetailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  closingDetail?: Maybe<ClosingDetail>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ModifyConditionDescription */
export type ModifyConditionDescriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ModifyConditionDescription. */
export type ModifyConditionDescriptionPayload = {
  __typename?: 'ModifyConditionDescriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Condition>;
  errors?: Maybe<Array<Error>>;
};

export type ModifyExternalPartnerAttributes = {
  id: Scalars['Int']['input'];
  partnerDescription?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ModifyExternalPartner */
export type ModifyExternalPartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalPartner: ModifyExternalPartnerAttributes;
};

/** Autogenerated return type of ModifyExternalPartner. */
export type ModifyExternalPartnerPayload = {
  __typename?: 'ModifyExternalPartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  externalPartner?: Maybe<ExternalPartner>;
};

/** Autogenerated input type of ModifyGeneralizedSecurityCategory */
export type ModifyGeneralizedSecurityCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalizedSecurityCategory: GeneralizedSecurityCategoryModifyAttributes;
};

/** Autogenerated return type of ModifyGeneralizedSecurityCategory. */
export type ModifyGeneralizedSecurityCategoryPayload = {
  __typename?: 'ModifyGeneralizedSecurityCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  generalizedSecurityCategory?: Maybe<GeneralizedSecurityCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of ModifyGeneralizedSecurity */
export type ModifyGeneralizedSecurityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalizedSecurity: GeneralizedSecurityInput;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of ModifyGeneralizedSecurity. */
export type ModifyGeneralizedSecurityPayload = {
  __typename?: 'ModifyGeneralizedSecurityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  generalizedSecurity?: Maybe<GeneralizedSecurity>;
};

/** Autogenerated input type of ModifyGroundfloorNote */
export type ModifyGroundfloorNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalPartnerId?: InputMaybe<Scalars['ID']['input']>;
  groundfloorNote: GroundfloorNoteUpdateAttributes;
  groundfloorNoteId?: InputMaybe<Scalars['ID']['input']>;
  minUnitsPerAccount?: InputMaybe<Scalars['Int']['input']>;
  offeringType?: InputMaybe<OfferingRegulation>;
  securityContents?: InputMaybe<Array<SecurityContentInput>>;
  unitPriceCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ModifyGroundfloorNote. */
export type ModifyGroundfloorNotePayload = {
  __typename?: 'ModifyGroundfloorNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  groundfloorNote: GroundfloorNoteV2;
};

/** Autogenerated input type of ModifyInvestorProfile */
export type ModifyInvestorProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  investorProfile: InvestorProfileInput;
  investorProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of ModifyInvestorProfile. */
export type ModifyInvestorProfilePayload = {
  __typename?: 'ModifyInvestorProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investorProfile?: Maybe<InvestorProfile>;
};

/** Autogenerated input type of ModifyLendingBorrowerEntity */
export type ModifyLendingBorrowerEntityInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfFormation?: InputMaybe<Scalars['Date']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  hasMoreOnePrincipal?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stateOfFormation?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ModifyLendingBorrowerEntity. */
export type ModifyLendingBorrowerEntityPayload = {
  __typename?: 'ModifyLendingBorrowerEntityPayload';
  accountId?: Maybe<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dateOfFormation?: Maybe<Scalars['Date']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasMoreOnePrincipal?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  stateOfFormation?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ModifyLendingLoanApplication */
export type ModifyLendingLoanApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lendingLoanApplication: LendingLoanApplicationAttributes;
};

/** Autogenerated return type of ModifyLendingLoanApplication. */
export type ModifyLendingLoanApplicationPayload = {
  __typename?: 'ModifyLendingLoanApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<LendingLoanApplication>;
};

/** Autogenerated input type of ModifyLendingPrincipal */
export type ModifyLendingPrincipalInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  personalCreditScore?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  principalStrategicFocus?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  totalProjectsCompleted?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ModifyLendingPrincipal. */
export type ModifyLendingPrincipalPayload = {
  __typename?: 'ModifyLendingPrincipalPayload';
  /** ID of the associated account */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** Email of the principal */
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** First name of the principal */
  firstName?: Maybe<Scalars['String']['output']>;
  /** ID of the principal */
  id: Scalars['ID']['output'];
  /** First name of the principal */
  lastName?: Maybe<Scalars['String']['output']>;
  personalCreditScore?: Maybe<Scalars['String']['output']>;
  /** Phone number of the principal */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  principalStrategicFocus?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  /** State of the principal */
  state?: Maybe<Scalars['String']['output']>;
  totalProjectsCompleted?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of ModifyLoanApplication */
export type ModifyLoanApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  loanApplication: LoanApplicationAttributes;
};

/** Autogenerated return type of ModifyLoanApplication. */
export type ModifyLoanApplicationPayload = {
  __typename?: 'ModifyLoanApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  loanApplication?: Maybe<LoanApplication>;
};

/** Autogenerated input type of ModifyPreapproval */
export type ModifyPreapprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preapproval?: InputMaybe<PreapprovalAttributes>;
};

/** Autogenerated return type of ModifyPreapproval. */
export type ModifyPreapprovalPayload = {
  __typename?: 'ModifyPreapprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  preapproval?: Maybe<Preapproval>;
};

/** Autogenerated input type of ModifyPressAsset */
export type ModifyPressAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pressAsset: PressAssetInput;
  thumbnailImage?: InputMaybe<S3AssetInput>;
};

/** Autogenerated return type of ModifyPressAsset. */
export type ModifyPressAssetPayload = {
  __typename?: 'ModifyPressAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  pressAsset?: Maybe<PressAsset>;
};

/** Autogenerated input type of ModifyPressItem */
export type ModifyPressItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pressItem: PressItemInput;
};

/** Autogenerated return type of ModifyPressItem. */
export type ModifyPressItemPayload = {
  __typename?: 'ModifyPressItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  pressItem?: Maybe<PressItem>;
};

/** Autogenerated input type of ModifyPrincipal */
export type ModifyPrincipalInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  personalCreditScore?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  principalStrategicFocus?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  totalProjectsCompleted?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ModifyPrincipal. */
export type ModifyPrincipalPayload = {
  __typename?: 'ModifyPrincipalPayload';
  /** ID of the associated account */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** Email of the principal */
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** First name of the principal */
  firstName?: Maybe<Scalars['String']['output']>;
  /** ID of the principal */
  id: Scalars['ID']['output'];
  /** First name of the principal */
  lastName?: Maybe<Scalars['String']['output']>;
  personalCreditScore?: Maybe<Scalars['String']['output']>;
  /** Phone number of the principal */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  principalStrategicFocus?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  /** State of the principal */
  state?: Maybe<Scalars['String']['output']>;
  totalProjectsCompleted?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of ModifyReit */
export type ModifyReitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  reit: ReitInput;
};

/** Autogenerated return type of ModifyReit. */
export type ModifyReitPayload = {
  __typename?: 'ModifyReitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reit?: Maybe<Reit>;
};

/** Autogenerated input type of ModifyRequestedTransaction */
export type ModifyRequestedTransactionInput = {
  amountCents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
  purpose: Scalars['String']['input'];
};

/** Autogenerated return type of ModifyRequestedTransaction. */
export type ModifyRequestedTransactionPayload = {
  __typename?: 'ModifyRequestedTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  transactionRequest: TransactionRequest;
};

/** Autogenerated input type of ModifyUserCommunicationSettingCollection */
export type ModifyUserCommunicationSettingCollectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sendEmail: Scalars['Boolean']['input'];
  sendNotification: Scalars['Boolean']['input'];
  sendSms: Scalars['Boolean']['input'];
  transactionalCommunicationCategory: TransactionalCommunicationCategoryAttributes;
};

/** Autogenerated return type of ModifyUserCommunicationSettingCollection. */
export type ModifyUserCommunicationSettingCollectionPayload = {
  __typename?: 'ModifyUserCommunicationSettingCollectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendNotification?: Maybe<Scalars['Boolean']['output']>;
  sendSms?: Maybe<Scalars['Boolean']['output']>;
  transactionalCommunicationCategory?: Maybe<TransactionalCommunicationCategory>;
};

/** Autogenerated input type of ModifyUserRegistration */
export type ModifyUserRegistrationInput = {
  accredited?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Entity>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumberE164?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  referralSessionId?: InputMaybe<Scalars['ID']['input']>;
  secureId: Scalars['String']['input'];
  secureToken: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ModifyUserRegistration. */
export type ModifyUserRegistrationPayload = {
  __typename?: 'ModifyUserRegistrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RegistrationError>>;
  userRegistration?: Maybe<UserRegistration>;
};

/** Autogenerated input type of ModifyVerifiableIdentity */
export type ModifyVerifiableIdentityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingInvestorAttributes?: InputMaybe<OnboardingInvestorAttributes>;
  verifiableIdentity: VerifiableIdentityAttributes;
};

/** Autogenerated return type of ModifyVerifiableIdentity. */
export type ModifyVerifiableIdentityPayload = {
  __typename?: 'ModifyVerifiableIdentityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  verifiableIdentity?: Maybe<VerifiableIdentity>;
};

/** Autogenerated input type of MoveLendingLoanAppThroughOrigination */
export type MoveLendingLoanAppThroughOriginationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  originationEvent?: InputMaybe<Scalars['String']['input']>;
  underwritingEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MoveLendingLoanAppThroughOrigination. */
export type MoveLendingLoanAppThroughOriginationPayload = {
  __typename?: 'MoveLendingLoanAppThroughOriginationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<Array<LendingLoanApplication>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abandonPreapproval?: Maybe<AbandonPreapprovalPayload>;
  acceptFlywheelParticipation?: Maybe<AcceptFlywheelParticipationPayload>;
  /** This mutation is used to set an account's investment schedule's to ACTIVE. */
  activateAutomaticInvestingSchedules?: Maybe<ActivateAutomaticInvestingSchedulesPayload>;
  activateLoanApplicationFeeWaiverPromotion?: Maybe<ActivateLoanApplicationFeeWaiverPromotionPayload>;
  addConditionForLoanAgreements?: Maybe<AddConditionForLoanAgreementsPayload>;
  addConditionToLendingLoanApplication?: Maybe<AddConditionToLendingLoanApplicationPayload>;
  addDocumentToPreapproval?: Maybe<AddDocumentToPreapprovalPayload>;
  addDomainToBlockList?: Maybe<AddDomainToBlockListPayload>;
  addSecurityToExternalPartner?: Maybe<AddSecurityToExternalPartnerPayload>;
  allocateReitSecurities?: Maybe<AllocateReitSecuritiesPayload>;
  amendDrawRequest?: Maybe<AmendDrawRequestPayload>;
  applyPromotionalCredit?: Maybe<ApplyPromotionalCreditPayload>;
  approveBalanceAdjustment?: Maybe<ApproveBalanceAdjustmentPayload>;
  /** Allows the approval of a PENDING_REVIEW bank account */
  approveBankAccount?: Maybe<ApproveBankAccountPayload>;
  /**
   * Approve the specified funds transfers. This action is only available for
   * transfers that are pending review, and is only permitted for employees.
   */
  approveFundsTransfers?: Maybe<ApproveFundsTransfersPayload>;
  approvePreapproval?: Maybe<ApprovePreapprovalPayload>;
  approveRequestedTransaction?: Maybe<ApproveRequestedTransactionPayload>;
  archiveInvestorUpdate?: Maybe<ArchiveInvestorUpdatePayload>;
  archiveNotification?: Maybe<ArchiveNotificationPayload>;
  archiveProgressUpdate?: Maybe<ArchiveProgressUpdatePayload>;
  archiveUser?: Maybe<ArchiveUserPayload>;
  assignGuarantorToLoanApplication?: Maybe<AssignGuarantorToLoanApplicationPayload>;
  authorGeneralizedSecurity?: Maybe<AuthorGeneralizedSecurityPayload>;
  authorGeneralizedSecurityCategory?: Maybe<AuthorGeneralizedSecurityCategoryPayload>;
  beginDocumentation?: Maybe<BeginDocumentationPayload>;
  /**
   * Attempts to enroll the current user in MFA.  A SMS code will be sent to the user.  Email is not supported for enrollment.
   * The user must provide this code to you and you must call completeMfaEnrollment with that code in order for MFA to
   * become enabled for a user.
   *
   * The following error statuses and codes may be returned:
   *   RATE_LIMIT_EXCEEDED (429): The user has requested MFA too quickly after
   * previously requesting MFA.  Please try again after 30 seconds.
   *   MFA_ALREADY_ENROLLED (409): The user is already successfully enrolled in MFA.  Call unenrollFromMfa first.
   *   UNAUTHORIZED_CLIENT (422): The client logged in is not authorized to perform this action
   *   SERVER_ERROR (500): Something has gone wrong in the server.
   *
   * The returned mfaAttempt object corresponds to the MFA code sent for verification.
   */
  beginMfaEnrollment?: Maybe<BeginMfaEnrollmentPayload>;
  beginUnderwriting?: Maybe<BeginUnderwritingPayload>;
  borrowerApproves?: Maybe<BorrowerApprovesPayload>;
  bulkAddExistingUsersToPromo?: Maybe<BulkAddExistingUsersToPromoPayload>;
  bulkInitiatePartialRepayment?: Maybe<BulkInitiatePartialRepaymentPayload>;
  /** Cancel the specified auto-investor account run, if possible. */
  cancelAutoInvestorAccountRun?: Maybe<CancelAutoInvestorAccountRunPayload>;
  cancelInvestment?: Maybe<CancelInvestmentPayload>;
  cancelPendingFundsTransfer?: Maybe<CancelPendingFundsTransferPayload>;
  cancelRepayment?: Maybe<CancelRepaymentPayload>;
  changeAccount?: Maybe<ChangeAccountPayload>;
  changeUserPassword?: Maybe<ChangeUserPasswordPayload>;
  cloneLoanApplication?: Maybe<CloneLoanApplicationPayload>;
  /** Closes a security.  This means setting it to `funding_commited` */
  closeSecurity?: Maybe<CloseSecurityPayload>;
  closingOrigination?: Maybe<ClosingOriginationPayload>;
  commitGeneralizedSecurityFunding?: Maybe<CommitGeneralizedSecurityFundingPayload>;
  completeClaCondition?: Maybe<CompleteClaConditionPayload>;
  /**
   * Attempts to complete enrollment of the current user in MFA.  You must provide
   * the OTP sent to the user via beginMfaEnrollment.
   *
   * The following error statuses and codes may be returned:
   *   MFA_CODE_INCORRECT (403): The provided OTP code was not correct.
   *   BAD_MFA_ATTEMPT (403): The MFA code has expired or there was no MFA session
   * found for the given user, JWT token, and IP address combination.  You must
   * request a new code.
   *   MFA_ALREADY_ENROLLED (409): The user is already successfully enrolled in MFA.  Call unenrollFromMfa first.
   *   MFA_NOT_ENROLLED (409): The user never began enrolling in MFA.
   *   UNAUTHORIZED_CLIENT (422): The client logged in is not authorized to perform this action
   *   SERVER_ERROR (500): Something has gone wrong in the server.
   *
   * If MFA is successfully enrolled, the user object is returned.
   */
  completeMfaEnrollment?: Maybe<CompleteMfaEnrollmentPayload>;
  completeUserRegistration?: Maybe<CompleteUserRegistrationPayload>;
  confirmFundsTransfer?: Maybe<ConfirmFundsTransferPayload>;
  connectAchWithPlaid?: Maybe<ConnectAchWithPlaidPayload>;
  connectBankAccountToUserAccount?: Maybe<ConnectBankAccountToUserAccountPayload>;
  createAccountTransfer?: Maybe<CreateAccountTransferPayload>;
  createBalanceAdjustment?: Maybe<CreateBalanceAdjustmentPayload>;
  createBeneficiary?: Maybe<CreateBeneficiaryPayload>;
  createBorrowerEntity?: Maybe<CreateBorrowerEntityPayload>;
  createCompanyUpdate?: Maybe<CreateCompanyUpdatePayload>;
  createEquityOffering?: Maybe<CreateEquityOfferingPayload>;
  createExternalPartner?: Maybe<CreateExternalPartnerPayload>;
  createGroundfloorNote?: Maybe<CreateGroundfloorNotePayload>;
  createGroundfloorNoteIcon?: Maybe<CreateGroundfloorNoteIconPayload>;
  createHostedDocument?: Maybe<CreateHostedDocumentPayload>;
  createInvestmentOpportunityFromLendingData?: Maybe<CreateInvestmentOpportunityFromLendingDataPayload>;
  createInvestmentOwnershipTransfer?: Maybe<CreateInvestmentOwnershipTransferPayload>;
  createInvestmentSchedules?: Maybe<CreateInvestmentSchedulesPayload>;
  createInvestmentWizardStrategy?: Maybe<CreateInvestmentWizardStrategyPayload>;
  createInvestorUpdate?: Maybe<CreateInvestorUpdatePayload>;
  createLendingBorrowerEntity?: Maybe<CreateLendingBorrowerEntityPayload>;
  createLendingBorrowerEntityAddress?: Maybe<CreateLendingBorrowerEntityAddressPayload>;
  createLendingPrincipal?: Maybe<CreateLendingPrincipalPayload>;
  createLendingPrincipalAddress?: Maybe<CreateLendingPrincipalAddressPayload>;
  createPreapproval?: Maybe<CreatePreapprovalPayload>;
  createPrincipal?: Maybe<CreatePrincipalPayload>;
  createProgressUpdate?: Maybe<CreateProgressUpdatePayload>;
  createPushNotificationSubscriptionConfiguration?: Maybe<CreatePushNotificationSubscriptionConfigurationPayload>;
  createRecurringTransferSchedule?: Maybe<CreateRecurringTransferSchedulePayload>;
  createReferralCampaign?: Maybe<CreateReferralCampaignPayload>;
  createReit?: Maybe<CreateReitPayload>;
  createSavingsGoal?: Maybe<CreateSavingsGoalPayload>;
  createTaxPayer?: Maybe<CreateTaxPayerPayload>;
  createTaxPayerForAccount?: Maybe<CreateTaxPayerForAccountPayload>;
  createTermSheet?: Maybe<CreateTermSheetPayload>;
  createVerifiedFundsTransfer?: Maybe<CreateVerifiedFundsTransferPayload>;
  createWireTransferRequest?: Maybe<CreateWireTransferRequestPayload>;
  creditUser?: Maybe<CreditUserPayload>;
  deactivateLoanApplicationFeeWaiverPromotion?: Maybe<DeactivateLoanApplicationFeeWaiverPromotionPayload>;
  disableAutomaticRepaymentTransfers?: Maybe<DisableAutomaticRepaymentTransfersPayload>;
  disableCondition?: Maybe<DisableConditionPayload>;
  editInvestorUpdate?: Maybe<EditInvestorUpdatePayload>;
  editProgressUpdate?: Maybe<EditProgressUpdatePayload>;
  enableAutomaticRepaymentTransfers?: Maybe<EnableAutomaticRepaymentTransfersPayload>;
  enablePlaidFeatures?: Maybe<EnablePlaidFeaturesPayload>;
  establishReferralSession?: Maybe<EstablishReferralSessionPayload>;
  establishReferralSessionForNewUsers?: Maybe<EstablishReferralSessionForNewUsersPayload>;
  finishFundingLoansWithFinanceAccount?: Maybe<FinishFundingLoansWithFinanceAccountPayload>;
  /** For the given user, halt any funds transfers that are still in flight; this will apply to all of the user's accounts. */
  haltFundsTransfers?: Maybe<HaltFundsTransfersPayload>;
  /** Allows users to initiate micro deposit verification for a new bank account. */
  initiateMicroDepositVerification?: Maybe<InitiateMicroDepositVerificationPayload>;
  initiatePartialRepayment?: Maybe<InitiatePartialRepaymentPayload>;
  issueApiConsumerJwt?: Maybe<IssueApiConsumerJwtPayload>;
  issueEmployeeJwt?: Maybe<IssueEmployeeJwtPayload>;
  issueUserGhostJwt?: Maybe<IssueUserGhostJwtPayload>;
  issueUserJwt?: Maybe<IssueUserJwtPayload>;
  /** Lock the specified user out of their account, and invalidate all of their existing sessions. */
  lockUser?: Maybe<LockUserPayload>;
  markLendingLoanRemoved?: Maybe<MarkLendingLoanRemovedPayload>;
  markLendingLoanRepaid?: Maybe<MarkLendingLoanRepaidPayload>;
  modifyAccreditation?: Maybe<ModifyAccreditationPayload>;
  modifyAddress?: Maybe<ModifyAddressPayload>;
  modifyBorrowerEntity?: Maybe<ModifyBorrowerEntityPayload>;
  modifyClaConditionDescription?: Maybe<ModifyClaConditionDescriptionPayload>;
  modifyClosingDetail?: Maybe<ModifyClosingDetailPayload>;
  modifyConditionDescription?: Maybe<ModifyConditionDescriptionPayload>;
  modifyExternalPartner?: Maybe<ModifyExternalPartnerPayload>;
  modifyGeneralizedSecurity?: Maybe<ModifyGeneralizedSecurityPayload>;
  modifyGeneralizedSecurityCategory?: Maybe<ModifyGeneralizedSecurityCategoryPayload>;
  modifyGroundfloorNote?: Maybe<ModifyGroundfloorNotePayload>;
  modifyInvestorProfile?: Maybe<ModifyInvestorProfilePayload>;
  modifyLendingBorrowerEntity?: Maybe<ModifyLendingBorrowerEntityPayload>;
  modifyLendingLoanApplication?: Maybe<ModifyLendingLoanApplicationPayload>;
  modifyLendingPrincipal?: Maybe<ModifyLendingPrincipalPayload>;
  modifyLoanApplication?: Maybe<ModifyLoanApplicationPayload>;
  modifyPreapproval?: Maybe<ModifyPreapprovalPayload>;
  modifyPressAsset?: Maybe<ModifyPressAssetPayload>;
  modifyPressItem?: Maybe<ModifyPressItemPayload>;
  modifyPrincipal?: Maybe<ModifyPrincipalPayload>;
  modifyReit?: Maybe<ModifyReitPayload>;
  modifyRequestedTransaction?: Maybe<ModifyRequestedTransactionPayload>;
  modifyUserCommunicationSettingCollection?: Maybe<ModifyUserCommunicationSettingCollectionPayload>;
  modifyUserRegistration?: Maybe<ModifyUserRegistrationPayload>;
  modifyVerifiableIdentity?: Maybe<ModifyVerifiableIdentityPayload>;
  moveLendingLoanAppThroughOrigination?: Maybe<MoveLendingLoanAppThroughOriginationPayload>;
  openAutoInvestorAccount?: Maybe<OpenAutoInvestorAccountPayload>;
  openBorrowerAccount?: Maybe<OpenBorrowerAccountPayload>;
  openInvestorAccount?: Maybe<OpenInvestorAccountPayload>;
  openInvestorCryptoAccount?: Maybe<OpenInvestorCryptoAccountPayload>;
  openReferrerAccount?: Maybe<OpenReferrerAccountPayload>;
  openYieldAccount?: Maybe<OpenYieldAccountPayload>;
  overrideRecaptchaScore?: Maybe<OverrideRecaptchaScorePayload>;
  /** This mutation is used to set an account's investment schedule's to PAUSED. */
  pauseAutomaticInvestingSchedules?: Maybe<PauseAutomaticInvestingSchedulesPayload>;
  pendPreapproval?: Maybe<PendPreapprovalPayload>;
  placeBatchInvestmentReservation?: Maybe<PlaceBatchInvestmentReservationPayload>;
  placePurchaseOrder?: Maybe<PlacePurchaseOrderPayload>;
  processPreapprovalPayment?: Maybe<ProcessPreapprovalPaymentPayload>;
  publishInvestorUpdate?: Maybe<PublishInvestorUpdatePayload>;
  publishProgressUpdate?: Maybe<PublishProgressUpdatePayload>;
  purchaseInvestments?: Maybe<PurchaseInvestmentsPayload>;
  readNotification?: Maybe<ReadNotificationPayload>;
  recordInvestmentWizardOptions?: Maybe<RecordInvestmentWizardOptionsPayload>;
  recordTermsAndConditionsAcceptance?: Maybe<RecordTermsAndConditionsAcceptancePayload>;
  recordUiInteraction?: Maybe<RecordUiInteractionPayload>;
  refundAndCloseGeneralizedSecurity?: Maybe<RefundAndCloseGeneralizedSecurityPayload>;
  registerCjCookie?: Maybe<RegisterCjCookiePayload>;
  /** Registers a new signature authentication key for a user.  This is used for biometric authentication. */
  registerSignatureAuthenticationKey?: Maybe<RegisterSignatureAuthenticationKeyPayload>;
  registerUnverifiedInvestor?: Maybe<RegisterUnverifiedInvestorPayload>;
  registerYieldInvestor?: Maybe<RegisterYieldInvestorPayload>;
  rejectBalanceAdjustment?: Maybe<RejectBalanceAdjustmentPayload>;
  /**
   * Reject the specified funds transfers. This action is only available for
   * transfers that are pending review, and is only permitted for employees.
   */
  rejectFundsTransfers?: Maybe<RejectFundsTransfersPayload>;
  rejectPreapproval?: Maybe<RejectPreapprovalPayload>;
  rejectRequestedTransaction?: Maybe<RejectRequestedTransactionPayload>;
  removeBeneficiary?: Maybe<RemoveBeneficiaryPayload>;
  removeClaCondition?: Maybe<RemoveClaConditionPayload>;
  removeExternalPartner?: Maybe<RemoveExternalPartnerPayload>;
  removeGuarantorFromLoanApplication?: Maybe<RemoveGuarantorFromLoanApplicationPayload>;
  removeInvestmentWizardStrategy?: Maybe<RemoveInvestmentWizardStrategyPayload>;
  removeInvestorUpdateImage?: Maybe<RemoveInvestorUpdateImagePayload>;
  removePressAsset?: Maybe<RemovePressAssetPayload>;
  removePressItem?: Maybe<RemovePressItemPayload>;
  removeProblemBankAccount?: Maybe<RemoveProblemBankAccountPayload>;
  removeRecurringTransferSchedule?: Maybe<RemoveRecurringTransferSchedulePayload>;
  removeReitHolding?: Maybe<RemoveReitHoldingPayload>;
  removeSavingsGoal?: Maybe<RemoveSavingsGoalPayload>;
  removeSecurityFromExternalPartner?: Maybe<RemoveSecurityFromExternalPartnerPayload>;
  removeSecurityFromPlatform?: Maybe<RemoveSecurityFromPlatformPayload>;
  removeTermSheet?: Maybe<RemoveTermSheetPayload>;
  repayGeneralizedSecurity?: Maybe<RepayGeneralizedSecurityPayload>;
  requestExport?: Maybe<RequestExportPayload>;
  requestPdfDownloadLink?: Maybe<RequestPdfDownloadLinkPayload>;
  requestTransaction?: Maybe<RequestTransactionPayload>;
  requestUserPasswordReset?: Maybe<RequestUserPasswordResetPayload>;
  resendEmailVerification?: Maybe<ResendEmailVerificationPayload>;
  /**
   * Re-triggers an MFA request.  A code will be sent to the user via the provided communication channel.
   * Provide previousMfaAttemptId to indicate which MFA session this re-send is for
   *
   * The following error statuses and codes may be returned:
   *   RATE_LIMIT_EXCEEDED (429): The user has requested MFA too quickly after
   * previously requesting MFA.  Please try again after 30 seconds.
   *   MFA_NOT_ENROLLED (409): The user is not enrolled (or enrolling) in MFA
   *   BAD_MFA_ATTEMPT (403): The previousMfaAttemptId provided was incorrect.
   *   MFA_SESSION_EXPIRED (410): The entire MFA session has expired.  The user must attempt logging in (or enrolling) again.
   *   UNAUTHORIZED_CLIENT (422): The client logged in is not authorized to perform this action
   *   SERVER_ERROR (500): Something has gone wrong in the server.
   *
   * The returned mfaAttempt object corresponds to the MFA code sent.
   */
  resendMfa?: Maybe<ResendMfaPayload>;
  resetPasswordForEmployee?: Maybe<ResetPasswordForEmployeePayload>;
  resetUserPassword?: Maybe<ResetUserPasswordPayload>;
  retrieveInitialPlaidLinkToken?: Maybe<RetrieveInitialPlaidLinkTokenPayload>;
  retrievePlaidLinkToken?: Maybe<RetrievePlaidLinkTokenPayload>;
  revealTerms?: Maybe<RevealTermsPayload>;
  /** Allows a user to reverify a bank account through plaid */
  reverifyOrReplacePlaidBankAccount?: Maybe<ReverifyOrReplacePlaidBankAccountPayload>;
  reverseBalanceAdjustment?: Maybe<ReverseBalanceAdjustmentPayload>;
  savePressAsset?: Maybe<SavePressAssetPayload>;
  savePressItem?: Maybe<SavePressItemPayload>;
  schedulePredefinedInvestmentStrategy?: Maybe<SchedulePredefinedInvestmentStrategyPayload>;
  sendTermSheetToPrincipal?: Maybe<SendTermSheetToPrincipalPayload>;
  sendTermsToBorrower?: Maybe<SendTermsToBorrowerPayload>;
  /** Create or update account-level settings for an investor-auto account. */
  setAutoInvestorAccountConfig?: Maybe<SetAutoInvestorAccountConfigPayload>;
  setBrokerApplicationFeeAmount?: Maybe<SetBrokerApplicationFeeAmountPayload>;
  setPrimaryAccount?: Maybe<SetPrimaryAccountPayload>;
  setReitReinvestmentSetting?: Maybe<SetReitReinvestmentSettingPayload>;
  setupSecurityForInstitutionalPurchase?: Maybe<SetupSecurityForInstitutionalPurchasePayload>;
  startLendingLoanApplicationUsingPreapproval?: Maybe<StartLendingLoanApplicationUsingPreapprovalPayload>;
  startPdfBatchGeneration?: Maybe<StartPdfBatchGenerationPayload>;
  startUserRegistration?: Maybe<StartUserRegistrationPayload>;
  submitAllStagedLabsRepayments?: Maybe<SubmitAllStagedLabsRepaymentsPayload>;
  submitNoteInterestPayment?: Maybe<SubmitNoteInterestPaymentPayload>;
  submitPartialRepayment?: Maybe<SubmitPartialRepaymentPayload>;
  supportingDocumentUploaded?: Maybe<SupportingDocumentUploadedPayload>;
  takeGeneralizedSecurityLive?: Maybe<TakeGeneralizedSecurityLivePayload>;
  toggleAccountFlag?: Maybe<ToggleAccountFlagPayload>;
  toggleBrokerApplicationFeeEnabled?: Maybe<ToggleBrokerApplicationFeeEnabledPayload>;
  toggleRecurringTransferSchedule?: Maybe<ToggleRecurringTransferSchedulePayload>;
  toggleUserModeration?: Maybe<ToggleUserModerationPayload>;
  transferFunds?: Maybe<TransferFundsPayload>;
  transferPrincipalLendingLoanApplications?: Maybe<TransferPrincipalLendingLoanApplicationsPayload>;
  transitionLendingLoan?: Maybe<TransitionLendingLoanPayload>;
  transitionTermSheet?: Maybe<TransitionTermSheetPayload>;
  unArchiveUser?: Maybe<UnArchiveUserPayload>;
  underwritingCompleted?: Maybe<UnderwritingCompletedPayload>;
  /**
   * Unenroll the current user from MFA, regardless of whether or not they were actually enrolled.
   *
   * The following error statuses and codes may be returned:
   *   MFA_REQUIRED (401): The user must first perform MFA before unenrolling.  The
   * mfaAttempt field is populated and you should use that to send the user through the MFA flow.
   *   UNAUTHORIZED_CLIENT (422): The client logged in is not authorized to perform this action
   *   SERVER_ERROR (500): Something has gone wrong in the server.
   */
  unenrollFromMfa?: Maybe<UnenrollFromMfaPayload>;
  unlinkBankAccountFromTrustline?: Maybe<UnlinkBankAccountFromTrustlinePayload>;
  unlockEmployee?: Maybe<UnlockEmployeePayload>;
  unlockUser?: Maybe<UnlockUserPayload>;
  unpublishInvestorUpdate?: Maybe<UnpublishInvestorUpdatePayload>;
  unreadNotification?: Maybe<UnreadNotificationPayload>;
  updateAutomaticRepaymentTransfers?: Maybe<UpdateAutomaticRepaymentTransfersPayload>;
  updateBeneficiary?: Maybe<UpdateBeneficiaryPayload>;
  updateConfiguration?: Maybe<UpdateConfigurationPayload>;
  updateDwollaCustomer?: Maybe<UpdateDwollaCustomerPayload>;
  updateHostedDocument?: Maybe<UpdateHostedDocumentPayload>;
  updateInvestmentWizardStrategy?: Maybe<UpdateInvestmentWizardStrategyPayload>;
  updateIraFundsTransferAmount?: Maybe<UpdateIraFundsTransferAmountPayload>;
  updatePushNotificationSubscriptionConfiguration?: Maybe<UpdatePushNotificationSubscriptionConfigurationPayload>;
  updateRecurringTransferSchedule?: Maybe<UpdateRecurringTransferSchedulePayload>;
  updateReferralCampaign?: Maybe<UpdateReferralCampaignPayload>;
  updateSavingsGoal?: Maybe<UpdateSavingsGoalPayload>;
  updateTaxPayer?: Maybe<UpdateTaxPayerPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateWireTransferRequest?: Maybe<UpdateWireTransferRequestPayload>;
  updateYieldInvestorProfile?: Maybe<UpdateYieldInvestorProfilePayload>;
  uploadVerificationDocument?: Maybe<UploadVerificationDocumentPayload>;
  verifyEmail?: Maybe<VerifyEmailPayload>;
  /**
   * Validates an OTP for MFA.  By design, this mutation is NOT idempotent.  You cannot validate the same OTP twice.
   *
   * The following error statuses and codes may be returned:
   *   MFA_CODE_INCORRECT (403): The provided OTP code was not correct.
   *   BAD_MFA_ATTEMPT (403): The attemptId provided was incorrect, the MFA code has
   * expired or there was no MFA session found for the given user, JWT token, and
   * IP address combination.  You must request a new code.
   *   MFA_SESSION_EXPIRED (410): The attemptId was correct but it has been too long
   * since MFA started, or MFA is already successful.  The user must log in again.
   *   MFA_NOT_ENROLLED (409): The user is not enrolled in MFA.
   *   UNAUTHORIZED_CLIENT (422): The client logged in is not authorized to perform this action
   *   SERVER_ERROR (500): Something has gone wrong in the server.
   */
  verifyMfaAttempt?: Maybe<VerifyMfaAttemptPayload>;
  /** Allows user to verify ownership of bank account once micro deposits are posted. */
  verifyMicroDeposits?: Maybe<VerifyMicroDepositsPayload>;
};


export type MutationAbandonPreapprovalArgs = {
  input: AbandonPreapprovalInput;
};


export type MutationAcceptFlywheelParticipationArgs = {
  input: AcceptFlywheelParticipationInput;
};


export type MutationActivateAutomaticInvestingSchedulesArgs = {
  input: ActivateAutomaticInvestingSchedulesInput;
};


export type MutationActivateLoanApplicationFeeWaiverPromotionArgs = {
  input: ActivateLoanApplicationFeeWaiverPromotionInput;
};


export type MutationAddConditionForLoanAgreementsArgs = {
  input: AddConditionForLoanAgreementsInput;
};


export type MutationAddConditionToLendingLoanApplicationArgs = {
  input: AddConditionToLendingLoanApplicationInput;
};


export type MutationAddDocumentToPreapprovalArgs = {
  input: AddDocumentToPreapprovalInput;
};


export type MutationAddDomainToBlockListArgs = {
  input: AddDomainToBlockListInput;
};


export type MutationAddSecurityToExternalPartnerArgs = {
  input: AddSecurityToExternalPartnerInput;
};


export type MutationAllocateReitSecuritiesArgs = {
  input: AllocateReitSecuritiesInput;
};


export type MutationAmendDrawRequestArgs = {
  input: AmendDrawRequestInput;
};


export type MutationApplyPromotionalCreditArgs = {
  input: ApplyPromotionalCreditInput;
};


export type MutationApproveBalanceAdjustmentArgs = {
  input: ApproveBalanceAdjustmentInput;
};


export type MutationApproveBankAccountArgs = {
  input: ApproveBankAccountInput;
};


export type MutationApproveFundsTransfersArgs = {
  input: ApproveFundsTransfersInput;
};


export type MutationApprovePreapprovalArgs = {
  input: ApprovePreapprovalInput;
};


export type MutationApproveRequestedTransactionArgs = {
  input: ApproveRequestedTransactionInput;
};


export type MutationArchiveInvestorUpdateArgs = {
  input: ArchiveInvestorUpdateInput;
};


export type MutationArchiveNotificationArgs = {
  input: ArchiveNotificationInput;
};


export type MutationArchiveProgressUpdateArgs = {
  input: ArchiveProgressUpdateInput;
};


export type MutationArchiveUserArgs = {
  input: ArchiveUserInput;
};


export type MutationAssignGuarantorToLoanApplicationArgs = {
  input: AssignGuarantorToLoanApplicationInput;
};


export type MutationAuthorGeneralizedSecurityArgs = {
  input: AuthorGeneralizedSecurityInput;
};


export type MutationAuthorGeneralizedSecurityCategoryArgs = {
  input: AuthorGeneralizedSecurityCategoryInput;
};


export type MutationBeginDocumentationArgs = {
  input: BeginDocumentationInput;
};


export type MutationBeginMfaEnrollmentArgs = {
  input: BeginMfaEnrollmentInput;
};


export type MutationBeginUnderwritingArgs = {
  input: BeginUnderwritingInput;
};


export type MutationBorrowerApprovesArgs = {
  input: BorrowerApprovesInput;
};


export type MutationBulkAddExistingUsersToPromoArgs = {
  input: BulkAddExistingUsersToPromoInput;
};


export type MutationBulkInitiatePartialRepaymentArgs = {
  input: BulkInitiatePartialRepaymentInput;
};


export type MutationCancelAutoInvestorAccountRunArgs = {
  input: CancelAutoInvestorAccountRunInput;
};


export type MutationCancelInvestmentArgs = {
  input: CancelInvestmentInput;
};


export type MutationCancelPendingFundsTransferArgs = {
  input: CancelPendingFundsTransferInput;
};


export type MutationCancelRepaymentArgs = {
  input: CancelRepaymentInput;
};


export type MutationChangeAccountArgs = {
  input: ChangeAccountInput;
};


export type MutationChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type MutationCloneLoanApplicationArgs = {
  input: CloneLoanApplicationInput;
};


export type MutationCloseSecurityArgs = {
  input: CloseSecurityInput;
};


export type MutationClosingOriginationArgs = {
  input: ClosingOriginationInput;
};


export type MutationCommitGeneralizedSecurityFundingArgs = {
  input: CommitGeneralizedSecurityFundingInput;
};


export type MutationCompleteClaConditionArgs = {
  input: CompleteClaConditionInput;
};


export type MutationCompleteMfaEnrollmentArgs = {
  input: CompleteMfaEnrollmentInput;
};


export type MutationCompleteUserRegistrationArgs = {
  input: CompleteUserRegistrationInput;
};


export type MutationConfirmFundsTransferArgs = {
  input: ConfirmFundsTransferInput;
};


export type MutationConnectAchWithPlaidArgs = {
  input: ConnectAchWithPlaidInput;
};


export type MutationConnectBankAccountToUserAccountArgs = {
  input: ConnectBankAccountToUserAccountInput;
};


export type MutationCreateAccountTransferArgs = {
  input: CreateAccountTransferInput;
};


export type MutationCreateBalanceAdjustmentArgs = {
  input: CreateBalanceAdjustmentInput;
};


export type MutationCreateBeneficiaryArgs = {
  input: CreateBeneficiaryInput;
};


export type MutationCreateBorrowerEntityArgs = {
  input: CreateBorrowerEntityInput;
};


export type MutationCreateCompanyUpdateArgs = {
  input: CreateCompanyUpdateInput;
};


export type MutationCreateEquityOfferingArgs = {
  input: CreateEquityOfferingInput;
};


export type MutationCreateExternalPartnerArgs = {
  input: CreateExternalPartnerInput;
};


export type MutationCreateGroundfloorNoteArgs = {
  input: CreateGroundfloorNoteInput;
};


export type MutationCreateGroundfloorNoteIconArgs = {
  input: CreateGroundfloorNoteIconInput;
};


export type MutationCreateHostedDocumentArgs = {
  input: CreateHostedDocumentInput;
};


export type MutationCreateInvestmentOpportunityFromLendingDataArgs = {
  input: CreateInvestmentOpportunityFromLendingDataInput;
};


export type MutationCreateInvestmentOwnershipTransferArgs = {
  input: CreateInvestmentOwnershipTransferInput;
};


export type MutationCreateInvestmentSchedulesArgs = {
  input: CreateInvestmentSchedulesInput;
};


export type MutationCreateInvestmentWizardStrategyArgs = {
  input: CreateInvestmentWizardStrategyInput;
};


export type MutationCreateInvestorUpdateArgs = {
  input: CreateInvestorUpdateInput;
};


export type MutationCreateLendingBorrowerEntityArgs = {
  input: CreateLendingBorrowerEntityInput;
};


export type MutationCreateLendingBorrowerEntityAddressArgs = {
  input: CreateLendingBorrowerEntityAddressInput;
};


export type MutationCreateLendingPrincipalArgs = {
  input: CreateLendingPrincipalInput;
};


export type MutationCreateLendingPrincipalAddressArgs = {
  input: CreateLendingPrincipalAddressInput;
};


export type MutationCreatePreapprovalArgs = {
  input: CreatePreapprovalInput;
};


export type MutationCreatePrincipalArgs = {
  input: CreatePrincipalInput;
};


export type MutationCreateProgressUpdateArgs = {
  input: CreateProgressUpdateInput;
};


export type MutationCreatePushNotificationSubscriptionConfigurationArgs = {
  input: CreatePushNotificationSubscriptionConfigurationInput;
};


export type MutationCreateRecurringTransferScheduleArgs = {
  input: CreateRecurringTransferScheduleInput;
};


export type MutationCreateReferralCampaignArgs = {
  input: CreateReferralCampaignInput;
};


export type MutationCreateReitArgs = {
  input: CreateReitInput;
};


export type MutationCreateSavingsGoalArgs = {
  input: CreateSavingsGoalInput;
};


export type MutationCreateTaxPayerArgs = {
  input: CreateTaxPayerInput;
};


export type MutationCreateTaxPayerForAccountArgs = {
  input: CreateTaxPayerForAccountInput;
};


export type MutationCreateTermSheetArgs = {
  input: CreateTermSheetInput;
};


export type MutationCreateVerifiedFundsTransferArgs = {
  input: CreateVerifiedFundsTransferInput;
};


export type MutationCreateWireTransferRequestArgs = {
  input: CreateWireTransferRequestInput;
};


export type MutationCreditUserArgs = {
  input: CreditUserInput;
};


export type MutationDeactivateLoanApplicationFeeWaiverPromotionArgs = {
  input: DeactivateLoanApplicationFeeWaiverPromotionInput;
};


export type MutationDisableAutomaticRepaymentTransfersArgs = {
  input: DisableAutomaticRepaymentTransfersInput;
};


export type MutationDisableConditionArgs = {
  input: DisableConditionInput;
};


export type MutationEditInvestorUpdateArgs = {
  input: EditInvestorUpdateInput;
};


export type MutationEditProgressUpdateArgs = {
  input: EditProgressUpdateInput;
};


export type MutationEnableAutomaticRepaymentTransfersArgs = {
  input: EnableAutomaticRepaymentTransfersInput;
};


export type MutationEnablePlaidFeaturesArgs = {
  input: EnablePlaidFeaturesInput;
};


export type MutationEstablishReferralSessionArgs = {
  input: EstablishReferralSessionInput;
};


export type MutationEstablishReferralSessionForNewUsersArgs = {
  input: EstablishReferralSessionForNewUsersInput;
};


export type MutationFinishFundingLoansWithFinanceAccountArgs = {
  input: FinishFundingLoansWithFinanceAccountInput;
};


export type MutationHaltFundsTransfersArgs = {
  input: HaltFundsTransfersInput;
};


export type MutationInitiateMicroDepositVerificationArgs = {
  input: InitiateMicroDepositVerificationInput;
};


export type MutationInitiatePartialRepaymentArgs = {
  input: InitiatePartialRepaymentInput;
};


export type MutationIssueApiConsumerJwtArgs = {
  input: IssueApiConsumerJwtInput;
};


export type MutationIssueEmployeeJwtArgs = {
  input: IssueEmployeeJwtInput;
};


export type MutationIssueUserGhostJwtArgs = {
  input: IssueUserGhostJwtInput;
};


export type MutationIssueUserJwtArgs = {
  input: IssueUserJwtInput;
};


export type MutationLockUserArgs = {
  input: LockUserInput;
};


export type MutationMarkLendingLoanRemovedArgs = {
  input: MarkLendingLoanRemovedInput;
};


export type MutationMarkLendingLoanRepaidArgs = {
  input: MarkLendingLoanRepaidInput;
};


export type MutationModifyAccreditationArgs = {
  input: ModifyAccreditationInput;
};


export type MutationModifyAddressArgs = {
  input: ModifyAddressInput;
};


export type MutationModifyBorrowerEntityArgs = {
  input: ModifyBorrowerEntityInput;
};


export type MutationModifyClaConditionDescriptionArgs = {
  input: ModifyClaConditionDescriptionInput;
};


export type MutationModifyClosingDetailArgs = {
  input: ModifyClosingDetailInput;
};


export type MutationModifyConditionDescriptionArgs = {
  input: ModifyConditionDescriptionInput;
};


export type MutationModifyExternalPartnerArgs = {
  input: ModifyExternalPartnerInput;
};


export type MutationModifyGeneralizedSecurityArgs = {
  input: ModifyGeneralizedSecurityInput;
};


export type MutationModifyGeneralizedSecurityCategoryArgs = {
  input: ModifyGeneralizedSecurityCategoryInput;
};


export type MutationModifyGroundfloorNoteArgs = {
  input: ModifyGroundfloorNoteInput;
};


export type MutationModifyInvestorProfileArgs = {
  input: ModifyInvestorProfileInput;
};


export type MutationModifyLendingBorrowerEntityArgs = {
  input: ModifyLendingBorrowerEntityInput;
};


export type MutationModifyLendingLoanApplicationArgs = {
  input: ModifyLendingLoanApplicationInput;
};


export type MutationModifyLendingPrincipalArgs = {
  input: ModifyLendingPrincipalInput;
};


export type MutationModifyLoanApplicationArgs = {
  input: ModifyLoanApplicationInput;
};


export type MutationModifyPreapprovalArgs = {
  input: ModifyPreapprovalInput;
};


export type MutationModifyPressAssetArgs = {
  input: ModifyPressAssetInput;
};


export type MutationModifyPressItemArgs = {
  input: ModifyPressItemInput;
};


export type MutationModifyPrincipalArgs = {
  input: ModifyPrincipalInput;
};


export type MutationModifyReitArgs = {
  input: ModifyReitInput;
};


export type MutationModifyRequestedTransactionArgs = {
  input: ModifyRequestedTransactionInput;
};


export type MutationModifyUserCommunicationSettingCollectionArgs = {
  input: ModifyUserCommunicationSettingCollectionInput;
};


export type MutationModifyUserRegistrationArgs = {
  input: ModifyUserRegistrationInput;
};


export type MutationModifyVerifiableIdentityArgs = {
  input: ModifyVerifiableIdentityInput;
};


export type MutationMoveLendingLoanAppThroughOriginationArgs = {
  input: MoveLendingLoanAppThroughOriginationInput;
};


export type MutationOpenAutoInvestorAccountArgs = {
  input: OpenAutoInvestorAccountInput;
};


export type MutationOpenBorrowerAccountArgs = {
  input: OpenBorrowerAccountInput;
};


export type MutationOpenInvestorAccountArgs = {
  input: OpenInvestorAccountInput;
};


export type MutationOpenInvestorCryptoAccountArgs = {
  input: OpenInvestorCryptoAccountInput;
};


export type MutationOpenReferrerAccountArgs = {
  input: OpenReferrerAccountInput;
};


export type MutationOpenYieldAccountArgs = {
  input: OpenYieldAccountInput;
};


export type MutationOverrideRecaptchaScoreArgs = {
  input: OverrideRecaptchaScoreInput;
};


export type MutationPauseAutomaticInvestingSchedulesArgs = {
  input: PauseAutomaticInvestingSchedulesInput;
};


export type MutationPendPreapprovalArgs = {
  input: PendPreapprovalInput;
};


export type MutationPlaceBatchInvestmentReservationArgs = {
  input: PlaceBatchInvestmentReservationInput;
};


export type MutationPlacePurchaseOrderArgs = {
  input: PlacePurchaseOrderInput;
};


export type MutationProcessPreapprovalPaymentArgs = {
  input: ProcessPreapprovalPaymentInput;
};


export type MutationPublishInvestorUpdateArgs = {
  input: PublishInvestorUpdateInput;
};


export type MutationPublishProgressUpdateArgs = {
  input: PublishProgressUpdateInput;
};


export type MutationPurchaseInvestmentsArgs = {
  input: PurchaseInvestmentsInput;
};


export type MutationReadNotificationArgs = {
  input: ReadNotificationInput;
};


export type MutationRecordInvestmentWizardOptionsArgs = {
  input: RecordInvestmentWizardOptionsInput;
};


export type MutationRecordTermsAndConditionsAcceptanceArgs = {
  input: RecordTermsAndConditionsAcceptanceInput;
};


export type MutationRecordUiInteractionArgs = {
  input: RecordUiInteractionInput;
};


export type MutationRefundAndCloseGeneralizedSecurityArgs = {
  input: RefundAndCloseGeneralizedSecurityInput;
};


export type MutationRegisterCjCookieArgs = {
  input: RegisterCjCookieInput;
};


export type MutationRegisterSignatureAuthenticationKeyArgs = {
  input: RegisterSignatureAuthenticationKeyInput;
};


export type MutationRegisterUnverifiedInvestorArgs = {
  input: RegisterUnverifiedInvestorInput;
};


export type MutationRegisterYieldInvestorArgs = {
  input: RegisterYieldInvestorInput;
};


export type MutationRejectBalanceAdjustmentArgs = {
  input: RejectBalanceAdjustmentInput;
};


export type MutationRejectFundsTransfersArgs = {
  input: RejectFundsTransfersInput;
};


export type MutationRejectPreapprovalArgs = {
  input: RejectPreapprovalInput;
};


export type MutationRejectRequestedTransactionArgs = {
  input: RejectRequestedTransactionInput;
};


export type MutationRemoveBeneficiaryArgs = {
  input: RemoveBeneficiaryInput;
};


export type MutationRemoveClaConditionArgs = {
  input: RemoveClaConditionInput;
};


export type MutationRemoveExternalPartnerArgs = {
  input: RemoveExternalPartnerInput;
};


export type MutationRemoveGuarantorFromLoanApplicationArgs = {
  input: RemoveGuarantorFromLoanApplicationInput;
};


export type MutationRemoveInvestmentWizardStrategyArgs = {
  input: RemoveInvestmentWizardStrategyInput;
};


export type MutationRemoveInvestorUpdateImageArgs = {
  input: RemoveInvestorUpdateImageInput;
};


export type MutationRemovePressAssetArgs = {
  input: RemovePressAssetInput;
};


export type MutationRemovePressItemArgs = {
  input: RemovePressItemInput;
};


export type MutationRemoveProblemBankAccountArgs = {
  input: RemoveProblemBankAccountInput;
};


export type MutationRemoveRecurringTransferScheduleArgs = {
  input: RemoveRecurringTransferScheduleInput;
};


export type MutationRemoveReitHoldingArgs = {
  input: RemoveReitHoldingInput;
};


export type MutationRemoveSavingsGoalArgs = {
  input: RemoveSavingsGoalInput;
};


export type MutationRemoveSecurityFromExternalPartnerArgs = {
  input: RemoveSecurityFromExternalPartnerInput;
};


export type MutationRemoveSecurityFromPlatformArgs = {
  input: RemoveSecurityFromPlatformInput;
};


export type MutationRemoveTermSheetArgs = {
  input: RemoveTermSheetInput;
};


export type MutationRepayGeneralizedSecurityArgs = {
  input: RepayGeneralizedSecurityInput;
};


export type MutationRequestExportArgs = {
  input: RequestExportInput;
};


export type MutationRequestPdfDownloadLinkArgs = {
  input: RequestPdfDownloadLinkInput;
};


export type MutationRequestTransactionArgs = {
  input: RequestTransactionInput;
};


export type MutationRequestUserPasswordResetArgs = {
  input: RequestUserPasswordResetInput;
};


export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput;
};


export type MutationResendMfaArgs = {
  input: ResendMfaInput;
};


export type MutationResetPasswordForEmployeeArgs = {
  input: ResetPasswordForEmployeeInput;
};


export type MutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type MutationRetrieveInitialPlaidLinkTokenArgs = {
  input: RetrieveInitialPlaidLinkTokenInput;
};


export type MutationRetrievePlaidLinkTokenArgs = {
  input: RetrievePlaidLinkTokenInput;
};


export type MutationRevealTermsArgs = {
  input: RevealTermsInput;
};


export type MutationReverifyOrReplacePlaidBankAccountArgs = {
  input: ReverifyOrReplacePlaidBankAccountInput;
};


export type MutationReverseBalanceAdjustmentArgs = {
  input: ReverseBalanceAdjustmentInput;
};


export type MutationSavePressAssetArgs = {
  input: SavePressAssetInput;
};


export type MutationSavePressItemArgs = {
  input: SavePressItemInput;
};


export type MutationSchedulePredefinedInvestmentStrategyArgs = {
  input: SchedulePredefinedInvestmentStrategyInput;
};


export type MutationSendTermSheetToPrincipalArgs = {
  input: SendTermSheetToPrincipalInput;
};


export type MutationSendTermsToBorrowerArgs = {
  input: SendTermsToBorrowerInput;
};


export type MutationSetAutoInvestorAccountConfigArgs = {
  input: SetAutoInvestorAccountConfigInput;
};


export type MutationSetBrokerApplicationFeeAmountArgs = {
  input: SetBrokerApplicationFeeAmountInput;
};


export type MutationSetPrimaryAccountArgs = {
  input: SetPrimaryAccountInput;
};


export type MutationSetReitReinvestmentSettingArgs = {
  input: SetReitReinvestmentSettingInput;
};


export type MutationSetupSecurityForInstitutionalPurchaseArgs = {
  input: SetupSecurityForInstitutionalPurchaseInput;
};


export type MutationStartLendingLoanApplicationUsingPreapprovalArgs = {
  input: StartLendingLoanApplicationUsingPreapprovalInput;
};


export type MutationStartPdfBatchGenerationArgs = {
  input: StartPdfBatchGenerationInput;
};


export type MutationStartUserRegistrationArgs = {
  input: StartUserRegistrationInput;
};


export type MutationSubmitAllStagedLabsRepaymentsArgs = {
  input: SubmitAllStagedLabsRepaymentsInput;
};


export type MutationSubmitNoteInterestPaymentArgs = {
  input: SubmitNoteInterestPaymentInput;
};


export type MutationSubmitPartialRepaymentArgs = {
  input: SubmitPartialRepaymentInput;
};


export type MutationSupportingDocumentUploadedArgs = {
  input: SupportingDocumentUploadedInput;
};


export type MutationTakeGeneralizedSecurityLiveArgs = {
  input: TakeGeneralizedSecurityLiveInput;
};


export type MutationToggleAccountFlagArgs = {
  input: ToggleAccountFlagInput;
};


export type MutationToggleBrokerApplicationFeeEnabledArgs = {
  input: ToggleBrokerApplicationFeeEnabledInput;
};


export type MutationToggleRecurringTransferScheduleArgs = {
  input: ToggleRecurringTransferScheduleInput;
};


export type MutationToggleUserModerationArgs = {
  input: ToggleUserModerationInput;
};


export type MutationTransferFundsArgs = {
  input: TransferFundsInput;
};


export type MutationTransferPrincipalLendingLoanApplicationsArgs = {
  input: TransferPrincipalLendingLoanApplicationsInput;
};


export type MutationTransitionLendingLoanArgs = {
  input: TransitionLendingLoanInput;
};


export type MutationTransitionTermSheetArgs = {
  input: TransitionTermSheetInput;
};


export type MutationUnArchiveUserArgs = {
  input: UnArchiveUserInput;
};


export type MutationUnderwritingCompletedArgs = {
  input: UnderwritingCompletedInput;
};


export type MutationUnenrollFromMfaArgs = {
  input: UnenrollFromMfaInput;
};


export type MutationUnlinkBankAccountFromTrustlineArgs = {
  input: UnlinkBankAccountFromTrustlineInput;
};


export type MutationUnlockEmployeeArgs = {
  input: UnlockEmployeeInput;
};


export type MutationUnlockUserArgs = {
  input: UnlockUserInput;
};


export type MutationUnpublishInvestorUpdateArgs = {
  input: UnpublishInvestorUpdateInput;
};


export type MutationUnreadNotificationArgs = {
  input: UnreadNotificationInput;
};


export type MutationUpdateAutomaticRepaymentTransfersArgs = {
  input: UpdateAutomaticRepaymentTransfersInput;
};


export type MutationUpdateBeneficiaryArgs = {
  input: UpdateBeneficiaryInput;
};


export type MutationUpdateConfigurationArgs = {
  input: UpdateConfigurationInput;
};


export type MutationUpdateDwollaCustomerArgs = {
  input: UpdateDwollaCustomerInput;
};


export type MutationUpdateHostedDocumentArgs = {
  input: UpdateHostedDocumentInput;
};


export type MutationUpdateInvestmentWizardStrategyArgs = {
  input: UpdateInvestmentWizardStrategyInput;
};


export type MutationUpdateIraFundsTransferAmountArgs = {
  input: UpdateIraFundsTransferAmountInput;
};


export type MutationUpdatePushNotificationSubscriptionConfigurationArgs = {
  input: UpdatePushNotificationSubscriptionConfigurationInput;
};


export type MutationUpdateRecurringTransferScheduleArgs = {
  input: UpdateRecurringTransferScheduleInput;
};


export type MutationUpdateReferralCampaignArgs = {
  input: UpdateReferralCampaignInput;
};


export type MutationUpdateSavingsGoalArgs = {
  input: UpdateSavingsGoalInput;
};


export type MutationUpdateTaxPayerArgs = {
  input: UpdateTaxPayerInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWireTransferRequestArgs = {
  input: UpdateWireTransferRequestInput;
};


export type MutationUpdateYieldInvestorProfileArgs = {
  input: UpdateYieldInvestorProfileInput;
};


export type MutationUploadVerificationDocumentArgs = {
  input: UploadVerificationDocumentInput;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyMfaAttemptArgs = {
  input: VerifyMfaAttemptInput;
};


export type MutationVerifyMicroDepositsArgs = {
  input: VerifyMicroDepositsInput;
};

export type NewReferralCampaignInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  effectiveAt: Scalars['ISO8601DateTime']['input'];
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  investmentMaturationThreshold?: InputMaybe<Scalars['Int']['input']>;
  investmentThresholdAmountCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referredRewardAmountCents: Scalars['Int']['input'];
  referrerRewardAmountCents: Scalars['Int']['input'];
  rewardThresholdAmountCents: Scalars['Int']['input'];
  systemName?: InputMaybe<ReferralCampaignSystemName>;
  type?: InputMaybe<ReferralCampaignTypes>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type NewTaxPayerInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  businessAccount: Scalars['Boolean']['input'];
  businessName?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  ein?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

/** A payment submitted for a GROUNDFLOOR note */
export type NoteInterestPayment = {
  __typename?: 'NoteInterestPayment';
  finalPayment?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  interestPaidCents?: Maybe<Scalars['Int']['output']>;
};

/** Notifications for users */
export type Notification = {
  __typename?: 'Notification';
  account: Account;
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  metadataJsonData?: Maybe<Scalars['String']['output']>;
  state: NotificationState;
  template: Scalars['String']['output'];
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Notification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Notification>;
};

export enum NotificationState {
  /** Notification has been archived by user */
  Archived = 'ARCHIVED',
  /** Notification has been read by user */
  Read = 'READ',
  /** Notification has not been read or archived by user */
  Unread = 'UNREAD'
}

/** Used to determine who we're selling a loan to */
export type Offering = {
  __typename?: 'Offering';
  id: Scalars['ID']['output'];
  /** The name of the offering */
  name: Scalars['String']['output'];
};

export enum OfferingRegulation {
  /** Regular GFN offering */
  Gfn = 'GFN',
  /** Offering to all users */
  GfnYield = 'GFN_YIELD',
  /** Offering to Groundfloor shareholders */
  Gfs = 'GFS',
  /** Offering to GA residents only */
  Ige = 'IGE',
  /** Offering to users in the velvet rope club */
  VelvetRope = 'VELVET_ROPE'
}

export type OnboardingInvestorAttributes = {
  businessIdentity?: InputMaybe<Scalars['Boolean']['input']>;
  investmentAmountCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of OpenAutoInvestorAccount */
export type OpenAutoInvestorAccountInput = {
  /**
   * If true, the server will attempt to link this new Auto Investor account to an
   * existing Dwolla bank account.  Examine account.trustlines.bankAccount to see if it worked.
   */
  autoLinkBankAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of OpenAutoInvestorAccount. */
export type OpenAutoInvestorAccountPayload = {
  __typename?: 'OpenAutoInvestorAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of OpenBorrowerAccount */
export type OpenBorrowerAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of OpenBorrowerAccount. */
export type OpenBorrowerAccountPayload = {
  __typename?: 'OpenBorrowerAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** A summary of an investor's open LRO investments.  For other investments, see the InvestorActivitySummary. */
export type OpenInvestmentsSummary = {
  __typename?: 'OpenInvestmentsSummary';
  currentSecurityInvestmentsSummary: InvestorSummaryRollup;
  defaultSecurityInvestmentsSummary: InvestorSummaryRollup;
  extendedSecurityInvestmentsSummary: InvestorSummaryRollup;
  /** @deprecated Use InvestorActivitySummary.openLoanInvestmentsSummary.investmentCount instead */
  investmentCount: Scalars['Int']['output'];
  /** @deprecated Use InvestorActivitySummary.openLoanInvestmentsSummary.sumOfAmountsCents instead */
  sumOfAmountsCents: Scalars['Float']['output'];
  /** @deprecated Use InvestorActivitySummary.openLoanInvestmentsSummary.expectedRateOfReturn instead */
  totalExpectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  workoutSecurityInvestmentsSummary: InvestorSummaryRollup;
};

/** Autogenerated input type of OpenInvestorAccount */
export type OpenInvestorAccountInput = {
  /**
   * If true, the server will attempt to link this new Auto Investor account to an
   * existing Dwolla bank account.  Examine account.trustlines.bankAccount to see if it worked.
   */
  autoLinkBankAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of OpenInvestorAccount. */
export type OpenInvestorAccountPayload = {
  __typename?: 'OpenInvestorAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of OpenInvestorCryptoAccount */
export type OpenInvestorCryptoAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of OpenInvestorCryptoAccount. */
export type OpenInvestorCryptoAccountPayload = {
  __typename?: 'OpenInvestorCryptoAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of OpenReferrerAccount */
export type OpenReferrerAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of OpenReferrerAccount. */
export type OpenReferrerAccountPayload = {
  __typename?: 'OpenReferrerAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of OpenYieldAccount */
export type OpenYieldAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OpenYieldAccount. */
export type OpenYieldAccountPayload = {
  __typename?: 'OpenYieldAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  yieldInvestorProfile?: Maybe<YieldInvestorProfile>;
};

/** The operating system of the user. */
export enum OperatingSystem {
  /** The user is using an Android device */
  Android = 'ANDROID',
  /** The user is using an iOS device */
  Ios = 'IOS',
  /** The user is using a web browser */
  Web = 'WEB'
}

export enum Order {
  /** Sort objects in ascending order */
  Asc = 'ASC',
  /** Sort objects in descending order */
  Desc = 'DESC'
}

export type OriginationFeeInput = {
  brokerAmountCents?: InputMaybe<Scalars['Int']['input']>;
  brokerBips?: InputMaybe<Scalars['Int']['input']>;
  groundfloorAmountCents?: InputMaybe<Scalars['Int']['input']>;
  groundfloorBips?: InputMaybe<Scalars['Int']['input']>;
  minimumCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of OverrideRecaptchaScore */
export type OverrideRecaptchaScoreInput = {
  canonicalScore: Scalars['Float']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  userSecureId: Scalars['String']['input'];
};

/** Autogenerated return type of OverrideRecaptchaScore. */
export type OverrideRecaptchaScorePayload = {
  __typename?: 'OverrideRecaptchaScorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  recaptchaScore?: Maybe<RecaptchaScore>;
};

/** OwnershipTransfer of LoanApplication or Investment */
export type OwnershipTransfer = Timestamp & {
  __typename?: 'OwnershipTransfer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fromAccount?: Maybe<Account>;
  fromUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  toAccount?: Maybe<User>;
  toUser?: Maybe<User>;
  transferredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationAttributes = {
  pageNumber: Scalars['Int']['input'];
  resultsPerPage: Scalars['Int']['input'];
};

/** Metadata for a paginated collection of objects */
export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  /** Number of results on the returned page */
  count: Scalars['Int']['output'];
  /** Current page number of returned results */
  pageNumber: Scalars['Int']['output'];
  /** Total number of results in the collection */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages based on the number of results per page requested */
  totalPageCount: Scalars['Int']['output'];
};

export type PartialRepayment = SecurityRepayment & {
  __typename?: 'PartialRepayment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  finalPayment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  returnOfCapitalCents?: Maybe<Scalars['Int']['output']>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  transactionDescriptor?: Maybe<RepaymentTransactionDescriptor>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type PartialRepaymentInput = {
  finalPayment: Scalars['Boolean']['input'];
  returnOfCapitalCents: Scalars['Int']['input'];
  securityId: Scalars['Int']['input'];
  totalPaymentAmountCents: Scalars['Int']['input'];
  transactionDescriptor?: InputMaybe<RepaymentTransactionDescriptor>;
};

/** Object to hold error information for authorization or validations */
export type PasswordModificationError = {
  __typename?: 'PasswordModificationError';
  /** Error code describing the nature of the failure. */
  code?: Maybe<PasswordModificationErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum PasswordModificationErrorCode {
  InvalidPassword = 'INVALID_PASSWORD',
  MfaRequired = 'MFA_REQUIRED',
  RecaptchaAuthenticationFailed = 'RECAPTCHA_AUTHENTICATION_FAILED',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  ServerError = 'SERVER_ERROR',
  UnauthorizedClient = 'UNAUTHORIZED_CLIENT',
  ValidationsFailed = 'VALIDATIONS_FAILED'
}

/** Autogenerated input type of PauseAutomaticInvestingSchedules */
export type PauseAutomaticInvestingSchedulesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The secure_id associated with an Account. */
  secureId: Scalars['ID']['input'];
};

/** Autogenerated return type of PauseAutomaticInvestingSchedules. */
export type PauseAutomaticInvestingSchedulesPayload = {
  __typename?: 'PauseAutomaticInvestingSchedulesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentSchedules: Array<InvestmentSchedule>;
};

export type PdfDocument = {
  account: Account;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: PdfDocumentTypeName;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of PDF documents, with meta-data concerning the page number, total number of pages etc. */
export type PdfDocumentCollection = {
  __typename?: 'PdfDocumentCollection';
  /** Information regarding the paginated results */
  paginationMetadata: PaginationMetadata;
  /** The paginated collection of PDF documents */
  pdfDocuments: Array<PdfDocument>;
};

export type PdfDocumentCollectionOptionsInput = {
  paginationAttributes?: InputMaybe<PaginationAttributes>;
  pdfDocumentFilters?: InputMaybe<PdfDocumentFilterInput>;
  sortAttributes?: InputMaybe<DefaultSortAttributes>;
};

export type PdfDocumentFilterInput = {
  /** The Secure ID of the account that owns the desired documents. */
  accountSecureId?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An array of PDF document types to filter for. */
  type?: InputMaybe<Array<PdfDocumentTypeName>>;
};

export enum PdfDocumentTypeName {
  MiscellaneousPdfDocument = 'MISCELLANEOUS_PDF_DOCUMENT',
  PdfLabsMonthlyStatement = 'PDF_LABS_MONTHLY_STATEMENT',
  PdfMonthlyStatement = 'PDF_MONTHLY_STATEMENT',
  PdfTaxForm = 'PDF_TAX_FORM'
}

export type PdfLabsMonthlyStatement = PdfDocument & {
  __typename?: 'PdfLabsMonthlyStatement';
  account: Account;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: PdfDocumentTypeName;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A PDF Document representing a user's monthly financial activity */
export type PdfMonthlyStatement = PdfDocument & {
  __typename?: 'PdfMonthlyStatement';
  account: Account;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  statementMonth?: Maybe<Scalars['String']['output']>;
  statementYear?: Maybe<Scalars['Int']['output']>;
  type: PdfDocumentTypeName;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A PDF Document representing a user's tax data */
export type PdfTaxForm = PdfDocument & {
  __typename?: 'PdfTaxForm';
  account: Account;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  taxYear?: Maybe<Scalars['Int']['output']>;
  type: PdfDocumentTypeName;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PendPreapproval */
export type PendPreapprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preapprovalId: Scalars['ID']['input'];
};

/** Autogenerated return type of PendPreapproval. */
export type PendPreapprovalPayload = {
  __typename?: 'PendPreapprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  preapproval?: Maybe<Preapproval>;
};

export enum PerformanceState {
  /** Only return securities that are defaulted */
  Default = 'DEFAULT',
  /** Only return securities that are Extended */
  Extended = 'EXTENDED',
  /** Only return securities that are Performing */
  Performing = 'PERFORMING'
}

/** Autogenerated input type of PlaceBatchInvestmentReservation */
export type PlaceBatchInvestmentReservationInput = {
  accountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  purchaseOrders: Array<LeafPurchaseOrderAttributes>;
};

/** Autogenerated return type of PlaceBatchInvestmentReservation. */
export type PlaceBatchInvestmentReservationPayload = {
  __typename?: 'PlaceBatchInvestmentReservationPayload';
  batchInvestmentReservation?: Maybe<BatchInvestmentReservation>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of PlacePurchaseOrder */
export type PlacePurchaseOrderInput = {
  children: Array<LeafPurchaseOrderAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trustlineId: Scalars['Int']['input'];
};

/** Autogenerated return type of PlacePurchaseOrder. */
export type PlacePurchaseOrderPayload = {
  __typename?: 'PlacePurchaseOrderPayload';
  children?: Maybe<Array<PurchaseOrder>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  id?: Maybe<Scalars['ID']['output']>;
  trustline?: Maybe<Trustline>;
};

/** Supports the portfolio control center for users */
export type PortfolioControlCenter = {
  __typename?: 'PortfolioControlCenter';
  account: Account;
  investmentSchedules: Array<InvestmentSchedule>;
  user: User;
};

/** Describes a qc maxx application between a borrower and Groundfloor */
export type Preapproval = {
  __typename?: 'Preapproval';
  account: Account;
  amountApprovedCents: Scalars['Int']['output'];
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  disclosureAdverseLegalJudgement: Scalars['Boolean']['output'];
  disclosureBankruptcy: Scalars['Boolean']['output'];
  disclosureConvictedOfFelony: Scalars['Boolean']['output'];
  disclosureForeclosure: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  geographicFocusStates?: Maybe<Array<Scalars['String']['output']>>;
  hostedDocuments?: Maybe<Array<HostedDocument>>;
  id: Scalars['ID']['output'];
  lendingBorrowerEntity?: Maybe<LendingBorrowerEntity>;
  lendingLoanApplications?: Maybe<Array<LendingLoanApplication>>;
  lendingPrincipal?: Maybe<LendingPrincipal>;
  state: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PreapprovalAttributes = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  amountApprovedCents?: InputMaybe<Scalars['Int']['input']>;
  approvedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  approverEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  disclosureAdverseLegalJudgement?: InputMaybe<Scalars['Boolean']['input']>;
  disclosureBankruptcy?: InputMaybe<Scalars['Boolean']['input']>;
  disclosureConvictedOfFelony?: InputMaybe<Scalars['Boolean']['input']>;
  disclosureForeclosure?: InputMaybe<Scalars['Boolean']['input']>;
  geographicFocusStates?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lendingBorrowerEntityId?: InputMaybe<Scalars['ID']['input']>;
  lendingPrincipalId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PreapprovalState {
  /** preapproval has been abandoned */
  Abandoned = 'ABANDONED',
  /** preapproval has been approved */
  Approved = 'APPROVED',
  /** preapproval is in process of being filled out */
  InProgress = 'IN_PROGRESS',
  /** awaiting underwriting review */
  InReview = 'IN_REVIEW',
  /** awaiting borrower information */
  Pending = 'PENDING',
  /** awaiting all documentation */
  PendingDocumentation = 'PENDING_DOCUMENTATION',
  /** awaiting payment */
  PendingPayment = 'PENDING_PAYMENT',
  /** preapproval has been rejected */
  Rejected = 'REJECTED'
}

export type PredefinedInvestmentStrategy = {
  __typename?: 'PredefinedInvestmentStrategy';
  borrowerExperienceScoreMax: Scalars['Int']['output'];
  borrowerExperienceScoreMin: Scalars['Int']['output'];
  filters: Array<PredefinedInvestmentStrategyFilter>;
  grades: Array<Scalars['String']['output']>;
  loanToValueScoreMax: Scalars['Int']['output'];
  loanToValueScoreMin: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pickedLoans: Array<PredefinedInvestmentStrategyPick>;
  skinInTheGameScoreMax: Scalars['Int']['output'];
  skinInTheGameScoreMin: Scalars['Int']['output'];
};

export type PredefinedInvestmentStrategyFilter = {
  __typename?: 'PredefinedInvestmentStrategyFilter';
  borrowerExperienceScoreMax: Scalars['Int']['output'];
  borrowerExperienceScoreMin: Scalars['Int']['output'];
  grades: Array<Scalars['String']['output']>;
  loanToValueScoreMax: Scalars['Int']['output'];
  loanToValueScoreMin: Scalars['Int']['output'];
  skinInTheGameScoreMax: Scalars['Int']['output'];
  skinInTheGameScoreMin: Scalars['Int']['output'];
};

export enum PredefinedInvestmentStrategyName {
  /** all */
  All = 'ALL',
  /** conservative */
  Conservative = 'CONSERVATIVE',
  /** dynamic */
  Dynamic = 'DYNAMIC',
  /** moderate */
  Moderate = 'MODERATE'
}

export type PredefinedInvestmentStrategyPick = {
  __typename?: 'PredefinedInvestmentStrategyPick';
  investingAmountCents: Scalars['Int']['output'];
  loan: RealEstateLoan;
};

export type PressAsset = {
  __typename?: 'PressAsset';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PressAssetInput = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PressItem = {
  __typename?: 'PressItem';
  author?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: PressItemTypeName;
  url: Scalars['String']['output'];
};

export type PressItemInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PressItemTypeName>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum PressItemTypeName {
  /** An article. */
  Article = 'ARTICLE',
  /** A standard press release. */
  PressRelease = 'PRESS_RELEASE'
}

/** Information of the pricipal for a loan */
export type Principal = {
  __typename?: 'Principal';
  /** ID of the associated account */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** The address that is associated with the principal */
  address?: Maybe<Address>;
  /** The date of birth for the principal */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** Email of the principal */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the principal */
  firstName?: Maybe<Scalars['String']['output']>;
  /** ID of the principal */
  id: Scalars['ID']['output'];
  /** First name of the principal */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The credit score of the principal */
  personalCreditScore?: Maybe<Scalars['String']['output']>;
  /** Phone number of the principal */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Strategic focus of the principal */
  principalStrategicFocus?: Maybe<Scalars['String']['output']>;
  /** Social Security Number of the principal */
  ssn?: Maybe<Scalars['String']['output']>;
  /** State of the principal */
  state?: Maybe<Scalars['String']['output']>;
  /** Principals experience */
  totalProjectsCompleted?: Maybe<Scalars['Int']['output']>;
};

export type PrincipalAttributes = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  annuallyCompletedProjectsAverageCount?: InputMaybe<Scalars['Int']['input']>;
  averageProjectCostCents?: InputMaybe<Scalars['Int']['input']>;
  averageProjectSalesPriceCents?: InputMaybe<Scalars['Int']['input']>;
  averageProjectsDurationMonths?: InputMaybe<Scalars['Int']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fundedLoansCount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  personalCreditScore?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  principalStrategicFocus?: InputMaybe<Scalars['String']['input']>;
  repaidLoansCount?: InputMaybe<Scalars['Int']['input']>;
  repaymentPercentage?: InputMaybe<Scalars['Float']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  totalProjectsCompleted?: InputMaybe<Scalars['Int']['input']>;
};

/** Information for the pricipal of a loan. */
export type PrincipalV2 = {
  __typename?: 'PrincipalV2';
  /** The address that is associated with the principal. */
  address?: Maybe<Address>;
  /** The number of projects that they complete per year on average. */
  annuallyCompletedProjectsAverageCount?: Maybe<Scalars['Int']['output']>;
  /** How much their projects typically cost in cents. */
  averageProjectCostCents?: Maybe<Scalars['Int']['output']>;
  /** The amount that their projects have sold for on average. */
  averageProjectSalesPriceCents?: Maybe<Scalars['Int']['output']>;
  /** How long their projects have taken to complete on average. */
  averageProjectsDurationMonths?: Maybe<Scalars['Int']['output']>;
  /** The number of projects the principal has completed before. */
  completedProjectsCount?: Maybe<Scalars['Int']['output']>;
  /** Email of the principal. */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the principal. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The number of the their loans that have been funded or repaid. */
  fundedOrRepaidLoansCount: Scalars['Int']['output'];
  /** ID of the principal. */
  id: Scalars['ID']['output'];
  /** First name of the principal. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone number of the principal. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The number of their loans that have been repaid. */
  repaidLoansCount: Scalars['Int']['output'];
  /** How often their projects are repaid on time as a percentage. */
  repaymentPercentage?: Maybe<Scalars['Float']['output']>;
  /** State of the principal. */
  state?: Maybe<Scalars['String']['output']>;
  /** Strategic focus of the principal. */
  strategicFocus?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ProcessPreapprovalPayment */
export type ProcessPreapprovalPaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preapprovalId: Scalars['ID']['input'];
  stripeToken: Scalars['String']['input'];
};

/** Autogenerated return type of ProcessPreapprovalPayment. */
export type ProcessPreapprovalPaymentPayload = {
  __typename?: 'ProcessPreapprovalPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  preapproval?: Maybe<Preapproval>;
};

/** A product release announcement */
export type ProductReleaseAnnouncement = {
  __typename?: 'ProductReleaseAnnouncement';
  /** Whether the announcement is active */
  active: Scalars['Boolean']['output'];
  /** Date the announcement expires */
  expiresOn: Scalars['ISO8601Date']['output'];
  /** ID of the announcement */
  id: Scalars['ID']['output'];
  /** Slides for the announcement */
  slides: Array<ProductReleaseSlide>;
  /** URL to show the announcement */
  targetUrl: Scalars['String']['output'];
  /** Title of the announcement */
  title: Scalars['String']['output'];
};

/** A slide for a product release announcement */
export type ProductReleaseSlide = {
  __typename?: 'ProductReleaseSlide';
  /** Text for the CTA button */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Description to show on the slide */
  description: Scalars['String']['output'];
  /** ID of the slide */
  id: Scalars['ID']['output'];
  /** Image to show on the slide */
  image?: Maybe<Image>;
  /** Ordering of the slide */
  ordering: Scalars['Int']['output'];
  /** Title to show on the slide */
  title: Scalars['String']['output'];
};

/** Updates of a project's status from borrowers */
export type ProgressUpdate = {
  __typename?: 'ProgressUpdate';
  /** string of html */
  html?: Maybe<Scalars['String']['output']>;
  /** ID of the progress update */
  id: Scalars['ID']['output'];
  /** The time that the record was published or updated last. */
  lastUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the associated lending loan */
  lendingLoan: LendingLoan;
  /** whether update is unpublished, published, or archived */
  state: ProgressUpdateState;
};

export enum ProgressUpdateState {
  /** The update was not relevant and was archived */
  Archived = 'ARCHIVED',
  /** The update has been published to the investing system */
  Published = 'PUBLISHED',
  /** The update has not been published to the investing system */
  Unpublished = 'UNPUBLISHED'
}

/** Funds that have been disbursed for promotional purposes */
export type PromotionalCredit = Timestamp & {
  __typename?: 'PromotionalCredit';
  account?: Maybe<Account>;
  /** Amount that the Promotional is for */
  amountCents?: Maybe<Scalars['Int']['output']>;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  approver?: Maybe<Employee>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<Employee>;
  id?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  postedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rejector?: Maybe<Employee>;
  restrictedCredit: Scalars['Boolean']['output'];
  reversedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reverser?: Maybe<Employee>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of PublishInvestorUpdate */
export type PublishInvestorUpdateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of PublishInvestorUpdate. */
export type PublishInvestorUpdatePayload = {
  __typename?: 'PublishInvestorUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investorUpdate?: Maybe<InvestorUpdate>;
};

/** Autogenerated input type of PublishProgressUpdate */
export type PublishProgressUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  progressUpdateId: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishProgressUpdate. */
export type PublishProgressUpdatePayload = {
  __typename?: 'PublishProgressUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  progressUpdate?: Maybe<ProgressUpdate>;
};

export type PublishableLendingLoan = {
  __typename?: 'PublishableLendingLoan';
  amountCents: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publishedLoanCount: Scalars['Int']['output'];
  term: Scalars['Int']['output'];
};

export type PublishableProgressUpdate = {
  __typename?: 'PublishableProgressUpdate';
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  loanName?: Maybe<Scalars['String']['output']>;
  principalFirstName?: Maybe<Scalars['String']['output']>;
  principalLastName?: Maybe<Scalars['String']['output']>;
  publishedLoans: Array<PublishedLoan>;
  state: ProgressUpdateState;
};

export type PublishedLoan = {
  __typename?: 'PublishedLoan';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PurchaseInvestments */
export type PurchaseInvestmentsInput = {
  children: Array<LeafPurchaseOrderAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trustlineId: Scalars['Int']['input'];
};

/** Autogenerated return type of PurchaseInvestments. */
export type PurchaseInvestmentsPayload = {
  __typename?: 'PurchaseInvestmentsPayload';
  children?: Maybe<Array<PurchaseOrder>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  id?: Maybe<Scalars['ID']['output']>;
  trustline?: Maybe<Trustline>;
};

/** An order to purchase an amount in a Security Offering, can be made in batches */
export type PurchaseOrder = Timestamp & {
  __typename?: 'PurchaseOrder';
  /** Amount to purchase, can be null for a root PurchaseOrder */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** Children (most likely leafs) */
  children?: Maybe<Array<PurchaseOrder>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Investments that were purchased */
  investments?: Maybe<Array<Investment>>;
  /** Parent (most likely root) */
  parent?: Maybe<PurchaseOrder>;
  /** Security offering to purchase amount in, can be null for root PurchaseOrder */
  security?: Maybe<Security>;
  /** Current state of the order(s) being placed */
  state: PurchaseOrderState;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum PurchaseOrderState {
  /** Fulfilled investments purchases are being cleared */
  Clearing = 'CLEARING',
  /** Order is completed and investments are cleared */
  Completed = 'COMPLETED',
  /** Order has been fulfilled */
  Fulfilling = 'FULFILLING',
  /** Funds have been aquired to fulfill order */
  Paid = 'PAID',
  /** Order is open and can still be modified */
  Pending = 'PENDING',
  /** Order has been placed and will be queued */
  Placed = 'PLACED'
}

/** Mobile user's current push notification category subscription settings. */
export type PushNotificationSubscriptionConfiguration = {
  __typename?: 'PushNotificationSubscriptionConfiguration';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** User is subscribed to bonus related push notifications. */
  subscribedToBonuses: Scalars['Boolean']['output'];
  /** User is subscribed to push notifications related to account errors. */
  subscribedToErrors: Scalars['Boolean']['output'];
  /** User is subscribed to milestone related push notifications. */
  subscribedToMilestones: Scalars['Boolean']['output'];
  /** User is subscribed to Groundfloor news related push notifications. */
  subscribedToNews: Scalars['Boolean']['output'];
  /** User is subscribed to activity summary related push notifications. */
  subscribedToSummaries: Scalars['Boolean']['output'];
  /** User is subscribed to FundsTransfer related push notifications. */
  subscribedToTransfers: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The secure_id of the user. */
  userId: Scalars['ID']['output'];
};

/** Object to hold error information for authorization or validations */
export type PushNotificationSubscriptionConfigurationError = {
  __typename?: 'PushNotificationSubscriptionConfigurationError';
  /** Error code describing the nature of the failure. */
  code?: Maybe<PushNotificationSubscriptionConfigurationErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum PushNotificationSubscriptionConfigurationErrorCode {
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  UnauthorizedClient = 'UNAUTHORIZED_CLIENT',
  UserAlreadyHasPushNotificationSubscriptionConfiguration = 'USER_ALREADY_HAS_PUSH_NOTIFICATION_SUBSCRIPTION_CONFIGURATION',
  ValidationsFailed = 'VALIDATIONS_FAILED'
}

/** An input object for creating a user's push notification subscription configuration. */
export type PushNotificationSubscriptionConfigurationInput = {
  /** User is subscribed to bonus related push notifications. */
  subscribedToBonuses: Scalars['Boolean']['input'];
  /** User is subscribed to push notifications related to account errors. */
  subscribedToErrors: Scalars['Boolean']['input'];
  /** User is subscribed to milestone related push notifications. */
  subscribedToMilestones: Scalars['Boolean']['input'];
  /** User is subscribed to Groundfloor news related push notifications. */
  subscribedToNews: Scalars['Boolean']['input'];
  /** User is subscribed to activity summary related push notifications. */
  subscribedToSummaries: Scalars['Boolean']['input'];
  /** User is subscribed to FundsTransfer related push notifications. */
  subscribedToTransfers: Scalars['Boolean']['input'];
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accounts?: Maybe<Array<Account>>;
  activeClients: Array<Client>;
  adminUser?: Maybe<AdminUser>;
  amountRecentlyTransferredIn?: Maybe<RecentTransferSummary>;
  applicationConditions?: Maybe<Array<LoanApplicationCondition>>;
  applicationContent?: Maybe<ApplicationContent>;
  autoInvestorAccountConfig?: Maybe<AutoInvestorAccountConfig>;
  autoInvestorAccountRunCollection?: Maybe<AutoInvestorAccountRunCollection>;
  balanceAdjustment?: Maybe<BalanceAdjustment>;
  balanceAdjustments?: Maybe<Array<BalanceAdjustment>>;
  bankAccount?: Maybe<BankAccount>;
  bankAccounts?: Maybe<Array<BankAccount>>;
  bdmProfile?: Maybe<BdmProfile>;
  /** A collection of account beneficiaries, optionally filtered by account ID. */
  beneficiaries: Array<Beneficiary>;
  /** a collection of blocked email domains */
  blockList: Scalars['String']['output'];
  borrowerEntity?: Maybe<BorrowerEntity>;
  /** Configuration details regarding the application fee paid by brokers. */
  brokerApplicationFeeConfiguration?: Maybe<BrokerApplicationFeeConfiguration>;
  closingDetail?: Maybe<ClosingDetail>;
  companyUpdates?: Maybe<Array<CompanyUpdate>>;
  conditions?: Maybe<Array<Condition>>;
  /** Value of requested configuration */
  configuration: Scalars['String']['output'];
  contribution?: Maybe<Contribution>;
  contributionAuthorizationForms?: Maybe<Array<CustomerAuthorizationForm>>;
  contributions?: Maybe<Array<Contribution>>;
  convertibleDebtNotes?: Maybe<Array<ConvertibleDebtNote>>;
  currentReferralCampaign?: Maybe<ReferralCampaign>;
  currentStairsReferralCampaign?: Maybe<ReferralCampaign>;
  customerAuthorizationForm?: Maybe<Array<CustomerAuthorizationForm>>;
  dailyInvestmentGroupCollection?: Maybe<DailyInvestmentGroupCollection>;
  /** Data points that can be graphed to show disbursements over time */
  disbursementsOverTime?: Maybe<Array<RepaymentDataPoint>>;
  disbursementsSummary?: Maybe<DisbursementsSummary>;
  emailStatus: EmailStatus;
  externalPartners?: Maybe<Array<ExternalPartner>>;
  fetchEmployeeByClient: Employee;
  fetchUserByClient: User;
  flagshipIndex?: Maybe<FlagshipIndex>;
  flagshipIndexGradeAggregations: Array<FlagshipIndexGradeAggregation>;
  flagshipIndexHoldings: FlagshipIndexHoldings;
  fundsTransferCollection?: Maybe<FundsTransferCollection>;
  fundsTransferList?: Maybe<FundsTransferListItemCollection>;
  /** @deprecated use recurringTransferSchedules */
  fundsTransferSchedules?: Maybe<Array<FundsTransferSchedule>>;
  fundsTransfers?: Maybe<Array<FundsTransfer>>;
  futureYieldBalances?: Maybe<Array<FutureYieldBalance>>;
  generalizedSecurities?: Maybe<Array<GeneralizedSecurity>>;
  generalizedSecurity?: Maybe<GeneralizedSecurity>;
  gf3PerformanceDashboard: Gf3PerformanceDashboard;
  graduatedGroundfloorLabsOfferings?: Maybe<Array<GeneralizedSecurity>>;
  groundfloorEquityOfferings?: Maybe<Array<GroundfloorEquityOffering>>;
  groundfloorNotes?: Maybe<Array<GroundfloorNote>>;
  intercomDigest?: Maybe<Scalars['String']['output']>;
  investableSecurities?: Maybe<Array<Security>>;
  investmentPortfolioBreakdown: InvestmentPortfolioBreakdown;
  investmentSchedules?: Maybe<Array<InvestmentSchedule>>;
  investmentV2: Investment;
  investmentWizardStrategies: Array<InvestmentWizardStrategy>;
  investments?: Maybe<Array<Investment>>;
  investmentsBySecuritySubtype?: Maybe<Array<Investment>>;
  investmentsV2: InvestmentConnection;
  investorActivitySummary: InvestorActivitySummary;
  /** Gets the count of Auto Investor Available LROs */
  investorAutoAvailableLroCount: Scalars['Int']['output'];
  investorDashboard?: Maybe<InvestorDashboardDataset>;
  investorProfile?: Maybe<InvestorProfile>;
  investorRepaymentCollection?: Maybe<InvestorRepaymentCollection>;
  investorRepayments?: Maybe<Array<InvestorRepayment>>;
  issuingLroIssuers: Array<LroIssuer>;
  labsInvestments: Array<Investment>;
  latestCompanyUpdate?: Maybe<CompanyUpdate>;
  lendingBorrowerEntity?: Maybe<LendingBorrowerEntity>;
  lendingLoan: LendingSecurity;
  lendingLoanApplication?: Maybe<LendingLoanApplication>;
  lendingLoans?: Maybe<Array<LendingLoan>>;
  lendingPrincipal?: Maybe<LendingPrincipal>;
  loanApplication?: Maybe<LoanApplication>;
  /** A promotion which allows borrowers to submit loan applications without paying the usual fee. */
  loanApplicationFeeWaiverPromotion?: Maybe<LoanApplicationFeeWaiverPromotion>;
  loanBySlug?: Maybe<RealEstateLoan>;
  loanFeeSchedules?: Maybe<LoanFeeSchedules>;
  loans?: Maybe<Array<Loan>>;
  marketingCategories: MarketingCategoryConnection;
  marketingCategory?: Maybe<MarketingCategory>;
  /** Summary of investment activity across the specified accounts */
  multiAccountInvestorActivitySummary: InvestorActivitySummary;
  notification?: Maybe<Notification>;
  notifications: NotificationConnection;
  /** @deprecated Use investorActivitySummary instead.  It has all of this information and more. */
  openInvestmentsSummary: OpenInvestmentsSummary;
  pdfDocuments?: Maybe<PdfDocumentCollection>;
  portfolioControlCenter?: Maybe<PortfolioControlCenter>;
  preapproval?: Maybe<Preapproval>;
  preapprovals?: Maybe<Array<Preapproval>>;
  predefinedInvestmentStrategies: Array<PredefinedInvestmentStrategy>;
  presignedPhotoUploadUrl?: Maybe<Scalars['String']['output']>;
  presignedUploadUrl?: Maybe<Scalars['String']['output']>;
  pressAssets: Array<PressAsset>;
  pressItems: Array<PressItem>;
  principal?: Maybe<Principal>;
  /** Returns all product release announcements */
  productReleaseAnnouncements: Array<ProductReleaseAnnouncement>;
  publishableLendingLoans: Array<PublishableLendingLoan>;
  publishableProgressUpdates: Array<PublishableProgressUpdate>;
  /**
   * Query to retrieve push notification subscription configuration for current
   * user. Will resolve to null if user does not have any saved.
   */
  pushNotificationSubscriptionConfigurationForCurrentUser?: Maybe<PushNotificationSubscriptionConfiguration>;
  recentlyRepaidLoans: RealEstateLoanConnection;
  reconciliationPayments: Array<ReconciliationPayment>;
  recurringTransferSchedules?: Maybe<Array<RecurringTransferSchedule>>;
  /** Status of the referral code */
  referralCodeStatus: ReferralCodeStatus;
  /** The status of the session referring this user */
  referralStatus?: Maybe<ReferralStatus>;
  /**
   * Query to retrieve ReferralSummary for current user. Will resolve to null if
   * user is not authenticated or ineligible for referrals.
   */
  referralSummaryForCurrentUser?: Maybe<ReferralSummary>;
  /** The session referring this user */
  referredSession?: Maybe<ReferralSession>;
  /** Whether or not the referrer code is valid */
  referrerAccountStatus: Scalars['Boolean']['output'];
  reitReinvestmentSetting?: Maybe<ReinvestmentSetting>;
  repaidInvestmentsSummary: RepaidInvestmentsSummary;
  root?: Maybe<Scalars['String']['output']>;
  s3PresignedUploadPayload?: Maybe<S3PresignedUploadPayload>;
  savingsGoals: Array<SavingsGoal>;
  scheduledPredefinedInvestmentStrategies: Array<ScheduledPredefinedInvestmentStrategy>;
  secBatches?: Maybe<Array<SecBatch>>;
  securities?: Maybe<Array<Security>>;
  security?: Maybe<Security>;
  securityOfferings: Array<SecurityV2>;
  /** Gets the count of live securities. */
  securityOfferingsCount: Scalars['Int']['output'];
  securityV2?: Maybe<SecurityV2>;
  /** Summary data on the account's portfolio performance */
  startPageAccountSummary?: Maybe<StartPageAccountSummary>;
  taxPayer?: Maybe<TaxPayer>;
  taxPayers?: Maybe<Array<TaxPayer>>;
  termSheetForAccessCode?: Maybe<TermSheet>;
  termSheetGenerationPermitted: Scalars['Boolean']['output'];
  /** Returns terms and conditions acceptances for the user if they exist, otherwise null */
  termsAndConditionsAcceptances?: Maybe<Array<TermsAndConditionsAcceptance>>;
  /** The transaction history for this account that supports infinite scrolling. */
  transactionHistory: AccountTransactionConnection;
  transactionRequest?: Maybe<TransactionRequest>;
  transactionRequests?: Maybe<Array<TransactionRequest>>;
  transactionalCommunicationCategories?: Maybe<Array<TransactionalCommunicationCategory>>;
  /** Returns the ui action if performed, otherwise null */
  uiInteractions?: Maybe<Array<UiInteraction>>;
  /**
   * ReferralSession objects that correspond to pending referrals.Display values
   * for the referral history table should utilize the updatedAt,
   * referrerRewardAmount, and referredUserName fields.
   */
  userCustomPendingReferrals: Array<ReferralSession>;
  /**
   * ReferralReward objects that have ben Redeemed.Display values for the referral
   * history table should utilize the updatedAt, referrerRewardAmount, state, and
   * referredUserName fields.
   */
  userCustomRedeemedRewards: Array<ReferralReward>;
  /** User's active referral campaign */
  userCustomReferralCampaign?: Maybe<ReferralCampaign>;
  userRegistration?: Maybe<UserRegistration>;
  validUserPasswordResetToken: Scalars['Boolean']['output'];
  yieldAccountSnapshots?: Maybe<Array<YieldAccountSnapshot>>;
  yieldInvestorProfile?: Maybe<YieldInvestorProfile>;
  yieldInvestorRewardStatus?: Maybe<InvestorRewardStatus>;
  yieldTransfers?: Maybe<Array<YieldTransfer>>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  types?: InputMaybe<Array<AccountTypeName>>;
};


export type QueryAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAmountRecentlyTransferredInArgs = {
  accountSecureId: Scalars['ID']['input'];
  numberOfDays: Scalars['Int']['input'];
};


export type QueryApplicationConditionsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationContentArgs = {
  location: ApplicationContentLocation;
};


export type QueryAutoInvestorAccountConfigArgs = {
  accountSecureId: Scalars['String']['input'];
};


export type QueryAutoInvestorAccountRunCollectionArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationAttributes>;
};


export type QueryBalanceAdjustmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBalanceAdjustmentsArgs = {
  accountSecureId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<BalanceAdjustmentState>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBdmProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBeneficiariesArgs = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBorrowerEntityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClosingDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConditionsArgs = {
  name: Scalars['String']['input'];
};


export type QueryConfigurationArgs = {
  key: Scalars['ID']['input'];
};


export type QueryContributionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContributionAuthorizationFormsArgs = {
  contributionId: Scalars['ID']['input'];
};


export type QueryConvertibleDebtNotesArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerAuthorizationFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDailyInvestmentGroupCollectionArgs = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationAttributes>;
  securitySubtypes?: InputMaybe<Array<SecuritySubtypeName>>;
  securityTypes?: InputMaybe<Array<SecurityTypeName>>;
};


export type QueryDisbursementsOverTimeArgs = {
  accountSecureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  granularity?: InputMaybe<DateGraphGranularity>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  securitySubtypes?: InputMaybe<Array<SecuritySubtypeName>>;
};


export type QueryDisbursementsSummaryArgs = {
  accountSecureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  securitySubtypes?: InputMaybe<Array<SecuritySubtypeName>>;
};


export type QueryEmailStatusArgs = {
  email: Scalars['String']['input'];
};


export type QueryFundsTransferCollectionArgs = {
  accountSecureId: Scalars['ID']['input'];
  paginationAttributes?: InputMaybe<PaginationAttributes>;
  sortAttributes?: InputMaybe<DefaultSortAttributes>;
};


export type QueryFundsTransferListArgs = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  paginationAttributes?: InputMaybe<PaginationAttributes>;
  sortAttributes?: InputMaybe<DefaultSortAttributes>;
};


export type QueryFundsTransferSchedulesArgs = {
  accountId: Scalars['ID']['input'];
  state?: InputMaybe<Array<FundsTransferScheduleState>>;
};


export type QueryFundsTransfersArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  state?: InputMaybe<Array<FundsTransferState>>;
};


export type QueryGeneralizedSecurityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGf3PerformanceDashboardArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type QueryGraduatedGroundfloorLabsOfferingsArgs = {
  types?: InputMaybe<Array<GeneralizedSecurityTypeName>>;
};


export type QueryGroundfloorEquityOfferingsArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroundfloorNotesArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIntercomDigestArgs = {
  operatingSystem: OperatingSystem;
};


export type QueryInvestableSecuritiesArgs = {
  types?: InputMaybe<Array<SecurityTypeName>>;
};


export type QueryInvestmentPortfolioBreakdownArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type QueryInvestmentSchedulesArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryInvestmentV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryInvestmentsArgs = {
  accountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  loanId?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<Array<InvestmentState>>;
};


export type QueryInvestmentsBySecuritySubtypeArgs = {
  accountSecureIds: Array<Scalars['ID']['input']>;
  investmentStates?: InputMaybe<Array<InvestmentState>>;
  securitySubtypes: Array<SecuritySubtypeName>;
};


export type QueryInvestmentsV2Args = {
  accountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  accountSecureId?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  investmentState?: InputMaybe<Array<InvestmentState>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxRepaidAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  minRepaidAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  securityId?: InputMaybe<Array<Scalars['ID']['input']>>;
  securityState?: InputMaybe<Array<SecurityState>>;
  securityType?: InputMaybe<Array<SecurityTypeName>>;
  sort?: InputMaybe<InvestmentSortAttributes>;
};


export type QueryInvestorActivitySummaryArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type QueryInvestorDashboardArgs = {
  accountSecureId: Scalars['ID']['input'];
  options?: InputMaybe<InvestorDashboardInput>;
};


export type QueryInvestorProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryInvestorRepaymentCollectionArgs = {
  accountSecureIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationAttributes>;
  securitySubtypes?: InputMaybe<Array<SecuritySubtypeName>>;
};


export type QueryInvestorRepaymentsArgs = {
  accountSecureIds: Array<Scalars['ID']['input']>;
  securitySubtypes?: InputMaybe<Array<SecuritySubtypeName>>;
};


export type QueryLabsInvestmentsArgs = {
  accountSecureId: Scalars['ID']['input'];
  states?: InputMaybe<Array<InvestmentState>>;
};


export type QueryLendingBorrowerEntityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLendingLoanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLendingLoanApplicationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLendingLoansArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLendingPrincipalArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLoanApplicationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLoanBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryLoansArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketingCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryActive?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketingCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMultiAccountInvestorActivitySummaryArgs = {
  accountSecureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationsArgs = {
  accountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<NotificationState>>;
};


export type QueryOpenInvestmentsSummaryArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type QueryPdfDocumentsArgs = {
  options?: InputMaybe<PdfDocumentCollectionOptionsInput>;
};


export type QueryPortfolioControlCenterArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryPreapprovalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPreapprovalsArgs = {
  states?: InputMaybe<Array<PreapprovalState>>;
};


export type QueryPredefinedInvestmentStrategiesArgs = {
  accountSecureId: Scalars['ID']['input'];
  amountCents: Scalars['Int']['input'];
  excludeLrosNotInvestedIn?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPresignedPhotoUploadUrlArgs = {
  mimeType: Scalars['String']['input'];
};


export type QueryPresignedUploadUrlArgs = {
  bucketName?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  objectName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrincipalArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductReleaseAnnouncementsArgs = {
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecentlyRepaidLoansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReconciliationPaymentsArgs = {
  accountSecureIds: Array<Scalars['ID']['input']>;
  types?: InputMaybe<Array<Type>>;
};


export type QueryRecurringTransferSchedulesArgs = {
  accountSecureId: Scalars['String']['input'];
};


export type QueryReferralCodeStatusArgs = {
  code: Scalars['String']['input'];
};


export type QueryReferrerAccountStatusArgs = {
  referralTagSecureId: Scalars['String']['input'];
};


export type QueryReitReinvestmentSettingArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type QueryRepaidInvestmentsSummaryArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type QueryS3PresignedUploadPayloadArgs = {
  assetPath: Scalars['String']['input'];
};


export type QuerySavingsGoalsArgs = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySecuritiesArgs = {
  state?: InputMaybe<Array<SecurityState>>;
};


export type QuerySecurityArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySecurityOfferingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<SecurityTypeName>>;
};


export type QuerySecurityOfferingsCountArgs = {
  types?: InputMaybe<Array<SecurityTypeName>>;
};


export type QuerySecurityV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryStartPageAccountSummaryArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type QueryTaxPayerArgs = {
  accountSecureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaxPayersArgs = {
  accountSecureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryTermSheetForAccessCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryTermSheetGenerationPermittedArgs = {
  lendingLoanApplicationSlug: Scalars['String']['input'];
};


export type QueryTermsAndConditionsAcceptancesArgs = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  termsType?: InputMaybe<Array<TermsAndConditions>>;
};


export type QueryTransactionHistoryArgs = {
  accountSecureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  accountTypes?: InputMaybe<Array<AccountTypeName>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<TransactionCategory>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  posted?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<AccountTransactionSortAttributes>;
  type?: InputMaybe<Array<TransactionType>>;
};


export type QueryTransactionRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionRequestsArgs = {
  approvalStates?: InputMaybe<Array<TransactionRequestApprovalState>>;
};


export type QueryUiInteractionsArgs = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  interactions: Array<UiInteractionName>;
};


export type QueryUserRegistrationArgs = {
  secureId: Scalars['ID']['input'];
  secureToken: Scalars['String']['input'];
};


export type QueryValidUserPasswordResetTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryYieldAccountSnapshotsArgs = {
  endOn: Scalars['ISO8601Date']['input'];
  startOn: Scalars['ISO8601Date']['input'];
};


export type QueryYieldInvestorProfileArgs = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryYieldInvestorRewardStatusArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type QueryYieldTransfersArgs = {
  endAt: Scalars['ISO8601DateTime']['input'];
  startAt: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated input type of ReadNotification */
export type ReadNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ReadNotification. */
export type ReadNotificationPayload = {
  __typename?: 'ReadNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  notification?: Maybe<Notification>;
};

/** A property loan, or Limited Recourse Obligation (LRO) as an investable security through GROUNDFLOOR. */
export type RealEstateLoan = SecurityV2 & {
  __typename?: 'RealEstateLoan';
  /** The percentage of an account's portfolio which is made up of investments in this security. */
  accountCommitmentsPortfolioPercentage?: Maybe<Scalars['Float']['output']>;
  activeOfferingSummaryUrl?: Maybe<Scalars['String']['output']>;
  /** The actual date on which the loan was repaid. */
  actualMaturityDate?: Maybe<Scalars['Date']['output']>;
  /** The address of the loan's property. */
  address: Address;
  /** The expected value of the property after it has been repaired. */
  afterRepairValueCents?: Maybe<Scalars['Int']['output']>;
  /** The amount that has been invested in the security in cents. */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** The amount remaining until the security has been fully funded. */
  amountRemainingCents: Scalars['Int']['output'];
  /** The loan amount including all draw amounts. */
  amountWithDrawOffsetsCents?: Maybe<Scalars['Int']['output']>;
  /** The address of the application */
  applicationAddress: Address;
  /** The score for the commitment of the borrower. */
  borrowerCommitmentScore: Scalars['Int']['output'];
  /** The borrower(s) on the loan. */
  borrowerEntities: Array<BorrowerEntityV2>;
  /** The borrower's equity in cents. */
  borrowerEquityCents?: Maybe<Scalars['Int']['output']>;
  /** The score for the experience of the borrower. */
  borrowerExperienceScore: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** Page/application content for the security. */
  contents: Array<SecurityContent>;
  /** The URL of the loan's cover image. */
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  /** The creation timestamp of the security. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The number of days before the loan has finished funding. */
  daysBeforeClosing: Scalars['Int']['output'];
  /** A description of the security. */
  description?: Maybe<Scalars['String']['output']>;
  /** The title of the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** The date the security will no longer be available on the platform */
  externalCloseOn?: Maybe<Scalars['Date']['output']>;
  /** External partners for this security */
  externalPartners: Array<ExternalPartner>;
  /** Whether or not the loan is funded. */
  funded: Scalars['Boolean']['output'];
  /** The date the loan was funded */
  fundsPostedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the security will be available on the platform */
  goLiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The primary key of the security. */
  id: Scalars['ID']['output'];
  /** Purchase constraints and other information for an investment in a particular account. */
  investmentPurchaseMetadata?: Maybe<InvestmentPurchaseMetadata>;
  /** Investments that have been made in the security. */
  investments: Array<Investment>;
  /** Updates for the investors on the progress of the project. */
  investorUpdates: Array<InvestorUpdate>;
  /** The number of people that have made an investment in the security. */
  investorsCount: Scalars['Int']['output'];
  /** The junior lien amount in cents. */
  juniorLienAmountCents: Scalars['Int']['output'];
  /** Whether or not the loan has the security-position of "Junior". */
  juniorSecurityPosition: Scalars['Boolean']['output'];
  /** The time at which the lenders were funded. */
  lendersFundedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The time at which the lenders were repaid. */
  lendersRepaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The loan-to-after-repair-value ratio as a percentage. */
  loanToArvPercentage: Scalars['Float']['output'];
  /** A score for the loan based on comparing the loan amount to the expected after-repair-value. */
  loanToArvScore?: Maybe<Scalars['Float']['output']>;
  /** The loan-to-project-costs ratio. */
  loanToProjectCostsPercentage?: Maybe<Scalars['Float']['output']>;
  /** The loan-to-value ratio. */
  loanToValuePercentage?: Maybe<Scalars['Float']['output']>;
  /** The score for the loan-to-value ratio. */
  loanToValueScore?: Maybe<Scalars['Int']['output']>;
  /** The score for the property location. */
  locationScore: Scalars['Int']['output'];
  /** The marketing category that the security has been assigned to. */
  marketingCategory?: Maybe<MarketingCategory>;
  /** The date the security was most recently purchased */
  mostRecentPurchasedAtForAccount?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether or not a loan has multiple liens with different repayment positions. */
  multipleRepaymentPositions: Scalars['Boolean']['output'];
  /** The name or title of the security. */
  name: Scalars['String']['output'];
  /** Regulation for the Offering */
  offeringRegulation?: Maybe<Scalars['String']['output']>;
  /** The way the loan will be repaid (monthly or deferred). */
  paymentType: LoanPayment;
  /** The percentage of the project that is complete as an integer beteween 0 and 100.  Null if not known. */
  percentComplete?: Maybe<Scalars['Int']['output']>;
  /** The state of the loan's performance. */
  performanceState: Scalars['String']['output'];
  /** Whether or not the LRO issuer is the GROUNDFLOOR prime issuer. */
  primeLroIssuer: Scalars['Boolean']['output'];
  /** The principal(s) on the loan. */
  principals: Array<PrincipalV2>;
  /** The cost of the project in cents. */
  projectCostCents?: Maybe<Scalars['Int']['output']>;
  /** The expected date for the loan to be repaid. */
  projectedMaturityDate?: Maybe<Scalars['Date']['output']>;
  /** The expected term of the loan in months. */
  projectedTermMonths: Scalars['Int']['output'];
  /** Photos of the property associated with the loan. */
  propertyPhotos: Array<Image>;
  /** The date that the property was purchased on. */
  propertyPurchasedOn?: Maybe<Scalars['Date']['output']>;
  /** The amount that the property is contracted for in cents. */
  purchasePriceCents: Scalars['Int']['output'];
  /** The purpose of the project (Rehab/Refinance, Build, etc). */
  purpose: LoanPurpose;
  /** The score for the quality of the valuation report. */
  qualityOfValuationReportScore?: Maybe<Scalars['Int']['output']>;
  /** The loan rate percentage as a decimal. */
  rate: Scalars['Float']['output'];
  /** Letter rating, indicating risk. */
  rating?: Maybe<Scalars['String']['output']>;
  /** Whether or not the security is "Regulation-A". */
  regA: Scalars['Boolean']['output'];
  /** The remaining term of the loan in months. */
  remainingTermMonths: Scalars['Float']['output'];
  /** The repayment position of the loan. */
  repaymentPosition?: Maybe<Scalars['Int']['output']>;
  /** Anything about the project that might be risky. */
  riskFactors?: Maybe<Scalars['String']['output']>;
  /** The disclosure language for the SEC batch of the security. */
  secBatchDisclosure?: Maybe<Scalars['String']['output']>;
  /** The date the sec_batch was qualified by sec */
  secBatchQualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the sec_batch was submitted to sec */
  secBatchSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether security is Tier 1 or not */
  secBatchTier1: Scalars['Boolean']['output'];
  securityAgreementUrl?: Maybe<Scalars['String']['output']>;
  /** The date the security began acrring interest */
  securityEffectiveOn?: Maybe<Scalars['Date']['output']>;
  /** The position of a security. */
  securityPosition?: Maybe<Scalars['String']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** The senior lien amount in cents. */
  seniorLienAmountCents: Scalars['Int']['output'];
  /** Whether or not the loan has the security-position of "Senior". */
  seniorSecurityPosition: Scalars['Boolean']['output'];
  /** The skin-in-the-game amount in cents. */
  skinInTheGameCents: Scalars['Int']['output'];
  /** The score for the skin-in-the-game. */
  skinInTheGameScore: Scalars['Int']['output'];
  /** The loan's slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The manner in which the property was evaluated. */
  sourceOfValuationReport?: Maybe<Scalars['String']['output']>;
  /** The state of the security. */
  state?: Maybe<Scalars['String']['output']>;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** The total loaned amount in cents. */
  totalAmountCents: Scalars['Int']['output'];
  /** The update timestamp of the security. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Abbreviation of the valuation method used */
  valuationAbbrev: LoanValuationAbbreviation;
  /** Label for  the valuation method used */
  valuationLabel: LoanValuationLabel;
  /** Whether or not the valuation-type is LTV. */
  valuationLtv: Scalars['Boolean']['output'];
  /** Value derived from valuation method */
  valuationValue: Scalars['Float']['output'];
};


/** A property loan, or Limited Recourse Obligation (LRO) as an investable security through GROUNDFLOOR. */
export type RealEstateLoanAccountCommitmentsPortfolioPercentageArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** A property loan, or Limited Recourse Obligation (LRO) as an investable security through GROUNDFLOOR. */
export type RealEstateLoanInvestmentPurchaseMetadataArgs = {
  accountSecureId: Scalars['ID']['input'];
};


/** A property loan, or Limited Recourse Obligation (LRO) as an investable security through GROUNDFLOOR. */
export type RealEstateLoanInvestmentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<InvestmentState>;
};


/** A property loan, or Limited Recourse Obligation (LRO) as an investable security through GROUNDFLOOR. */
export type RealEstateLoanMostRecentPurchasedAtForAccountArgs = {
  accountSecureId: Scalars['ID']['input'];
};

/** The connection type for RealEstateLoan. */
export type RealEstateLoanConnection = {
  __typename?: 'RealEstateLoanConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RealEstateLoanEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RealEstateLoan>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RealEstateLoanEdge = {
  __typename?: 'RealEstateLoanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RealEstateLoan>;
};

export type RecaptchaScore = {
  __typename?: 'RecaptchaScore';
  /** The canonical score, where 0 is a bad actor and 10 is a good actor */
  canonicalScore: Scalars['Float']['output'];
  /** Explanation of why this user's score was overridden */
  comment?: Maybe<Scalars['String']['output']>;
  /** The time this event was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The employee who created this override */
  employee?: Maybe<Employee>;
  /** The description of the user action that triggered this scoring event */
  event: Scalars['String']['output'];
  /** The reason the Recaptcha Failed, if applicable */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** Primary key for a RecaptchaScore record */
  id: Scalars['Int']['output'];
  /** Whether or not the user has had a score overridden by customer success */
  overridden: Scalars['Boolean']['output'];
  /** A raw floating point score from the vendor */
  rawScore: Scalars['Float']['output'];
  /** The type of score (third party vendor, customer success override, etc.) */
  scoreType: Score;
  /** The source of this score, e.g. Customer Success or a vendor */
  source: Scalars['String']['output'];
};

export enum RecaptchaVersion {
  GoogleRecaptchaEnterpriseV1 = 'GOOGLE_RECAPTCHA_ENTERPRISE_V1',
  GoogleRecaptchaV2 = 'GOOGLE_RECAPTCHA_V2',
  GoogleRecaptchaV3 = 'GOOGLE_RECAPTCHA_V3'
}

/** A summary of funds that have recently been transferred for an account. */
export type RecentTransferSummary = {
  __typename?: 'RecentTransferSummary';
  /** The transferred amount that has been recently completed, in cents. */
  completedTransferCents: Scalars['Int']['output'];
  /** The transferred amount that has been recently initiated, but not yet posted, in cents. */
  pendingTransferCents: Scalars['Int']['output'];
  /** The total amount that has been transferred recently, in cents. */
  totalTransferCents: Scalars['Int']['output'];
};

export type ReconciliationPayment = {
  __typename?: 'ReconciliationPayment';
  disbursedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  interestAmountCents: Scalars['Int']['output'];
  principalAmountCents: Scalars['Int']['output'];
  state: ReconciliationPaymentState;
  totalAmountCents: Scalars['Int']['output'];
  transactionNumber?: Maybe<Scalars['ID']['output']>;
  type: Type;
};

export enum ReconciliationPaymentState {
  /** The payment has been completed. */
  Disbursed = 'DISBURSED',
  /** The payment has been built and is in the process of being paid. */
  Disbursing = 'DISBURSING',
  /** The payment is in the process of being built. */
  New = 'NEW'
}

/** Autogenerated input type of RecordInvestmentWizardOptions */
export type RecordInvestmentWizardOptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  options: Scalars['JSON']['input'];
  purchaseOrderId: Scalars['ID']['input'];
};

/** Autogenerated return type of RecordInvestmentWizardOptions. */
export type RecordInvestmentWizardOptionsPayload = {
  __typename?: 'RecordInvestmentWizardOptionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentWizardFilterOption?: Maybe<InvestmentWizardFilterOption>;
};

/** Autogenerated input type of RecordTermsAndConditionsAcceptance */
export type RecordTermsAndConditionsAcceptanceInput = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The type of terms and conditions being accepted by the user */
  termsType: TermsAndConditions;
};

/** Autogenerated return type of RecordTermsAndConditionsAcceptance. */
export type RecordTermsAndConditionsAcceptancePayload = {
  __typename?: 'RecordTermsAndConditionsAcceptancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  termsAndConditionsAcceptance?: Maybe<TermsAndConditionsAcceptance>;
};

/** Autogenerated input type of RecordUiInteraction */
export type RecordUiInteractionInput = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the UI interaction performed */
  interaction: UiInteractionName;
  /** The details of the UI interaction performed */
  interactionDetail?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RecordUiInteraction. */
export type RecordUiInteractionPayload = {
  __typename?: 'RecordUiInteractionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  uiInteraction?: Maybe<UiInteraction>;
};

export type RecurringTransferSchedule = {
  __typename?: 'RecurringTransferSchedule';
  account: Account;
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  destination: BankAccount;
  id: Scalars['ID']['output'];
  interval: RecurringTransferScheduleInterval;
  lastTransferOn?: Maybe<Scalars['ISO8601Date']['output']>;
  nextTransferOn?: Maybe<Scalars['ISO8601Date']['output']>;
  pausedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  scheduleStartOn: Scalars['ISO8601Date']['output'];
  source: BankAccount;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export enum RecurringTransferScheduleInterval {
  /** biweekly */
  Biweekly = 'BIWEEKLY',
  /** first_and_fifteenth */
  FirstAndFifteenth = 'FIRST_AND_FIFTEENTH',
  /** monthly */
  Monthly = 'MONTHLY',
  /** weekly */
  Weekly = 'WEEKLY'
}

/** A Referral Campaign in our system used to incentivize investors. */
export type ReferralCampaign = {
  __typename?: 'ReferralCampaign';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The date at which the RefferralCampaign is active. */
  effectiveAt: Scalars['ISO8601DateTime']['output'];
  /** The date at which the RefferralCampaign expires. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The identifier of a ReferralCampaign. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The number of days old an investment must be before it counts towards fulfilling the campaign's criteria. */
  investmentMaturationThreshold?: Maybe<Scalars['Int']['output']>;
  /** The amount required to be committed in investments in order to earn the reward. */
  investmentThresholdAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The name of the campaign */
  name?: Maybe<Scalars['String']['output']>;
  /** Promo codes for campaign */
  referralPromoCodes: Array<ReferralPromoCode>;
  /** The reward amount for the referred account. */
  referredRewardAmountCents: Scalars['Int']['output'];
  /** The currency associated with the referred account reward. */
  referredRewardAmountCurrency?: Maybe<Scalars['String']['output']>;
  /** The reward amount for the referrer. */
  referrerRewardAmountCents: Scalars['Int']['output'];
  /** The currency associated with the referrer award. */
  referrerRewardAmountCurrency?: Maybe<Scalars['String']['output']>;
  /** The amount of time after an account is created that a referral code can be applied, in hours. */
  registrationWindowHours?: Maybe<Scalars['Int']['output']>;
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The threshold amount for the reward. */
  rewardThresholdAmountCents: Scalars['Int']['output'];
  /** The currency associated with the reward threshold amount. */
  rewardThresholdAmountCurrency?: Maybe<Scalars['String']['output']>;
  /** State of the ReferralCampaign object. Currently not used. */
  state?: Maybe<Scalars['String']['output']>;
  /** Denotes which system is used by the ReferralCampaign object. */
  systemName?: Maybe<ReferralCampaignSystemName>;
  /** Type of campaign */
  type: ReferralCampaignTypes;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ReferralCampaignSystemName {
  /** ReferralCampaign requiring both sufficient funds transfers in and sufficient invested amount before granting the reward */
  TransferAndInvestCampaign = 'TRANSFER_AND_INVEST_CAMPAIGN'
}

export enum ReferralCampaignTypes {
  /** Custom campaign */
  Custom = 'CUSTOM',
  /** Global campaign */
  Global = 'GLOBAL'
}

export enum ReferralCodeStatus {
  /** Code for expired custom campaign */
  ExpiredCustom = 'EXPIRED_CUSTOM',
  /** Invalid code */
  Invalid = 'INVALID',
  /** Valid code for global campaign but no current global campaign */
  NoCurrentGlobal = 'NO_CURRENT_GLOBAL',
  /** Valid code for global campaign */
  ValidCustom = 'VALID_CUSTOM',
  /** Valid code for global campaign */
  ValidGlobal = 'VALID_GLOBAL'
}

/** Object to hold error information for authorization or validations */
export type ReferralError = {
  __typename?: 'ReferralError';
  /** Error code describing the nature of the failure. */
  code?: Maybe<ReferralErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum ReferralErrorCode {
  ReferringUserNotFound = 'REFERRING_USER_NOT_FOUND',
  RequiredConditionsMissing = 'REQUIRED_CONDITIONS_MISSING',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  ServerError = 'SERVER_ERROR',
  UnauthorizedClient = 'UNAUTHORIZED_CLIENT',
  UsedOwnReferralCode = 'USED_OWN_REFERRAL_CODE',
  UserAlreadyReferred = 'USER_ALREADY_REFERRED',
  UserRegistrationDatePastReferralWindow = 'USER_REGISTRATION_DATE_PAST_REFERRAL_WINDOW',
  ValidationsFailed = 'VALIDATIONS_FAILED'
}

/** Promo Code for Custom Referral Campaigns */
export type ReferralPromoCode = {
  __typename?: 'ReferralPromoCode';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/**
 * A ReferralReward in our system received by a user who has completed all the
 * necessary and sufficient steps of a given version of the ReferralCampaign ruleset.
 */
export type ReferralReward = {
  __typename?: 'ReferralReward';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Transactional Credits associated with this ReferralReward. */
  credits: Array<Credit>;
  /** Transactional Debits associated with this ReferralReward. */
  debits: Array<Debit>;
  /** The identifier of the ReferralReward. Corresponds to the secure_id */
  id: Scalars['ID']['output'];
  redeemedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ReferralCampaign object associated with this ReferralReward. */
  referralCampaign: ReferralCampaign;
  /** The ReferralSession object associated with this ReferralReward. */
  referralSession: ReferralSession;
  /** The name of the referred user. Only present when referred_account is not null. */
  referredUserName?: Maybe<Scalars['String']['output']>;
  /** The investor account of the referring user */
  referrerAccount: Account;
  /** The reward amount for the referrer, taken from the ReferralCampaign, listed in cents. */
  referrerRewardAmount: Scalars['Int']['output'];
  /** The investor account of the user who earned this reward. */
  rewardedAccount: Account;
  /** Corresponds to 'earned' or 'redeemed'. */
  state: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A Referral Session in our system used to link referred account and new user. */
export type ReferralSession = {
  __typename?: 'ReferralSession';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The number of days until the reward is earned, or nil if the reward has not been earned */
  daysUntilReward?: Maybe<Scalars['Int']['output']>;
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the referred account has invested sufficient funds to earn the reward */
  hasReferredUserCompletedInvestments?: Maybe<Scalars['Boolean']['output']>;
  /** The identifier of a ReferralSession. Corresponds to the secure_id field. */
  id: Scalars['ID']['output'];
  /** The (current) ReferralCampaign associated with this ReferralSession. */
  referralCampaign: ReferralCampaign;
  /** The account referred after successful signup. */
  referredAccount?: Maybe<Account>;
  /** The name of the referred user. Only present when referred_account is not null. */
  referredUserName?: Maybe<Scalars['String']['output']>;
  /** The first name of the referring user */
  referrerFirstName?: Maybe<Scalars['String']['output']>;
  /** The reward amount for the referrer, taken from the ReferralCampaign, listed in cents. */
  referrerRewardAmount: Scalars['Int']['output'];
  /** The state of the ReferralSession. */
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ReferralStatus = {
  __typename?: 'ReferralStatus';
  hasLinkedBankAccount: Scalars['Boolean']['output'];
  hasPurchasedSufficientInvestments: Scalars['Boolean']['output'];
  hasTransferredSufficientFunds: Scalars['Boolean']['output'];
};

/** Summary of referral information for a user. */
export type ReferralSummary = {
  __typename?: 'ReferralSummary';
  /**
   * ReferralReward objects that have not yet been Redeemed.Display values for the
   * referral history table should utilize the updatedAt, referrerRewardAmount,
   * state, and referredUserName fields.
   * @deprecated This should always be empty, since we don't have manual reward redemption anymore.
   */
  earnedRewards: Array<ReferralReward>;
  /** Corresponds to the secure_id field of the ReferralTag associated with the account. */
  key: Scalars['ID']['output'];
  /**
   * ReferralSession objects that correspond to pending referrals.Display values
   * for the referral history table should utilize the updatedAt,
   * referrerRewardAmount, and referredUserName fields.
   */
  pendingReferrals: Array<ReferralSession>;
  /**
   * ReferralReward objects that have ben Redeemed.Display values for the referral
   * history table should utilize the updatedAt, referrerRewardAmount, state, and
   * referredUserName fields.
   */
  redeemedRewards: Array<ReferralReward>;
  /** The unique referral link associated with a given account. */
  referralLink: Scalars['String']['output'];
};

/** Autogenerated input type of RefundAndCloseGeneralizedSecurity */
export type RefundAndCloseGeneralizedSecurityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RefundAndCloseGeneralizedSecurity. */
export type RefundAndCloseGeneralizedSecurityPayload = {
  __typename?: 'RefundAndCloseGeneralizedSecurityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  generalizedSecurity?: Maybe<GeneralizedSecurity>;
};

/** Autogenerated input type of RegisterCjCookie */
export type RegisterCjCookieInput = {
  cjCookie: CjCookieInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RegisterCjCookie. */
export type RegisterCjCookiePayload = {
  __typename?: 'RegisterCjCookiePayload';
  cjCookie?: Maybe<CjCookie>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RegisterSignatureAuthenticationKey */
export type RegisterSignatureAuthenticationKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A description of the key, such as the device name. */
  keyDescription?: InputMaybe<Scalars['String']['input']>;
  /** The public key of this key as a base64 encoded DER format. */
  publicKey: Scalars['String']['input'];
  /** The key details and proof of possession. */
  signature: SignatureCredentials;
};

/** Autogenerated return type of RegisterSignatureAuthenticationKey. */
export type RegisterSignatureAuthenticationKeyPayload = {
  __typename?: 'RegisterSignatureAuthenticationKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** Whether an existing key with the same key ID was replaced as part of this action. */
  existingKeyReplaced?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of RegisterUnverifiedInvestor */
export type RegisterUnverifiedInvestorInput = {
  /** Investor account type to be created */
  accountType?: InputMaybe<InvestorAccount>;
  address: UnverifiedAddressAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communicationProtocols?: InputMaybe<Array<CommunicationProtocolAttributes>>;
  credentials: CredentialAttributes;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  referralSessionId?: InputMaybe<Scalars['ID']['input']>;
  unverifiableIdentity: UnverifiedIdentityAttributes;
};

/** Autogenerated return type of RegisterUnverifiedInvestor. */
export type RegisterUnverifiedInvestorPayload = {
  __typename?: 'RegisterUnverifiedInvestorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RegistrationError>>;
  jwt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of RegisterYieldInvestor */
export type RegisterYieldInvestorInput = {
  address: AddressAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  credentials: CredentialAttributes;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  unverifiableIdentity: YieldIdentityAttributes;
};

/** Autogenerated return type of RegisterYieldInvestor. */
export type RegisterYieldInvestorPayload = {
  __typename?: 'RegisterYieldInvestorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RegistrationError>>;
  user?: Maybe<User>;
  yieldInvestorProfile?: Maybe<YieldInvestorProfile>;
};

/** Object to hold error information for authorization or validations */
export type RegistrationError = {
  __typename?: 'RegistrationError';
  /** Error code describing the nature of the failure. */
  code?: Maybe<RegistrationErrorCode>;
  /** Detailed message about the error. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Path pointer to the attribute causing the error if applicable. */
  pointer?: Maybe<Scalars['String']['output']>;
  /** Status code which correlates to http status codes. */
  status?: Maybe<Scalars['String']['output']>;
};

export enum RegistrationErrorCode {
  DuplicateEmail = 'DUPLICATE_EMAIL',
  EmailIssue = 'EMAIL_ISSUE',
  InvalidZipcode = 'INVALID_ZIPCODE',
  RecaptchaAuthenticationFailed = 'RECAPTCHA_AUTHENTICATION_FAILED',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  ServerError = 'SERVER_ERROR',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  UnauthorizedClient = 'UNAUTHORIZED_CLIENT'
}

export type ReinvestmentSetting = {
  __typename?: 'ReinvestmentSetting';
  id: Scalars['Int']['output'];
  reinvestmentType: ReinvestmentTypeName;
};

export enum ReinvestmentTypeName {
  None = 'NONE',
  ReturnOfCapital = 'RETURN_OF_CAPITAL',
  ReturnOfCapitalAndRealizedReturn = 'RETURN_OF_CAPITAL_AND_REALIZED_RETURN'
}

export type Reit = SecurityV2 & {
  __typename?: 'Reit';
  /** The percentage of an account's portfolio which is made up of investments in this security. */
  accountCommitmentsPortfolioPercentage?: Maybe<Scalars['Float']['output']>;
  activeOfferingSummaryUrl?: Maybe<Scalars['String']['output']>;
  /** The amount that has been invested in the security in cents. */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** The amount remaining until the security has been fully funded. */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** Page/application content for the security. */
  contents: Array<SecurityContent>;
  /** The creation timestamp of the security. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The title of the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  disbursementType: DisbursementTypeName;
  /** The date the security will no longer be available on the platform */
  externalCloseOn?: Maybe<Scalars['Date']['output']>;
  /** External partners for this security */
  externalPartners: Array<ExternalPartner>;
  /** The date the loan was funded */
  fundsPostedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the security will be available on the platform */
  goLiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The primary key of the security. */
  id: Scalars['ID']['output'];
  /** The URL of the reit's icon image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Purchase constraints and other information for an investment in a particular account. */
  investmentPurchaseMetadata?: Maybe<InvestmentPurchaseMetadata>;
  /** Investments that have been made in the security. */
  investments: Array<Investment>;
  /** Updates for the investors on the progress of the project. */
  investorUpdates: Array<InvestorUpdate>;
  /** The number of people that have made an investment in the security. */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that the security has been assigned to. */
  marketingCategory?: Maybe<MarketingCategory>;
  /** The date the security was most recently purchased */
  mostRecentPurchasedAtForAccount?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name or title of the security. */
  name: Scalars['String']['output'];
  /** Regulation for the Offering */
  offeringRegulation?: Maybe<Scalars['String']['output']>;
  rateRange: FloatRange;
  /** The date the sec_batch was qualified by sec */
  secBatchQualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the sec_batch was submitted to sec */
  secBatchSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether security is Tier 1 or not */
  secBatchTier1: Scalars['Boolean']['output'];
  securityAgreementUrl?: Maybe<Scalars['String']['output']>;
  /** The date the security began acrring interest */
  securityEffectiveOn?: Maybe<Scalars['Date']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** The state of the security. */
  state?: Maybe<Scalars['String']['output']>;
  /** The term of the REIT in months. */
  termMonths: Scalars['Int']['output'];
  totalLoanCount: Scalars['Int']['output'];
  /** The update timestamp of the security. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  weightedLoanAverages?: Maybe<WeightedLoanAverages>;
};


export type ReitAccountCommitmentsPortfolioPercentageArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type ReitInvestmentPurchaseMetadataArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type ReitInvestmentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<InvestmentState>;
};


export type ReitMostRecentPurchasedAtForAccountArgs = {
  accountSecureId: Scalars['ID']['input'];
};

export type ReitInitialFundingDetailsInput = {
  fundingAmountCents: Scalars['Int']['input'];
  shareCount: Scalars['Int']['input'];
};

export type ReitInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  coverImageS3Key?: InputMaybe<Scalars['String']['input']>;
  externalCloseDate?: InputMaybe<Scalars['Date']['input']>;
  feePercentage?: InputMaybe<Scalars['Float']['input']>;
  goLiveAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  minimumUnitsPerAccount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  termMonths?: InputMaybe<Scalars['Int']['input']>;
  unitPriceCents?: InputMaybe<Scalars['Int']['input']>;
};

export type ReitV0 = Security & {
  __typename?: 'ReitV0';
  /** Amount that security is for */
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  disbursementType: DisbursementTypeName;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** The URL of the reit's icon image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  /** Interest rate */
  rate?: Maybe<Scalars['Float']['output']>;
  rateRange: FloatRange;
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** Length of time to projected maturity in months from loan effectivedate */
  term: Scalars['Int']['output'];
  /** The term of the REIT in months. */
  termMonths: Scalars['Int']['output'];
  totalLoanCount: Scalars['Int']['output'];
  weightedLoanAverages?: Maybe<WeightedLoanAverages>;
};

/** Autogenerated input type of RejectBalanceAdjustment */
export type RejectBalanceAdjustmentInput = {
  balanceAdjustmentId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RejectBalanceAdjustment. */
export type RejectBalanceAdjustmentPayload = {
  __typename?: 'RejectBalanceAdjustmentPayload';
  balanceAdjustment?: Maybe<BalanceAdjustment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of RejectFundsTransfers */
export type RejectFundsTransfersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the funds transfers to reject. */
  fundsTransferIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RejectFundsTransfers. */
export type RejectFundsTransfersPayload = {
  __typename?: 'RejectFundsTransfersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RejectPreapproval */
export type RejectPreapprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preapprovalId: Scalars['ID']['input'];
};

/** Autogenerated return type of RejectPreapproval. */
export type RejectPreapprovalPayload = {
  __typename?: 'RejectPreapprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  preapprovalId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of RejectRequestedTransaction */
export type RejectRequestedTransactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RejectRequestedTransaction. */
export type RejectRequestedTransactionPayload = {
  __typename?: 'RejectRequestedTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  id?: Maybe<Scalars['ID']['output']>;
  transactionRequest?: Maybe<TransactionRequest>;
};

/** Autogenerated input type of RemoveBeneficiary */
export type RemoveBeneficiaryInput = {
  beneficiaryId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveBeneficiary. */
export type RemoveBeneficiaryPayload = {
  __typename?: 'RemoveBeneficiaryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of RemoveClaCondition */
export type RemoveClaConditionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveClaCondition. */
export type RemoveClaConditionPayload = {
  __typename?: 'RemoveClaConditionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplicationCondition?: Maybe<LoanApplicationCondition>;
};

/** Autogenerated input type of RemoveExternalPartner */
export type RemoveExternalPartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveExternalPartner. */
export type RemoveExternalPartnerPayload = {
  __typename?: 'RemoveExternalPartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of RemoveGuarantorFromLoanApplication */
export type RemoveGuarantorFromLoanApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lendingLoanApplicationId: Scalars['Int']['input'];
  lendingPrincipalId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveGuarantorFromLoanApplication. */
export type RemoveGuarantorFromLoanApplicationPayload = {
  __typename?: 'RemoveGuarantorFromLoanApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  lendingLoanApplication?: Maybe<LendingLoanApplication>;
};

/** Autogenerated input type of RemoveInvestmentWizardStrategy */
export type RemoveInvestmentWizardStrategyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveInvestmentWizardStrategy. */
export type RemoveInvestmentWizardStrategyPayload = {
  __typename?: 'RemoveInvestmentWizardStrategyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of RemoveInvestorUpdateImage */
export type RemoveInvestorUpdateImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  imageSecureId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveInvestorUpdateImage. */
export type RemoveInvestorUpdateImagePayload = {
  __typename?: 'RemoveInvestorUpdateImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemovePressAsset */
export type RemovePressAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pressAssetId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemovePressAsset. */
export type RemovePressAssetPayload = {
  __typename?: 'RemovePressAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of RemovePressItem */
export type RemovePressItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pressItemId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemovePressItem. */
export type RemovePressItemPayload = {
  __typename?: 'RemovePressItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of RemoveProblemBankAccount */
export type RemoveProblemBankAccountInput = {
  bankAccountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveProblemBankAccount. */
export type RemoveProblemBankAccountPayload = {
  __typename?: 'RemoveProblemBankAccountPayload';
  bankAccount?: Maybe<DwollaBankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveRecurringTransferSchedule */
export type RemoveRecurringTransferScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveRecurringTransferSchedule. */
export type RemoveRecurringTransferSchedulePayload = {
  __typename?: 'RemoveRecurringTransferSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  recurringTransferSchedule?: Maybe<RecurringTransferSchedule>;
};

/** Autogenerated input type of RemoveReitHolding */
export type RemoveReitHoldingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reitId: Scalars['Int']['input'];
  securityId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveReitHolding. */
export type RemoveReitHoldingPayload = {
  __typename?: 'RemoveReitHoldingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reit?: Maybe<Reit>;
};

/** Autogenerated input type of RemoveSavingsGoal */
export type RemoveSavingsGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveSavingsGoal. */
export type RemoveSavingsGoalPayload = {
  __typename?: 'RemoveSavingsGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of RemoveSecurityFromExternalPartner */
export type RemoveSecurityFromExternalPartnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  securityId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveSecurityFromExternalPartner. */
export type RemoveSecurityFromExternalPartnerPayload = {
  __typename?: 'RemoveSecurityFromExternalPartnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  externalPartner?: Maybe<ExternalPartner>;
};

/** Autogenerated input type of RemoveSecurityFromPlatform */
export type RemoveSecurityFromPlatformInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSecurityFromPlatform. */
export type RemoveSecurityFromPlatformPayload = {
  __typename?: 'RemoveSecurityFromPlatformPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  security?: Maybe<Security>;
};

/** Autogenerated input type of RemoveTermSheet */
export type RemoveTermSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveTermSheet. */
export type RemoveTermSheetPayload = {
  __typename?: 'RemoveTermSheetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/**
 * A summary of an investor's repaid LRO loan investments.  For summary of all
 * securities, including repaid, see InvestorActivitySummary.
 */
export type RepaidInvestmentsSummary = {
  __typename?: 'RepaidInvestmentsSummary';
  /**
   * A summary of all repaid loans broken down by repayment month
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  allLoanInvestmentsSummaryByRepaymentMonth: Array<InvestorSummaryRollupGroup>;
  /**
   * A summary of all repaid LROs regardless of performance state
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  allSecurityInvestmentsSummary: InvestorSummaryRollup;
  /**
   * A summary of all repaid LROs in the "current" state (meaning paid on time).
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  currentSecurityInvestmentsSummary: InvestorSummaryRollup;
  /**
   * A summary of all repaid defaulted LROs
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  defaultSecurityInvestmentsSummary: InvestorSummaryRollup;
  /**
   * A summary of all repaid LROs in the "extended" state
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  extendedSecurityInvestmentsSummary: InvestorSummaryRollup;
  /**
   * A summary of repaid loans in the current calendar month
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  loanInvestmentsSummaryThisMonth?: Maybe<InvestorSummaryRollup>;
  /**
   * A summary of repaid loans in the current calendar week beginning on Monday
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  loanInvestmentsSummaryThisWeek?: Maybe<InvestorSummaryRollup>;
  /**
   * A summary of repaid loans in the current calendar year
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  loanInvestmentsSummaryThisYear?: Maybe<InvestorSummaryRollup>;
  /**
   * Data points that can be graphed to show repayment sums over time
   * @deprecated Use repaymentsOverTimeBySubtype instead
   */
  repaymentsOverTime: Array<RepaymentDataPoint>;
  /** Data points that can be graphed to show repayment sums over time */
  repaymentsOverTimeBySubtype: Array<RepaymentDataPoint>;
  /** @deprecated Use allSecurityInvestmentsSummary.actualRateOfReturn instead */
  totalActualRateOfReturn?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use allSecurityInvestmentsSummary.expectedRateOfReturn instead */
  totalExpectedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  /**
   * A summary of all repaid LROs in the "workout" state.
   * @deprecated Use InvestorActivitySummary.customSummary instead
   */
  workoutSecurityInvestmentsSummary: InvestorSummaryRollup;
};


/**
 * A summary of an investor's repaid LRO loan investments.  For summary of all
 * securities, including repaid, see InvestorActivitySummary.
 */
export type RepaidInvestmentsSummaryRepaymentsOverTimeArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  granularity: DateGraphGranularity;
  lookbackDays: Scalars['Int']['input'];
  securityTypes?: InputMaybe<Array<SecurityTypeName>>;
};


/**
 * A summary of an investor's repaid LRO loan investments.  For summary of all
 * securities, including repaid, see InvestorActivitySummary.
 */
export type RepaidInvestmentsSummaryRepaymentsOverTimeBySubtypeArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  granularity: DateGraphGranularity;
  groupedBySubtype?: InputMaybe<Scalars['Boolean']['input']>;
  lookbackDays: Scalars['Int']['input'];
  securitySubtypes?: InputMaybe<Array<SecuritySubtypeName>>;
};

/** Autogenerated input type of RepayGeneralizedSecurity */
export type RepayGeneralizedSecurityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RepayGeneralizedSecurity. */
export type RepayGeneralizedSecurityPayload = {
  __typename?: 'RepayGeneralizedSecurityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  generalizedSecurity?: Maybe<GeneralizedSecurity>;
};

/** a single data point in a graph where the X axis is a date and the Y axis is the repayment amount or net earnings amount */
export type RepaymentDataPoint = InvestmentDataPoint & {
  __typename?: 'RepaymentDataPoint';
  /** The dollar amount at the end of the date. */
  amountCents: Scalars['BigInt']['output'];
  /** The date! */
  date: Scalars['ISO8601Date']['output'];
  /** The number of active investments at the end of the date. */
  investmentCount: Scalars['Int']['output'];
  /** The net earnings amount for the data point. */
  netEarningsCents: Scalars['Long']['output'];
  /** The repayment amount for the data point.  Alias of amountCents. */
  repaymentCents: Scalars['Long']['output'];
  /** The subgrouping of the data point, if any.  Only used if specified in the query. */
  subgrouping?: Maybe<Scalars['String']['output']>;
};

export enum RepaymentOutcome {
  NotYetRepaid = 'NOT_YET_REPAID',
  RepaidAtLoss = 'REPAID_AT_LOSS',
  RepaidInFull = 'REPAID_IN_FULL',
  RepaidPrincipalOnly = 'REPAID_PRINCIPAL_ONLY',
  RepaidWithExtraInterest = 'REPAID_WITH_EXTRA_INTEREST',
  RepaidWithPartialInterest = 'REPAID_WITH_PARTIAL_INTEREST'
}

export enum RepaymentTransactionDescriptor {
  DefaultParcelRepay = 'DEFAULT_PARCEL_REPAY',
  EarlyParcelRepay = 'EARLY_PARCEL_REPAY',
  GeneralizedSecurityExit = 'GENERALIZED_SECURITY_EXIT',
  InterestPayment = 'INTEREST_PAYMENT',
  LroInterest = 'LRO_INTEREST',
  LroRepayment = 'LRO_REPAYMENT',
  MonthlyPayment = 'MONTHLY_PAYMENT',
  NotesInterest = 'NOTES_INTEREST',
  RentalIncome = 'RENTAL_INCOME',
  ReserveDeployment = 'RESERVE_DEPLOYMENT',
  ReturnedFunds = 'RETURNED_FUNDS'
}

/** Autogenerated input type of RequestExport */
export type RequestExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportRequest?: InputMaybe<ExportRequestAttributes>;
};

/** Autogenerated return type of RequestExport. */
export type RequestExportPayload = {
  __typename?: 'RequestExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  exportRequest?: Maybe<ExportRequest>;
};

/** Autogenerated input type of RequestPdfDownloadLink */
export type RequestPdfDownloadLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RequestPdfDownloadLink. */
export type RequestPdfDownloadLinkPayload = {
  __typename?: 'RequestPdfDownloadLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RequestTransaction */
export type RequestTransactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  request: TransactionRequestAttributes;
};

/** Autogenerated return type of RequestTransaction. */
export type RequestTransactionPayload = {
  __typename?: 'RequestTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  transactionRequest?: Maybe<TransactionRequest>;
};

/** Autogenerated input type of RequestUserPasswordReset */
export type RequestUserPasswordResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of RequestUserPasswordReset. */
export type RequestUserPasswordResetPayload = {
  __typename?: 'RequestUserPasswordResetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ResendEmailVerification */
export type ResendEmailVerificationInput = {
  accountSecureId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResendEmailVerification. */
export type ResendEmailVerificationPayload = {
  __typename?: 'ResendEmailVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResendMfa */
export type ResendMfaInput = {
  /** How the user wishes to receive the code */
  channel?: InputMaybe<MfaChannel>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The previous MFA attempt ID to re-send. */
  previousMfaAttemptId: Scalars['ID']['input'];
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of ResendMfa. */
export type ResendMfaPayload = {
  __typename?: 'ResendMfaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** The new MFA attempt corresponding to the newly-sent message */
  mfaAttempt?: Maybe<MfaAttempt>;
};

/** Autogenerated input type of ResetPasswordForEmployee */
export type ResetPasswordForEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPasswordForEmployee. */
export type ResetPasswordForEmployeePayload = {
  __typename?: 'ResetPasswordForEmployeePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ResetUserPassword */
export type ResetUserPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of ResetUserPassword. */
export type ResetUserPasswordPayload = {
  __typename?: 'ResetUserPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of RetrieveInitialPlaidLinkToken */
export type RetrieveInitialPlaidLinkTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  redirectUri: Scalars['String']['input'];
};

/** Autogenerated return type of RetrieveInitialPlaidLinkToken. */
export type RetrieveInitialPlaidLinkTokenPayload = {
  __typename?: 'RetrieveInitialPlaidLinkTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  linkToken?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RetrievePlaidLinkToken */
export type RetrievePlaidLinkTokenInput = {
  androidPackageName?: InputMaybe<Scalars['String']['input']>;
  bankAccountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RetrievePlaidLinkToken. */
export type RetrievePlaidLinkTokenPayload = {
  __typename?: 'RetrievePlaidLinkTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  linkToken?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RevealTerms */
export type RevealTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  originationEvent?: InputMaybe<Scalars['String']['input']>;
  underwritingEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RevealTerms. */
export type RevealTermsPayload = {
  __typename?: 'RevealTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<Array<LendingLoanApplication>>;
};

export type RevenueLineItem = {
  __typename?: 'RevenueLineItem';
  amountCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type RevenueLineItemAttributes = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ReverifyOrReplacePlaidBankAccount */
export type ReverifyOrReplacePlaidBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  plaidAccountId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  trustlineId: Scalars['Int']['input'];
};

/** Autogenerated return type of ReverifyOrReplacePlaidBankAccount. */
export type ReverifyOrReplacePlaidBankAccountPayload = {
  __typename?: 'ReverifyOrReplacePlaidBankAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<AuthenticationError>>;
};

/** Autogenerated input type of ReverseBalanceAdjustment */
export type ReverseBalanceAdjustmentInput = {
  balanceAdjustmentId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ReverseBalanceAdjustment. */
export type ReverseBalanceAdjustmentPayload = {
  __typename?: 'ReverseBalanceAdjustmentPayload';
  balanceAdjustment?: Maybe<BalanceAdjustment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type S3AssetInput = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type S3PresignedUploadPayload = {
  __typename?: 'S3PresignedUploadPayload';
  metadata: S3PresignedUploadPayloadMetadata;
  url: Scalars['String']['output'];
};

export type S3PresignedUploadPayloadMetadata = {
  __typename?: 'S3PresignedUploadPayloadMetadata';
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};

/** Autogenerated input type of SavePressAsset */
export type SavePressAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pressAsset: PressAssetInput;
  thumbnailImage: S3AssetInput;
};

/** Autogenerated return type of SavePressAsset. */
export type SavePressAssetPayload = {
  __typename?: 'SavePressAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  pressAsset?: Maybe<PressAsset>;
};

/** Autogenerated input type of SavePressItem */
export type SavePressItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pressItem: PressItemInput;
};

/** Autogenerated return type of SavePressItem. */
export type SavePressItemPayload = {
  __typename?: 'SavePressItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  pressItem?: Maybe<PressItem>;
};

/** An object for users' savings goals. */
export type SavingsGoal = {
  __typename?: 'SavingsGoal';
  goalAmount: Scalars['Int']['output'];
  goalName: Scalars['String']['output'];
  goalTargetDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

/** An input object for users' savings goals. */
export type SavingsGoalAttributes = {
  goalAmount: Scalars['Int']['input'];
  goalName: Scalars['String']['input'];
  goalTargetDate: Scalars['Date']['input'];
};

/** Autogenerated input type of SchedulePredefinedInvestmentStrategy */
export type SchedulePredefinedInvestmentStrategyInput = {
  accountSecureId: Scalars['ID']['input'];
  amountCents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  strategy: PredefinedInvestmentStrategyName;
};

/** Autogenerated return type of SchedulePredefinedInvestmentStrategy. */
export type SchedulePredefinedInvestmentStrategyPayload = {
  __typename?: 'SchedulePredefinedInvestmentStrategyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  scheduledPredefinedInvestmentStrategy?: Maybe<ScheduledPredefinedInvestmentStrategy>;
};

export type ScheduledPredefinedInvestmentStrategy = {
  __typename?: 'ScheduledPredefinedInvestmentStrategy';
  account: Account;
  amountCents: Scalars['Int']['output'];
  fundsTransfers: Array<FundsTransfer>;
  id: Scalars['ID']['output'];
  purchaseOrder?: Maybe<PurchaseOrder>;
  state: Scalars['String']['output'];
  strategy?: Maybe<PredefinedInvestmentStrategyName>;
};

export type Score = {
  __typename?: 'Score';
  /** Human readable name for the score type */
  name: Scalars['String']['output'];
  /** The weight of this score type */
  weight: Scalars['Float']['output'];
};

/** Used to determine how we're selling a security */
export type SecBatch = {
  __typename?: 'SecBatch';
  /** The name of the batch */
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The issuer of our LROs */
  lroIssuer?: Maybe<LroIssuer>;
  /** The Offering that the LROs are available under */
  offering?: Maybe<Offering>;
};

/** The connection type for SecurityV2. */
export type SecuritiesConnection = {
  __typename?: 'SecuritiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SecuritiesEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SecurityV2>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SecuritiesEdge = {
  __typename?: 'SecuritiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SecurityV2>;
};

export type Security = {
  /** Amount that security is for */
  amountCents: Scalars['Int']['output'];
  /** Amount of purchased investments */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** Amount remaining that can be purchased */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** A short descriptive title for the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** Date the security will no longer be available on the platform */
  externalCloseDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Number of purchased Investments */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that is associated with the security */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Human readable distiguishable name for security */
  name: Scalars['String']['output'];
  /** Interest rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Date the investment was purchased */
  securityMaturesAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** Current state security offering is in */
  state: SecurityState;
  /** Summary of the intended purpose of the funds will be used for */
  summary?: Maybe<Scalars['String']['output']>;
  /** Length of time to projected maturity in months from loan effectivedate */
  term: Scalars['Int']['output'];
};

export type SecurityContent = {
  __typename?: 'SecurityContent';
  html: Scalars['String']['output'];
  locationKey: SecurityContentLocationKey;
};

export type SecurityContentInput = {
  html?: InputMaybe<Scalars['String']['input']>;
  locationKey?: InputMaybe<SecurityContentLocationKey>;
};

export enum SecurityContentLocationKey {
  FundingAndClosing = 'FUNDING_AND_CLOSING',
  InvestorProtections = 'INVESTOR_PROTECTIONS',
  Offering = 'OFFERING',
  Partner = 'PARTNER',
  PermittedUses = 'PERMITTED_USES',
  ReturnsOfCapitalAndSecurityInterest = 'RETURNS_OF_CAPITAL_AND_SECURITY_INTEREST',
  RiskFactors = 'RISK_FACTORS'
}

/** Provides parameters for purchasing investments in a Security offering */
export type SecurityPurchaseConfiguration = {
  __typename?: 'SecurityPurchaseConfiguration';
  id: Scalars['ID']['output'];
  /**
   * Minimum number of units per account that must be purchased in a Security
   * offering to invest, effectively sets a min purchase amount per Account
   */
  minUnitsPerAccount: Scalars['Int']['output'];
  /**
   * Defines the increments a Security offering can be purchased at and in some
   * cases the value of the shares at the time of purchase
   */
  unitPriceCents: Scalars['Int']['output'];
};

export type SecurityRepayment = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  finalPayment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  returnOfCapitalCents?: Maybe<Scalars['Int']['output']>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  transactionDescriptor?: Maybe<RepaymentTransactionDescriptor>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SecuritySortAttributes = {
  field: SecuritySortField;
  order: Order;
};

export enum SecuritySortField {
  DisbursementType = 'DISBURSEMENT_TYPE',
  ExpectedTerm = 'EXPECTED_TERM',
  LatestPurchasedAtDate = 'LATEST_PURCHASED_AT_DATE',
  MaturityDate = 'MATURITY_DATE',
  Performance = 'PERFORMANCE',
  Rate = 'RATE',
  /** The rating (a.k.a. grade) of the security */
  Rating = 'RATING',
  RepaidAt = 'REPAID_AT'
}

export enum SecurityState {
  /** Investors in the security offering have been refunded */
  Closed = 'CLOSED',
  /** Investors in the security offering are currently being refunded */
  Closing = 'CLOSING',
  /** Security offering has been fully funded */
  FundingCommited = 'FUNDING_COMMITED',
  /** Security offering funds have been posted */
  FundingPosted = 'FUNDING_POSTED',
  /** Security offering that is live for investment purchases */
  Live = 'LIVE',
  /** Fresh security offering that has not gone live yet */
  New = 'NEW',
  /** Currently repaying investors of security offering */
  ProcessingRepayment = 'PROCESSING_REPAYMENT',
  /** Security offering has been removed from the platform */
  Removed = 'REMOVED',
  /** Investors in the security offering have been repaid */
  Repaid = 'REPAID',
  /** Repayment of security offering to investors has been annnounced */
  RepaymentAnnounced = 'REPAYMENT_ANNOUNCED'
}

export enum SecuritySubtypeName {
  CashFlowAdvance = 'CASH_FLOW_ADVANCE',
  ConstructionEquity = 'CONSTRUCTION_EQUITY',
  FlagshipIndexCohort = 'FLAGSHIP_INDEX_COHORT',
  GeneralizedSecurity = 'GENERALIZED_SECURITY',
  GfDebtNote = 'GF_DEBT_NOTE',
  GfEquity = 'GF_EQUITY',
  GfNote = 'GF_NOTE',
  GrowthIndex = 'GROWTH_INDEX',
  GrowthIndexSidecar = 'GROWTH_INDEX_SIDECAR',
  HomeEquityInvestment = 'HOME_EQUITY_INVESTMENT',
  LandAdvance = 'LAND_ADVANCE',
  Loan = 'LOAN',
  LongTermRentalEquity = 'LONG_TERM_RENTAL_EQUITY',
  MonthlyIncomeIndex = 'MONTHLY_INCOME_INDEX',
  PortfolioResale = 'PORTFOLIO_RESALE',
  Reit = 'REIT',
  RenovationEquity = 'RENOVATION_EQUITY',
  RentalPortfolio = 'RENTAL_PORTFOLIO',
  SecondLienFinancing = 'SECOND_LIEN_FINANCING',
  ShortTermRentalEquity = 'SHORT_TERM_RENTAL_EQUITY'
}

export enum SecurityTypeName {
  GeneralizedSecurity = 'GENERALIZED_SECURITY',
  GfDebtNote = 'GF_DEBT_NOTE',
  GfEquity = 'GF_EQUITY',
  GfNote = 'GF_NOTE',
  Loan = 'LOAN',
  Reit = 'REIT'
}

export type SecurityV2 = {
  /** The percentage of an account's portfolio which is made up of investments in this security. */
  accountCommitmentsPortfolioPercentage?: Maybe<Scalars['Float']['output']>;
  activeOfferingSummaryUrl?: Maybe<Scalars['String']['output']>;
  /** The amount that has been invested in the security in cents. */
  amountInvestedCents: Scalars['Int']['output'];
  /** Maximum amount in cents that can be invested */
  amountMaxInvestmentCents: Scalars['Int']['output'];
  /** The amount remaining until the security has been fully funded. */
  amountRemainingCents: Scalars['Int']['output'];
  /** Maximum percent of a security that can be purcahsed */
  cap: Scalars['Int']['output'];
  /** Page/application content for the security. */
  contents: Array<SecurityContent>;
  /** The creation timestamp of the security. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The title of the security */
  descriptiveTitle?: Maybe<Scalars['String']['output']>;
  /** The date the security will no longer be available on the platform */
  externalCloseOn?: Maybe<Scalars['Date']['output']>;
  /** External partners for this security */
  externalPartners: Array<ExternalPartner>;
  /** The date the loan was funded */
  fundsPostedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the security will be available on the platform */
  goLiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The primary key of the security. */
  id: Scalars['ID']['output'];
  /** Purchase constraints and other information for an investment in a particular account. */
  investmentPurchaseMetadata?: Maybe<InvestmentPurchaseMetadata>;
  /** Investments that have been made in the security. */
  investments: Array<Investment>;
  /** Updates for the investors on the progress of the project. */
  investorUpdates: Array<InvestorUpdate>;
  /** The number of people that have made an investment in the security. */
  investorsCount: Scalars['Int']['output'];
  /** The marketing category that the security has been assigned to. */
  marketingCategory?: Maybe<MarketingCategory>;
  /** The date the security was most recently purchased */
  mostRecentPurchasedAtForAccount?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name or title of the security. */
  name: Scalars['String']['output'];
  /** Regulation for the Offering */
  offeringRegulation?: Maybe<Scalars['String']['output']>;
  /** The date the sec_batch was qualified by sec */
  secBatchQualifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date the sec_batch was submitted to sec */
  secBatchSubmittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether security is Tier 1 or not */
  secBatchTier1: Scalars['Boolean']['output'];
  securityAgreementUrl?: Maybe<Scalars['String']['output']>;
  /** The date the security began acrring interest */
  securityEffectiveOn?: Maybe<Scalars['Date']['output']>;
  securityPurchaseConfiguration: SecurityPurchaseConfiguration;
  /** The state of the security. */
  state?: Maybe<Scalars['String']['output']>;
  /** The update timestamp of the security. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type SecurityV2AccountCommitmentsPortfolioPercentageArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type SecurityV2InvestmentPurchaseMetadataArgs = {
  accountSecureId: Scalars['ID']['input'];
};


export type SecurityV2InvestmentsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<InvestmentState>;
};


export type SecurityV2MostRecentPurchasedAtForAccountArgs = {
  accountSecureId: Scalars['ID']['input'];
};

/** Autogenerated input type of SendTermSheetToPrincipal */
export type SendTermSheetToPrincipalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of SendTermSheetToPrincipal. */
export type SendTermSheetToPrincipalPayload = {
  __typename?: 'SendTermSheetToPrincipalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of SendTermsToBorrower */
export type SendTermsToBorrowerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  originationEvent?: InputMaybe<Scalars['String']['input']>;
  underwritingEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendTermsToBorrower. */
export type SendTermsToBorrowerPayload = {
  __typename?: 'SendTermsToBorrowerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<Array<LendingLoanApplication>>;
};

/** Autogenerated input type of SetAutoInvestorAccountConfig */
export type SetAutoInvestorAccountConfigInput = {
  accountConfigAttributes: AutoInvestorAccountConfigAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The account's secure_id */
  secureId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetAutoInvestorAccountConfig. */
export type SetAutoInvestorAccountConfigPayload = {
  __typename?: 'SetAutoInvestorAccountConfigPayload';
  accountConfig?: Maybe<AutoInvestorAccountConfig>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of SetBrokerApplicationFeeAmount */
export type SetBrokerApplicationFeeAmountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The desired fee amount for broker loan applications, in cents. */
  feeAmountCents: Scalars['Int']['input'];
};

/** Autogenerated return type of SetBrokerApplicationFeeAmount. */
export type SetBrokerApplicationFeeAmountPayload = {
  __typename?: 'SetBrokerApplicationFeeAmountPayload';
  /** The current broker application fee configuration. */
  brokerApplicationFeeConfiguration?: Maybe<BrokerApplicationFeeConfiguration>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A collection of errors, if any have occurred. */
  errors: Array<Error>;
};

/** Autogenerated input type of SetPrimaryAccount */
export type SetPrimaryAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  primaryAccountSecureId: Scalars['String']['input'];
};

/** Autogenerated return type of SetPrimaryAccount. */
export type SetPrimaryAccountPayload = {
  __typename?: 'SetPrimaryAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of SetReitReinvestmentSetting */
export type SetReitReinvestmentSettingInput = {
  accountSecureId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reinvestmentType: ReinvestmentTypeName;
};

/** Autogenerated return type of SetReitReinvestmentSetting. */
export type SetReitReinvestmentSettingPayload = {
  __typename?: 'SetReitReinvestmentSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reinvestmentSetting?: Maybe<ReinvestmentSetting>;
};

/** Autogenerated input type of SetupSecurityForInstitutionalPurchase */
export type SetupSecurityForInstitutionalPurchaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  secBatchId: Scalars['ID']['input'];
  securityId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetupSecurityForInstitutionalPurchase. */
export type SetupSecurityForInstitutionalPurchasePayload = {
  __typename?: 'SetupSecurityForInstitutionalPurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  security?: Maybe<Security>;
};

/** A set of credentials used to log in with a signature instead of a password.  Used for biometric authentication. */
export type SignatureCredentials = {
  /** The ID of the key used for signing */
  keyId: Scalars['String']['input'];
  /** The signed payload used to verify the key */
  signedPayload: SignedNoncePayload;
};

/** A signed packet of data to verify ownership of a signing key */
export type SignedNoncePayload = {
  /** A number which is greater than that of any previous signed nonce for the key */
  nonce: Scalars['BigInt']['input'];
  /** Arbitrary data to add to the end of the nonce before signing */
  salt: Scalars['String']['input'];
  /** The signature of the nonce concatenated with the salt and base64 encoded */
  signature: Scalars['String']['input'];
};

export enum Source {
  AutomaticReinvestment = 'AUTOMATIC_REINVESTMENT',
  ManualInvestment = 'MANUAL_INVESTMENT'
}

/** Autogenerated input type of StartLendingLoanApplicationUsingPreapproval */
export type StartLendingLoanApplicationUsingPreapprovalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  preapprovalId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartLendingLoanApplicationUsingPreapproval. */
export type StartLendingLoanApplicationUsingPreapprovalPayload = {
  __typename?: 'StartLendingLoanApplicationUsingPreapprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<LendingLoanApplication>;
};

/**
 * Summary of an account's portfolio with regard to Available Cash, Money at Work,
 * Principal Invested, Interest Earned, and Annualized Return.
 */
export type StartPageAccountSummary = {
  __typename?: 'StartPageAccountSummary';
  /** Actual annualized rate of return earned on closed LROs and GF Notes. */
  annualizedReturnOnClosedInvestments?: Maybe<Scalars['Float']['output']>;
  /** Total cents (including fractions) of interest accrued on Active LRO and Note Investments */
  expectedAccruedInterestCents: Scalars['Float']['output'];
  /** Total cents of interest expected to be earned per second on Active LRO and Note Investments */
  expectedInterestCentsPerSecond: Scalars['Float']['output'];
  /** Total Amount Cents available for investing right now */
  investableFundsAmountCents: Scalars['Long']['output'];
  /** Total interest earned on LROs and GF Notes across account history. Does not reflect interest accrued on Open Investments. */
  lifetimeInterestEarnedAmountCents: Scalars['Long']['output'];
  /** Total Principal invested in LROs and GF Notes across account history, excluding Open Investments. */
  lifetimePrincipalInvestedAmountCents: Scalars['Long']['output'];
  /** Total Amount Cents currently invested in Active LRO and Note Investments */
  moneyAtWorkAmountCents: Scalars['Long']['output'];
  /** Change of money_at_work_amount_cents compared to 30 days ago */
  moneyAtWorkAmountCentsChangeLast30Days?: Maybe<Scalars['Long']['output']>;
  /**
   * Percentage change of money_at_work_amount_cents compared to 30 days ago.  Can
   * null if the user had no money at work 30 days ago
   */
  moneyAtWorkPercentChangeLast30Days?: Maybe<Scalars['Float']['output']>;
  /**
   * Total net amount of contributions made by the user into the account. This
   * amount takes into account lifetime funds transfers in and is adjusted by funds
   * transfers out, with the assumption that transfers out are first transfers of
   * interest earned and only after exhausting earned interest are funds transfers
   * out a reduction of the user's contribution
   */
  netContributionAmountCents?: Maybe<Scalars['Long']['output']>;
};

/** Autogenerated input type of StartPdfBatchGeneration */
export type StartPdfBatchGenerationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pdfBatchId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartPdfBatchGeneration. */
export type StartPdfBatchGenerationPayload = {
  __typename?: 'StartPdfBatchGenerationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  pdfBatchId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of StartUserRegistration */
export type StartUserRegistrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of StartUserRegistration. */
export type StartUserRegistrationPayload = {
  __typename?: 'StartUserRegistrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<RegistrationError>>;
  secureToken?: Maybe<Scalars['String']['output']>;
  userRegistration?: Maybe<UserRegistration>;
};

/** Autogenerated input type of SubmitAllStagedLabsRepayments */
export type SubmitAllStagedLabsRepaymentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitAllStagedLabsRepayments. */
export type SubmitAllStagedLabsRepaymentsPayload = {
  __typename?: 'SubmitAllStagedLabsRepaymentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SubmitNoteInterestPayment */
export type SubmitNoteInterestPaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groundfloorNoteId: Scalars['Int']['input'];
  interestWindowPaymentId: Scalars['Int']['input'];
};

/** Autogenerated return type of SubmitNoteInterestPayment. */
export type SubmitNoteInterestPaymentPayload = {
  __typename?: 'SubmitNoteInterestPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  noteInterestPayment?: Maybe<NoteInterestPayment>;
};

/** Autogenerated input type of SubmitPartialRepayment */
export type SubmitPartialRepaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of SubmitPartialRepayment. */
export type SubmitPartialRepaymentPayload = {
  __typename?: 'SubmitPartialRepaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  partialRepayment?: Maybe<PartialRepayment>;
};

/** the state of a loan application when it was submitted */
export type SubmittedLoanApplication = {
  __typename?: 'SubmittedLoanApplication';
  address?: Maybe<Address>;
  adverseLegalJudgment?: Maybe<Scalars['Boolean']['output']>;
  afterRepairValue?: Maybe<Scalars['Float']['output']>;
  afterRepairValueBasedOn?: Maybe<Scalars['String']['output']>;
  afterRepairValueCents?: Maybe<Scalars['Int']['output']>;
  agreementAccepted?: Maybe<Scalars['String']['output']>;
  /** The product SKU of the loan application */
  applicationSku?: Maybe<ApplicationSku>;
  attorneyFeeCents: Scalars['Int']['output'];
  bankruptcy?: Maybe<Scalars['Boolean']['output']>;
  /** assigned BDM */
  bdm?: Maybe<AdminUser>;
  borrowerEquityCents?: Maybe<Scalars['Int']['output']>;
  /** Keeps track of whether the loan app is brokered */
  brokered?: Maybe<Scalars['Boolean']['output']>;
  /** down payment amount */
  cashDownPayment?: Maybe<Scalars['Float']['output']>;
  /** down payment in cents */
  cashDownPaymentCents?: Maybe<Scalars['Int']['output']>;
  cashToClose?: Maybe<Scalars['Float']['output']>;
  /** time the CLA was approved */
  claApprovedAt?: Maybe<Scalars['Date']['output']>;
  /** time the CLA was sent */
  claSentAt?: Maybe<Scalars['Date']['output']>;
  closingDetail?: Maybe<ClosingDetail>;
  contractEndDate?: Maybe<Scalars['Date']['output']>;
  /** value of property at purchase */
  contractPurchasePrice?: Maybe<Scalars['Float']['output']>;
  contractPurchasePriceCents?: Maybe<Scalars['Int']['output']>;
  convincedOfAFelony?: Maybe<Scalars['Boolean']['output']>;
  /** The primary image that is shown for the loan application */
  coverImage?: Maybe<Image>;
  /** summary of the loan-transaction */
  dealSummary?: Maybe<Scalars['String']['output']>;
  /** amount for closing */
  downPaymentAmount?: Maybe<Scalars['Float']['output']>;
  existingLoanPayoffCents?: Maybe<Scalars['Int']['output']>;
  exitStrategy?: Maybe<Scalars['String']['output']>;
  feesRolledIn: Scalars['Boolean']['output'];
  foreclosure?: Maybe<Scalars['Boolean']['output']>;
  /** initial disbursement at closing */
  groundfloorDay1?: Maybe<Scalars['Float']['output']>;
  guarantors?: Maybe<Array<LendingPrincipal>>;
  /** ID of the application */
  id?: Maybe<Scalars['ID']['output']>;
  initialAmountRequestedCents?: Maybe<Scalars['Int']['output']>;
  /** first draw */
  initialDisbursement?: Maybe<Scalars['String']['output']>;
  interestType?: Maybe<LendingLoanApplicationInterest>;
  /** key_loan_feature field from Salesforce */
  keyLoanFeature?: Maybe<Scalars['String']['output']>;
  lendingBorrowerEntity?: Maybe<LendingBorrowerEntity>;
  /** lending_origination_fee associated to object */
  lendingOriginationFee?: Maybe<LendingOriginationFee>;
  lendingPrincipal?: Maybe<LendingPrincipal>;
  loanApplicationConditions?: Maybe<Array<LoanApplicationCondition>>;
  /** The current state of the application, as represented in the loan tracker */
  loanTrackerState?: Maybe<LoanTrackerState>;
  /** loan amount over ARV */
  ltarv?: Maybe<Scalars['Float']['output']>;
  /** loan amount over project cost */
  ltc?: Maybe<Scalars['Float']['output']>;
  /** loan amount over value */
  ltv?: Maybe<Scalars['Float']['output']>;
  monthlyInterestPayment?: Maybe<Scalars['Float']['output']>;
  /** current stage in salesforce */
  opportunityState?: Maybe<LoanApplicationOpportunityState>;
  originalPurchaseDate?: Maybe<Scalars['Date']['output']>;
  /** The status of the origination flow */
  originationState?: Maybe<LoanApplicationOriginationState>;
  ownershipStatus?: Maybe<Scalars['String']['output']>;
  /** how often payments will be made */
  paymentType?: Maybe<Scalars['String']['output']>;
  preapprovals?: Maybe<Array<Preapproval>>;
  processingFeeCents: Scalars['Int']['output'];
  propertyType?: Maybe<Scalars['String']['output']>;
  /** value of the property as-is */
  propertyValue?: Maybe<Scalars['Float']['output']>;
  propertyValueCents?: Maybe<Scalars['Int']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  /** Interest rate for the loan */
  rate?: Maybe<Scalars['Float']['output']>;
  rateModifier?: Maybe<Scalars['Float']['output']>;
  /** grade of the loan */
  rating?: Maybe<Scalars['String']['output']>;
  /** The version of the engine this was rated under */
  ratingEngineVersion?: Maybe<Scalars['String']['output']>;
  /** AKA LIP Escrow Holdback */
  rehabFundsNeeded?: Maybe<Scalars['Float']['output']>;
  /** our lien on the property */
  securityPosition?: Maybe<Scalars['String']['output']>;
  /** unique, non-incremental handle for the application */
  slug?: Maybe<Scalars['String']['output']>;
  state: LendingLoanApplicationState;
  stateEvents: Array<LendingLoanApplicationStateEvents>;
  /** loan application as submitted */
  submittedVersion?: Maybe<SubmittedLoanApplication>;
  supportingDocuments?: Maybe<Array<Asset>>;
  targetClosingDate?: Maybe<Scalars['Date']['output']>;
  tasks: Array<Task>;
  /** length of time the loan will last */
  term?: Maybe<Scalars['String']['output']>;
  /** The current term sheet for the application */
  termSheet?: Maybe<TermSheet>;
  /** loan amount with fees */
  totalAmountWithFees?: Maybe<Scalars['Float']['output']>;
  /** total amount of the loan */
  totalLoanAmount?: Maybe<Scalars['Float']['output']>;
  totalProjectCost?: Maybe<Scalars['Float']['output']>;
  totalRehabBudget?: Maybe<Scalars['Float']['output']>;
  totalRehabBudgetCents?: Maybe<Scalars['Int']['output']>;
  underwritingFeeCents: Scalars['Int']['output'];
  /** keep track of CLA status */
  underwritingState?: Maybe<LoanApplicationUnderwritingState>;
};

/** Autogenerated input type of SupportingDocumentUploaded */
export type SupportingDocumentUploadedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the uploaded document */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SupportingDocumentUploaded. */
export type SupportingDocumentUploadedPayload = {
  __typename?: 'SupportingDocumentUploadedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Legacy BankAccount that was provisioned by Synapsepay as a funding source */
export type SynapsepayBankAccount = BankAccount & {
  __typename?: 'SynapsepayBankAccount';
  accountType?: Maybe<Scalars['String']['output']>;
  bankAccountFeatures: Array<BankAccountFeature>;
  bankName?: Maybe<Scalars['String']['output']>;
  connectedTrustlines: Array<Trustline>;
  descriptiveName: Scalars['String']['output'];
  errors: Array<BankAccountError>;
  id: Scalars['ID']['output'];
  last4Digits?: Maybe<Scalars['String']['output']>;
  /** Have associated micro deposits posted to users bank account. */
  microDepositsPosted: Scalars['Boolean']['output'];
  state: BankAccountState;
  uuid: Scalars['ID']['output'];
  verificationAttempts: Scalars['Int']['output'];
  verificationLevel: BankAccountVerificationLevel;
};

/** Autogenerated input type of TakeGeneralizedSecurityLive */
export type TakeGeneralizedSecurityLiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalizedSecurityId: Scalars['ID']['input'];
};

/** Autogenerated return type of TakeGeneralizedSecurityLive. */
export type TakeGeneralizedSecurityLivePayload = {
  __typename?: 'TakeGeneralizedSecurityLivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  generalizedSecurity?: Maybe<GeneralizedSecurity>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** info for a task associated to an object */
export type Task = {
  __typename?: 'Task';
  /** ID of the principal */
  id: Scalars['ID']['output'];
  /** Name of the task */
  name: Scalars['String']['output'];
  /** State of the task */
  state: Scalars['String']['output'];
  supportingDocument?: Maybe<Asset>;
  /** Info about the task */
  tooltipText?: Maybe<Scalars['String']['output']>;
};

export type TaxPayer = {
  __typename?: 'TaxPayer';
  account: Account;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  businessAccount?: Maybe<Scalars['Boolean']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  earnedInterestCentsForTaxYear?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  obfuscatedEin?: Maybe<Scalars['String']['output']>;
  obfuscatedSsn?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type TaxPayerModificationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  businessAccount?: InputMaybe<Scalars['Boolean']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/** A log of the terms agreed to by a borrower for a loan */
export type TermSheet = {
  __typename?: 'TermSheet';
  /** The associated application */
  applicationForTerms: LendingLoanApplication;
  /** ID of the term sheet */
  id: Scalars['ID']['output'];
  /** The associated application */
  lendingLoanApplication: LendingLoanApplication;
  /** State of the task */
  state: TermSheetState;
  /** Valid transitions for the term sheet */
  stateEvents: Array<TermSheetStateEvent>;
  /** The application's version */
  versionId: Scalars['Int']['output'];
};

export enum TermSheetState {
  /** Term sheet has been sent to the principal but not viewed */
  PrincipalTermsSent = 'PRINCIPAL_TERMS_SENT',
  /** Term sheet has been agreed to by the user */
  TermsAgreed = 'TERMS_AGREED',
  /** Term sheet has been generated but not sent to the user */
  TermsGenerated = 'TERMS_GENERATED',
  /** Term sheet has been rejected */
  TermsRejected = 'TERMS_REJECTED',
  /** Term sheet has been sent to the owner but not viewed */
  TermsSent = 'TERMS_SENT',
  /** Term sheet has been viewed but not agreed to or rejected */
  TermsViewed = 'TERMS_VIEWED'
}

export enum TermSheetStateEvent {
  /** The terms have been agreed to by the user */
  AgreeToTermSheet = 'AGREE_TO_TERM_SHEET',
  /** The terms have been rejected by the user */
  RejectTermSheet = 'REJECT_TERM_SHEET',
  /** The term sheet has been sent to the principal by the broker */
  SendPrincipalTermSheet = 'SEND_PRINCIPAL_TERM_SHEET',
  /** The term sheet has been sent to the owner */
  SendTermSheet = 'SEND_TERM_SHEET',
  /** The user has viewed the term sheet */
  ViewedTermSheet = 'VIEWED_TERM_SHEET'
}

export enum TermsAndConditions {
  /** Terms and conditions for GF3 accounts automatically investing in the REIT */
  Gf3AutomaticReitInvesting = 'GF3_AUTOMATIC_REIT_INVESTING'
}

/** A record of an acceptance of terms and conditions */
export type TermsAndConditionsAcceptance = {
  __typename?: 'TermsAndConditionsAcceptance';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Secure ID of the account; null for user-level acceptances */
  accountSecureId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identified for the Terms and Conditions Acceptance */
  id: Scalars['ID']['output'];
  /** The investment associated with the Terms and Conditions Acceptance */
  investment?: Maybe<Investment>;
  /** The security associated with the Terms and Conditions Acceptance */
  security?: Maybe<Security>;
  /** Type of Terms and Conditions Accepted */
  termsAndConditions: TermsAndConditions;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the user that accepted the Terms and Conditions */
  userId: Scalars['ID']['output'];
};

export type Timestamp = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of ToggleAccountFlag */
export type ToggleAccountFlagInput = {
  accountSecureId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flag: AccountFlags;
  value: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ToggleAccountFlag. */
export type ToggleAccountFlagPayload = {
  __typename?: 'ToggleAccountFlagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of ToggleBrokerApplicationFeeEnabled */
export type ToggleBrokerApplicationFeeEnabledInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ToggleBrokerApplicationFeeEnabled. */
export type ToggleBrokerApplicationFeeEnabledPayload = {
  __typename?: 'ToggleBrokerApplicationFeeEnabledPayload';
  /** The current broker application fee configuration. */
  brokerApplicationFeeConfiguration?: Maybe<BrokerApplicationFeeConfiguration>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A collection of errors, if any have occurred. */
  errors: Array<Error>;
};

/** Autogenerated input type of ToggleRecurringTransferSchedule */
export type ToggleRecurringTransferScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of ToggleRecurringTransferSchedule. */
export type ToggleRecurringTransferSchedulePayload = {
  __typename?: 'ToggleRecurringTransferSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  recurringTransferSchedule?: Maybe<RecurringTransferSchedule>;
};

/** Autogenerated input type of ToggleUserModeration */
export type ToggleUserModerationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of ToggleUserModeration. */
export type ToggleUserModerationPayload = {
  __typename?: 'ToggleUserModerationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

export enum TransactionCategory {
  Flagship = 'FLAGSHIP',
  FundsTransfer = 'FUNDS_TRANSFER',
  Labs = 'LABS',
  Loans = 'LOANS',
  Notes = 'NOTES',
  Other = 'OTHER',
  Stock = 'STOCK'
}

/** Represents an Employee's request to perform a transaciton against an investor's account */
export type TransactionRequest = {
  __typename?: 'TransactionRequest';
  amountCents: Scalars['Int']['output'];
  approvalState: TransactionRequestApprovalState;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fromBankAccount: BankAccount;
  id?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  purpose: Scalars['String']['output'];
  requestedAt: Scalars['ISO8601DateTime']['output'];
  toBankAccount: BankAccount;
  transactionState: TransactionRequestTransactionState;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum TransactionRequestApprovalState {
  /** Request has been approved and will be processed very soon */
  Approved = 'APPROVED',
  /** Request has been rejected */
  Rejected = 'REJECTED',
  /** Request is pending approval */
  Requested = 'REQUESTED',
  /** Request has been taken back */
  Unrequested = 'UNREQUESTED'
}

export type TransactionRequestAttributes = {
  amountCents: Scalars['Int']['input'];
  fromBankAccountId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  purpose: Scalars['String']['input'];
  toBankAccountId: Scalars['Int']['input'];
};

export enum TransactionRequestTransactionState {
  /** Transaction has posted */
  Completed = 'COMPLETED',
  /** Transaction failed to post */
  Failed = 'FAILED',
  /** Waiting on approval before processing */
  PendingApproval = 'PENDING_APPROVAL',
  /** Creating and posting transaction */
  Processing = 'PROCESSING'
}

export enum TransactionType {
  Investment = 'INVESTMENT',
  Other = 'OTHER',
  Refund = 'REFUND',
  Repayment = 'REPAYMENT',
  TransferIn = 'TRANSFER_IN',
  TransferOut = 'TRANSFER_OUT'
}

/** Represents a collection of transactional communications */
export type TransactionalCommunicationCategory = {
  __typename?: 'TransactionalCommunicationCategory';
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  sendEmail: Scalars['Boolean']['output'];
  sendNotification: Scalars['Boolean']['output'];
  sendSms: Scalars['Boolean']['output'];
};

export type TransactionalCommunicationCategoryAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of TransferFunds */
export type TransferFundsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundsTransfer: FundsTransferAttributes;
};

/** Autogenerated return type of TransferFunds. */
export type TransferFundsPayload = {
  __typename?: 'TransferFundsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  fundsTransfer?: Maybe<FundsTransfer>;
};

/** Transfer and Invest promotion details */
export type TransferInvestPromo = {
  __typename?: 'TransferInvestPromo';
  allUserPromo?: Maybe<Scalars['Boolean']['output']>;
  allUsersAdded?: Maybe<Scalars['Boolean']['output']>;
  disburseOn: Scalars['Date']['output'];
  maxRewardCents: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  promoEndOn: Scalars['Date']['output'];
  qualificationEndOn: Scalars['Date']['output'];
  rewardAmountCents: Scalars['Int']['output'];
  signupEndOn: Scalars['Date']['output'];
  signupStartOn: Scalars['Date']['output'];
  termsAndConditionsUrl: Scalars['String']['output'];
  thresholdCents: Scalars['Int']['output'];
  type: TransferInvestPromoTypes;
};

export enum TransferInvestPromoTypes {
  /** Shareholder-Only Transfer and Invest Promotion */
  ShareholderOnly = 'shareholder_only',
  /** Transfer and Invest Promotion */
  TransferAndInvest = 'transfer_and_invest'
}

/** Calculated values for Transfer and Invest promotion */
export type TransferInvestPromotionTracker = {
  __typename?: 'TransferInvestPromotionTracker';
  earnedAmountCents: Scalars['Int']['output'];
  investedAmountCents: Scalars['Int']['output'];
  transferInvestPromo: TransferInvestPromo;
  transferredAmountCents: Scalars['Int']['output'];
};

/** Autogenerated input type of TransferPrincipalLendingLoanApplications */
export type TransferPrincipalLendingLoanApplicationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPrincipalId: Scalars['Int']['input'];
  previousPrincipalIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated return type of TransferPrincipalLendingLoanApplications. */
export type TransferPrincipalLendingLoanApplicationsPayload = {
  __typename?: 'TransferPrincipalLendingLoanApplicationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of TransitionLendingLoan */
export type TransitionLendingLoanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of TransitionLendingLoan. */
export type TransitionLendingLoanPayload = {
  __typename?: 'TransitionLendingLoanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoan?: Maybe<LendingLoan>;
};

/** Autogenerated input type of TransitionTermSheet */
export type TransitionTermSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  stateEvent: TermSheetStateEvent;
};

/** Autogenerated return type of TransitionTermSheet. */
export type TransitionTermSheetPayload = {
  __typename?: 'TransitionTermSheetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  termSheet?: Maybe<TermSheet>;
};

/** Central object in provisioning connections to providers for movement of funds */
export type Trustline = {
  __typename?: 'Trustline';
  /** Account that owns the trustline */
  account: Account;
  /** Funding source the Trustline connects to */
  bankAccount?: Maybe<BankAccount>;
  /** The date and time when the trustline's connected bank account can be removed or replaced */
  bankAccountProbationEndsOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The identity used to provision the account with the provider */
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  /** Provider the trustline is connecting to */
  provider: TrustlineProvider;
  /** State of the connection to the provider */
  state: TrustlineState;
};

export enum TrustlineProvider {
  /** Dwolla ACH */
  Dwolla = 'DWOLLA',
  /** Trustline to internal GROUNDFLOOR funds */
  Groundfloor = 'GROUNDFLOOR',
  /** IRA Services (ISCP) */
  IraServices = 'IRA_SERVICES',
  /** Sandbox just for development and test env */
  Sandbox = 'SANDBOX'
}

export enum TrustlineState {
  /** Archived and no longer active */
  Archived = 'ARCHIVED',
  /** Trustline's bank_account, customer & identity_card can be editted freely */
  Authoring = 'AUTHORING',
  /** Trustline connection is currently being provisioned with provider */
  BeingConnected = 'BEING_CONNECTED',
  /** Connected to provider */
  Connected = 'CONNECTED',
  /** Failed to provision connection to provider */
  ConnectionFailed = 'CONNECTION_FAILED',
  /** Not yet connected to a provider */
  NotConnected = 'NOT_CONNECTED',
  /** Connection is provisioned but but verification is being retried with provide */
  RetryingProviderVerification = 'RETRYING_PROVIDER_VERIFICATION'
}

export enum Type {
  Flywheel = 'FLYWHEEL'
}

/** A record of a UI Interaction taken by a user or account */
export type UiInteraction = {
  __typename?: 'UiInteraction';
  /** Secure ID of the account; null for user-level ui actions */
  accountSecureId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Identified for the UI Interaction */
  id: Scalars['ID']['output'];
  /** Name of the UI Interaction */
  interaction: UiInteractionName;
  /** Extra details of the UI Interaction */
  interactionDetail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the user that performed the UI Interaction */
  userId: Scalars['ID']['output'];
};

export enum UiInteractionName {
  /** user has accepted the terms and conditions for the index product */
  HasAcceptedIndexTermsAndConditions = 'HAS_ACCEPTED_INDEX_TERMS_AND_CONDITIONS',
  /** user has seen and closed the success banner after being referred */
  HasClosedReferralSuccessBanner = 'HAS_CLOSED_REFERRAL_SUCCESS_BANNER',
  /** User has been prompted to update tax info and has updated it or confirmed that it is correct */
  HasConfirmedTaxInfo = 'HAS_CONFIRMED_TAX_INFO',
  /**
   * user has seen and dismissed a notification that a funds transfer has failed.
   * the updatedAt date of this dismissal can be used as the from date when quering
   * failed transactions
   */
  HasDismissedFailedFundsTransferNotification = 'HAS_DISMISSED_FAILED_FUNDS_TRANSFER_NOTIFICATION',
  /** user has seen and dismissed the terms and conditions modal for the index product */
  HasDismissedIndexTermsAndConditionsModal = 'HAS_DISMISSED_INDEX_TERMS_AND_CONDITIONS_MODAL',
  /** user has seen the advances moving banner on the labs dashboard */
  HasSeenAdvancesMovingBanner = 'HAS_SEEN_ADVANCES_MOVING_BANNER',
  /** user has seen the advances moving modal on the labs dashboard */
  HasSeenAdvancesMovingModal = 'HAS_SEEN_ADVANCES_MOVING_MODAL',
  /** User has seen the product release announcement specified in the interaction_detail */
  HasSeenProductReleaseAnnouncement = 'HAS_SEEN_PRODUCT_RELEASE_ANNOUNCEMENT',
  /** user has seen the welcome modal for an auto investor account */
  HasSeenWelcomeToAutoInvestorAccountModal = 'HAS_SEEN_WELCOME_TO_AUTO_INVESTOR_ACCOUNT_MODAL',
  /** user has seen the onboarding survey and chosen the exploration path */
  OnboardingSurveyInvestmentGoalExplore = 'ONBOARDING_SURVEY_INVESTMENT_GOAL_EXPLORE',
  /** user has seen the onboarding survey and chosen the growth path */
  OnboardingSurveyInvestmentGoalGrowth = 'ONBOARDING_SURVEY_INVESTMENT_GOAL_GROWTH',
  /** user has seen the onboarding survey and chosen the passive income path */
  OnboardingSurveyInvestmentGoalIncome = 'ONBOARDING_SURVEY_INVESTMENT_GOAL_INCOME',
  /** user has seen the onboarding survey and chosen to skip completion */
  OnboardingSurveyInvestmentGoalSkipped = 'ONBOARDING_SURVEY_INVESTMENT_GOAL_SKIPPED'
}

/** Autogenerated input type of UnArchiveUser */
export type UnArchiveUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userArchivalId: Scalars['Int']['input'];
};

/** Autogenerated return type of UnArchiveUser. */
export type UnArchiveUserPayload = {
  __typename?: 'UnArchiveUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UnderwritingCompleted */
export type UnderwritingCompletedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  originationEvent?: InputMaybe<Scalars['String']['input']>;
  underwritingEvent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnderwritingCompleted. */
export type UnderwritingCompletedPayload = {
  __typename?: 'UnderwritingCompletedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  lendingLoanApplication?: Maybe<Array<LendingLoanApplication>>;
};

/** Autogenerated input type of UnenrollFromMfa */
export type UnenrollFromMfaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  /** The ID of the user to unenroll.  Defaults to the current user. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UnenrollFromMfa. */
export type UnenrollFromMfaPayload = {
  __typename?: 'UnenrollFromMfaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** If MFA is required, a new MFA Attempt will be triggered and returned */
  mfaAttempt?: Maybe<MfaAttempt>;
  user: User;
};

/** Autogenerated input type of UnlinkBankAccountFromTrustline */
export type UnlinkBankAccountFromTrustlineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trustlineId: Scalars['Int']['input'];
};

/** Autogenerated return type of UnlinkBankAccountFromTrustline. */
export type UnlinkBankAccountFromTrustlinePayload = {
  __typename?: 'UnlinkBankAccountFromTrustlinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  trustline?: Maybe<Trustline>;
};

/** Autogenerated input type of UnlockEmployee */
export type UnlockEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlockEmployee. */
export type UnlockEmployeePayload = {
  __typename?: 'UnlockEmployeePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UnlockUser */
export type UnlockUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlockUser. */
export type UnlockUserPayload = {
  __typename?: 'UnlockUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UnpublishInvestorUpdate */
export type UnpublishInvestorUpdateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of UnpublishInvestorUpdate. */
export type UnpublishInvestorUpdatePayload = {
  __typename?: 'UnpublishInvestorUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investorUpdate?: Maybe<InvestorUpdate>;
};

/** Autogenerated input type of UnreadNotification */
export type UnreadNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnreadNotification. */
export type UnreadNotificationPayload = {
  __typename?: 'UnreadNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  notification?: Maybe<Notification>;
};

export type UnverifiedAddressAttributes = {
  country?: InputMaybe<Scalars['String']['input']>;
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type UnverifiedIdentityAttributes = {
  accredited?: InputMaybe<Scalars['Boolean']['input']>;
  businessAccount?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateAutomaticRepaymentTransfers */
export type UpdateAutomaticRepaymentTransfersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationAccountSecureId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  originAccountSecureId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateAutomaticRepaymentTransfers. */
export type UpdateAutomaticRepaymentTransfersPayload = {
  __typename?: 'UpdateAutomaticRepaymentTransfersPayload';
  automaticRepaymentTransferSetting?: Maybe<AutomaticRepaymentTransferSetting>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateBeneficiary */
export type UpdateBeneficiaryInput = {
  addressAttributes?: InputMaybe<AddressAttributes>;
  beneficiaryId: Scalars['Int']['input'];
  beneficiaryInput: BeneficiaryInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBeneficiary. */
export type UpdateBeneficiaryPayload = {
  __typename?: 'UpdateBeneficiaryPayload';
  beneficiary?: Maybe<Beneficiary>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateConfiguration */
export type UpdateConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateConfiguration. */
export type UpdateConfigurationPayload = {
  __typename?: 'UpdateConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateDwollaCustomer */
export type UpdateDwollaCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dwollaCustomerInput: DwollaCustomerInput;
  /**
   * Flag to control whether updates will be applied to the User object and the
   * address associated to the User in addition to the updates to the
   * DwollaCustomer.
   */
  updateUserAndUserAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to control whether the verified attribute of the DwollaCustomer should be true */
  upgradeDwollaCustomerToVerified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateDwollaCustomer. */
export type UpdateDwollaCustomerPayload = {
  __typename?: 'UpdateDwollaCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dwollaCustomer?: Maybe<DwollaCustomer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateHostedDocument */
export type UpdateHostedDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hostedDocument?: InputMaybe<HostedDocumentAttributes>;
};

/** Autogenerated return type of UpdateHostedDocument. */
export type UpdateHostedDocumentPayload = {
  __typename?: 'UpdateHostedDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  hostedDocument?: Maybe<HostedDocument>;
};

/** Autogenerated input type of UpdateInvestmentWizardStrategy */
export type UpdateInvestmentWizardStrategyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  investmentWizardStrategy: InvestmentWizardStrategyInput;
};

/** Autogenerated return type of UpdateInvestmentWizardStrategy. */
export type UpdateInvestmentWizardStrategyPayload = {
  __typename?: 'UpdateInvestmentWizardStrategyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  investmentWizardStrategy?: Maybe<InvestmentWizardStrategy>;
};

/** Autogenerated input type of UpdateIraFundsTransferAmount */
export type UpdateIraFundsTransferAmountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundsTransferId: Scalars['Int']['input'];
  updatedAmountCents: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateIraFundsTransferAmount. */
export type UpdateIraFundsTransferAmountPayload = {
  __typename?: 'UpdateIraFundsTransferAmountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  fundsTransfer?: Maybe<FundsTransfer>;
};

/** Autogenerated input type of UpdatePushNotificationSubscriptionConfiguration */
export type UpdatePushNotificationSubscriptionConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pushNotificationSubscriptionConfiguration: PushNotificationSubscriptionConfigurationInput;
};

/** Autogenerated return type of UpdatePushNotificationSubscriptionConfiguration. */
export type UpdatePushNotificationSubscriptionConfigurationPayload = {
  __typename?: 'UpdatePushNotificationSubscriptionConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<PushNotificationSubscriptionConfigurationError>>;
  pushNotificationSubscriptionConfiguration?: Maybe<PushNotificationSubscriptionConfiguration>;
};

export type UpdateRecurringTransferScheduleAttributes = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  scheduleStartOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated input type of UpdateRecurringTransferSchedule */
export type UpdateRecurringTransferScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  recurringTransferSchedule: UpdateRecurringTransferScheduleAttributes;
};

/** Autogenerated return type of UpdateRecurringTransferSchedule. */
export type UpdateRecurringTransferSchedulePayload = {
  __typename?: 'UpdateRecurringTransferSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  recurringTransferSchedule?: Maybe<RecurringTransferSchedule>;
};

/** Autogenerated input type of UpdateReferralCampaign */
export type UpdateReferralCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  referralCampaign?: InputMaybe<EditReferralCampaignInput>;
};

/** Autogenerated return type of UpdateReferralCampaign. */
export type UpdateReferralCampaignPayload = {
  __typename?: 'UpdateReferralCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  referralCampaign?: Maybe<ReferralCampaign>;
};

/** Autogenerated input type of UpdateSavingsGoal */
export type UpdateSavingsGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  savingsGoal: SavingsGoalAttributes;
};

/** Autogenerated return type of UpdateSavingsGoal. */
export type UpdateSavingsGoalPayload = {
  __typename?: 'UpdateSavingsGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  savingsGoal?: Maybe<SavingsGoal>;
};

/** Autogenerated input type of UpdateTaxPayer */
export type UpdateTaxPayerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Update the lazy group of tax payers for a user if this tax payer belongs to
   * one. Setting this to false will remove the tax payer from the lazy group it's in.
   */
  lazy?: InputMaybe<Scalars['Boolean']['input']>;
  taxPayerId: Scalars['Int']['input'];
  taxPayerInput: TaxPayerModificationInput;
};

/** Autogenerated return type of UpdateTaxPayer. */
export type UpdateTaxPayerPayload = {
  __typename?: 'UpdateTaxPayerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  taxPayer?: Maybe<TaxPayer>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  accountSecureId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  user: UserAttributes;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** If MFA is required, a new MFA Attempt will be triggered and returned */
  mfaAttempt?: Maybe<MfaAttempt>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateWireTransferRequest */
export type UpdateWireTransferRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  wireTransferRequest?: InputMaybe<WireTransferRequestAttributes>;
};

/** Autogenerated return type of UpdateWireTransferRequest. */
export type UpdateWireTransferRequestPayload = {
  __typename?: 'UpdateWireTransferRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  wireTransferRequest?: Maybe<WireTransferRequest>;
};

/** Autogenerated input type of UpdateYieldInvestorProfile */
export type UpdateYieldInvestorProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  yieldInvestorProfile: YieldInvestorProfileAttributes;
};

/** Autogenerated return type of UpdateYieldInvestorProfile. */
export type UpdateYieldInvestorProfilePayload = {
  __typename?: 'UpdateYieldInvestorProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  yieldInvestorProfile?: Maybe<YieldInvestorProfile>;
};

/** Autogenerated input type of UploadVerificationDocument */
export type UploadVerificationDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hostedDocument: HostedDocumentAttributes;
  trustlineId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UploadVerificationDocument. */
export type UploadVerificationDocumentPayload = {
  __typename?: 'UploadVerificationDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  hostedDocument?: Maybe<HostedDocument>;
};

/** The identity and credentials of a user on the platform */
export type User = Timestamp & {
  __typename?: 'User';
  /** If the user is an accredited investor or not */
  accredited: Scalars['Boolean']['output'];
  /** Address of user */
  address: Address;
  /** Returns the setting if the user has enabled automatic repayment transfers */
  automaticRepaymentTransferSetting?: Maybe<AutomaticRepaymentTransferSetting>;
  /** Clubs to which the user belongs */
  clubs: Array<Club>;
  /** Communication Protocols connected to the user */
  communicationProtocols: Array<CommunicationProtocol>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** If the user has declared they're accredited */
  declaredAccredited: Scalars['Boolean']['output'];
  /** Whether or not a given user is eligible to invest in GROUNDFLOOR notes. */
  eligibleForNoteInvesting: Scalars['Boolean']['output'];
  /** Email of the user */
  email: Scalars['String']['output'];
  /** Whether or not a given user has verified their email address */
  emailVerified: Scalars['Boolean']['output'];
  featureFlagContext: Scalars['JSON']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** ID of the user */
  id: Scalars['ID']['output'];
  investorMonthlyStatements: Array<PdfMonthlyStatement>;
  investorTaxDocuments: Array<PdfTaxForm>;
  isDwollaBusinessCustomer: Scalars['Boolean']['output'];
  /** User is onboarding if they have no investment or transfer activity */
  isOnboarding: Scalars['Boolean']['output'];
  kycState?: Maybe<KycState>;
  /** @deprecated This will always be null */
  lastMfaAttempt?: Maybe<MfaAttempt>;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** If the user has MFA enabled or not */
  mfaEnabled: Scalars['Boolean']['output'];
  /** Account that the user owns or belongs to as a member */
  myAccounts?: Maybe<Array<Account>>;
  /** Full name of user */
  name: Scalars['String']['output'];
  /** Phone number of the user */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Normalized E164 phone number */
  phoneNumberE164?: Maybe<Scalars['String']['output']>;
  /** Normalized E164 phone number */
  phoneNumberE164Formatted?: Maybe<Scalars['String']['output']>;
  primaryAccountSecureId?: Maybe<Scalars['String']['output']>;
  /** Accounts viable to be selected as the primary account */
  primaryAccountSelectionOptions: Array<AccountDisplayName>;
  referralAccountSecureId?: Maybe<Scalars['String']['output']>;
  stairsMonthlyStatements: Array<PdfMonthlyStatement>;
  stairsTaxDocuments: Array<PdfTaxForm>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userActivityStatistics: UserActivityStatistics;
  /** Whether the user has confirmed their accreditation status */
  userConfirmedAccreditationStatus: Scalars['Boolean']['output'];
  /** UUID of the user */
  uuid: Scalars['ID']['output'];
};


/** The identity and credentials of a user on the platform */
export type UserMyAccountsArgs = {
  types?: InputMaybe<Array<AccountTypeName>>;
};

/** Statistics on various User activity across all accounts. */
export type UserActivityStatistics = {
  __typename?: 'UserActivityStatistics';
  /** Any User's Accounts has purchased an Investment */
  hasActiveOrRepaidInvestments: Scalars['Boolean']['output'];
  /** Any User's Account currently has a pending FundsTransfer */
  hasPendingFundsTransfers: Scalars['Boolean']['output'];
  /** Any User's Account has a pending PurchaseOrder */
  hasPendingPurchaseOrders: Scalars['Boolean']['output'];
  /** Any User's Account currently has a pending FundsTransfer */
  hasPendingWireTransfers: Scalars['Boolean']['output'];
  /** Any User's Accounts have a posted FundsTransfer */
  hasPostedFundsTransfers: Scalars['Boolean']['output'];
  /** Any User's Account currently has a pending FundsTransfer */
  hasPostedWireTransfers: Scalars['Boolean']['output'];
};

export type UserAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberE164?: InputMaybe<Scalars['String']['input']>;
};

/** Maintains the state of a User's registration flow */
export type UserRegistration = Timestamp & {
  __typename?: 'UserRegistration';
  accredited?: Maybe<Scalars['Boolean']['output']>;
  canComplete: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  entityType?: Maybe<Entity>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumberE164?: Maybe<Scalars['String']['output']>;
  referralSessionId?: Maybe<Scalars['ID']['output']>;
  secureId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type VerifiableIdentity = {
  __typename?: 'VerifiableIdentity';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type VerifiableIdentityAttributes = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  businessClassification?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  ein?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

/** Autogenerated input type of VerifyEmail */
export type VerifyEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  verificationCode: Scalars['String']['input'];
};

/** Autogenerated return type of VerifyEmail. */
export type VerifyEmailPayload = {
  __typename?: 'VerifyEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailVerificationId?: Maybe<Scalars['Int']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of VerifyMfaAttempt */
export type VerifyMfaAttemptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true and if the original MFA session is due to a login attempt, then a
   * successful validation here will also complete login and issue a jwt.
   */
  completeLoginOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** The MFA attempt ID to validate */
  mfaAttemptId: Scalars['ID']['input'];
  /** The one-time code sent from beginMfaEnrollment or resendMfa */
  otp: Scalars['String']['input'];
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
};

/** Autogenerated return type of VerifyMfaAttempt. */
export type VerifyMfaAttemptPayload = {
  __typename?: 'VerifyMfaAttemptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /**
   * If the MFA session was for login and the attempt was successful, and if
   * completeLoginOnSuccess is true, this will contain the user's JWT
   */
  jwt?: Maybe<Jwt>;
  /** Whether the OTP was valid or not */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of VerifyMicroDeposits */
export type VerifyMicroDepositsInput = {
  /** Corresponds to the first amount sent for microdeposit verification. */
  amount1Cents: Scalars['Int']['input'];
  /** Corresponds to the second amount sent for microdeposit verification. */
  amount2Cents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Used for reporting purposes. Must match value supplied to Google by front end. Required for Recaptcha Enterprise V1. */
  recaptchaAction?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponseToken: Scalars['String']['input'];
  /** reCAPTCHA site key associated with the site/app.  Required for Recaptcha Enterprise V1. */
  recaptchaSiteKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaVersion?: InputMaybe<RecaptchaVersion>;
  /** The ID of the trustline tied to the verifying bank account. */
  trustlineId: Scalars['Int']['input'];
};

/** Autogenerated return type of VerifyMicroDeposits. */
export type VerifyMicroDepositsPayload = {
  __typename?: 'VerifyMicroDepositsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<MicroDepositVerificationError>>;
  trustline?: Maybe<Trustline>;
};

export type WeightedLoanAverages = {
  __typename?: 'WeightedLoanAverages';
  ltv?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  skinInTheGamePercentage?: Maybe<Scalars['Float']['output']>;
  term?: Maybe<Scalars['Float']['output']>;
};

export type WireTransferRequest = {
  __typename?: 'WireTransferRequest';
  closedOn?: Maybe<Scalars['Date']['output']>;
  holdbackAmountCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lendingLoan?: Maybe<LendingLoan>;
  participationDeductionCents?: Maybe<Scalars['Int']['output']>;
  revenueLineItems?: Maybe<Array<RevenueLineItem>>;
  state?: Maybe<Scalars['String']['output']>;
  stubInterestCents?: Maybe<Scalars['Int']['output']>;
  totalRevenueCents?: Maybe<Scalars['Int']['output']>;
  wireAmountCents?: Maybe<Scalars['Int']['output']>;
};

export type WireTransferRequestAttributes = {
  closedOn?: InputMaybe<Scalars['Date']['input']>;
  holdbackAmountCents?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lendingLoanId?: InputMaybe<Scalars['Int']['input']>;
  participationDeductionCents?: InputMaybe<Scalars['Int']['input']>;
  revenueLineItems?: InputMaybe<Array<RevenueLineItemAttributes>>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type YieldAccountSnapshot = {
  __typename?: 'YieldAccountSnapshot';
  account: Account;
  averageReturnRate: Scalars['Float']['output'];
  balanceCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interestCents?: Maybe<Scalars['Int']['output']>;
  interestTotalCents: Scalars['Int']['output'];
  interestYearToDateCents: Scalars['Int']['output'];
  portfolioAverageChangeRate: Scalars['Float']['output'];
  portfolioChangeCents: Scalars['Int']['output'];
  portfolioChangeRate: Scalars['Float']['output'];
  reversedInCents: Scalars['Int']['output'];
  reversedOutCents: Scalars['Int']['output'];
  rollupAverageCents: Scalars['Int']['output'];
  rollupCents: Scalars['Int']['output'];
  snapshotOn: Scalars['ISO8601Date']['output'];
  transferredInCents: Scalars['Int']['output'];
  transferredOutCents: Scalars['Int']['output'];
  transfers: Array<YieldTransfer>;
};

export type YieldIdentityAttributes = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type YieldInvestorProfile = {
  __typename?: 'YieldInvestorProfile';
  account: Account;
  accruedInterestCents: Scalars['Float']['output'];
  accruedInterestCentsTick: Scalars['Float']['output'];
  achTrustline: Trustline;
  clearedBalanceCents: Scalars['Int']['output'];
  currentBalanceCents: Scalars['Int']['output'];
  currentBalanceRemainder: Scalars['Float']['output'];
  currentYieldRate: Scalars['Float']['output'];
  defaultYieldRate: Scalars['Float']['output'];
  gfiaTrustline: Trustline;
  id: Scalars['ID']['output'];
  investorRewardStatus: InvestorRewardStatus;
  lastRoundupAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastScheduledTransferAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rollupEnabled: Scalars['Boolean']['output'];
  sixMonthProjectionAmount: Scalars['Float']['output'];
  stairsRecurringFundsTransfersEnabledSystemWide: Scalars['Boolean']['output'];
  systemWideRoundupsEnabled: Scalars['Boolean']['output'];
  threeMonthProjectionAmount: Scalars['Float']['output'];
  twelveMonthProjectionAmount: Scalars['Float']['output'];
  user: User;
};

export type YieldInvestorProfileAttributes = {
  id?: InputMaybe<Scalars['ID']['input']>;
  rollupEnabled: Scalars['Boolean']['input'];
};

export type YieldTransfer = {
  __typename?: 'YieldTransfer';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fromDescriptiveName?: Maybe<Scalars['String']['output']>;
  initiatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  interestCents: Scalars['Int']['output'];
  principalCents?: Maybe<Scalars['Int']['output']>;
  returnRate?: Maybe<Scalars['Float']['output']>;
  rollupTransactionCount?: Maybe<Scalars['Int']['output']>;
  /** reflects the time of the most recent update to the YieldTransfer */
  timestamp: Scalars['ISO8601DateTime']['output'];
  toDescriptiveName?: Maybe<Scalars['String']['output']>;
  transactionNumber?: Maybe<Scalars['ID']['output']>;
  yieldNoteRate?: Maybe<Scalars['Float']['output']>;
  yieldTransferStatus: YieldTransferStatus;
  yieldTransferType: YieldTransferTypeName;
};

export enum YieldTransferStatus {
  /** Transfer has been cancelled */
  Cancelled = 'CANCELLED',
  /** Transfer is being processed */
  Pending = 'PENDING',
  /** Transfer has been flagged for suspicious activity */
  PendingReview = 'PENDING_REVIEW',
  /** Transfer is completed */
  Processed = 'PROCESSED',
  /** Transfer has been rejected due to suspicous activity */
  Rejected = 'REJECTED'
}

export enum YieldTransferTypeName {
  /** Transfer from Investment repayment */
  DividendsTransfer = 'DIVIDENDS_TRANSFER',
  /** One off Funds Transfer */
  ManualFundsTransfer = 'MANUAL_FUNDS_TRANSFER',
  /** Reversal From One-Off Funds Transfer */
  ManualFundsTransferReversal = 'MANUAL_FUNDS_TRANSFER_REVERSAL',
  /** Promotional Credit from Groundfloor */
  PromotionalCredit = 'PROMOTIONAL_CREDIT',
  /** Fund Transfer From Rollup */
  RollupFundsTransfer = 'ROLLUP_FUNDS_TRANSFER',
  /** Transfer Reversal From Rollup */
  RollupFundsTransferReversal = 'ROLLUP_FUNDS_TRANSFER_REVERSAL',
  /** Funds Transfer From Re-occuring Schedule */
  ScheduledFundsTransfer = 'SCHEDULED_FUNDS_TRANSFER',
  /** Transfer Reversal From Recurring Schedule */
  ScheduledFundsTransferReversal = 'SCHEDULED_FUNDS_TRANSFER_REVERSAL'
}

export type ErrorFragment = { __typename?: 'Error', detail?: string | null, pointer?: string | null, status?: string | null, code?: ErrorCode | null };

export type ArchiveProgressUpdateMutationVariables = Exact<{
  progressUpdateId: Scalars['ID']['input'];
}>;


export type ArchiveProgressUpdateMutation = { __typename?: 'Mutation', archiveProgressUpdate?: { __typename?: 'ArchiveProgressUpdatePayload', errors?: Array<{ __typename?: 'Error', status?: string | null, detail?: string | null, code?: ErrorCode | null }> | null } | null };

export type FetchEmployeeByClientQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchEmployeeByClientQuery = { __typename?: 'Query', fetchEmployeeByClient: { __typename?: 'Employee', email: string, id: string, employeeRoles: Array<{ __typename?: 'EmployeeRole', id: number, name: EmployeeRoleName, state: EmployeeRoleState }> } };

export type LendingLoanQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;


export type LendingLoanQuery = { __typename?: 'Query', lendingLoan: { __typename?: 'LendingLoan', id: string, name: string, amountCents: number, term: number, rate: number, rating: string, repaymentPosition?: number | null, constructionSecondaryDrawAmountCents?: number | null, loanToValueScore: number, qualityOfValuationReportScore: number, locationScore: number, borrowerCommitmentScore?: number | null, borrowerExperienceScore: number, skinInTheGameScore: number, projectedMaturityDate?: any | null, projectedRepaymentOn?: any | null, calculatedPortfolioAmountCents?: number | null, propertyPhotos: Array<{ __typename?: 'Image', id: string, url?: string | null, fileType?: string | null }>, address: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, countryIsoCode?: string | null, latitude?: number | null, longitude?: number | null }, lendingLoanApplication: { __typename?: 'LendingLoanApplication', id: string, term?: string | null, purpose?: string | null, paymentType?: string | null, securityPosition?: string | null, propertyType?: string | null, totalRehabBudgetCents?: number | null, afterRepairValueCents?: number | null, afterRepairValueBasedOn?: string | null, propertyValueCents?: number | null, originalPurchaseDate?: any | null, keyLoanFeature?: string | null, lendingPrincipal?: { __typename?: 'LendingPrincipal', id: string, firstName?: string | null, lastName?: string | null, principalStrategicFocus?: string | null, fundedOrRepaidLoansCount: number, repaidLoansCount: number, repaymentPercentage?: number | null, annuallyCompletedProjectsAverageCount?: number | null, averageProjectSalesPriceCents?: number | null, averageProjectsDurationMonths?: number | null, averageProjectCostCents?: number | null } | null, lendingBorrowerEntity?: { __typename?: 'LendingBorrowerEntity', id: string, fullName?: string | null, dateOfFormation?: any | null, totalInventoryValueCents: any, totalDebtCents: any, unsoldUnitsCount: number, agedUnsoldUnitsCount: number, completedProjectsCount: number, revenueCents: any, grossMarginPercentage?: number | null } | null, coverImage?: { __typename?: 'Image', id: string, url?: string | null, fileType?: string | null } | null }, publishedLoans: Array<{ __typename?: 'Loan', id: string, amountCents: number, portfolioAmountCents?: number | null, amountInvestedCents: number, amountMaxInvestmentCents: number, amountRemainingCents: number, borrowerExperienceScore: number, cap: number, descriptiveTitle?: string | null, externalCloseDate?: any | null, investorsCount: number, loanMaturesOn?: any | null, loanToValueScore: number, loanValuationPercent?: number | null, locationScore: number, name: string, paymentType: LoanPayment, purpose?: LoanPurpose | null, qualityOfValuationReportScore: number, rate?: number | null, rating: string, securityMaturesAt?: any | null, skinInTheGameScore: number, slug: string, state: SecurityState, summary?: string | null, term: number, valuationAbbrev: LoanValuationAbbreviation, valuationLabel: LoanValuationLabel, valuationValue: number, address: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, countryIsoCode?: string | null, latitude?: number | null, longitude?: number | null } }> } };

export type PublishableLendingLoansQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishableLendingLoansQuery = { __typename?: 'Query', publishableLendingLoans: Array<{ __typename?: 'PublishableLendingLoan', id: number, amountCents: number, name: string, term: number, publishedLoanCount: number }> };

export type PublishableProgressUpdatesQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishableProgressUpdatesQuery = { __typename?: 'Query', publishableProgressUpdates: Array<{ __typename?: 'PublishableProgressUpdate', id: string, html: string, lastUpdatedAt?: any | null, state: ProgressUpdateState, principalFirstName?: string | null, principalLastName?: string | null }> };

export type IssueApiConsumerJwtMutationVariables = Exact<{ [key: string]: never; }>;


export type IssueApiConsumerJwtMutation = { __typename?: 'Mutation', issueApiConsumerJwt?: { __typename?: 'IssueApiConsumerJwtPayload', jwtPayload?: { __typename?: 'Jwt', jwt: string, tokenType: string } | null, errors?: Array<{ __typename?: 'Error', status?: string | null, detail?: string | null, code?: ErrorCode | null }> | null } | null };

export type IssueEmployeeJwtMutationVariables = Exact<{
  input: IssueEmployeeJwtInput;
}>;


export type IssueEmployeeJwtMutation = { __typename?: 'Mutation', issueEmployeeJwt?: { __typename?: 'IssueEmployeeJwtPayload', jwtPayload?: { __typename?: 'Jwt', jwt: string, tokenType: string } | null, errors?: Array<{ __typename?: 'Error', code?: ErrorCode | null, detail?: string | null, status?: string | null }> | null } | null };

export type PublishProgressUpdateMutationVariables = Exact<{
  input: PublishProgressUpdateInput;
}>;


export type PublishProgressUpdateMutation = { __typename?: 'Mutation', publishProgressUpdate?: { __typename?: 'PublishProgressUpdatePayload', progressUpdate?: { __typename?: 'ProgressUpdate', id: string, html?: string | null, lastUpdatedAt?: any | null, state: ProgressUpdateState, lendingLoan: { __typename?: 'LendingLoan', id: string, name: string, amountCents: number, term: number, rate: number, rating: string, repaymentPosition?: number | null, constructionSecondaryDrawAmountCents?: number | null, loanToValueScore: number, qualityOfValuationReportScore: number, locationScore: number, borrowerCommitmentScore?: number | null, borrowerExperienceScore: number, skinInTheGameScore: number, projectedMaturityDate?: any | null, projectedRepaymentOn?: any | null, calculatedPortfolioAmountCents?: number | null, propertyPhotos: Array<{ __typename?: 'Image', id: string, url?: string | null, fileType?: string | null }>, address: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, countryIsoCode?: string | null, latitude?: number | null, longitude?: number | null }, lendingLoanApplication: { __typename?: 'LendingLoanApplication', id: string, term?: string | null, purpose?: string | null, paymentType?: string | null, securityPosition?: string | null, propertyType?: string | null, totalRehabBudgetCents?: number | null, afterRepairValueCents?: number | null, afterRepairValueBasedOn?: string | null, propertyValueCents?: number | null, originalPurchaseDate?: any | null, keyLoanFeature?: string | null, lendingPrincipal?: { __typename?: 'LendingPrincipal', id: string, firstName?: string | null, lastName?: string | null, principalStrategicFocus?: string | null, fundedOrRepaidLoansCount: number, repaidLoansCount: number, repaymentPercentage?: number | null, annuallyCompletedProjectsAverageCount?: number | null, averageProjectSalesPriceCents?: number | null, averageProjectsDurationMonths?: number | null, averageProjectCostCents?: number | null } | null, lendingBorrowerEntity?: { __typename?: 'LendingBorrowerEntity', id: string, fullName?: string | null, dateOfFormation?: any | null, totalInventoryValueCents: any, totalDebtCents: any, unsoldUnitsCount: number, agedUnsoldUnitsCount: number, completedProjectsCount: number, revenueCents: any, grossMarginPercentage?: number | null } | null, coverImage?: { __typename?: 'Image', id: string, url?: string | null, fileType?: string | null } | null }, publishedLoans: Array<{ __typename?: 'Loan', id: string, amountCents: number, portfolioAmountCents?: number | null, amountInvestedCents: number, amountMaxInvestmentCents: number, amountRemainingCents: number, borrowerExperienceScore: number, cap: number, descriptiveTitle?: string | null, externalCloseDate?: any | null, investorsCount: number, loanMaturesOn?: any | null, loanToValueScore: number, loanValuationPercent?: number | null, locationScore: number, name: string, paymentType: LoanPayment, purpose?: LoanPurpose | null, qualityOfValuationReportScore: number, rate?: number | null, rating: string, securityMaturesAt?: any | null, skinInTheGameScore: number, slug: string, state: SecurityState, summary?: string | null, term: number, valuationAbbrev: LoanValuationAbbreviation, valuationLabel: LoanValuationLabel, valuationValue: number, address: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, countryIsoCode?: string | null, latitude?: number | null, longitude?: number | null } }> } } | null, errors?: Array<{ __typename?: 'Error', code?: ErrorCode | null, detail?: string | null, status?: string | null }> | null } | null };

export type CreateInvestmentOpportunityFromLendingDataMutationVariables = Exact<{
  input: CreateInvestmentOpportunityFromLendingDataInput;
}>;


export type CreateInvestmentOpportunityFromLendingDataMutation = { __typename?: 'Mutation', createInvestmentOpportunityFromLendingData?: { __typename?: 'CreateInvestmentOpportunityFromLendingDataPayload', loanApplication?: { __typename?: 'LoanApplication', id: string, principal?: { __typename?: 'Principal', id: string } | null, borrowerEntity?: { __typename?: 'BorrowerEntity', id: string } | null } | null, errors?: Array<{ __typename?: 'Error', status?: string | null, detail?: string | null, code?: ErrorCode | null }> | null } | null };

export type SecBatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type SecBatchesQuery = { __typename?: 'Query', secBatches?: Array<{ __typename?: 'SecBatch', id: string, displayName: string }> | null };

export const ErrorFragmentDoc = gql`
    fragment ErrorFragment on Error {
  detail
  pointer
  status
  code
}
    `;
export const ArchiveProgressUpdateDocument = gql`
    mutation ArchiveProgressUpdate($progressUpdateId: ID!) {
  archiveProgressUpdate(input: {progressUpdateId: $progressUpdateId}) {
    errors {
      status
      detail
      code
    }
  }
}
    `;

/**
 * __useArchiveProgressUpdateMutation__
 *
 * To run a mutation, you first call `useArchiveProgressUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProgressUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchiveProgressUpdateMutation({
 *   variables: {
 *     progressUpdateId: // value for 'progressUpdateId'
 *   },
 * });
 */
export function useArchiveProgressUpdateMutation(options: VueApolloComposable.UseMutationOptions<ArchiveProgressUpdateMutation, ArchiveProgressUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ArchiveProgressUpdateMutation, ArchiveProgressUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ArchiveProgressUpdateMutation, ArchiveProgressUpdateMutationVariables>(ArchiveProgressUpdateDocument, options);
}
export type ArchiveProgressUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ArchiveProgressUpdateMutation, ArchiveProgressUpdateMutationVariables>;
export const FetchEmployeeByClientDocument = gql`
    query FetchEmployeeByClient {
  fetchEmployeeByClient {
    email
    employeeRoles {
      id
      name
      state
    }
    id
  }
}
    `;

/**
 * __useFetchEmployeeByClientQuery__
 *
 * To run a query within a Vue component, call `useFetchEmployeeByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeByClientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchEmployeeByClientQuery();
 */
export function useFetchEmployeeByClientQuery(options: VueApolloComposable.UseQueryOptions<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables>(FetchEmployeeByClientDocument, {}, options);
}
export function useFetchEmployeeByClientLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables>(FetchEmployeeByClientDocument, {}, options);
}
export type FetchEmployeeByClientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchEmployeeByClientQuery, FetchEmployeeByClientQueryVariables>;
export const LendingLoanDocument = gql`
    query LendingLoan($loanId: ID!) {
  lendingLoan(id: $loanId) {
    ... on LendingLoan {
      id
      name
      amountCents
      term
      rate
      rating
      repaymentPosition
      constructionSecondaryDrawAmountCents
      loanToValueScore
      qualityOfValuationReportScore
      locationScore
      borrowerCommitmentScore
      borrowerExperienceScore
      skinInTheGameScore
      projectedMaturityDate
      projectedRepaymentOn
      calculatedPortfolioAmountCents
      propertyPhotos {
        id
        url
        fileType
      }
      address {
        id
        address1
        address2
        city
        state
        zipcode
        country
        countryIsoCode
        latitude
        longitude
      }
      lendingLoanApplication {
        id
        term
        purpose
        paymentType
        securityPosition
        propertyType
        totalRehabBudgetCents
        afterRepairValueCents
        afterRepairValueBasedOn
        propertyValueCents
        originalPurchaseDate
        keyLoanFeature
        lendingPrincipal {
          id
          firstName
          lastName
          principalStrategicFocus
          fundedOrRepaidLoansCount
          repaidLoansCount
          repaymentPercentage
          annuallyCompletedProjectsAverageCount
          averageProjectSalesPriceCents
          averageProjectsDurationMonths
          averageProjectCostCents
        }
        lendingBorrowerEntity {
          id
          fullName
          dateOfFormation
          totalInventoryValueCents
          totalDebtCents
          unsoldUnitsCount
          agedUnsoldUnitsCount
          completedProjectsCount
          revenueCents
          grossMarginPercentage
        }
        coverImage {
          id
          url
          fileType
        }
      }
      publishedLoans {
        id
        amountCents
        portfolioAmountCents
        amountInvestedCents
        amountMaxInvestmentCents
        amountRemainingCents
        borrowerExperienceScore
        cap
        descriptiveTitle
        externalCloseDate
        investorsCount
        loanMaturesOn
        loanToValueScore
        loanValuationPercent
        locationScore
        name
        paymentType
        purpose
        qualityOfValuationReportScore
        rate
        rating
        securityMaturesAt
        skinInTheGameScore
        slug
        state
        summary
        term
        valuationAbbrev
        valuationLabel
        valuationValue
        address {
          id
          address1
          address2
          city
          state
          zipcode
          country
          countryIsoCode
          latitude
          longitude
        }
      }
    }
  }
}
    `;

/**
 * __useLendingLoanQuery__
 *
 * To run a query within a Vue component, call `useLendingLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useLendingLoanQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLendingLoanQuery({
 *   loanId: // value for 'loanId'
 * });
 */
export function useLendingLoanQuery(variables: LendingLoanQueryVariables | VueCompositionApi.Ref<LendingLoanQueryVariables> | ReactiveFunction<LendingLoanQueryVariables>, options: VueApolloComposable.UseQueryOptions<LendingLoanQuery, LendingLoanQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LendingLoanQuery, LendingLoanQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LendingLoanQuery, LendingLoanQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LendingLoanQuery, LendingLoanQueryVariables>(LendingLoanDocument, variables, options);
}
export function useLendingLoanLazyQuery(variables?: LendingLoanQueryVariables | VueCompositionApi.Ref<LendingLoanQueryVariables> | ReactiveFunction<LendingLoanQueryVariables>, options: VueApolloComposable.UseQueryOptions<LendingLoanQuery, LendingLoanQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LendingLoanQuery, LendingLoanQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LendingLoanQuery, LendingLoanQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LendingLoanQuery, LendingLoanQueryVariables>(LendingLoanDocument, variables, options);
}
export type LendingLoanQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LendingLoanQuery, LendingLoanQueryVariables>;
export const PublishableLendingLoansDocument = gql`
    query PublishableLendingLoans {
  publishableLendingLoans {
    id
    amountCents
    name
    term
    publishedLoanCount
  }
}
    `;

/**
 * __usePublishableLendingLoansQuery__
 *
 * To run a query within a Vue component, call `usePublishableLendingLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishableLendingLoansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePublishableLendingLoansQuery();
 */
export function usePublishableLendingLoansQuery(options: VueApolloComposable.UseQueryOptions<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables>(PublishableLendingLoansDocument, {}, options);
}
export function usePublishableLendingLoansLazyQuery(options: VueApolloComposable.UseQueryOptions<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables>(PublishableLendingLoansDocument, {}, options);
}
export type PublishableLendingLoansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PublishableLendingLoansQuery, PublishableLendingLoansQueryVariables>;
export const PublishableProgressUpdatesDocument = gql`
    query PublishableProgressUpdates {
  publishableProgressUpdates {
    id
    html
    lastUpdatedAt
    state
    principalFirstName
    principalLastName
  }
}
    `;

/**
 * __usePublishableProgressUpdatesQuery__
 *
 * To run a query within a Vue component, call `usePublishableProgressUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishableProgressUpdatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePublishableProgressUpdatesQuery();
 */
export function usePublishableProgressUpdatesQuery(options: VueApolloComposable.UseQueryOptions<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables>(PublishableProgressUpdatesDocument, {}, options);
}
export function usePublishableProgressUpdatesLazyQuery(options: VueApolloComposable.UseQueryOptions<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables>(PublishableProgressUpdatesDocument, {}, options);
}
export type PublishableProgressUpdatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PublishableProgressUpdatesQuery, PublishableProgressUpdatesQueryVariables>;
export const IssueApiConsumerJwtDocument = gql`
    mutation IssueApiConsumerJwt {
  issueApiConsumerJwt(input: {}) {
    jwtPayload: jwt {
      jwt
      tokenType
    }
    errors {
      status
      detail
      code
    }
  }
}
    `;

/**
 * __useIssueApiConsumerJwtMutation__
 *
 * To run a mutation, you first call `useIssueApiConsumerJwtMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueApiConsumerJwtMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueApiConsumerJwtMutation();
 */
export function useIssueApiConsumerJwtMutation(options: VueApolloComposable.UseMutationOptions<IssueApiConsumerJwtMutation, IssueApiConsumerJwtMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueApiConsumerJwtMutation, IssueApiConsumerJwtMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueApiConsumerJwtMutation, IssueApiConsumerJwtMutationVariables>(IssueApiConsumerJwtDocument, options);
}
export type IssueApiConsumerJwtMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueApiConsumerJwtMutation, IssueApiConsumerJwtMutationVariables>;
export const IssueEmployeeJwtDocument = gql`
    mutation IssueEmployeeJwt($input: IssueEmployeeJwtInput!) {
  issueEmployeeJwt(input: $input) {
    jwtPayload: jwt {
      jwt
      tokenType
    }
    errors {
      code
      detail
      status
    }
  }
}
    `;

/**
 * __useIssueEmployeeJwtMutation__
 *
 * To run a mutation, you first call `useIssueEmployeeJwtMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueEmployeeJwtMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueEmployeeJwtMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIssueEmployeeJwtMutation(options: VueApolloComposable.UseMutationOptions<IssueEmployeeJwtMutation, IssueEmployeeJwtMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueEmployeeJwtMutation, IssueEmployeeJwtMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueEmployeeJwtMutation, IssueEmployeeJwtMutationVariables>(IssueEmployeeJwtDocument, options);
}
export type IssueEmployeeJwtMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueEmployeeJwtMutation, IssueEmployeeJwtMutationVariables>;
export const PublishProgressUpdateDocument = gql`
    mutation PublishProgressUpdate($input: PublishProgressUpdateInput!) {
  publishProgressUpdate(input: $input) {
    progressUpdate {
      id
      html
      lastUpdatedAt
      state
      lendingLoan {
        id
        name
        amountCents
        term
        rate
        rating
        repaymentPosition
        constructionSecondaryDrawAmountCents
        loanToValueScore
        qualityOfValuationReportScore
        locationScore
        borrowerCommitmentScore
        borrowerExperienceScore
        skinInTheGameScore
        projectedMaturityDate
        projectedRepaymentOn
        calculatedPortfolioAmountCents
        propertyPhotos {
          id
          url
          fileType
        }
        address {
          id
          address1
          address2
          city
          state
          zipcode
          country
          countryIsoCode
          latitude
          longitude
        }
        lendingLoanApplication {
          id
          term
          purpose
          paymentType
          securityPosition
          propertyType
          totalRehabBudgetCents
          afterRepairValueCents
          afterRepairValueBasedOn
          propertyValueCents
          originalPurchaseDate
          keyLoanFeature
          lendingPrincipal {
            id
            firstName
            lastName
            principalStrategicFocus
            fundedOrRepaidLoansCount
            repaidLoansCount
            repaymentPercentage
            annuallyCompletedProjectsAverageCount
            averageProjectSalesPriceCents
            averageProjectsDurationMonths
            averageProjectCostCents
          }
          lendingBorrowerEntity {
            id
            fullName
            dateOfFormation
            totalInventoryValueCents
            totalDebtCents
            unsoldUnitsCount
            agedUnsoldUnitsCount
            completedProjectsCount
            revenueCents
            grossMarginPercentage
          }
          coverImage {
            id
            url
            fileType
          }
        }
        publishedLoans {
          id
          amountCents
          portfolioAmountCents
          amountInvestedCents
          amountMaxInvestmentCents
          amountRemainingCents
          borrowerExperienceScore
          cap
          descriptiveTitle
          externalCloseDate
          investorsCount
          loanMaturesOn
          loanToValueScore
          loanValuationPercent
          locationScore
          name
          paymentType
          purpose
          qualityOfValuationReportScore
          rate
          rating
          securityMaturesAt
          skinInTheGameScore
          slug
          state
          summary
          term
          valuationAbbrev
          valuationLabel
          valuationValue
          address {
            id
            address1
            address2
            city
            state
            zipcode
            country
            countryIsoCode
            latitude
            longitude
          }
        }
      }
    }
    errors {
      code
      detail
      status
    }
  }
}
    `;

/**
 * __usePublishProgressUpdateMutation__
 *
 * To run a mutation, you first call `usePublishProgressUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishProgressUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishProgressUpdateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePublishProgressUpdateMutation(options: VueApolloComposable.UseMutationOptions<PublishProgressUpdateMutation, PublishProgressUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PublishProgressUpdateMutation, PublishProgressUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PublishProgressUpdateMutation, PublishProgressUpdateMutationVariables>(PublishProgressUpdateDocument, options);
}
export type PublishProgressUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PublishProgressUpdateMutation, PublishProgressUpdateMutationVariables>;
export const CreateInvestmentOpportunityFromLendingDataDocument = gql`
    mutation CreateInvestmentOpportunityFromLendingData($input: CreateInvestmentOpportunityFromLendingDataInput!) {
  createInvestmentOpportunityFromLendingData(input: $input) {
    loanApplication {
      id
      principal {
        id
      }
      borrowerEntity {
        id
      }
    }
    errors {
      status
      detail
      code
    }
  }
}
    `;

/**
 * __useCreateInvestmentOpportunityFromLendingDataMutation__
 *
 * To run a mutation, you first call `useCreateInvestmentOpportunityFromLendingDataMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvestmentOpportunityFromLendingDataMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateInvestmentOpportunityFromLendingDataMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvestmentOpportunityFromLendingDataMutation(options: VueApolloComposable.UseMutationOptions<CreateInvestmentOpportunityFromLendingDataMutation, CreateInvestmentOpportunityFromLendingDataMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateInvestmentOpportunityFromLendingDataMutation, CreateInvestmentOpportunityFromLendingDataMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateInvestmentOpportunityFromLendingDataMutation, CreateInvestmentOpportunityFromLendingDataMutationVariables>(CreateInvestmentOpportunityFromLendingDataDocument, options);
}
export type CreateInvestmentOpportunityFromLendingDataMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateInvestmentOpportunityFromLendingDataMutation, CreateInvestmentOpportunityFromLendingDataMutationVariables>;
export const SecBatchesDocument = gql`
    query SecBatches {
  secBatches {
    id
    displayName
  }
}
    `;

/**
 * __useSecBatchesQuery__
 *
 * To run a query within a Vue component, call `useSecBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecBatchesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSecBatchesQuery();
 */
export function useSecBatchesQuery(options: VueApolloComposable.UseQueryOptions<SecBatchesQuery, SecBatchesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SecBatchesQuery, SecBatchesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SecBatchesQuery, SecBatchesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SecBatchesQuery, SecBatchesQueryVariables>(SecBatchesDocument, {}, options);
}
export function useSecBatchesLazyQuery(options: VueApolloComposable.UseQueryOptions<SecBatchesQuery, SecBatchesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SecBatchesQuery, SecBatchesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SecBatchesQuery, SecBatchesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SecBatchesQuery, SecBatchesQueryVariables>(SecBatchesDocument, {}, options);
}
export type SecBatchesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SecBatchesQuery, SecBatchesQueryVariables>;